//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface ICommunicationsClient {
    getAll(ownerId: string, ownerTableName: string, searchExpr: string | null | undefined, searchOperation: string | null | undefined, searchValue: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, showActivity: boolean | undefined, showMail: boolean | undefined, showNote: boolean | undefined, searchString: string | null | undefined): Promise<CommunicationDto[]>;
    postAddNote(command: CreateNoteCommunicationCommand): Promise<FileResponse>;
    postUpdateNote(command: UpdateNoteCommunicationCommand): Promise<FileResponse>;
    uploadMsgFile(id: string): Promise<FileResponse>;
    deleteCommunication(communicationId: string): Promise<FileResponse>;
    renderMail(communicationId: string): Promise<FileResponse>;
    open(blobUrl: string | null | undefined, fileName: string | null | undefined, container: string | null | undefined): Promise<FileResponse>;
}

export class CommunicationsClient implements ICommunicationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll(ownerId: string, ownerTableName: string, searchExpr: string | null | undefined, searchOperation: string | null | undefined, searchValue: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, showActivity: boolean | undefined, showMail: boolean | undefined, showNote: boolean | undefined, searchString: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<CommunicationDto[]> {
        let url_ = this.baseUrl + "/api/Communications/{ownerId}/{ownerTableName}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        if (ownerTableName === undefined || ownerTableName === null)
            throw new Error("The parameter 'ownerTableName' must be defined.");
        url_ = url_.replace("{ownerTableName}", encodeURIComponent("" + ownerTableName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (searchExpr !== null && searchExpr !== undefined)
            content_.append("searchExpr", searchExpr.toString());
        if (searchOperation !== null && searchOperation !== undefined)
            content_.append("searchOperation", searchOperation.toString());
        if (searchValue !== null && searchValue !== undefined)
            content_.append("searchValue", searchValue.toString());
        if (requireTotalCount === null || requireTotalCount === undefined)
            throw new Error("The parameter 'requireTotalCount' cannot be null.");
        else
            content_.append("RequireTotalCount", requireTotalCount.toString());
        if (requireGroupCount === null || requireGroupCount === undefined)
            throw new Error("The parameter 'requireGroupCount' cannot be null.");
        else
            content_.append("RequireGroupCount", requireGroupCount.toString());
        if (isCountQuery === null || isCountQuery === undefined)
            throw new Error("The parameter 'isCountQuery' cannot be null.");
        else
            content_.append("IsCountQuery", isCountQuery.toString());
        if (skip === null || skip === undefined)
            throw new Error("The parameter 'skip' cannot be null.");
        else
            content_.append("Skip", skip.toString());
        if (take === null || take === undefined)
            throw new Error("The parameter 'take' cannot be null.");
        else
            content_.append("Take", take.toString());
        if (sort !== null && sort !== undefined)
            sort.forEach(item_ => content_.append("Sort", item_.toString()));
        if (group !== null && group !== undefined)
            group.forEach(item_ => content_.append("Group", item_.toString()));
        if (filter !== null && filter !== undefined)
            filter.forEach(item_ => content_.append("Filter", item_.toString()));
        if (totalSummary !== null && totalSummary !== undefined)
            totalSummary.forEach(item_ => content_.append("TotalSummary", item_.toString()));
        if (groupSummary !== null && groupSummary !== undefined)
            groupSummary.forEach(item_ => content_.append("GroupSummary", item_.toString()));
        if (select !== null && select !== undefined)
            select.forEach(item_ => content_.append("Select", item_.toString()));
        if (preSelect !== null && preSelect !== undefined)
            preSelect.forEach(item_ => content_.append("PreSelect", item_.toString()));
        if (remoteSelect !== null && remoteSelect !== undefined)
            content_.append("RemoteSelect", remoteSelect.toString());
        if (remoteGrouping !== null && remoteGrouping !== undefined)
            content_.append("RemoteGrouping", remoteGrouping.toString());
        if (expandLinqSumType !== null && expandLinqSumType !== undefined)
            content_.append("ExpandLinqSumType", expandLinqSumType.toString());
        if (primaryKey !== null && primaryKey !== undefined)
            primaryKey.forEach(item_ => content_.append("PrimaryKey", item_.toString()));
        if (defaultSort !== null && defaultSort !== undefined)
            content_.append("DefaultSort", defaultSort.toString());
        if (stringToLower !== null && stringToLower !== undefined)
            content_.append("StringToLower", stringToLower.toString());
        if (paginateViaPrimaryKey !== null && paginateViaPrimaryKey !== undefined)
            content_.append("PaginateViaPrimaryKey", paginateViaPrimaryKey.toString());
        if (sortByPrimaryKey !== null && sortByPrimaryKey !== undefined)
            content_.append("SortByPrimaryKey", sortByPrimaryKey.toString());
        if (allowAsyncOverSync === null || allowAsyncOverSync === undefined)
            throw new Error("The parameter 'allowAsyncOverSync' cannot be null.");
        else
            content_.append("AllowAsyncOverSync", allowAsyncOverSync.toString());
        if (showActivity === null || showActivity === undefined)
            throw new Error("The parameter 'showActivity' cannot be null.");
        else
            content_.append("ShowActivity", showActivity.toString());
        if (showMail === null || showMail === undefined)
            throw new Error("The parameter 'showMail' cannot be null.");
        else
            content_.append("ShowMail", showMail.toString());
        if (showNote === null || showNote === undefined)
            throw new Error("The parameter 'showNote' cannot be null.");
        else
            content_.append("ShowNote", showNote.toString());
        if (searchString !== null && searchString !== undefined)
            content_.append("SearchString", searchString.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CommunicationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CommunicationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationDto[]>(null as any);
    }

    postAddNote(command: CreateNoteCommunicationCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAddNote(_response);
        });
    }

    protected processPostAddNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postUpdateNote(command: UpdateNoteCommunicationCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateNote(_response);
        });
    }

    protected processPostUpdateNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadMsgFile(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMsgFile(_response);
        });
    }

    protected processUploadMsgFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteCommunication(communicationId: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/{communicationId}";
        if (communicationId === undefined || communicationId === null)
            throw new Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCommunication(_response);
        });
    }

    protected processDeleteCommunication(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    renderMail(communicationId: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/RenderMail/{communicationId}";
        if (communicationId === undefined || communicationId === null)
            throw new Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderMail(_response);
        });
    }

    protected processRenderMail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    open(blobUrl: string | null | undefined, fileName: string | null | undefined, container: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Communications/Open?";
        if (blobUrl !== undefined && blobUrl !== null)
            url_ += "blobUrl=" + encodeURIComponent("" + blobUrl) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (container !== undefined && container !== null)
            url_ += "container=" + encodeURIComponent("" + container) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOpen(_response);
        });
    }

    protected processOpen(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IConfigClient {
    getAuthenticationConfig(): Promise<AuthenticationConfig>;
    getSecurityConfig(): Promise<SecurityConfig>;
    getLayoutConfig(): Promise<LayoutConfig>;
    getMailConfig(): Promise<MailConfig>;
    getCompanyConfig(): Promise<CompanyConfig>;
    getAzureADOptions(): Promise<AzureADOptions>;
    getEnv(): Promise<FileResponse>;
}

export class ConfigClient implements IConfigClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAuthenticationConfig( cancelToken?: CancelToken | undefined): Promise<AuthenticationConfig> {
        let url_ = this.baseUrl + "/api/Config/GetAuthenticationConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthenticationConfig(_response);
        });
    }

    protected processGetAuthenticationConfig(response: AxiosResponse): Promise<AuthenticationConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationConfig.fromJS(resultData200);
            return Promise.resolve<AuthenticationConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationConfig>(null as any);
    }

    getSecurityConfig( cancelToken?: CancelToken | undefined): Promise<SecurityConfig> {
        let url_ = this.baseUrl + "/api/Config/GetSecurityConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSecurityConfig(_response);
        });
    }

    protected processGetSecurityConfig(response: AxiosResponse): Promise<SecurityConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SecurityConfig.fromJS(resultData200);
            return Promise.resolve<SecurityConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SecurityConfig>(null as any);
    }

    getLayoutConfig( cancelToken?: CancelToken | undefined): Promise<LayoutConfig> {
        let url_ = this.baseUrl + "/api/Config/GetLayoutConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLayoutConfig(_response);
        });
    }

    protected processGetLayoutConfig(response: AxiosResponse): Promise<LayoutConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LayoutConfig.fromJS(resultData200);
            return Promise.resolve<LayoutConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LayoutConfig>(null as any);
    }

    getMailConfig( cancelToken?: CancelToken | undefined): Promise<MailConfig> {
        let url_ = this.baseUrl + "/api/Config/GetMailConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailConfig(_response);
        });
    }

    protected processGetMailConfig(response: AxiosResponse): Promise<MailConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailConfig.fromJS(resultData200);
            return Promise.resolve<MailConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailConfig>(null as any);
    }

    getCompanyConfig( cancelToken?: CancelToken | undefined): Promise<CompanyConfig> {
        let url_ = this.baseUrl + "/api/Config/GetCompanyConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyConfig(_response);
        });
    }

    protected processGetCompanyConfig(response: AxiosResponse): Promise<CompanyConfig> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyConfig.fromJS(resultData200);
            return Promise.resolve<CompanyConfig>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyConfig>(null as any);
    }

    getAzureADOptions( cancelToken?: CancelToken | undefined): Promise<AzureADOptions> {
        let url_ = this.baseUrl + "/api/Config/GetAzureADOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAzureADOptions(_response);
        });
    }

    protected processGetAzureADOptions(response: AxiosResponse): Promise<AzureADOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AzureADOptions.fromJS(resultData200);
            return Promise.resolve<AzureADOptions>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AzureADOptions>(null as any);
    }

    getEnv( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/env";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnv(_response);
        });
    }

    protected processGetEnv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISettingsClient {
    get(): Promise<Settings>;
    update(command: SettingsUpdateCommand): Promise<void>;
}

export class SettingsClient implements ISettingsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get( cancelToken?: CancelToken | undefined): Promise<Settings> {
        let url_ = this.baseUrl + "/api/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Settings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Settings.fromJS(resultData200);
            return Promise.resolve<Settings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Settings>(null as any);
    }

    update(command: SettingsUpdateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IActionPointsClient {
    delete(id: string): Promise<void>;
    mail(id: string, command: MailActionPointCommand): Promise<void>;
    updateStatus(id: string, command: UpdateActionPointStatusCommand): Promise<void>;
    uploadFile(id: string): Promise<string>;
    fetchFile(id: string, filename: string | null | undefined): Promise<FileResponse>;
}

export class ActionPointsClient implements IActionPointsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    delete(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActionPoints/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    mail(id: string, command: MailActionPointCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActionPoints/{id}/Mail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateStatus(id: string, command: UpdateActionPointStatusCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ActionPoints/{id}/Status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadFile(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ActionPoints/{id}/Upload";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    fetchFile(id: string, filename: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActionPoints/{id}/File?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFetchFile(_response);
        });
    }

    protected processFetchFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMailTemplatesClient {
    getAll(type: MailTemplateType | null | undefined): Promise<MailTemplateDto[]>;
    create(command: CreateMailTemplateCommand): Promise<string>;
    getSingle(id: string): Promise<MailTemplateDto>;
    update(id: string, command: UpdateMailTemplateCommand): Promise<void>;
    remove(id: string): Promise<void>;
}

export class MailTemplatesClient implements IMailTemplatesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll(type: MailTemplateType | null | undefined, cancelToken?: CancelToken | undefined): Promise<MailTemplateDto[]> {
        let url_ = this.baseUrl + "/api/MailTemplates?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<MailTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MailTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailTemplateDto[]>(null as any);
    }

    create(command: CreateMailTemplateCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/MailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSingle(id: string, cancelToken?: CancelToken | undefined): Promise<MailTemplateDto> {
        let url_ = this.baseUrl + "/api/MailTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<MailTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailTemplateDto.fromJS(resultData200);
            return Promise.resolve<MailTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailTemplateDto>(null as any);
    }

    update(id: string, command: UpdateMailTemplateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MailTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    remove(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MailTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface INoteTypesClient {
    getAll(): Promise<NoteType[]>;
    addNoteType(command: CreateNoteTypesCommand): Promise<FileResponse>;
    updateNoteType(command: UpdateNoteTypesCommand): Promise<FileResponse>;
    deleteNoteType(command: DeleteNoteTypesCommand): Promise<FileResponse>;
}

export class NoteTypesClient implements INoteTypesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<NoteType[]> {
        let url_ = this.baseUrl + "/api/NoteTypes/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<NoteType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NoteType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteType[]>(null as any);
    }

    addNoteType(command: CreateNoteTypesCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NoteTypes/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNoteType(_response);
        });
    }

    protected processAddNoteType(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateNoteType(command: UpdateNoteTypesCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NoteTypes/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNoteType(_response);
        });
    }

    protected processUpdateNoteType(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteNoteType(command: DeleteNoteTypesCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NoteTypes/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteNoteType(_response);
        });
    }

    protected processDeleteNoteType(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ITasksClient {
    getItems(userId: string | null | undefined, unassigned: boolean | undefined, projectId: string | null | undefined, includeClosed: boolean | undefined, team: string | null | undefined): Promise<FileResponse>;
    postItem(command: CreateTaskCommand): Promise<FileResponse>;
    lookup(projectId: string | null | undefined, parentId: string | null | undefined, onlyMyTasks: boolean | undefined, includeClosed: boolean | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined): Promise<FileResponse>;
    getNumberOfTasks(): Promise<FileResponse>;
    getItem(id: string): Promise<CustomTaskDto>;
    putItem(id: string, command: UpdateTaskCommand): Promise<FileResponse>;
    deleteItem(id: string): Promise<FileResponse>;
    postItem2(command: CreateTaskNoteCommand): Promise<FileResponse>;
    updateStatus(id: string, command: UpdateTaskStatusCommand): Promise<CustomTask>;
}

export class TasksClient implements ITasksClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getItems(userId: string | null | undefined, unassigned: boolean | undefined, projectId: string | null | undefined, includeClosed: boolean | undefined, team: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (unassigned === null)
            throw new Error("The parameter 'unassigned' cannot be null.");
        else if (unassigned !== undefined)
            url_ += "unassigned=" + encodeURIComponent("" + unassigned) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (includeClosed === null)
            throw new Error("The parameter 'includeClosed' cannot be null.");
        else if (includeClosed !== undefined)
            url_ += "includeClosed=" + encodeURIComponent("" + includeClosed) + "&";
        if (team !== undefined && team !== null)
            url_ += "team=" + encodeURIComponent("" + team) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItems(_response);
        });
    }

    protected processGetItems(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postItem(command: CreateTaskCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostItem(_response);
        });
    }

    protected processPostItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    lookup(projectId: string | null | undefined, parentId: string | null | undefined, onlyMyTasks: boolean | undefined, includeClosed: boolean | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks/Lookup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (onlyMyTasks === null)
            throw new Error("The parameter 'onlyMyTasks' cannot be null.");
        else if (onlyMyTasks !== undefined)
            url_ += "onlyMyTasks=" + encodeURIComponent("" + onlyMyTasks) + "&";
        if (includeClosed === null)
            throw new Error("The parameter 'includeClosed' cannot be null.");
        else if (includeClosed !== undefined)
            url_ += "includeClosed=" + encodeURIComponent("" + includeClosed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requireTotalCount === null || requireTotalCount === undefined)
            throw new Error("The parameter 'requireTotalCount' cannot be null.");
        else
            content_.append("RequireTotalCount", requireTotalCount.toString());
        if (requireGroupCount === null || requireGroupCount === undefined)
            throw new Error("The parameter 'requireGroupCount' cannot be null.");
        else
            content_.append("RequireGroupCount", requireGroupCount.toString());
        if (isCountQuery === null || isCountQuery === undefined)
            throw new Error("The parameter 'isCountQuery' cannot be null.");
        else
            content_.append("IsCountQuery", isCountQuery.toString());
        if (skip === null || skip === undefined)
            throw new Error("The parameter 'skip' cannot be null.");
        else
            content_.append("Skip", skip.toString());
        if (take === null || take === undefined)
            throw new Error("The parameter 'take' cannot be null.");
        else
            content_.append("Take", take.toString());
        if (sort !== null && sort !== undefined)
            sort.forEach(item_ => content_.append("Sort", item_.toString()));
        if (group !== null && group !== undefined)
            group.forEach(item_ => content_.append("Group", item_.toString()));
        if (filter !== null && filter !== undefined)
            filter.forEach(item_ => content_.append("Filter", item_.toString()));
        if (totalSummary !== null && totalSummary !== undefined)
            totalSummary.forEach(item_ => content_.append("TotalSummary", item_.toString()));
        if (groupSummary !== null && groupSummary !== undefined)
            groupSummary.forEach(item_ => content_.append("GroupSummary", item_.toString()));
        if (select !== null && select !== undefined)
            select.forEach(item_ => content_.append("Select", item_.toString()));
        if (preSelect !== null && preSelect !== undefined)
            preSelect.forEach(item_ => content_.append("PreSelect", item_.toString()));
        if (remoteSelect !== null && remoteSelect !== undefined)
            content_.append("RemoteSelect", remoteSelect.toString());
        if (remoteGrouping !== null && remoteGrouping !== undefined)
            content_.append("RemoteGrouping", remoteGrouping.toString());
        if (expandLinqSumType !== null && expandLinqSumType !== undefined)
            content_.append("ExpandLinqSumType", expandLinqSumType.toString());
        if (primaryKey !== null && primaryKey !== undefined)
            primaryKey.forEach(item_ => content_.append("PrimaryKey", item_.toString()));
        if (defaultSort !== null && defaultSort !== undefined)
            content_.append("DefaultSort", defaultSort.toString());
        if (stringToLower !== null && stringToLower !== undefined)
            content_.append("StringToLower", stringToLower.toString());
        if (paginateViaPrimaryKey !== null && paginateViaPrimaryKey !== undefined)
            content_.append("PaginateViaPrimaryKey", paginateViaPrimaryKey.toString());
        if (sortByPrimaryKey !== null && sortByPrimaryKey !== undefined)
            content_.append("SortByPrimaryKey", sortByPrimaryKey.toString());
        if (allowAsyncOverSync === null || allowAsyncOverSync === undefined)
            throw new Error("The parameter 'allowAsyncOverSync' cannot be null.");
        else
            content_.append("AllowAsyncOverSync", allowAsyncOverSync.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getNumberOfTasks( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks/Count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfTasks(_response);
        });
    }

    protected processGetNumberOfTasks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getItem(id: string, cancelToken?: CancelToken | undefined): Promise<CustomTaskDto> {
        let url_ = this.baseUrl + "/api/Tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItem(_response);
        });
    }

    protected processGetItem(response: AxiosResponse): Promise<CustomTaskDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomTaskDto.fromJS(resultData200);
            return Promise.resolve<CustomTaskDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomTaskDto>(null as any);
    }

    putItem(id: string, command: UpdateTaskCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutItem(_response);
        });
    }

    protected processPutItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteItem(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteItem(_response);
        });
    }

    protected processDeleteItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postItem2(command: CreateTaskNoteCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Tasks/AddNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostItem2(_response);
        });
    }

    protected processPostItem2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateStatus(id: string, command: UpdateTaskStatusCommand, cancelToken?: CancelToken | undefined): Promise<CustomTask> {
        let url_ = this.baseUrl + "/api/Tasks/{id}/update-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<CustomTask> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomTask.fromJS(resultData200);
            return Promise.resolve<CustomTask>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomTask>(null as any);
    }
}

export interface ITaskTemplatesClient {
    getAll(): Promise<TaskTemplateDto[]>;
    postItem(command: CreateTaskTemplateCommand): Promise<FileResponse>;
    getItem(id: string): Promise<TaskTemplateDto>;
    putItem(id: string, command: UpdateTaskTemplateCommand): Promise<FileResponse>;
    deleteItem(id: string): Promise<FileResponse>;
}

export class TaskTemplatesClient implements ITaskTemplatesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<TaskTemplateDto[]> {
        let url_ = this.baseUrl + "/api/TaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TaskTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskTemplateDto[]>(null as any);
    }

    postItem(command: CreateTaskTemplateCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostItem(_response);
        });
    }

    protected processPostItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getItem(id: string, cancelToken?: CancelToken | undefined): Promise<TaskTemplateDto> {
        let url_ = this.baseUrl + "/api/TaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItem(_response);
        });
    }

    protected processGetItem(response: AxiosResponse): Promise<TaskTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskTemplateDto.fromJS(resultData200);
            return Promise.resolve<TaskTemplateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskTemplateDto>(null as any);
    }

    putItem(id: string, command: UpdateTaskTemplateCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutItem(_response);
        });
    }

    protected processPutItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteItem(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteItem(_response);
        });
    }

    protected processDeleteItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IContractsClient {
    get(projectId: string | null | undefined): Promise<ContractListItemDto[]>;
    create(command: CreateContractFromMeasuringStateCommand): Promise<string>;
    getSingle(documentNumber: string): Promise<ContractDto>;
    putContract(documentNumber: string, command: UpdateContractCommand): Promise<void>;
    deleteSingle(documentNumber: string): Promise<void>;
    generateDocument(documentNumber: string, settings: FinanceDocumentSettings): Promise<void>;
    getDocument(documentNumber: string): Promise<FileResponse>;
    mail(command: MailContractCommand): Promise<void>;
    approveContract(documentNumber: string): Promise<void>;
    rejectContract(documentNumber: string): Promise<void>;
    resetContractPrices(documentNumber: string): Promise<void>;
}

export class ContractsClient implements IContractsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ContractListItemDto[]> {
        let url_ = this.baseUrl + "/api/Contracts?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContractListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContractListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractListItemDto[]>(null as any);
    }

    create(command: CreateContractFromMeasuringStateCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSingle(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractDto.fromJS(resultData200);
            return Promise.resolve<ContractDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDto>(null as any);
    }

    putContract(documentNumber: string, command: UpdateContractCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutContract(_response);
        });
    }

    protected processPutContract(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSingle(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSingle(_response);
        });
    }

    protected processDeleteSingle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateDocument(documentNumber: string, settings: FinanceDocumentSettings, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}/GenerateDocument";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocument(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}/Document";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    mail(command: MailContractCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    approveContract(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}/Accept";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveContract(_response);
        });
    }

    protected processApproveContract(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    rejectContract(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}/Reject";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectContract(_response);
        });
    }

    protected processRejectContract(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetContractPrices(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Contracts/{documentNumber}/ResetPrices";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetContractPrices(_response);
        });
    }

    protected processResetContractPrices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMeasurementsClient {
    getStats(): Promise<FileResponse>;
    getList(projectId: string): Promise<MeasurementListItemDto[]>;
    createMeasurement(projectId: string, command: CreateMeasurementCommand): Promise<string>;
    getSingle(projectId: string, documentNumber: string): Promise<MeasurementDto>;
    deleteMeasurement(projectId: string, documentNumber: string): Promise<void>;
    getDocument(projectId: string, documentNumber: string): Promise<FileResponse>;
    getUsedReferences(projectId: string): Promise<string[]>;
    duplicateMeasurement(projectId: string, command: DuplicateMeasurementCommand): Promise<string>;
    mergeMeasurement(projectId: string, command: MeasurementMergeCommand): Promise<string>;
    updateMeasurementBasics(projectId: string, command: UpdateMeasurementBasicsCommand): Promise<string>;
    updateMeasurement(timestamp: string | null | undefined, projectId: string, command: UpdateMeasurementCommand): Promise<string>;
    getNextMeasurementNumber(projectId: string): Promise<string>;
}

export class MeasurementsClient implements IMeasurementsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getStats( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Measurements/Stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStats(_response);
        });
    }

    protected processGetStats(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getList(projectId: string, cancelToken?: CancelToken | undefined): Promise<MeasurementListItemDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<MeasurementListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasurementListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasurementListItemDto[]>(null as any);
    }

    createMeasurement(projectId: string, command: CreateMeasurementCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMeasurement(_response);
        });
    }

    protected processCreateMeasurement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSingle(projectId: string, documentNumber: string, cancelToken?: CancelToken | undefined): Promise<MeasurementDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/{documentNumber}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<MeasurementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasurementDto.fromJS(resultData200);
            return Promise.resolve<MeasurementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasurementDto>(null as any);
    }

    deleteMeasurement(projectId: string, documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/{documentNumber}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMeasurement(_response);
        });
    }

    protected processDeleteMeasurement(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocument(projectId: string, documentNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/{documentNumber}/Document";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getUsedReferences(projectId: string, cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/UsedReferences";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsedReferences(_response);
        });
    }

    protected processGetUsedReferences(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    duplicateMeasurement(projectId: string, command: DuplicateMeasurementCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/duplicate";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicateMeasurement(_response);
        });
    }

    protected processDuplicateMeasurement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    mergeMeasurement(projectId: string, command: MeasurementMergeCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/merge";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMergeMeasurement(_response);
        });
    }

    protected processMergeMeasurement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateMeasurementBasics(projectId: string, command: UpdateMeasurementBasicsCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/UpdateBasics";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMeasurementBasics(_response);
        });
    }

    protected processUpdateMeasurementBasics(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateMeasurement(timestamp: string | null | undefined, projectId: string, command: UpdateMeasurementCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/Update?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (timestamp !== undefined && timestamp !== null)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMeasurement(_response);
        });
    }

    protected processUpdateMeasurement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getNextMeasurementNumber(projectId: string, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Measurements/GetNextMeasurementNumber";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNextMeasurementNumber(_response);
        });
    }

    protected processGetNextMeasurementNumber(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IMeasuringStatesClient {
    getMeasuringStateForAgendaOverview(start: Date | undefined, end: Date | undefined, includeAll: boolean | undefined, searchValue: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined): Promise<LoadResultMapOfMeasuringStateForAgenda>;
    getMeasuringStatesForAgendaPopup(query: GetMeasuringStateForAgendaPopupQuery): Promise<MeasuringStateForAgenda[]>;
    calculateEndDateForAgenda(query: GenerateMeasuringStatePlanningEndDateCommand): Promise<Date>;
    get(projectId: string): Promise<MeasuringStateListItemDto[]>;
    getSingle(documentNumber: string, monthExecuted: Date | null | undefined): Promise<MeasuringStateDto>;
    remove(documentNumber: string): Promise<void>;
    getDocument(documentNumber: string): Promise<FileResponse>;
    generateDocument(documentNumber: string): Promise<FileResponse>;
    getRawMaterials(projectId: string, documentNumber: string): Promise<MeasuringStateRawMaterialUsageDto[]>;
    update(command: UpdateMeasuringStateCommand): Promise<void>;
    updateMeasuringStateType(command: UpdateMeasuringStateTypeCommand): Promise<void>;
    generate(command: GenerateMeasuringStateCommand): Promise<string>;
    generateFromMeasurement(command: GenerateMeasuringStateFromMeasurementCommand): Promise<string>;
    split(command: SplitMeasuringStateCommand): Promise<void>;
    merge(command: MergeMeasuringStateCommand): Promise<void>;
    setQualityChecked(documentNumber: string, qualityCheckedDate: Date): Promise<FileResponse>;
    listForFollowUp(query: ListForFollowUpQuery): Promise<ListForFollowUpLoadResultDto>;
    setMultipleQualityChecked(command: SetMultipleQualityCheckedCommand): Promise<FileResponse>;
    listProjectsToProgress(query: ListProjectsToProgressQuery): Promise<ListProjectsToProgressLoadResultDto>;
}

export class MeasuringStatesClient implements IMeasuringStatesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getMeasuringStateForAgendaOverview(start: Date | undefined, end: Date | undefined, includeAll: boolean | undefined, searchValue: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfMeasuringStateForAgenda> {
        let url_ = this.baseUrl + "/api/MeasuringStates/GetMeasuringStateForAgendaOverview?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (includeAll === null)
            throw new Error("The parameter 'includeAll' cannot be null.");
        else if (includeAll !== undefined)
            url_ += "includeAll=" + encodeURIComponent("" + includeAll) + "&";
        if (searchValue !== undefined && searchValue !== null)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requireTotalCount === null || requireTotalCount === undefined)
            throw new Error("The parameter 'requireTotalCount' cannot be null.");
        else
            content_.append("RequireTotalCount", requireTotalCount.toString());
        if (requireGroupCount === null || requireGroupCount === undefined)
            throw new Error("The parameter 'requireGroupCount' cannot be null.");
        else
            content_.append("RequireGroupCount", requireGroupCount.toString());
        if (isCountQuery === null || isCountQuery === undefined)
            throw new Error("The parameter 'isCountQuery' cannot be null.");
        else
            content_.append("IsCountQuery", isCountQuery.toString());
        if (skip === null || skip === undefined)
            throw new Error("The parameter 'skip' cannot be null.");
        else
            content_.append("Skip", skip.toString());
        if (take === null || take === undefined)
            throw new Error("The parameter 'take' cannot be null.");
        else
            content_.append("Take", take.toString());
        if (sort !== null && sort !== undefined)
            sort.forEach(item_ => content_.append("Sort", item_.toString()));
        if (group !== null && group !== undefined)
            group.forEach(item_ => content_.append("Group", item_.toString()));
        if (filter !== null && filter !== undefined)
            filter.forEach(item_ => content_.append("Filter", item_.toString()));
        if (totalSummary !== null && totalSummary !== undefined)
            totalSummary.forEach(item_ => content_.append("TotalSummary", item_.toString()));
        if (groupSummary !== null && groupSummary !== undefined)
            groupSummary.forEach(item_ => content_.append("GroupSummary", item_.toString()));
        if (select !== null && select !== undefined)
            select.forEach(item_ => content_.append("Select", item_.toString()));
        if (preSelect !== null && preSelect !== undefined)
            preSelect.forEach(item_ => content_.append("PreSelect", item_.toString()));
        if (remoteSelect !== null && remoteSelect !== undefined)
            content_.append("RemoteSelect", remoteSelect.toString());
        if (remoteGrouping !== null && remoteGrouping !== undefined)
            content_.append("RemoteGrouping", remoteGrouping.toString());
        if (expandLinqSumType !== null && expandLinqSumType !== undefined)
            content_.append("ExpandLinqSumType", expandLinqSumType.toString());
        if (primaryKey !== null && primaryKey !== undefined)
            primaryKey.forEach(item_ => content_.append("PrimaryKey", item_.toString()));
        if (defaultSort !== null && defaultSort !== undefined)
            content_.append("DefaultSort", defaultSort.toString());
        if (stringToLower !== null && stringToLower !== undefined)
            content_.append("StringToLower", stringToLower.toString());
        if (paginateViaPrimaryKey !== null && paginateViaPrimaryKey !== undefined)
            content_.append("PaginateViaPrimaryKey", paginateViaPrimaryKey.toString());
        if (sortByPrimaryKey !== null && sortByPrimaryKey !== undefined)
            content_.append("SortByPrimaryKey", sortByPrimaryKey.toString());
        if (allowAsyncOverSync === null || allowAsyncOverSync === undefined)
            throw new Error("The parameter 'allowAsyncOverSync' cannot be null.");
        else
            content_.append("AllowAsyncOverSync", allowAsyncOverSync.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeasuringStateForAgendaOverview(_response);
        });
    }

    protected processGetMeasuringStateForAgendaOverview(response: AxiosResponse): Promise<LoadResultMapOfMeasuringStateForAgenda> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfMeasuringStateForAgenda.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfMeasuringStateForAgenda>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfMeasuringStateForAgenda>(null as any);
    }

    getMeasuringStatesForAgendaPopup(query: GetMeasuringStateForAgendaPopupQuery, cancelToken?: CancelToken | undefined): Promise<MeasuringStateForAgenda[]> {
        let url_ = this.baseUrl + "/api/MeasuringStates/GetMeasuringStatesForAgendaPopup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeasuringStatesForAgendaPopup(_response);
        });
    }

    protected processGetMeasuringStatesForAgendaPopup(response: AxiosResponse): Promise<MeasuringStateForAgenda[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringStateForAgenda.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasuringStateForAgenda[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateForAgenda[]>(null as any);
    }

    calculateEndDateForAgenda(query: GenerateMeasuringStatePlanningEndDateCommand, cancelToken?: CancelToken | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/MeasuringStates/CalculateEndDateForAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateEndDateForAgenda(_response);
        });
    }

    protected processCalculateEndDateForAgenda(response: AxiosResponse): Promise<Date> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return Promise.resolve<Date>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date>(null as any);
    }

    get(projectId: string, cancelToken?: CancelToken | undefined): Promise<MeasuringStateListItemDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/measuringstates";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<MeasuringStateListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringStateListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasuringStateListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateListItemDto[]>(null as any);
    }

    getSingle(documentNumber: string, monthExecuted: Date | null | undefined, cancelToken?: CancelToken | undefined): Promise<MeasuringStateDto> {
        let url_ = this.baseUrl + "/api/MeasuringStates/{documentNumber}?";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        if (monthExecuted !== undefined && monthExecuted !== null)
            url_ += "monthExecuted=" + encodeURIComponent(monthExecuted ? "" + monthExecuted.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<MeasuringStateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateDto.fromJS(resultData200);
            return Promise.resolve<MeasuringStateDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateDto>(null as any);
    }

    remove(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeasuringStates/{documentNumber}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocument(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringStates/{documentNumber}/Document";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateDocument(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringStates/{documentNumber}/Document";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRawMaterials(projectId: string, documentNumber: string, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRawMaterialUsageDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/measuringstates/{documentNumber}/rawmaterials";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRawMaterials(_response);
        });
    }

    protected processGetRawMaterials(response: AxiosResponse): Promise<MeasuringStateRawMaterialUsageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringStateRawMaterialUsageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasuringStateRawMaterialUsageDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRawMaterialUsageDto[]>(null as any);
    }

    update(command: UpdateMeasuringStateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeasuringStates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateMeasuringStateType(command: UpdateMeasuringStateTypeCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeasuringStates/SetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMeasuringStateType(_response);
        });
    }

    protected processUpdateMeasuringStateType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generate(command: GenerateMeasuringStateCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/MeasuringStates/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    generateFromMeasurement(command: GenerateMeasuringStateFromMeasurementCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/MeasuringStates/Generate-from-measurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFromMeasurement(_response);
        });
    }

    protected processGenerateFromMeasurement(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    split(command: SplitMeasuringStateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeasuringStates/Split";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSplit(_response);
        });
    }

    protected processSplit(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    merge(command: MergeMeasuringStateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeasuringStates/Merge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setQualityChecked(documentNumber: string, qualityCheckedDate: Date, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringStates/{documentNumber}/SetQualityChecked";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qualityCheckedDate);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetQualityChecked(_response);
        });
    }

    protected processSetQualityChecked(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listForFollowUp(query: ListForFollowUpQuery, cancelToken?: CancelToken | undefined): Promise<ListForFollowUpLoadResultDto> {
        let url_ = this.baseUrl + "/api/MeasuringStates/ListForFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForFollowUp(_response);
        });
    }

    protected processListForFollowUp(response: AxiosResponse): Promise<ListForFollowUpLoadResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListForFollowUpLoadResultDto.fromJS(resultData200);
            return Promise.resolve<ListForFollowUpLoadResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListForFollowUpLoadResultDto>(null as any);
    }

    setMultipleQualityChecked(command: SetMultipleQualityCheckedCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringStates/SetMultipleQualityChecked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMultipleQualityChecked(_response);
        });
    }

    protected processSetMultipleQualityChecked(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    listProjectsToProgress(query: ListProjectsToProgressQuery, cancelToken?: CancelToken | undefined): Promise<ListProjectsToProgressLoadResultDto> {
        let url_ = this.baseUrl + "/api/MeasuringStates/ListProjectsToProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProjectsToProgress(_response);
        });
    }

    protected processListProjectsToProgress(response: AxiosResponse): Promise<ListProjectsToProgressLoadResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListProjectsToProgressLoadResultDto.fromJS(resultData200);
            return Promise.resolve<ListProjectsToProgressLoadResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListProjectsToProgressLoadResultDto>(null as any);
    }
}

export interface IMeasuringStatesRatingClient {
    getSingle(documentNumber: string, subcontractorId: string): Promise<MeasuringStateRatingItemInfoDto>;
    getAverageBySubcontractor(subcontractorId: string): Promise<MeasuringStateRatingAverageInfoDto>;
    create(command: CreateMeasuringStateRatingCommand): Promise<MeasuringStateRating>;
    update(id: string | null | undefined, command: UpdateMeasuringStateRatingCommand): Promise<MeasuringStateRating>;
    delete(command: DeleteMeasuringStateRatingCommand): Promise<MeasuringStateRating>;
}

export class MeasuringStatesRatingClient implements IMeasuringStatesRatingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getSingle(documentNumber: string, subcontractorId: string, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRatingItemInfoDto> {
        let url_ = this.baseUrl + "/api/MeasuringStatesRating/{documentNumber}/{subcontractorId}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        if (subcontractorId === undefined || subcontractorId === null)
            throw new Error("The parameter 'subcontractorId' must be defined.");
        url_ = url_.replace("{subcontractorId}", encodeURIComponent("" + subcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<MeasuringStateRatingItemInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateRatingItemInfoDto.fromJS(resultData200);
            return Promise.resolve<MeasuringStateRatingItemInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRatingItemInfoDto>(null as any);
    }

    getAverageBySubcontractor(subcontractorId: string, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRatingAverageInfoDto> {
        let url_ = this.baseUrl + "/api/MeasuringStatesRating/{subcontractorId}";
        if (subcontractorId === undefined || subcontractorId === null)
            throw new Error("The parameter 'subcontractorId' must be defined.");
        url_ = url_.replace("{subcontractorId}", encodeURIComponent("" + subcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAverageBySubcontractor(_response);
        });
    }

    protected processGetAverageBySubcontractor(response: AxiosResponse): Promise<MeasuringStateRatingAverageInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateRatingAverageInfoDto.fromJS(resultData200);
            return Promise.resolve<MeasuringStateRatingAverageInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRatingAverageInfoDto>(null as any);
    }

    create(command: CreateMeasuringStateRatingCommand, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRating> {
        let url_ = this.baseUrl + "/api/MeasuringStatesRating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<MeasuringStateRating> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateRating.fromJS(resultData200);
            return Promise.resolve<MeasuringStateRating>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRating>(null as any);
    }

    update(id: string | null | undefined, command: UpdateMeasuringStateRatingCommand, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRating> {
        let url_ = this.baseUrl + "/api/MeasuringStatesRating?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<MeasuringStateRating> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateRating.fromJS(resultData200);
            return Promise.resolve<MeasuringStateRating>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRating>(null as any);
    }

    delete(command: DeleteMeasuringStateRatingCommand, cancelToken?: CancelToken | undefined): Promise<MeasuringStateRating> {
        let url_ = this.baseUrl + "/api/MeasuringStatesRating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<MeasuringStateRating> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeasuringStateRating.fromJS(resultData200);
            return Promise.resolve<MeasuringStateRating>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringStateRating>(null as any);
    }
}

export interface IProgressStatementsClient {
    getFromProject(projectId: string): Promise<ProgressStatementListItemDto[]>;
    create(projectId: string): Promise<string>;
    getSingle(documentNumber: string, projectId: string | null | undefined): Promise<ProgressStatementDto>;
    update(documentNumber: string, command: UpdateProgressStatementCommand): Promise<void>;
    delete(documentNumber: string, projectId: string | null | undefined): Promise<void>;
    getDocument(documentNumber: string): Promise<FileResponse>;
    generateDocument(documentNumber: string, command: GenerateProgressStatementDocumentCommand): Promise<FileResponse>;
    export(command: ExportProgressStatementCommand): Promise<FileResponse>;
    exportPdf(command: ExportPdfProgressStatementCommand): Promise<FileResponse>;
    getProjectData(documentNumber: string, projectId: string | null | undefined): Promise<ProgressStatementSelectionDataDto[]>;
    addData(documentNumber: string, command: AddProgressStatementDataCommand): Promise<void>;
    mail(command: MailProgressStatementCommand): Promise<void>;
    getForInvoice(query: GetProgressStatementsForInvoiceQuery): Promise<ProgressStatementListItemDto[]>;
    listForFollowUp(query: ListProgressStatementsForFollowUpQuery): Promise<ListProgressStatementForFollowUpLoadResultDto>;
    setStatus(command: SetProgressStatementStatusCommand): Promise<FileResponse>;
}

export class ProgressStatementsClient implements IProgressStatementsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getFromProject(projectId: string, cancelToken?: CancelToken | undefined): Promise<ProgressStatementListItemDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/ProgressStatements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromProject(_response);
        });
    }

    protected processGetFromProject(response: AxiosResponse): Promise<ProgressStatementListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgressStatementListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgressStatementListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressStatementListItemDto[]>(null as any);
    }

    create(projectId: string, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/ProgressStatements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSingle(documentNumber: string, projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ProgressStatementDto> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}?";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<ProgressStatementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgressStatementDto.fromJS(resultData200);
            return Promise.resolve<ProgressStatementDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressStatementDto>(null as any);
    }

    update(documentNumber: string, command: UpdateProgressStatementCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(documentNumber: string, projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}?";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocument(documentNumber: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}/Document";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateDocument(documentNumber: string, command: GenerateProgressStatementDocumentCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}/Document";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(command: ExportProgressStatementCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProgressStatements/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportPdf(command: ExportPdfProgressStatementCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProgressStatements/ExportPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPdf(_response);
        });
    }

    protected processExportPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProjectData(documentNumber: string, projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ProgressStatementSelectionDataDto[]> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}/ProjectData?";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectData(_response);
        });
    }

    protected processGetProjectData(response: AxiosResponse): Promise<ProgressStatementSelectionDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgressStatementSelectionDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgressStatementSelectionDataDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressStatementSelectionDataDto[]>(null as any);
    }

    addData(documentNumber: string, command: AddProgressStatementDataCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ProgressStatements/{documentNumber}/ProjectData";
        if (documentNumber === undefined || documentNumber === null)
            throw new Error("The parameter 'documentNumber' must be defined.");
        url_ = url_.replace("{documentNumber}", encodeURIComponent("" + documentNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddData(_response);
        });
    }

    protected processAddData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    mail(command: MailProgressStatementCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ProgressStatements/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getForInvoice(query: GetProgressStatementsForInvoiceQuery, cancelToken?: CancelToken | undefined): Promise<ProgressStatementListItemDto[]> {
        let url_ = this.baseUrl + "/api/ProgressStatements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForInvoice(_response);
        });
    }

    protected processGetForInvoice(response: AxiosResponse): Promise<ProgressStatementListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgressStatementListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProgressStatementListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgressStatementListItemDto[]>(null as any);
    }

    listForFollowUp(query: ListProgressStatementsForFollowUpQuery, cancelToken?: CancelToken | undefined): Promise<ListProgressStatementForFollowUpLoadResultDto> {
        let url_ = this.baseUrl + "/api/ProgressStatements/ListForFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListForFollowUp(_response);
        });
    }

    protected processListForFollowUp(response: AxiosResponse): Promise<ListProgressStatementForFollowUpLoadResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListProgressStatementForFollowUpLoadResultDto.fromJS(resultData200);
            return Promise.resolve<ListProgressStatementForFollowUpLoadResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListProgressStatementForFollowUpLoadResultDto>(null as any);
    }

    setStatus(command: SetProgressStatementStatusCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProgressStatements/SetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStatus(_response);
        });
    }

    protected processSetStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProjectContactsClient {
    getContacts(projectId: string): Promise<ProjectContactDto[]>;
    addOrUpdateContact(projectId: string, command: ProjectAddOrUpdateContactCommand): Promise<ProjectContactDto>;
    removeContact(projectId: string, contactId: string): Promise<void>;
}

export class ProjectContactsClient implements IProjectContactsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getContacts(projectId: string, cancelToken?: CancelToken | undefined): Promise<ProjectContactDto[]> {
        let url_ = this.baseUrl + "/api/V2/Project/{projectId}/contacts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContacts(_response);
        });
    }

    protected processGetContacts(response: AxiosResponse): Promise<ProjectContactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectContactDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectContactDto[]>(null as any);
    }

    addOrUpdateContact(projectId: string, command: ProjectAddOrUpdateContactCommand, cancelToken?: CancelToken | undefined): Promise<ProjectContactDto> {
        let url_ = this.baseUrl + "/api/V2/Project/{projectId}/contacts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateContact(_response);
        });
    }

    protected processAddOrUpdateContact(response: AxiosResponse): Promise<ProjectContactDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectContactDto.fromJS(resultData200);
            return Promise.resolve<ProjectContactDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectContactDto>(null as any);
    }

    removeContact(projectId: string, contactId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/V2/Project/{projectId}/contacts/{contactId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveContact(_response);
        });
    }

    protected processRemoveContact(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectOutlookPluginClient {
    getProjects(): Promise<ProjectForOutlookPlugin[]>;
    searchProjects(search: string | null | undefined, limit: number | null | undefined): Promise<ProjectForOutlookPlugin[]>;
    postEmail(projectId: string | null | undefined, communication: Communication): Promise<FileResponse>;
}

export class ProjectOutlookPluginClient implements IProjectOutlookPluginClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getProjects( cancelToken?: CancelToken | undefined): Promise<ProjectForOutlookPlugin[]> {
        let url_ = this.baseUrl + "/api/ProjectOutlookPlugin/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<ProjectForOutlookPlugin[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectForOutlookPlugin.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectForOutlookPlugin[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectForOutlookPlugin[]>(null as any);
    }

    searchProjects(search: string | null | undefined, limit: number | null | undefined, cancelToken?: CancelToken | undefined): Promise<ProjectForOutlookPlugin[]> {
        let url_ = this.baseUrl + "/api/ProjectOutlookPlugin/SearchProjects?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProjects(_response);
        });
    }

    protected processSearchProjects(response: AxiosResponse): Promise<ProjectForOutlookPlugin[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectForOutlookPlugin.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectForOutlookPlugin[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectForOutlookPlugin[]>(null as any);
    }

    postEmail(projectId: string | null | undefined, communication: Communication, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectOutlookPlugin/PostEmail?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communication);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostEmail(_response);
        });
    }

    protected processPostEmail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProjectReportsClient {
    getAll(projectId: string, includeTemplates: boolean): Promise<ProjectReportsVm>;
    manualSyncOnenote(projectId: string, command: ManualSyncOnenoteCommand): Promise<Date>;
    create(projectId: string, command: CreateProjectReportCommand): Promise<ProjectReport>;
    update(projectId: string, command: UpdateProjectReportCommand): Promise<ProjectReport>;
    delete(projectId: string, pageId: string): Promise<void>;
}

export class ProjectReportsClient implements IProjectReportsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll(projectId: string, includeTemplates: boolean, cancelToken?: CancelToken | undefined): Promise<ProjectReportsVm> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Reports/{includeTemplates}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (includeTemplates === undefined || includeTemplates === null)
            throw new Error("The parameter 'includeTemplates' must be defined.");
        url_ = url_.replace("{includeTemplates}", encodeURIComponent("" + includeTemplates));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProjectReportsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectReportsVm.fromJS(resultData200);
            return Promise.resolve<ProjectReportsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectReportsVm>(null as any);
    }

    manualSyncOnenote(projectId: string, command: ManualSyncOnenoteCommand, cancelToken?: CancelToken | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Reports/ManualSyncOnenote";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManualSyncOnenote(_response);
        });
    }

    protected processManualSyncOnenote(response: AxiosResponse): Promise<Date> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return Promise.resolve<Date>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date>(null as any);
    }

    create(projectId: string, command: CreateProjectReportCommand, cancelToken?: CancelToken | undefined): Promise<ProjectReport> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Reports";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ProjectReport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectReport.fromJS(resultData200);
            return Promise.resolve<ProjectReport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectReport>(null as any);
    }

    update(projectId: string, command: UpdateProjectReportCommand, cancelToken?: CancelToken | undefined): Promise<ProjectReport> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Reports";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProjectReport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectReport.fromJS(resultData200);
            return Promise.resolve<ProjectReport>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectReport>(null as any);
    }

    delete(projectId: string, pageId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/Reports/{pageId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectsClient {
    getResyncProjects(): Promise<FileResponse>;
    getProjectBasicInfo(id: string): Promise<ProjectBasicInfoDto>;
    lookupProjects(query: ProjectsLookupQuery): Promise<LoadResultMapOfProjectListItemDto>;
    designMaterialOrder(query: GetMaterialOrderDesignInfoQuery): Promise<MaterialOrderDesignInfoDto[]>;
    getMatchingProjects(addressLine1: string | null | undefined, zip: string | null | undefined): Promise<Project[]>;
    getProjectsForAgenda(): Promise<ProjectForPlanningViewModel[]>;
    getProjectsContacts(id: string): Promise<AssignedContact[]>;
    getAllProjectContacts(query: GetAllProjectContactsQuery): Promise<LoadResultMapOfContactBasicInformation>;
    getUsedCodes(id: string): Promise<string[]>;
    getPurchaseOverview(query: GetProjectPurchaseOverviewQuery): Promise<ProjectPurchaseOverviewDto>;
    postProject(command: ProjectCreateCommand): Promise<Project>;
    update(id: string, command: ProjectUpdateCommand): Promise<void>;
    setLocation(id: string, command: ProjectLocationUpdateCommand): Promise<void>;
    processZip(query: ProcessZipCommand): Promise<FileResponse>;
    sendZipData(query: MailFichesZipCommand): Promise<FileResponse>;
    getTemplateCompanyPrefixes(): Promise<TemplateCompanyPrefixDto[]>;
    toggleProjectOnHold(id: string, reason: string): Promise<FileResponse>;
}

export class ProjectsClient implements IProjectsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getResyncProjects( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/Projects/ResyncProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResyncProjects(_response);
        });
    }

    protected processGetResyncProjects(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProjectBasicInfo(id: string, cancelToken?: CancelToken | undefined): Promise<ProjectBasicInfoDto> {
        let url_ = this.baseUrl + "/api/v2/Projects/{id}/BasicInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectBasicInfo(_response);
        });
    }

    protected processGetProjectBasicInfo(response: AxiosResponse): Promise<ProjectBasicInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectBasicInfoDto.fromJS(resultData200);
            return Promise.resolve<ProjectBasicInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectBasicInfoDto>(null as any);
    }

    lookupProjects(query: ProjectsLookupQuery, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfProjectListItemDto> {
        let url_ = this.baseUrl + "/api/V2/Projects/lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupProjects(_response);
        });
    }

    protected processLookupProjects(response: AxiosResponse): Promise<LoadResultMapOfProjectListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfProjectListItemDto.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfProjectListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfProjectListItemDto>(null as any);
    }

    designMaterialOrder(query: GetMaterialOrderDesignInfoQuery, cancelToken?: CancelToken | undefined): Promise<MaterialOrderDesignInfoDto[]> {
        let url_ = this.baseUrl + "/api/v2/Projects/DesignMaterialOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDesignMaterialOrder(_response);
        });
    }

    protected processDesignMaterialOrder(response: AxiosResponse): Promise<MaterialOrderDesignInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialOrderDesignInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MaterialOrderDesignInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaterialOrderDesignInfoDto[]>(null as any);
    }

    getMatchingProjects(addressLine1: string | null | undefined, zip: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<Project[]> {
        let url_ = this.baseUrl + "/api/Projects/get-matching?";
        if (addressLine1 !== undefined && addressLine1 !== null)
            url_ += "AddressLine1=" + encodeURIComponent("" + addressLine1) + "&";
        if (zip !== undefined && zip !== null)
            url_ += "Zip=" + encodeURIComponent("" + zip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMatchingProjects(_response);
        });
    }

    protected processGetMatchingProjects(response: AxiosResponse): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Project.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Project[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project[]>(null as any);
    }

    getProjectsForAgenda( cancelToken?: CancelToken | undefined): Promise<ProjectForPlanningViewModel[]> {
        let url_ = this.baseUrl + "/api/Projects/GetProjectsForAgenda";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForAgenda(_response);
        });
    }

    protected processGetProjectsForAgenda(response: AxiosResponse): Promise<ProjectForPlanningViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectForPlanningViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectForPlanningViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectForPlanningViewModel[]>(null as any);
    }

    getProjectsContacts(id: string, cancelToken?: CancelToken | undefined): Promise<AssignedContact[]> {
        let url_ = this.baseUrl + "/api/Projects/{id}/Contacts";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsContacts(_response);
        });
    }

    protected processGetProjectsContacts(response: AxiosResponse): Promise<AssignedContact[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignedContact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssignedContact[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssignedContact[]>(null as any);
    }

    getAllProjectContacts(query: GetAllProjectContactsQuery, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfContactBasicInformation> {
        let url_ = this.baseUrl + "/api/Projects/Contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProjectContacts(_response);
        });
    }

    protected processGetAllProjectContacts(response: AxiosResponse): Promise<LoadResultMapOfContactBasicInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfContactBasicInformation.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfContactBasicInformation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfContactBasicInformation>(null as any);
    }

    getUsedCodes(id: string, cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Projects/{id}/Codes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsedCodes(_response);
        });
    }

    protected processGetUsedCodes(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getPurchaseOverview(query: GetProjectPurchaseOverviewQuery, cancelToken?: CancelToken | undefined): Promise<ProjectPurchaseOverviewDto> {
        let url_ = this.baseUrl + "/api/Projects/PurchaseOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPurchaseOverview(_response);
        });
    }

    protected processGetPurchaseOverview(response: AxiosResponse): Promise<ProjectPurchaseOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectPurchaseOverviewDto.fromJS(resultData200);
            return Promise.resolve<ProjectPurchaseOverviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectPurchaseOverviewDto>(null as any);
    }

    postProject(command: ProjectCreateCommand, cancelToken?: CancelToken | undefined): Promise<Project> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostProject(_response);
        });
    }

    protected processPostProject(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    update(id: string, command: ProjectUpdateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setLocation(id: string, command: ProjectLocationUpdateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{id}/Location";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetLocation(_response);
        });
    }

    protected processSetLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    processZip(query: ProcessZipCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/processZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessZip(_response);
        });
    }

    protected processProcessZip(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendZipData(query: MailFichesZipCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/sendZipData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendZipData(_response);
        });
    }

    protected processSendZipData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplateCompanyPrefixes( cancelToken?: CancelToken | undefined): Promise<TemplateCompanyPrefixDto[]> {
        let url_ = this.baseUrl + "/api/Projects/GetTemplateCompanyPrefixes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateCompanyPrefixes(_response);
        });
    }

    protected processGetTemplateCompanyPrefixes(response: AxiosResponse): Promise<TemplateCompanyPrefixDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateCompanyPrefixDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateCompanyPrefixDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateCompanyPrefixDto[]>(null as any);
    }

    toggleProjectOnHold(id: string, reason: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{id}/ToggleProjectOnHold";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reason);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleProjectOnHold(_response);
        });
    }

    protected processToggleProjectOnHold(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IPlanningsClient {
    lookupProjects(statusId: number | undefined, workType: string | null | undefined, subcontractorId: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined): Promise<FileResponse>;
    getProjectProgression(projectId: string | null | undefined): Promise<ProjectProgressionDto>;
    getSingleAgendaItemForEdit(query: GetSinglePlanningAgendaItemForEditQuery): Promise<PlanningAgendaItem>;
    getAgendaItems(query: GetPlanningAgendaItemsQuery): Promise<PlanningAgendaItemForAgenda[]>;
    getAgendaItemsForProgressMode(query: GetPlanningItemsForProgressModeQuery): Promise<PlanningItemForProgressMode[]>;
    createAgendaItem(command: CreatePlanningAgendaItemCommand): Promise<FileResponse>;
    updateAgendaItem(command: UpdatePlanningAgendaItemCommand): Promise<FileResponse>;
    updateAgendaItemByDrop(command: UpdatePlanningAgendaItemByDropCommand): Promise<FileResponse>;
    deleteAgendaItem(command: DeletePlanningAgendaItemCommand): Promise<FileResponse>;
}

export class PlanningsClient implements IPlanningsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    lookupProjects(statusId: number | undefined, workType: string | null | undefined, subcontractorId: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Plannings/lookup?";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (workType !== undefined && workType !== null)
            url_ += "workType=" + encodeURIComponent("" + workType) + "&";
        if (subcontractorId !== undefined && subcontractorId !== null)
            url_ += "subcontractorId=" + encodeURIComponent("" + subcontractorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requireTotalCount === null || requireTotalCount === undefined)
            throw new Error("The parameter 'requireTotalCount' cannot be null.");
        else
            content_.append("RequireTotalCount", requireTotalCount.toString());
        if (requireGroupCount === null || requireGroupCount === undefined)
            throw new Error("The parameter 'requireGroupCount' cannot be null.");
        else
            content_.append("RequireGroupCount", requireGroupCount.toString());
        if (isCountQuery === null || isCountQuery === undefined)
            throw new Error("The parameter 'isCountQuery' cannot be null.");
        else
            content_.append("IsCountQuery", isCountQuery.toString());
        if (skip === null || skip === undefined)
            throw new Error("The parameter 'skip' cannot be null.");
        else
            content_.append("Skip", skip.toString());
        if (take === null || take === undefined)
            throw new Error("The parameter 'take' cannot be null.");
        else
            content_.append("Take", take.toString());
        if (sort !== null && sort !== undefined)
            sort.forEach(item_ => content_.append("Sort", item_.toString()));
        if (group !== null && group !== undefined)
            group.forEach(item_ => content_.append("Group", item_.toString()));
        if (filter !== null && filter !== undefined)
            filter.forEach(item_ => content_.append("Filter", item_.toString()));
        if (totalSummary !== null && totalSummary !== undefined)
            totalSummary.forEach(item_ => content_.append("TotalSummary", item_.toString()));
        if (groupSummary !== null && groupSummary !== undefined)
            groupSummary.forEach(item_ => content_.append("GroupSummary", item_.toString()));
        if (select !== null && select !== undefined)
            select.forEach(item_ => content_.append("Select", item_.toString()));
        if (preSelect !== null && preSelect !== undefined)
            preSelect.forEach(item_ => content_.append("PreSelect", item_.toString()));
        if (remoteSelect !== null && remoteSelect !== undefined)
            content_.append("RemoteSelect", remoteSelect.toString());
        if (remoteGrouping !== null && remoteGrouping !== undefined)
            content_.append("RemoteGrouping", remoteGrouping.toString());
        if (expandLinqSumType !== null && expandLinqSumType !== undefined)
            content_.append("ExpandLinqSumType", expandLinqSumType.toString());
        if (primaryKey !== null && primaryKey !== undefined)
            primaryKey.forEach(item_ => content_.append("PrimaryKey", item_.toString()));
        if (defaultSort !== null && defaultSort !== undefined)
            content_.append("DefaultSort", defaultSort.toString());
        if (stringToLower !== null && stringToLower !== undefined)
            content_.append("StringToLower", stringToLower.toString());
        if (paginateViaPrimaryKey !== null && paginateViaPrimaryKey !== undefined)
            content_.append("PaginateViaPrimaryKey", paginateViaPrimaryKey.toString());
        if (sortByPrimaryKey !== null && sortByPrimaryKey !== undefined)
            content_.append("SortByPrimaryKey", sortByPrimaryKey.toString());
        if (allowAsyncOverSync === null || allowAsyncOverSync === undefined)
            throw new Error("The parameter 'allowAsyncOverSync' cannot be null.");
        else
            content_.append("AllowAsyncOverSync", allowAsyncOverSync.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupProjects(_response);
        });
    }

    protected processLookupProjects(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProjectProgression(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<ProjectProgressionDto> {
        let url_ = this.baseUrl + "/api/Plannings/GetProjectProgression?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectProgression(_response);
        });
    }

    protected processGetProjectProgression(response: AxiosResponse): Promise<ProjectProgressionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectProgressionDto.fromJS(resultData200);
            return Promise.resolve<ProjectProgressionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectProgressionDto>(null as any);
    }

    getSingleAgendaItemForEdit(query: GetSinglePlanningAgendaItemForEditQuery, cancelToken?: CancelToken | undefined): Promise<PlanningAgendaItem> {
        let url_ = this.baseUrl + "/api/Plannings/GetSingleAgendaItemForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleAgendaItemForEdit(_response);
        });
    }

    protected processGetSingleAgendaItemForEdit(response: AxiosResponse): Promise<PlanningAgendaItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PlanningAgendaItem.fromJS(resultData200);
            return Promise.resolve<PlanningAgendaItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanningAgendaItem>(null as any);
    }

    getAgendaItems(query: GetPlanningAgendaItemsQuery, cancelToken?: CancelToken | undefined): Promise<PlanningAgendaItemForAgenda[]> {
        let url_ = this.baseUrl + "/api/Plannings/GetAgendaItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgendaItems(_response);
        });
    }

    protected processGetAgendaItems(response: AxiosResponse): Promise<PlanningAgendaItemForAgenda[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanningAgendaItemForAgenda.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PlanningAgendaItemForAgenda[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanningAgendaItemForAgenda[]>(null as any);
    }

    getAgendaItemsForProgressMode(query: GetPlanningItemsForProgressModeQuery, cancelToken?: CancelToken | undefined): Promise<PlanningItemForProgressMode[]> {
        let url_ = this.baseUrl + "/api/Plannings/GetAgendaItemsForProgressMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgendaItemsForProgressMode(_response);
        });
    }

    protected processGetAgendaItemsForProgressMode(response: AxiosResponse): Promise<PlanningItemForProgressMode[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanningItemForProgressMode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PlanningItemForProgressMode[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PlanningItemForProgressMode[]>(null as any);
    }

    createAgendaItem(command: CreatePlanningAgendaItemCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Plannings/CreateAgendaItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAgendaItem(_response);
        });
    }

    protected processCreateAgendaItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateAgendaItem(command: UpdatePlanningAgendaItemCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Plannings/UpdateAgendaItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAgendaItem(_response);
        });
    }

    protected processUpdateAgendaItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateAgendaItemByDrop(command: UpdatePlanningAgendaItemByDropCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Plannings/UpdateAgendaItemByDrop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAgendaItemByDrop(_response);
        });
    }

    protected processUpdateAgendaItemByDrop(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteAgendaItem(command: DeletePlanningAgendaItemCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Plannings/DeleteAgendaItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAgendaItem(_response);
        });
    }

    protected processDeleteAgendaItem(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IMailsClient {
    sendMail(command: SendMailCommand): Promise<void>;
}

export class MailsClient implements IMailsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    sendMail(command: SendMailCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Mails/send-mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMail(_response);
        });
    }

    protected processSendMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICreditNotesClient {
    lookup(query: CreditNotesLookupQuery): Promise<LoadResultMapOfCreditNoteListItemDto>;
    getSingle(id: string): Promise<CreditNoteDto>;
    update(id: string, command: UpdateCreditNoteCommand): Promise<void>;
    remove(id: string): Promise<void>;
    download(id: string): Promise<FileResponse>;
    generateDocument(id: string, command: GenerateCreditNoteDocumentCommand): Promise<FileResponse>;
    create(command: CreateCreditNoteCommand): Promise<string>;
    mail(command: MailCreditNoteCommand): Promise<void>;
    sendToAccountant(command: SendCreditNotesToAccountantCommand): Promise<FileResponse>;
}

export class CreditNotesClient implements ICreditNotesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    lookup(query: CreditNotesLookupQuery, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfCreditNoteListItemDto> {
        let url_ = this.baseUrl + "/api/CreditNotes/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<LoadResultMapOfCreditNoteListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfCreditNoteListItemDto.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfCreditNoteListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfCreditNoteListItemDto>(null as any);
    }

    getSingle(id: string, cancelToken?: CancelToken | undefined): Promise<CreditNoteDto> {
        let url_ = this.baseUrl + "/api/CreditNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<CreditNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreditNoteDto.fromJS(resultData200);
            return Promise.resolve<CreditNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditNoteDto>(null as any);
    }

    update(id: string, command: UpdateCreditNoteCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CreditNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    remove(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CreditNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    download(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CreditNotes/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateDocument(id: string, command: GenerateCreditNoteDocumentCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CreditNotes/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(command: CreateCreditNoteCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/CreditNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    mail(command: MailCreditNoteCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CreditNotes/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendToAccountant(command: SendCreditNotesToAccountantCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/CreditNotes/SendToAccountant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendToAccountant(_response);
        });
    }

    protected processSendToAccountant(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IInvoicesClient {
    getUnprocessedAdvanced(projectId: string | null | undefined): Promise<InvoiceListItemDto[]>;
    getInvoicesRappels(query: GetInvoicesForRappelsQuery): Promise<InvoiceListItemDto[]>;
    getStats(projectId: string | null | undefined): Promise<InvoiceStatsDto>;
    getInvoice(id: string): Promise<InvoiceDto>;
    update(id: string, command: InvoiceUpdateCommand): Promise<void>;
    remove(id: string): Promise<void>;
    getDocument(id: string): Promise<FileResponse>;
    generateDocument(id: string, command: GenerateInvoiceDocumentCommand): Promise<FileResponse>;
    generateInvoiceFromQuotations(command: GenerateInvoiceFromQuotationsCommand): Promise<string>;
    generateAdvancedInvoice(command: GenerateAdvancedInvoiceCommand): Promise<string>;
    generateFromProgressStatements(command: GenerateInvoiceFromProgressStatementsCommand): Promise<string>;
    generateFromMeasuringState(command: GenerateInvoiceFromMeasuringStatesCommand): Promise<string>;
    create(projectId: string | null | undefined): Promise<string>;
    publish(id: string): Promise<InvoiceDto>;
    paid(command: InvoicePaidCommand): Promise<PaymentDto>;
    mail(command: MailInvoiceCommand): Promise<void>;
    paymentLookUp(invoiceId: string | null | undefined, projectId: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined): Promise<FileResponse>;
    getPayment(id: string): Promise<PaymentDto>;
    removePayment(id: string): Promise<void>;
    editPaid(command: EditInvoicePaidCommand): Promise<PaymentDto>;
    sendToAccountant(command: SendInvoicesToAccountantCommand): Promise<FileResponse>;
    getInvoiceCanBeRemoved(id: string | null | undefined): Promise<boolean>;
}

export class InvoicesClient implements IInvoicesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getUnprocessedAdvanced(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<InvoiceListItemDto[]> {
        let url_ = this.baseUrl + "/api/Invoices/advanced?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnprocessedAdvanced(_response);
        });
    }

    protected processGetUnprocessedAdvanced(response: AxiosResponse): Promise<InvoiceListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceListItemDto[]>(null as any);
    }

    getInvoicesRappels(query: GetInvoicesForRappelsQuery, cancelToken?: CancelToken | undefined): Promise<InvoiceListItemDto[]> {
        let url_ = this.baseUrl + "/api/Invoices/rappels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicesRappels(_response);
        });
    }

    protected processGetInvoicesRappels(response: AxiosResponse): Promise<InvoiceListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoiceListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceListItemDto[]>(null as any);
    }

    getStats(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<InvoiceStatsDto> {
        let url_ = this.baseUrl + "/api/Invoices/stats?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStats(_response);
        });
    }

    protected processGetStats(response: AxiosResponse): Promise<InvoiceStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceStatsDto.fromJS(resultData200);
            return Promise.resolve<InvoiceStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceStatsDto>(null as any);
    }

    getInvoice(id: string, cancelToken?: CancelToken | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDto.fromJS(resultData200);
            return Promise.resolve<InvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    update(id: string, command: InvoiceUpdateCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Invoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    remove(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Invoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDocument(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoices/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateDocument(id: string, command: GenerateInvoiceDocumentCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoices/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateInvoiceFromQuotations(command: GenerateInvoiceFromQuotationsCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Invoices/Generate/FromQuotations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateInvoiceFromQuotations(_response);
        });
    }

    protected processGenerateInvoiceFromQuotations(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    generateAdvancedInvoice(command: GenerateAdvancedInvoiceCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Invoices/Generate/FromQuotationsAdvanced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateAdvancedInvoice(_response);
        });
    }

    protected processGenerateAdvancedInvoice(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    generateFromProgressStatements(command: GenerateInvoiceFromProgressStatementsCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Invoices/Generate/FromProgressStatements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFromProgressStatements(_response);
        });
    }

    protected processGenerateFromProgressStatements(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    generateFromMeasuringState(command: GenerateInvoiceFromMeasuringStatesCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Invoices/Generate/FromMeasuringState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateFromMeasuringState(_response);
        });
    }

    protected processGenerateFromMeasuringState(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    create(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Invoices?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    publish(id: string, cancelToken?: CancelToken | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/Invoices/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDto.fromJS(resultData200);
            return Promise.resolve<InvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    paid(command: InvoicePaidCommand, cancelToken?: CancelToken | undefined): Promise<PaymentDto> {
        let url_ = this.baseUrl + "/api/Invoices/Paid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaid(_response);
        });
    }

    protected processPaid(response: AxiosResponse): Promise<PaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentDto.fromJS(resultData200);
            return Promise.resolve<PaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentDto>(null as any);
    }

    mail(command: MailInvoiceCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Invoices/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    paymentLookUp(invoiceId: string | null | undefined, projectId: string | null | undefined, requireTotalCount: boolean | undefined, requireGroupCount: boolean | undefined, isCountQuery: boolean | undefined, skip: number | undefined, take: number | undefined, sort: SortingInfo[] | null | undefined, group: GroupingInfo[] | null | undefined, filter: any[] | null | undefined, totalSummary: SummaryInfo[] | null | undefined, groupSummary: SummaryInfo[] | null | undefined, select: string[] | null | undefined, preSelect: string[] | null | undefined, remoteSelect: boolean | null | undefined, remoteGrouping: boolean | null | undefined, expandLinqSumType: boolean | null | undefined, primaryKey: string[] | null | undefined, defaultSort: string | null | undefined, stringToLower: boolean | null | undefined, paginateViaPrimaryKey: boolean | null | undefined, sortByPrimaryKey: boolean | null | undefined, allowAsyncOverSync: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoices/PaymentLookUp?";
        if (invoiceId !== undefined && invoiceId !== null)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (requireTotalCount === null || requireTotalCount === undefined)
            throw new Error("The parameter 'requireTotalCount' cannot be null.");
        else
            content_.append("RequireTotalCount", requireTotalCount.toString());
        if (requireGroupCount === null || requireGroupCount === undefined)
            throw new Error("The parameter 'requireGroupCount' cannot be null.");
        else
            content_.append("RequireGroupCount", requireGroupCount.toString());
        if (isCountQuery === null || isCountQuery === undefined)
            throw new Error("The parameter 'isCountQuery' cannot be null.");
        else
            content_.append("IsCountQuery", isCountQuery.toString());
        if (skip === null || skip === undefined)
            throw new Error("The parameter 'skip' cannot be null.");
        else
            content_.append("Skip", skip.toString());
        if (take === null || take === undefined)
            throw new Error("The parameter 'take' cannot be null.");
        else
            content_.append("Take", take.toString());
        if (sort !== null && sort !== undefined)
            sort.forEach(item_ => content_.append("Sort", item_.toString()));
        if (group !== null && group !== undefined)
            group.forEach(item_ => content_.append("Group", item_.toString()));
        if (filter !== null && filter !== undefined)
            filter.forEach(item_ => content_.append("Filter", item_.toString()));
        if (totalSummary !== null && totalSummary !== undefined)
            totalSummary.forEach(item_ => content_.append("TotalSummary", item_.toString()));
        if (groupSummary !== null && groupSummary !== undefined)
            groupSummary.forEach(item_ => content_.append("GroupSummary", item_.toString()));
        if (select !== null && select !== undefined)
            select.forEach(item_ => content_.append("Select", item_.toString()));
        if (preSelect !== null && preSelect !== undefined)
            preSelect.forEach(item_ => content_.append("PreSelect", item_.toString()));
        if (remoteSelect !== null && remoteSelect !== undefined)
            content_.append("RemoteSelect", remoteSelect.toString());
        if (remoteGrouping !== null && remoteGrouping !== undefined)
            content_.append("RemoteGrouping", remoteGrouping.toString());
        if (expandLinqSumType !== null && expandLinqSumType !== undefined)
            content_.append("ExpandLinqSumType", expandLinqSumType.toString());
        if (primaryKey !== null && primaryKey !== undefined)
            primaryKey.forEach(item_ => content_.append("PrimaryKey", item_.toString()));
        if (defaultSort !== null && defaultSort !== undefined)
            content_.append("DefaultSort", defaultSort.toString());
        if (stringToLower !== null && stringToLower !== undefined)
            content_.append("StringToLower", stringToLower.toString());
        if (paginateViaPrimaryKey !== null && paginateViaPrimaryKey !== undefined)
            content_.append("PaginateViaPrimaryKey", paginateViaPrimaryKey.toString());
        if (sortByPrimaryKey !== null && sortByPrimaryKey !== undefined)
            content_.append("SortByPrimaryKey", sortByPrimaryKey.toString());
        if (allowAsyncOverSync === null || allowAsyncOverSync === undefined)
            throw new Error("The parameter 'allowAsyncOverSync' cannot be null.");
        else
            content_.append("AllowAsyncOverSync", allowAsyncOverSync.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymentLookUp(_response);
        });
    }

    protected processPaymentLookUp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPayment(id: string, cancelToken?: CancelToken | undefined): Promise<PaymentDto> {
        let url_ = this.baseUrl + "/api/Invoices/Payment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayment(_response);
        });
    }

    protected processGetPayment(response: AxiosResponse): Promise<PaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentDto.fromJS(resultData200);
            return Promise.resolve<PaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentDto>(null as any);
    }

    removePayment(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Invoices/Payment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePayment(_response);
        });
    }

    protected processRemovePayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    editPaid(command: EditInvoicePaidCommand, cancelToken?: CancelToken | undefined): Promise<PaymentDto> {
        let url_ = this.baseUrl + "/api/Invoices/EditPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditPaid(_response);
        });
    }

    protected processEditPaid(response: AxiosResponse): Promise<PaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentDto.fromJS(resultData200);
            return Promise.resolve<PaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentDto>(null as any);
    }

    sendToAccountant(command: SendInvoicesToAccountantCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoices/SendToAccountant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendToAccountant(_response);
        });
    }

    protected processSendToAccountant(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getInvoiceCanBeRemoved(id: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Invoices/GetInvoiceCanBeRemoved?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceCanBeRemoved(_response);
        });
    }

    protected processGetInvoiceCanBeRemoved(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IInvoicingClosedLogsClient {
    get(): Promise<InvoicingClosedLog[]>;
    create(command: CreateInvoicingClosedLogCommand): Promise<FileResponse>;
}

export class InvoicingClosedLogsClient implements IInvoicingClosedLogsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get( cancelToken?: CancelToken | undefined): Promise<InvoicingClosedLog[]> {
        let url_ = this.baseUrl + "/api/InvoicingClosedLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<InvoicingClosedLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoicingClosedLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<InvoicingClosedLog[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoicingClosedLog[]>(null as any);
    }

    create(command: CreateInvoicingClosedLogCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/InvoicingClosedLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IOrdersClient {
    lookup(query: OrdersLookupQuery): Promise<OrdersLookupLoadResultDto>;
    get(id: string): Promise<OrderVm>;
    put(id: string, command: UpdateOrderCommand): Promise<FileResponse>;
    download(id: string): Promise<FileResponse>;
    export(command: ExportOrderCommand): Promise<FileResponse>;
    getDocumentUrl(id: string): Promise<FileResponse>;
    putLines(id: string, command: UpdateOrderLinesCommand): Promise<FileResponse>;
    goodsReceived(id: string): Promise<FileResponse>;
    invoiceReceived(id: string): Promise<FileResponse>;
    mail(command: MailOrderCommand): Promise<void>;
    createMaterialOrderFromMeasuringStates(command: CreateMaterialOrderFromMeasuringStatesCommand): Promise<void>;
}

export class OrdersClient implements IOrdersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    lookup(query: OrdersLookupQuery, cancelToken?: CancelToken | undefined): Promise<OrdersLookupLoadResultDto> {
        let url_ = this.baseUrl + "/api/Orders/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<OrdersLookupLoadResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrdersLookupLoadResultDto.fromJS(resultData200);
            return Promise.resolve<OrdersLookupLoadResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrdersLookupLoadResultDto>(null as any);
    }

    get(id: string, cancelToken?: CancelToken | undefined): Promise<OrderVm> {
        let url_ = this.baseUrl + "/api/Orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderVm.fromJS(resultData200);
            return Promise.resolve<OrderVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderVm>(null as any);
    }

    put(id: string, command: UpdateOrderCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    download(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    export(command: ExportOrderCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDocumentUrl(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}/DocumentUrl";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentUrl(_response);
        });
    }

    protected processGetDocumentUrl(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    putLines(id: string, command: UpdateOrderLinesCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}/Lines";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutLines(_response);
        });
    }

    protected processPutLines(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    goodsReceived(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}/GoodsReceived";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoodsReceived(_response);
        });
    }

    protected processGoodsReceived(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    invoiceReceived(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Orders/{id}/InvoiceReceived";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoiceReceived(_response);
        });
    }

    protected processInvoiceReceived(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    mail(command: MailOrderCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Orders/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createMaterialOrderFromMeasuringStates(command: CreateMaterialOrderFromMeasuringStatesCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Orders/MeasuringStateMaterialOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMaterialOrderFromMeasuringStates(_response);
        });
    }

    protected processCreateMaterialOrderFromMeasuringStates(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IQuotationsClient {
    getSingle(id: string): Promise<QuotationDetailedDto>;
    update(id: string, command: UpdateQuotationDetailsCommand): Promise<QuotationDetailedDto>;
    remove(id: string): Promise<void>;
    getList(projectId: string | null | undefined, contactId: string | null | undefined): Promise<QuotationBasicListItemDto[]>;
    getStats(): Promise<QuotationsStatsDto>;
    getDocument(id: string): Promise<FileResponse>;
    getQuotationsForAgenda(command: QuotationListForAgendaQuery): Promise<QuotationForAgenda[]>;
    getDiscountLinesOfQuotations(quotationIds: string[] | null | undefined): Promise<{ [key: string]: QuotationDiscountLineDto[]; }>;
    getQuotationTypes(): Promise<QuotationTypeDto[]>;
    duplicate(id: string): Promise<QuotationDetailedDto>;
    increaseByPercentage(command: IncreaseQuotationByPercentageCommand): Promise<QuotationDetailedDto>;
    generateDocument(command: GenerateQuotationDocumentCommand): Promise<FileResponse>;
    generate(command: GenerateQuotationCommand): Promise<QuotationDetailedDto>;
    create(projectId: string | null | undefined): Promise<QuotationDetailedDto>;
    mail(command: MailQuotationCommand): Promise<void>;
}

export class QuotationsClient implements IQuotationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getSingle(id: string, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    update(id: string, command: UpdateQuotationDetailsCommand, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    remove(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Quotations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getList(projectId: string | null | undefined, contactId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<QuotationBasicListItemDto[]> {
        let url_ = this.baseUrl + "/api/Quotations/List?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (contactId !== undefined && contactId !== null)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<QuotationBasicListItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuotationBasicListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuotationBasicListItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationBasicListItemDto[]>(null as any);
    }

    getStats( cancelToken?: CancelToken | undefined): Promise<QuotationsStatsDto> {
        let url_ = this.baseUrl + "/api/Quotations/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStats(_response);
        });
    }

    protected processGetStats(response: AxiosResponse): Promise<QuotationsStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationsStatsDto.fromJS(resultData200);
            return Promise.resolve<QuotationsStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationsStatsDto>(null as any);
    }

    getDocument(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Quotations/{id}/Document";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQuotationsForAgenda(command: QuotationListForAgendaQuery, cancelToken?: CancelToken | undefined): Promise<QuotationForAgenda[]> {
        let url_ = this.baseUrl + "/api/Quotations/GetQuotationsForAgenda";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotationsForAgenda(_response);
        });
    }

    protected processGetQuotationsForAgenda(response: AxiosResponse): Promise<QuotationForAgenda[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuotationForAgenda.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuotationForAgenda[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationForAgenda[]>(null as any);
    }

    getDiscountLinesOfQuotations(quotationIds: string[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: QuotationDiscountLineDto[]; }> {
        let url_ = this.baseUrl + "/api/Quotations/discount-lines?";
        if (quotationIds !== undefined && quotationIds !== null)
            quotationIds && quotationIds.forEach(item => { url_ += "QuotationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiscountLinesOfQuotations(_response);
        });
    }

    protected processGetDiscountLinesOfQuotations(response: AxiosResponse): Promise<{ [key: string]: QuotationDiscountLineDto[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDiscountLinesDto.fromJS(resultData200);
            return Promise.resolve<{ [key: string]: QuotationDiscountLineDto[]; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: QuotationDiscountLineDto[]; }>(null as any);
    }

    getQuotationTypes( cancelToken?: CancelToken | undefined): Promise<QuotationTypeDto[]> {
        let url_ = this.baseUrl + "/api/Quotations/quotation-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotationTypes(_response);
        });
    }

    protected processGetQuotationTypes(response: AxiosResponse): Promise<QuotationTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuotationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuotationTypeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationTypeDto[]>(null as any);
    }

    duplicate(id: string, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations/{id}/duplicate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicate(_response);
        });
    }

    protected processDuplicate(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    increaseByPercentage(command: IncreaseQuotationByPercentageCommand, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations/IncreaseByPercentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncreaseByPercentage(_response);
        });
    }

    protected processIncreaseByPercentage(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    generateDocument(command: GenerateQuotationDocumentCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Quotations/GeneratePdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDocument(_response);
        });
    }

    protected processGenerateDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generate(command: GenerateQuotationCommand, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    create(projectId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<QuotationDetailedDto> {
        let url_ = this.baseUrl + "/api/Quotations?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<QuotationDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotationDetailedDto.fromJS(resultData200);
            return Promise.resolve<QuotationDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotationDetailedDto>(null as any);
    }

    mail(command: MailQuotationCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Quotations/Mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail(_response);
        });
    }

    protected processMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IVolumeDiscountClient {
    getAll(): Promise<VolumeDiscount[]>;
    addVolumeDiscount(command: CreateVolumeDiscountsCommand): Promise<FileResponse>;
    updateVolumeDiscount(command: UpdateVolumeDiscountsCommand): Promise<FileResponse>;
    deleteVolumeDiscount(command: DeleteVolumeDiscountsCommand): Promise<FileResponse>;
}

export class VolumeDiscountClient implements IVolumeDiscountClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<VolumeDiscount[]> {
        let url_ = this.baseUrl + "/api/VolumeDiscount/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<VolumeDiscount[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VolumeDiscount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VolumeDiscount[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VolumeDiscount[]>(null as any);
    }

    addVolumeDiscount(command: CreateVolumeDiscountsCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VolumeDiscount/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddVolumeDiscount(_response);
        });
    }

    protected processAddVolumeDiscount(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateVolumeDiscount(command: UpdateVolumeDiscountsCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VolumeDiscount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVolumeDiscount(_response);
        });
    }

    protected processUpdateVolumeDiscount(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteVolumeDiscount(command: DeleteVolumeDiscountsCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VolumeDiscount/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVolumeDiscount(_response);
        });
    }

    protected processDeleteVolumeDiscount(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICompaniesClient {
    get(id: string): Promise<Company>;
}

export class CompaniesClient implements ICompaniesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(id: string, cancelToken?: CancelToken | undefined): Promise<Company> {
        let url_ = this.baseUrl + "/api/Companies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Company> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Company.fromJS(resultData200);
            return Promise.resolve<Company>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Company>(null as any);
    }
}

export interface IContactsClient {
    lookupContacts(query: ContactsLookupQuery): Promise<LoadResultMapOfContactListItemDto>;
    getBasicInfo(id: string): Promise<ContactBasicsDto>;
    /**
     * @return or

    or
     */
    getContactDetailed(id: string): Promise<any>;
    deleteContact(id: string): Promise<void>;
    createContact(command: CreateContactCommand): Promise<string>;
    updateContact(command: UpdateContactCommand): Promise<void>;
    createCompany(command: CreateCompanyCommand): Promise<string>;
    updateCompany(command: UpdateCompanyCommand): Promise<void>;
    createSubcontractor(command: CreateSubcontractorCommand): Promise<string>;
    updateSubcontractor(command: UpdateSubcontractorCommand): Promise<void>;
    get(id: string): Promise<FileResponse>;
    get2(id: string): Promise<Contact>;
}

export class ContactsClient implements IContactsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    lookupContacts(query: ContactsLookupQuery, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfContactListItemDto> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupContacts(_response);
        });
    }

    protected processLookupContacts(response: AxiosResponse): Promise<LoadResultMapOfContactListItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfContactListItemDto.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfContactListItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfContactListItemDto>(null as any);
    }

    getBasicInfo(id: string, cancelToken?: CancelToken | undefined): Promise<ContactBasicsDto> {
        let url_ = this.baseUrl + "/api/V2/Contacts/{id}/Basics";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasicInfo(_response);
        });
    }

    protected processGetBasicInfo(response: AxiosResponse): Promise<ContactBasicsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactBasicsDto.fromJS(resultData200);
            return Promise.resolve<ContactBasicsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactBasicsDto>(null as any);
    }

    /**
     * @return or

    or
     */
    getContactDetailed(id: string, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/V2/Contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContactDetailed(_response);
        });
    }

    protected processGetContactDetailed(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    deleteContact(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/V2/Contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact(_response);
        });
    }

    protected processDeleteContact(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createContact(command: CreateContactCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact(_response);
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateContact(command: UpdateContactCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContact(_response);
        });
    }

    protected processUpdateContact(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createCompany(command: CreateCompanyCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompany(_response);
        });
    }

    protected processCreateCompany(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateCompany(command: UpdateCompanyCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompany(_response);
        });
    }

    protected processUpdateCompany(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createSubcontractor(command: CreateSubcontractorCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Subcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSubcontractor(_response);
        });
    }

    protected processCreateSubcontractor(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateSubcontractor(command: UpdateSubcontractorCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/V2/Contacts/Subcontractor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubcontractor(_response);
        });
    }

    protected processUpdateSubcontractor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    get(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get2(id: string, cancelToken?: CancelToken | undefined): Promise<Contact> {
        let url_ = this.baseUrl + "/v2/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: AxiosResponse): Promise<Contact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Contact.fromJS(resultData200);
            return Promise.resolve<Contact>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Contact>(null as any);
    }
}

export interface IEmployeesClient {
    syncEmployees(): Promise<FileResponse>;
    updateEmployee(command: UpdateEmployeeCommand): Promise<FileResponse>;
    getLoggedInEmployee(): Promise<Employee>;
    getEmployeesFromO365(): Promise<DirectoryObject[]>;
}

export class EmployeesClient implements IEmployeesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    syncEmployees( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Employees/SyncEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncEmployees(_response);
        });
    }

    protected processSyncEmployees(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateEmployee(command: UpdateEmployeeCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Employees/UpdateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLoggedInEmployee( cancelToken?: CancelToken | undefined): Promise<Employee> {
        let url_ = this.baseUrl + "/api/Employees/GetLoggedInEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoggedInEmployee(_response);
        });
    }

    protected processGetLoggedInEmployee(response: AxiosResponse): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Employee.fromJS(resultData200);
            return Promise.resolve<Employee>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Employee>(null as any);
    }

    getEmployeesFromO365( cancelToken?: CancelToken | undefined): Promise<DirectoryObject[]> {
        let url_ = this.baseUrl + "/api/Employees/GetEmployeesFromO365";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesFromO365(_response);
        });
    }

    protected processGetEmployeesFromO365(response: AxiosResponse): Promise<DirectoryObject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectoryObject.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DirectoryObject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DirectoryObject[]>(null as any);
    }
}

export interface ISubcontractorsClient {
    get(id: string): Promise<Subcontractor>;
}

export class SubcontractorsClient implements ISubcontractorsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(id: string, cancelToken?: CancelToken | undefined): Promise<Subcontractor> {
        let url_ = this.baseUrl + "/api/Subcontractors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Subcontractor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Subcontractor.fromJS(resultData200);
            return Promise.resolve<Subcontractor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Subcontractor>(null as any);
    }
}

export interface ISuppliersClient {
    getAll(): Promise<ContactBasicsDto[]>;
}

export class SuppliersClient implements ISuppliersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<ContactBasicsDto[]> {
        let url_ = this.baseUrl + "/api/Suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ContactBasicsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactBasicsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ContactBasicsDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactBasicsDto[]>(null as any);
    }
}

export interface ITeamsClient {
    getAllTeamsForAgenda(): Promise<TeamAgendaDto[]>;
    getAllTeamsForPlanning(query: GetTeamsForPlanningQuery): Promise<TeamForPlanningDto[]>;
    getAllTeamsSubcontractor(subcontractorId: string): Promise<Team[]>;
    postCreateTeam(command: CreateTeamCommand): Promise<string>;
    postUpdateTeam(command: UpdateTeamCommand): Promise<FileResponse>;
    deleteTeam(teamId: string): Promise<FileResponse>;
}

export class TeamsClient implements ITeamsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAllTeamsForAgenda( cancelToken?: CancelToken | undefined): Promise<TeamAgendaDto[]> {
        let url_ = this.baseUrl + "/api/Teams/GetTeamsForAgenda";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTeamsForAgenda(_response);
        });
    }

    protected processGetAllTeamsForAgenda(response: AxiosResponse): Promise<TeamAgendaDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamAgendaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TeamAgendaDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamAgendaDto[]>(null as any);
    }

    getAllTeamsForPlanning(query: GetTeamsForPlanningQuery, cancelToken?: CancelToken | undefined): Promise<TeamForPlanningDto[]> {
        let url_ = this.baseUrl + "/api/Teams/GetAllTeamsForPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTeamsForPlanning(_response);
        });
    }

    protected processGetAllTeamsForPlanning(response: AxiosResponse): Promise<TeamForPlanningDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamForPlanningDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TeamForPlanningDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamForPlanningDto[]>(null as any);
    }

    getAllTeamsSubcontractor(subcontractorId: string, cancelToken?: CancelToken | undefined): Promise<Team[]> {
        let url_ = this.baseUrl + "/api/Teams/{subcontractorId}";
        if (subcontractorId === undefined || subcontractorId === null)
            throw new Error("The parameter 'subcontractorId' must be defined.");
        url_ = url_.replace("{subcontractorId}", encodeURIComponent("" + subcontractorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTeamsSubcontractor(_response);
        });
    }

    protected processGetAllTeamsSubcontractor(response: AxiosResponse): Promise<Team[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Team.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Team[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Team[]>(null as any);
    }

    postCreateTeam(command: CreateTeamCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Teams/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCreateTeam(_response);
        });
    }

    protected processPostCreateTeam(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    postUpdateTeam(command: UpdateTeamCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Teams/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUpdateTeam(_response);
        });
    }

    protected processPostUpdateTeam(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTeam(teamId: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTeam(_response);
        });
    }

    protected processDeleteTeam(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IZipClient {
    getCityByZip(zipCode: string): Promise<ZipCodeDto>;
}

export class ZipClient implements IZipClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCityByZip(zipCode: string, cancelToken?: CancelToken | undefined): Promise<ZipCodeDto> {
        let url_ = this.baseUrl + "/searchCity/{zipCode}";
        if (zipCode === undefined || zipCode === null)
            throw new Error("The parameter 'zipCode' must be defined.");
        url_ = url_.replace("{zipCode}", encodeURIComponent("" + zipCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCityByZip(_response);
        });
    }

    protected processGetCityByZip(response: AxiosResponse): Promise<ZipCodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ZipCodeDto.fromJS(resultData200);
            return Promise.resolve<ZipCodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZipCodeDto>(null as any);
    }
}

export interface IArticleCategoryClient {
    get(): Promise<ArticleCategory[]>;
    create(command: CreateArticleCategoryCommand): Promise<string>;
    lookup(options: DataSourceLoadOptions): Promise<LoadResultMapOfArticleCategory>;
    update(id: string, command: UpdateArticleCategoryCommand): Promise<void>;
    deleteSingle(articleCategoryId: string): Promise<void>;
}

export class ArticleCategoryClient implements IArticleCategoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get( cancelToken?: CancelToken | undefined): Promise<ArticleCategory[]> {
        let url_ = this.baseUrl + "/api/ArticleCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ArticleCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ArticleCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleCategory[]>(null as any);
    }

    create(command: CreateArticleCategoryCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ArticleCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    lookup(options: DataSourceLoadOptions, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfArticleCategory> {
        let url_ = this.baseUrl + "/api/ArticleCategory/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<LoadResultMapOfArticleCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfArticleCategory.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfArticleCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfArticleCategory>(null as any);
    }

    update(id: string, command: UpdateArticleCategoryCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ArticleCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSingle(articleCategoryId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ArticleCategory/{articleCategoryId}";
        if (articleCategoryId === undefined || articleCategoryId === null)
            throw new Error("The parameter 'articleCategoryId' must be defined.");
        url_ = url_.replace("{articleCategoryId}", encodeURIComponent("" + articleCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSingle(_response);
        });
    }

    protected processDeleteSingle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IArticlesClient {
    getAll(): Promise<Article[]>;
    create(command: CreateArticleCommand): Promise<Article>;
    getSingle(id: string): Promise<Article>;
    update(id: string, command: UpdateArticleCommand): Promise<Article>;
    delete(id: string): Promise<void>;
    copy(command: CopyArticleCommand): Promise<Article>;
    updateBasicInfo(id: string, command: UpdateArticleBasicsCommand): Promise<Article>;
    updateLabourcost(id: string, command: UpdateArticleLabourCostCommand): Promise<Article>;
    updateBillOfMaterials(id: string, command: UpdateArticleBillOfMaterialsCommand): Promise<Article>;
    getTranslations(id: string): Promise<ArticleTranslationDto[]>;
    updateTranslations(id: string, translations: ArticleTranslationDto[]): Promise<FileResponse>;
    addVariant(id: string, name: string): Promise<Article>;
    updateVariant(id: string, name: string, variant: Variant): Promise<Article>;
    deleteVariant(id: string, name: string): Promise<Article>;
}

export class ArticlesClient implements IArticlesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<Article[]> {
        let url_ = this.baseUrl + "/api/Articles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<Article[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Article.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Article[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article[]>(null as any);
    }

    create(command: CreateArticleCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    getSingle(id: string, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingle(_response);
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    update(id: string, command: UpdateArticleCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copy(command: CopyArticleCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    updateBasicInfo(id: string, command: UpdateArticleBasicsCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/Basics";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBasicInfo(_response);
        });
    }

    protected processUpdateBasicInfo(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    updateLabourcost(id: string, command: UpdateArticleLabourCostCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/Labourcosts";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLabourcost(_response);
        });
    }

    protected processUpdateLabourcost(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    updateBillOfMaterials(id: string, command: UpdateArticleBillOfMaterialsCommand, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/BillOfMaterials";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBillOfMaterials(_response);
        });
    }

    protected processUpdateBillOfMaterials(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    getTranslations(id: string, cancelToken?: CancelToken | undefined): Promise<ArticleTranslationDto[]> {
        let url_ = this.baseUrl + "/api/Articles/{id}/GetTranslations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: AxiosResponse): Promise<ArticleTranslationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ArticleTranslationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticleTranslationDto[]>(null as any);
    }

    updateTranslations(id: string, translations: ArticleTranslationDto[], cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Articles/{id}/UpdateTranslations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(translations);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTranslations(_response);
        });
    }

    protected processUpdateTranslations(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addVariant(id: string, name: string, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/variants/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddVariant(_response);
        });
    }

    protected processAddVariant(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    updateVariant(id: string, name: string, variant: Variant, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/variants/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variant);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVariant(_response);
        });
    }

    protected processUpdateVariant(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }

    deleteVariant(id: string, name: string, cancelToken?: CancelToken | undefined): Promise<Article> {
        let url_ = this.baseUrl + "/api/Articles/{id}/variants/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVariant(_response);
        });
    }

    protected processDeleteVariant(response: AxiosResponse): Promise<Article> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Article.fromJS(resultData200);
            return Promise.resolve<Article>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Article>(null as any);
    }
}

export interface IMeasuringUnitsClient {
    getMeasuringUnits(): Promise<MeasuringUnit[]>;
    create(command: CreateMeasuringUnitCommand): Promise<FileResponse>;
    update(command: UpdateMeasuringUnitCommand): Promise<FileResponse>;
    delete(id: string): Promise<FileResponse>;
    getTranslations(name: string): Promise<MeasuringUnitTranslationDto[]>;
    updateTranslations(name: string, translations: MeasuringUnitTranslationDto[]): Promise<FileResponse>;
}

export class MeasuringUnitsClient implements IMeasuringUnitsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getMeasuringUnits( cancelToken?: CancelToken | undefined): Promise<MeasuringUnit[]> {
        let url_ = this.baseUrl + "/api/MeasuringUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMeasuringUnits(_response);
        });
    }

    protected processGetMeasuringUnits(response: AxiosResponse): Promise<MeasuringUnit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringUnit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasuringUnit[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringUnit[]>(null as any);
    }

    create(command: CreateMeasuringUnitCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    update(command: UpdateMeasuringUnitCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringUnits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTranslations(name: string, cancelToken?: CancelToken | undefined): Promise<MeasuringUnitTranslationDto[]> {
        let url_ = this.baseUrl + "/api/MeasuringUnits/{name}/GetTranslations";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: AxiosResponse): Promise<MeasuringUnitTranslationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringUnitTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MeasuringUnitTranslationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeasuringUnitTranslationDto[]>(null as any);
    }

    updateTranslations(name: string, translations: MeasuringUnitTranslationDto[], cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeasuringUnits/{name}/UpdateTranslations";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(translations);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTranslations(_response);
        });
    }

    protected processUpdateTranslations(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRawMaterialGroupsClient {
    getAll(): Promise<RawMaterialGroup[]>;
    createRawMaterialGroup(command: CreateRawMaterialGroupCommand): Promise<RawMaterialGroup[]>;
    updateRawMaterialGroup(command: UpdateRawMaterialGroupCommand): Promise<RawMaterialGroup[]>;
    deleteRawMaterialGroup(command: DeleteRawMaterialGroupCommand): Promise<RawMaterialGroup[]>;
}

export class RawMaterialGroupsClient implements IRawMaterialGroupsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAll( cancelToken?: CancelToken | undefined): Promise<RawMaterialGroup[]> {
        let url_ = this.baseUrl + "/api/RawMaterialGroups/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RawMaterialGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RawMaterialGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGroup[]>(null as any);
    }

    createRawMaterialGroup(command: CreateRawMaterialGroupCommand, cancelToken?: CancelToken | undefined): Promise<RawMaterialGroup[]> {
        let url_ = this.baseUrl + "/api/RawMaterialGroups/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRawMaterialGroup(_response);
        });
    }

    protected processCreateRawMaterialGroup(response: AxiosResponse): Promise<RawMaterialGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RawMaterialGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGroup[]>(null as any);
    }

    updateRawMaterialGroup(command: UpdateRawMaterialGroupCommand, cancelToken?: CancelToken | undefined): Promise<RawMaterialGroup[]> {
        let url_ = this.baseUrl + "/api/RawMaterialGroups/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRawMaterialGroup(_response);
        });
    }

    protected processUpdateRawMaterialGroup(response: AxiosResponse): Promise<RawMaterialGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RawMaterialGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGroup[]>(null as any);
    }

    deleteRawMaterialGroup(command: DeleteRawMaterialGroupCommand, cancelToken?: CancelToken | undefined): Promise<RawMaterialGroup[]> {
        let url_ = this.baseUrl + "/api/RawMaterialGroups/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRawMaterialGroup(_response);
        });
    }

    protected processDeleteRawMaterialGroup(response: AxiosResponse): Promise<RawMaterialGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RawMaterialGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RawMaterialGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialGroup[]>(null as any);
    }
}

export interface IRawMaterialsClient {
    getRawMaterial(id: string): Promise<RawMaterialDto>;
    postRawMaterial(command: CreateRawMaterialCommand): Promise<RawMaterial>;
    putRawMaterial(command: UpdateRawMaterialCommand): Promise<RawMaterial>;
    exportData(supplierId: string | null | undefined): Promise<FileResponse>;
    importData(command: ImportRawMaterialsDataCommand): Promise<void>;
}

export class RawMaterialsClient implements IRawMaterialsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getRawMaterial(id: string, cancelToken?: CancelToken | undefined): Promise<RawMaterialDto> {
        let url_ = this.baseUrl + "/api/RawMaterials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRawMaterial(_response);
        });
    }

    protected processGetRawMaterial(response: AxiosResponse): Promise<RawMaterialDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterialDto.fromJS(resultData200);
            return Promise.resolve<RawMaterialDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterialDto>(null as any);
    }

    postRawMaterial(command: CreateRawMaterialCommand, cancelToken?: CancelToken | undefined): Promise<RawMaterial> {
        let url_ = this.baseUrl + "/api/RawMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRawMaterial(_response);
        });
    }

    protected processPostRawMaterial(response: AxiosResponse): Promise<RawMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterial.fromJS(resultData200);
            return Promise.resolve<RawMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterial>(null as any);
    }

    putRawMaterial(command: UpdateRawMaterialCommand, cancelToken?: CancelToken | undefined): Promise<RawMaterial> {
        let url_ = this.baseUrl + "/api/RawMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutRawMaterial(_response);
        });
    }

    protected processPutRawMaterial(response: AxiosResponse): Promise<RawMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RawMaterial.fromJS(resultData200);
            return Promise.resolve<RawMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RawMaterial>(null as any);
    }

    exportData(supplierId: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RawMaterials/ExportData?";
        if (supplierId !== undefined && supplierId !== null)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportData(_response);
        });
    }

    protected processExportData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    importData(command: ImportRawMaterialsDataCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/ImportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportData(_response);
        });
    }

    protected processImportData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ITunnelGroupsClient {
    get(): Promise<TunnelGroup[]>;
    create(command: CreateTunnelGroupCommand): Promise<string>;
    lookup(options: DataSourceLoadOptions): Promise<LoadResultMapOfTunnelGroup>;
    update(id: string, command: UpdateTunnelGroupCommand): Promise<void>;
    deleteSingle(tunnelGroupId: string): Promise<void>;
}

export class TunnelGroupsClient implements ITunnelGroupsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get( cancelToken?: CancelToken | undefined): Promise<TunnelGroup[]> {
        let url_ = this.baseUrl + "/api/TunnelGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TunnelGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TunnelGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TunnelGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TunnelGroup[]>(null as any);
    }

    create(command: CreateTunnelGroupCommand, cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/TunnelGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    lookup(options: DataSourceLoadOptions, cancelToken?: CancelToken | undefined): Promise<LoadResultMapOfTunnelGroup> {
        let url_ = this.baseUrl + "/api/TunnelGroups/Lookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<LoadResultMapOfTunnelGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoadResultMapOfTunnelGroup.fromJS(resultData200);
            return Promise.resolve<LoadResultMapOfTunnelGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoadResultMapOfTunnelGroup>(null as any);
    }

    update(id: string, command: UpdateTunnelGroupCommand, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TunnelGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSingle(tunnelGroupId: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TunnelGroups/{tunnelGroupId}";
        if (tunnelGroupId === undefined || tunnelGroupId === null)
            throw new Error("The parameter 'tunnelGroupId' must be defined.");
        url_ = url_.replace("{tunnelGroupId}", encodeURIComponent("" + tunnelGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSingle(_response);
        });
    }

    protected processDeleteSingle(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CommunicationDto implements ICommunicationDto {
    id?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    strippedBody?: string | undefined;
    communicationType?: CommunicationType;
    fromName?: string | undefined;
    fromValue?: string | undefined;
    dateSent?: Date;
    createDate?: Date;
    ownerId?: string | undefined;
    createdByName?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeId?: string | undefined;
    noteTypeName?: string | undefined;
    receivers?: CommunictionReceiver[] | undefined;
    attachments?: CommunicationAttachment[] | undefined;

    constructor(data?: ICommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.strippedBody = _data["strippedBody"];
            this.communicationType = _data["communicationType"];
            this.fromName = _data["fromName"];
            this.fromValue = _data["fromValue"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.ownerId = _data["ownerId"];
            this.createdByName = _data["createdByName"];
            this.noteTypeIcon = _data["noteTypeIcon"];
            this.noteTypeId = _data["noteTypeId"];
            this.noteTypeName = _data["noteTypeName"];
            if (Array.isArray(_data["receivers"])) {
                this.receivers = [] as any;
                for (let item of _data["receivers"])
                    this.receivers!.push(CommunictionReceiver.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommunicationAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["strippedBody"] = this.strippedBody;
        data["communicationType"] = this.communicationType;
        data["fromName"] = this.fromName;
        data["fromValue"] = this.fromValue;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["ownerId"] = this.ownerId;
        data["createdByName"] = this.createdByName;
        data["noteTypeIcon"] = this.noteTypeIcon;
        data["noteTypeId"] = this.noteTypeId;
        data["noteTypeName"] = this.noteTypeName;
        if (Array.isArray(this.receivers)) {
            data["receivers"] = [];
            for (let item of this.receivers)
                data["receivers"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationDto {
    id?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    strippedBody?: string | undefined;
    communicationType?: CommunicationType;
    fromName?: string | undefined;
    fromValue?: string | undefined;
    dateSent?: Date;
    createDate?: Date;
    ownerId?: string | undefined;
    createdByName?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeId?: string | undefined;
    noteTypeName?: string | undefined;
    receivers?: CommunictionReceiver[] | undefined;
    attachments?: CommunicationAttachment[] | undefined;
}

export enum CommunicationType {
    Activity = 0,
    Mail = 1,
    Note = 2,
}

export class CommunictionReceiver implements ICommunictionReceiver {
    communicationId?: string | undefined;
    receiverType?: ReceiverType | undefined;
    value?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: ICommunictionReceiver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationId = _data["communicationId"];
            this.receiverType = _data["receiverType"];
            this.value = _data["value"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CommunictionReceiver {
        data = typeof data === 'object' ? data : {};
        let result = new CommunictionReceiver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationId"] = this.communicationId;
        data["receiverType"] = this.receiverType;
        data["value"] = this.value;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICommunictionReceiver {
    communicationId?: string | undefined;
    receiverType?: ReceiverType | undefined;
    value?: string | undefined;
    displayName?: string | undefined;
}

export enum ReceiverType {
    Default = 0,
    CC = 1,
    BCC = 2,
    To = 3,
}

export class CommunicationAttachment implements ICommunicationAttachment {
    communicationId?: string | undefined;
    blobName?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    isInline?: boolean | undefined;
    inlineId?: string | undefined;
    sign?: boolean | undefined;
    signatureSetting?: SignatureSetting | undefined;

    constructor(data?: ICommunicationAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationId = _data["communicationId"];
            this.blobName = _data["blobName"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.isInline = _data["isInline"];
            this.inlineId = _data["inlineId"];
            this.sign = _data["sign"];
            this.signatureSetting = _data["signatureSetting"] ? SignatureSetting.fromJS(_data["signatureSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommunicationAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationId"] = this.communicationId;
        data["blobName"] = this.blobName;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["isInline"] = this.isInline;
        data["inlineId"] = this.inlineId;
        data["sign"] = this.sign;
        data["signatureSetting"] = this.signatureSetting ? this.signatureSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommunicationAttachment {
    communicationId?: string | undefined;
    blobName?: string | undefined;
    fileName?: string | undefined;
    mimeType?: string | undefined;
    isInline?: boolean | undefined;
    inlineId?: string | undefined;
    sign?: boolean | undefined;
    signatureSetting?: SignatureSetting | undefined;
}

export class SignatureSetting implements ISignatureSetting {
    widthCm?: number | undefined;
    heightCm?: number | undefined;
    xOffsetCm?: number | undefined;
    yOffsetCm?: number | undefined;
    valid?: boolean;

    constructor(data?: ISignatureSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widthCm = _data["widthCm"];
            this.heightCm = _data["heightCm"];
            this.xOffsetCm = _data["xOffsetCm"];
            this.yOffsetCm = _data["yOffsetCm"];
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): SignatureSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widthCm"] = this.widthCm;
        data["heightCm"] = this.heightCm;
        data["xOffsetCm"] = this.xOffsetCm;
        data["yOffsetCm"] = this.yOffsetCm;
        data["valid"] = this.valid;
        return data;
    }
}

export interface ISignatureSetting {
    widthCm?: number | undefined;
    heightCm?: number | undefined;
    xOffsetCm?: number | undefined;
    yOffsetCm?: number | undefined;
    valid?: boolean;
}

/** Represents a sorting parameter. */
export class SortingInfo implements ISortingInfo {
    /** The data field to be used for sorting. */
    selector?: string | undefined;
    /** A flag indicating whether data should be sorted in a descending order. */
    desc?: boolean;

    constructor(data?: ISortingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"];
            this.desc = _data["desc"];
        }
    }

    static fromJS(data: any): SortingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SortingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector;
        data["desc"] = this.desc;
        return data;
    }
}

/** Represents a sorting parameter. */
export interface ISortingInfo {
    /** The data field to be used for sorting. */
    selector?: string | undefined;
    /** A flag indicating whether data should be sorted in a descending order. */
    desc?: boolean;
}

/** Represents a grouping level to be applied to data. */
export class GroupingInfo extends SortingInfo implements IGroupingInfo {
    /** A value that groups data in ranges of a given length or date/time period. */
    groupInterval?: string | undefined;
    /** A flag indicating whether the group's data objects should be returned. */
    isExpanded?: boolean | undefined;

    constructor(data?: IGroupingInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupInterval = _data["groupInterval"];
            this.isExpanded = _data["isExpanded"];
        }
    }

    static fromJS(data: any): GroupingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GroupingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupInterval"] = this.groupInterval;
        data["isExpanded"] = this.isExpanded;
        super.toJSON(data);
        return data;
    }
}

/** Represents a grouping level to be applied to data. */
export interface IGroupingInfo extends ISortingInfo {
    /** A value that groups data in ranges of a given length or date/time period. */
    groupInterval?: string | undefined;
    /** A flag indicating whether the group's data objects should be returned. */
    isExpanded?: boolean | undefined;
}

/** Represents a group or total summary definition. */
export class SummaryInfo implements ISummaryInfo {
    /** The data field to be used for calculating the summary. */
    selector?: string | undefined;
    /** An aggregate function: "sum", "min", "max", "avg", or "count". */
    summaryType?: string | undefined;

    constructor(data?: ISummaryInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selector = _data["selector"];
            this.summaryType = _data["summaryType"];
        }
    }

    static fromJS(data: any): SummaryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selector"] = this.selector;
        data["summaryType"] = this.summaryType;
        return data;
    }
}

/** Represents a group or total summary definition. */
export interface ISummaryInfo {
    /** The data field to be used for calculating the summary. */
    selector?: string | undefined;
    /** An aggregate function: "sum", "min", "max", "avg", or "count". */
    summaryType?: string | undefined;
}

export class CreateNoteCommunicationCommand implements ICreateNoteCommunicationCommand {
    ownerId?: string | undefined;
    ownerTableName?: string | undefined;
    body?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeId?: string | undefined;

    constructor(data?: ICreateNoteCommunicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.ownerTableName = _data["ownerTableName"];
            this.body = _data["body"];
            this.noteTypeIcon = _data["noteTypeIcon"];
            this.noteTypeName = _data["noteTypeName"];
            this.noteTypeId = _data["noteTypeId"];
        }
    }

    static fromJS(data: any): CreateNoteCommunicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteCommunicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["ownerTableName"] = this.ownerTableName;
        data["body"] = this.body;
        data["noteTypeIcon"] = this.noteTypeIcon;
        data["noteTypeName"] = this.noteTypeName;
        data["noteTypeId"] = this.noteTypeId;
        return data;
    }
}

export interface ICreateNoteCommunicationCommand {
    ownerId?: string | undefined;
    ownerTableName?: string | undefined;
    body?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeId?: string | undefined;
}

export class UpdateNoteCommunicationCommand implements IUpdateNoteCommunicationCommand {
    id?: string | undefined;
    body?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeId?: string | undefined;

    constructor(data?: IUpdateNoteCommunicationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.body = _data["body"];
            this.noteTypeName = _data["noteTypeName"];
            this.noteTypeIcon = _data["noteTypeIcon"];
            this.noteTypeId = _data["noteTypeId"];
        }
    }

    static fromJS(data: any): UpdateNoteCommunicationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNoteCommunicationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["body"] = this.body;
        data["noteTypeName"] = this.noteTypeName;
        data["noteTypeIcon"] = this.noteTypeIcon;
        data["noteTypeId"] = this.noteTypeId;
        return data;
    }
}

export interface IUpdateNoteCommunicationCommand {
    id?: string | undefined;
    body?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeIcon?: string | undefined;
    noteTypeId?: string | undefined;
}

export class AuthenticationConfig implements IAuthenticationConfig {
    clientId?: string | undefined;
    site?: string | undefined;

    constructor(data?: IAuthenticationConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.site = _data["site"];
        }
    }

    static fromJS(data: any): AuthenticationConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["site"] = this.site;
        return data;
    }
}

export interface IAuthenticationConfig {
    clientId?: string | undefined;
    site?: string | undefined;
}

export class SecurityConfig implements ISecurityConfig {
    administrationGroup?: string | undefined;
    calculatorGroup?: string | undefined;
    hrGroup?: string | undefined;
    administratorGroup?: string | undefined;
    qualityGuardGroup?: string | undefined;
    qualityGuardOneSkinGroup?: string | undefined;
    projectCoordinatorGroup?: string | undefined;
    userGroup?: string | undefined;
    invoicingRead?: string | undefined;
    articleReadWrite?: string | undefined;
    quotationRead?: string | undefined;
    machineryRead?: string | undefined;
    machineryReadWrite?: string | undefined;
    purchaseRead?: string | undefined;
    purchaseOrderRead?: string | undefined;
    taskAdmin?: string | undefined;

    constructor(data?: ISecurityConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationGroup = _data["administrationGroup"];
            this.calculatorGroup = _data["calculatorGroup"];
            this.hrGroup = _data["hrGroup"];
            this.administratorGroup = _data["administratorGroup"];
            this.qualityGuardGroup = _data["qualityGuardGroup"];
            this.qualityGuardOneSkinGroup = _data["qualityGuardOneSkinGroup"];
            this.projectCoordinatorGroup = _data["projectCoordinatorGroup"];
            this.userGroup = _data["userGroup"];
            this.invoicingRead = _data["invoicingRead"];
            this.articleReadWrite = _data["articleReadWrite"];
            this.quotationRead = _data["quotationRead"];
            this.machineryRead = _data["machineryRead"];
            this.machineryReadWrite = _data["machineryReadWrite"];
            this.purchaseRead = _data["purchaseRead"];
            this.purchaseOrderRead = _data["purchaseOrderRead"];
            this.taskAdmin = _data["taskAdmin"];
        }
    }

    static fromJS(data: any): SecurityConfig {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationGroup"] = this.administrationGroup;
        data["calculatorGroup"] = this.calculatorGroup;
        data["hrGroup"] = this.hrGroup;
        data["administratorGroup"] = this.administratorGroup;
        data["qualityGuardGroup"] = this.qualityGuardGroup;
        data["qualityGuardOneSkinGroup"] = this.qualityGuardOneSkinGroup;
        data["projectCoordinatorGroup"] = this.projectCoordinatorGroup;
        data["userGroup"] = this.userGroup;
        data["invoicingRead"] = this.invoicingRead;
        data["articleReadWrite"] = this.articleReadWrite;
        data["quotationRead"] = this.quotationRead;
        data["machineryRead"] = this.machineryRead;
        data["machineryReadWrite"] = this.machineryReadWrite;
        data["purchaseRead"] = this.purchaseRead;
        data["purchaseOrderRead"] = this.purchaseOrderRead;
        data["taskAdmin"] = this.taskAdmin;
        return data;
    }
}

export interface ISecurityConfig {
    administrationGroup?: string | undefined;
    calculatorGroup?: string | undefined;
    hrGroup?: string | undefined;
    administratorGroup?: string | undefined;
    qualityGuardGroup?: string | undefined;
    qualityGuardOneSkinGroup?: string | undefined;
    projectCoordinatorGroup?: string | undefined;
    userGroup?: string | undefined;
    invoicingRead?: string | undefined;
    articleReadWrite?: string | undefined;
    quotationRead?: string | undefined;
    machineryRead?: string | undefined;
    machineryReadWrite?: string | undefined;
    purchaseRead?: string | undefined;
    purchaseOrderRead?: string | undefined;
    taskAdmin?: string | undefined;
}

export class LayoutConfig implements ILayoutConfig {
    faviconPrefix?: string | undefined;
    headTitle?: string | undefined;
    footerText?: string | undefined;
    navbarLogoUrl?: string | undefined;
    navbarCompanyName?: string | undefined;

    constructor(data?: ILayoutConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faviconPrefix = _data["faviconPrefix"];
            this.headTitle = _data["headTitle"];
            this.footerText = _data["footerText"];
            this.navbarLogoUrl = _data["navbarLogoUrl"];
            this.navbarCompanyName = _data["navbarCompanyName"];
        }
    }

    static fromJS(data: any): LayoutConfig {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faviconPrefix"] = this.faviconPrefix;
        data["headTitle"] = this.headTitle;
        data["footerText"] = this.footerText;
        data["navbarLogoUrl"] = this.navbarLogoUrl;
        data["navbarCompanyName"] = this.navbarCompanyName;
        return data;
    }
}

export interface ILayoutConfig {
    faviconPrefix?: string | undefined;
    headTitle?: string | undefined;
    footerText?: string | undefined;
    navbarLogoUrl?: string | undefined;
    navbarCompanyName?: string | undefined;
}

export class MailConfig implements IMailConfig {
    infoMailAddress?: string | undefined;
    accountingMailAddress?: string | undefined;
    executionMailAddress?: string | undefined;
    calculationMailAddress?: string | undefined;
    invoicingMailAddress?: string | undefined;
    fromName?: string | undefined;
    erpReportingName?: string | undefined;
    mailTestRedirectAddress?: string | undefined;

    constructor(data?: IMailConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoMailAddress = _data["infoMailAddress"];
            this.accountingMailAddress = _data["accountingMailAddress"];
            this.executionMailAddress = _data["executionMailAddress"];
            this.calculationMailAddress = _data["calculationMailAddress"];
            this.invoicingMailAddress = _data["invoicingMailAddress"];
            this.fromName = _data["fromName"];
            this.erpReportingName = _data["erpReportingName"];
            this.mailTestRedirectAddress = _data["mailTestRedirectAddress"];
        }
    }

    static fromJS(data: any): MailConfig {
        data = typeof data === 'object' ? data : {};
        let result = new MailConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoMailAddress"] = this.infoMailAddress;
        data["accountingMailAddress"] = this.accountingMailAddress;
        data["executionMailAddress"] = this.executionMailAddress;
        data["calculationMailAddress"] = this.calculationMailAddress;
        data["invoicingMailAddress"] = this.invoicingMailAddress;
        data["fromName"] = this.fromName;
        data["erpReportingName"] = this.erpReportingName;
        data["mailTestRedirectAddress"] = this.mailTestRedirectAddress;
        return data;
    }
}

export interface IMailConfig {
    infoMailAddress?: string | undefined;
    accountingMailAddress?: string | undefined;
    executionMailAddress?: string | undefined;
    calculationMailAddress?: string | undefined;
    invoicingMailAddress?: string | undefined;
    fromName?: string | undefined;
    erpReportingName?: string | undefined;
    mailTestRedirectAddress?: string | undefined;
}

export class CompanyConfig implements ICompanyConfig {
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    invoiceAccountantEmail?: string | undefined;
    creditNoteAccountantEmail?: string | undefined;
    timeZone?: string | undefined;
    vatNumber?: string | undefined;
    invoiceDocumentNumberFormat?: string | undefined;
    creditNoteDocumentNumberFormat?: string | undefined;
    enableHideSensitiveDocuments?: string | undefined;

    constructor(data?: ICompanyConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.email = _data["email"];
            this.invoiceAccountantEmail = _data["invoiceAccountantEmail"];
            this.creditNoteAccountantEmail = _data["creditNoteAccountantEmail"];
            this.timeZone = _data["timeZone"];
            this.vatNumber = _data["vatNumber"];
            this.invoiceDocumentNumberFormat = _data["invoiceDocumentNumberFormat"];
            this.creditNoteDocumentNumberFormat = _data["creditNoteDocumentNumberFormat"];
            this.enableHideSensitiveDocuments = _data["enableHideSensitiveDocuments"];
        }
    }

    static fromJS(data: any): CompanyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["email"] = this.email;
        data["invoiceAccountantEmail"] = this.invoiceAccountantEmail;
        data["creditNoteAccountantEmail"] = this.creditNoteAccountantEmail;
        data["timeZone"] = this.timeZone;
        data["vatNumber"] = this.vatNumber;
        data["invoiceDocumentNumberFormat"] = this.invoiceDocumentNumberFormat;
        data["creditNoteDocumentNumberFormat"] = this.creditNoteDocumentNumberFormat;
        data["enableHideSensitiveDocuments"] = this.enableHideSensitiveDocuments;
        return data;
    }
}

export interface ICompanyConfig {
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    invoiceAccountantEmail?: string | undefined;
    creditNoteAccountantEmail?: string | undefined;
    timeZone?: string | undefined;
    vatNumber?: string | undefined;
    invoiceDocumentNumberFormat?: string | undefined;
    creditNoteDocumentNumberFormat?: string | undefined;
    enableHideSensitiveDocuments?: string | undefined;
}

/** Options for configuring authentication using Azure Active Directory. */
export class AzureADOptions implements IAzureADOptions {
    /** Gets or sets the OpenID Connect authentication scheme to use for authentication with this instance
of Azure Active Directory authentication. */
    openIdConnectSchemeName?: string | undefined;
    /** Gets or sets the Cookie authentication scheme to use for sign in with this instance of
Azure Active Directory authentication. */
    cookieSchemeName?: string | undefined;
    /** Gets or sets the Jwt bearer authentication scheme to use for validating access tokens for this
instance of Azure Active Directory Bearer authentication. */
    jwtBearerSchemeName?: string | undefined;
    /** Gets or sets the client Id. */
    clientId?: string | undefined;
    /** Gets or sets the client secret. */
    clientSecret?: string | undefined;
    /** Gets or sets the tenant Id. */
    tenantId?: string | undefined;
    /** Gets or sets the Azure Active Directory instance. */
    instance?: string | undefined;
    /** Gets or sets the domain of the Azure Active Directory tenant. */
    domain?: string | undefined;
    /** Gets or sets the sign in callback path. */
    callbackPath?: string | undefined;
    /** Gets or sets the sign out callback path. */
    signedOutCallbackPath?: string | undefined;
    /** Gets all the underlying authentication schemes. */
    allSchemes?: string[] | undefined;

    constructor(data?: IAzureADOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openIdConnectSchemeName = _data["openIdConnectSchemeName"];
            this.cookieSchemeName = _data["cookieSchemeName"];
            this.jwtBearerSchemeName = _data["jwtBearerSchemeName"];
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.tenantId = _data["tenantId"];
            this.instance = _data["instance"];
            this.domain = _data["domain"];
            this.callbackPath = _data["callbackPath"];
            this.signedOutCallbackPath = _data["signedOutCallbackPath"];
            if (Array.isArray(_data["allSchemes"])) {
                this.allSchemes = [] as any;
                for (let item of _data["allSchemes"])
                    this.allSchemes!.push(item);
            }
        }
    }

    static fromJS(data: any): AzureADOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AzureADOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openIdConnectSchemeName"] = this.openIdConnectSchemeName;
        data["cookieSchemeName"] = this.cookieSchemeName;
        data["jwtBearerSchemeName"] = this.jwtBearerSchemeName;
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["tenantId"] = this.tenantId;
        data["instance"] = this.instance;
        data["domain"] = this.domain;
        data["callbackPath"] = this.callbackPath;
        data["signedOutCallbackPath"] = this.signedOutCallbackPath;
        if (Array.isArray(this.allSchemes)) {
            data["allSchemes"] = [];
            for (let item of this.allSchemes)
                data["allSchemes"].push(item);
        }
        return data;
    }
}

/** Options for configuring authentication using Azure Active Directory. */
export interface IAzureADOptions {
    /** Gets or sets the OpenID Connect authentication scheme to use for authentication with this instance
of Azure Active Directory authentication. */
    openIdConnectSchemeName?: string | undefined;
    /** Gets or sets the Cookie authentication scheme to use for sign in with this instance of
Azure Active Directory authentication. */
    cookieSchemeName?: string | undefined;
    /** Gets or sets the Jwt bearer authentication scheme to use for validating access tokens for this
instance of Azure Active Directory Bearer authentication. */
    jwtBearerSchemeName?: string | undefined;
    /** Gets or sets the client Id. */
    clientId?: string | undefined;
    /** Gets or sets the client secret. */
    clientSecret?: string | undefined;
    /** Gets or sets the tenant Id. */
    tenantId?: string | undefined;
    /** Gets or sets the Azure Active Directory instance. */
    instance?: string | undefined;
    /** Gets or sets the domain of the Azure Active Directory tenant. */
    domain?: string | undefined;
    /** Gets or sets the sign in callback path. */
    callbackPath?: string | undefined;
    /** Gets or sets the sign out callback path. */
    signedOutCallbackPath?: string | undefined;
    /** Gets all the underlying authentication schemes. */
    allSchemes?: string[] | undefined;
}

export class EntityBase implements IEntityBase {
    id?: string | undefined;
    logs?: Log[] | undefined;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(Log.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        let result = new EntityBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntityBase {
    id?: string | undefined;
    logs?: Log[] | undefined;
}

export class Settings extends EntityBase implements ISettings {
    defaultMargin?: number;
    defaultHourRate?: number;
    defaultTermsOfPayment?: number;
    rentalMailingTemplate?: string | undefined;
    warrantySetupTemplate?: string | undefined;
    checkinAtWorkTemplate?: string | undefined;
    safetyHealthEnvironmentPlanTemplate?: string | undefined;
    riskAnalysisTemplate?: string | undefined;
    insuranceAttestId?: string | undefined;
    quotationSmsTemplate?: string | undefined;
    invoiceSmsTemplate?: string | undefined;
    phaseArticleId?: string | undefined;
    cleanUpArticleId?: string | undefined;
    cleanUpPerUnitArticleId?: string | undefined;
    wasteDisposalArticleId?: string | undefined;
    wasteDisposalPerUnitArticleId?: string | undefined;
    paymentReminderTemplate?: string | undefined;
    invoicing?: InvoicingSettings | undefined;
    planning?: PlanningSettings | undefined;
    defaultCleanUpPercentage?: number | undefined;
    defaultWasteDisposalPercentage?: number | undefined;
    summaryInCategories?: boolean;
    version?: DocumentVersion;

    constructor(data?: ISettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.defaultMargin = _data["defaultMargin"];
            this.defaultHourRate = _data["defaultHourRate"];
            this.defaultTermsOfPayment = _data["defaultTermsOfPayment"];
            this.rentalMailingTemplate = _data["rentalMailingTemplate"];
            this.warrantySetupTemplate = _data["warrantySetupTemplate"];
            this.checkinAtWorkTemplate = _data["checkinAtWorkTemplate"];
            this.safetyHealthEnvironmentPlanTemplate = _data["safetyHealthEnvironmentPlanTemplate"];
            this.riskAnalysisTemplate = _data["riskAnalysisTemplate"];
            this.insuranceAttestId = _data["insuranceAttestId"];
            this.quotationSmsTemplate = _data["quotationSmsTemplate"];
            this.invoiceSmsTemplate = _data["invoiceSmsTemplate"];
            this.phaseArticleId = _data["phaseArticleId"];
            this.cleanUpArticleId = _data["cleanUpArticleId"];
            this.cleanUpPerUnitArticleId = _data["cleanUpPerUnitArticleId"];
            this.wasteDisposalArticleId = _data["wasteDisposalArticleId"];
            this.wasteDisposalPerUnitArticleId = _data["wasteDisposalPerUnitArticleId"];
            this.paymentReminderTemplate = _data["paymentReminderTemplate"];
            this.invoicing = _data["invoicing"] ? InvoicingSettings.fromJS(_data["invoicing"]) : <any>undefined;
            this.planning = _data["planning"] ? PlanningSettings.fromJS(_data["planning"]) : <any>undefined;
            this.defaultCleanUpPercentage = _data["defaultCleanUpPercentage"];
            this.defaultWasteDisposalPercentage = _data["defaultWasteDisposalPercentage"];
            this.summaryInCategories = _data["summaryInCategories"];
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Settings {
        data = typeof data === 'object' ? data : {};
        let result = new Settings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultMargin"] = this.defaultMargin;
        data["defaultHourRate"] = this.defaultHourRate;
        data["defaultTermsOfPayment"] = this.defaultTermsOfPayment;
        data["rentalMailingTemplate"] = this.rentalMailingTemplate;
        data["warrantySetupTemplate"] = this.warrantySetupTemplate;
        data["checkinAtWorkTemplate"] = this.checkinAtWorkTemplate;
        data["safetyHealthEnvironmentPlanTemplate"] = this.safetyHealthEnvironmentPlanTemplate;
        data["riskAnalysisTemplate"] = this.riskAnalysisTemplate;
        data["insuranceAttestId"] = this.insuranceAttestId;
        data["quotationSmsTemplate"] = this.quotationSmsTemplate;
        data["invoiceSmsTemplate"] = this.invoiceSmsTemplate;
        data["phaseArticleId"] = this.phaseArticleId;
        data["cleanUpArticleId"] = this.cleanUpArticleId;
        data["cleanUpPerUnitArticleId"] = this.cleanUpPerUnitArticleId;
        data["wasteDisposalArticleId"] = this.wasteDisposalArticleId;
        data["wasteDisposalPerUnitArticleId"] = this.wasteDisposalPerUnitArticleId;
        data["paymentReminderTemplate"] = this.paymentReminderTemplate;
        data["invoicing"] = this.invoicing ? this.invoicing.toJSON() : <any>undefined;
        data["planning"] = this.planning ? this.planning.toJSON() : <any>undefined;
        data["defaultCleanUpPercentage"] = this.defaultCleanUpPercentage;
        data["defaultWasteDisposalPercentage"] = this.defaultWasteDisposalPercentage;
        data["summaryInCategories"] = this.summaryInCategories;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISettings extends IEntityBase {
    defaultMargin?: number;
    defaultHourRate?: number;
    defaultTermsOfPayment?: number;
    rentalMailingTemplate?: string | undefined;
    warrantySetupTemplate?: string | undefined;
    checkinAtWorkTemplate?: string | undefined;
    safetyHealthEnvironmentPlanTemplate?: string | undefined;
    riskAnalysisTemplate?: string | undefined;
    insuranceAttestId?: string | undefined;
    quotationSmsTemplate?: string | undefined;
    invoiceSmsTemplate?: string | undefined;
    phaseArticleId?: string | undefined;
    cleanUpArticleId?: string | undefined;
    cleanUpPerUnitArticleId?: string | undefined;
    wasteDisposalArticleId?: string | undefined;
    wasteDisposalPerUnitArticleId?: string | undefined;
    paymentReminderTemplate?: string | undefined;
    invoicing?: InvoicingSettings | undefined;
    planning?: PlanningSettings | undefined;
    defaultCleanUpPercentage?: number | undefined;
    defaultWasteDisposalPercentage?: number | undefined;
    summaryInCategories?: boolean;
    version?: DocumentVersion;
}

export class InvoicingSettings implements IInvoicingSettings {
    reminderEnabled?: boolean;
    firstReminderTemplateId?: string | undefined;
    secondReminderTemplateId?: string | undefined;
    secondReminderInDays?: number;

    constructor(data?: IInvoicingSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderEnabled = _data["reminderEnabled"];
            this.firstReminderTemplateId = _data["firstReminderTemplateId"];
            this.secondReminderTemplateId = _data["secondReminderTemplateId"];
            this.secondReminderInDays = _data["secondReminderInDays"];
        }
    }

    static fromJS(data: any): InvoicingSettings {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderEnabled"] = this.reminderEnabled;
        data["firstReminderTemplateId"] = this.firstReminderTemplateId;
        data["secondReminderTemplateId"] = this.secondReminderTemplateId;
        data["secondReminderInDays"] = this.secondReminderInDays;
        return data;
    }
}

export interface IInvoicingSettings {
    reminderEnabled?: boolean;
    firstReminderTemplateId?: string | undefined;
    secondReminderTemplateId?: string | undefined;
    secondReminderInDays?: number;
}

export class PlanningSettings implements IPlanningSettings {
    intervalMessageReportDate?: number;

    constructor(data?: IPlanningSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intervalMessageReportDate = _data["intervalMessageReportDate"];
        }
    }

    static fromJS(data: any): PlanningSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intervalMessageReportDate"] = this.intervalMessageReportDate;
        return data;
    }
}

export interface IPlanningSettings {
    intervalMessageReportDate?: number;
}

export class DocumentVersion implements IDocumentVersion {
    major?: number;
    minor?: number;
    revision?: number;

    constructor(data?: IDocumentVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"];
            this.minor = _data["minor"];
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): DocumentVersion {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["revision"] = this.revision;
        return data;
    }
}

export interface IDocumentVersion {
    major?: number;
    minor?: number;
    revision?: number;
}

export class Log implements ILog {
    type?: LogType;
    trigger?: string | undefined;
    userId?: string | undefined;
    message?: string | undefined;
    object?: any | undefined;
    objectRef?: string | undefined;
    moment?: Date;

    constructor(data?: ILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.trigger = _data["trigger"];
            this.userId = _data["userId"];
            this.message = _data["message"];
            this.object = _data["object"];
            this.objectRef = _data["objectRef"];
            this.moment = _data["moment"] ? new Date(_data["moment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Log {
        data = typeof data === 'object' ? data : {};
        let result = new Log();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["trigger"] = this.trigger;
        data["userId"] = this.userId;
        data["message"] = this.message;
        data["object"] = this.object;
        data["objectRef"] = this.objectRef;
        data["moment"] = this.moment ? this.moment.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILog {
    type?: LogType;
    trigger?: string | undefined;
    userId?: string | undefined;
    message?: string | undefined;
    object?: any | undefined;
    objectRef?: string | undefined;
    moment?: Date;
}

export enum LogType {
    Info = 0,
    Success = 1,
    Warning = 2,
    Error = 3,
    Note = 4,
    Mail = 5,
    PhoneCall = 6,
}

export class SettingsUpdateCommand implements ISettingsUpdateCommand {
    defaultMargin?: number;
    defaultHourRate?: number;
    defaultTermsOfPayment?: number;
    rentalMailingTemplate?: string | undefined;
    warrantySetupTemplate?: string | undefined;
    checkinAtWorkTemplate?: string | undefined;
    safetyHealthEnvironmentPlanTemplate?: string | undefined;
    riskAnalysisTemplate?: string | undefined;
    quotationSmsTemplate?: string | undefined;
    invoiceSmsTemplate?: string | undefined;
    paymentReminderTemplate?: string | undefined;
    phaseArticleId?: string | undefined;
    cleanUpArticleId?: string | undefined;
    cleanUpPerUnitArticleId?: string | undefined;
    wasteDisposalArticleId?: string | undefined;
    wasteDisposalPerUnitArticleId?: string | undefined;
    invoicing?: InvoicingSettings | undefined;
    planning?: PlanningSettings | undefined;
    defaultCleanUpPercentage?: number | undefined;
    defaultWasteDisposalPercentage?: number | undefined;
    summaryInCategories?: boolean;

    constructor(data?: ISettingsUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultMargin = _data["defaultMargin"];
            this.defaultHourRate = _data["defaultHourRate"];
            this.defaultTermsOfPayment = _data["defaultTermsOfPayment"];
            this.rentalMailingTemplate = _data["rentalMailingTemplate"];
            this.warrantySetupTemplate = _data["warrantySetupTemplate"];
            this.checkinAtWorkTemplate = _data["checkinAtWorkTemplate"];
            this.safetyHealthEnvironmentPlanTemplate = _data["safetyHealthEnvironmentPlanTemplate"];
            this.riskAnalysisTemplate = _data["riskAnalysisTemplate"];
            this.quotationSmsTemplate = _data["quotationSmsTemplate"];
            this.invoiceSmsTemplate = _data["invoiceSmsTemplate"];
            this.paymentReminderTemplate = _data["paymentReminderTemplate"];
            this.phaseArticleId = _data["phaseArticleId"];
            this.cleanUpArticleId = _data["cleanUpArticleId"];
            this.cleanUpPerUnitArticleId = _data["cleanUpPerUnitArticleId"];
            this.wasteDisposalArticleId = _data["wasteDisposalArticleId"];
            this.wasteDisposalPerUnitArticleId = _data["wasteDisposalPerUnitArticleId"];
            this.invoicing = _data["invoicing"] ? InvoicingSettings.fromJS(_data["invoicing"]) : <any>undefined;
            this.planning = _data["planning"] ? PlanningSettings.fromJS(_data["planning"]) : <any>undefined;
            this.defaultCleanUpPercentage = _data["defaultCleanUpPercentage"];
            this.defaultWasteDisposalPercentage = _data["defaultWasteDisposalPercentage"];
            this.summaryInCategories = _data["summaryInCategories"];
        }
    }

    static fromJS(data: any): SettingsUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultMargin"] = this.defaultMargin;
        data["defaultHourRate"] = this.defaultHourRate;
        data["defaultTermsOfPayment"] = this.defaultTermsOfPayment;
        data["rentalMailingTemplate"] = this.rentalMailingTemplate;
        data["warrantySetupTemplate"] = this.warrantySetupTemplate;
        data["checkinAtWorkTemplate"] = this.checkinAtWorkTemplate;
        data["safetyHealthEnvironmentPlanTemplate"] = this.safetyHealthEnvironmentPlanTemplate;
        data["riskAnalysisTemplate"] = this.riskAnalysisTemplate;
        data["quotationSmsTemplate"] = this.quotationSmsTemplate;
        data["invoiceSmsTemplate"] = this.invoiceSmsTemplate;
        data["paymentReminderTemplate"] = this.paymentReminderTemplate;
        data["phaseArticleId"] = this.phaseArticleId;
        data["cleanUpArticleId"] = this.cleanUpArticleId;
        data["cleanUpPerUnitArticleId"] = this.cleanUpPerUnitArticleId;
        data["wasteDisposalArticleId"] = this.wasteDisposalArticleId;
        data["wasteDisposalPerUnitArticleId"] = this.wasteDisposalPerUnitArticleId;
        data["invoicing"] = this.invoicing ? this.invoicing.toJSON() : <any>undefined;
        data["planning"] = this.planning ? this.planning.toJSON() : <any>undefined;
        data["defaultCleanUpPercentage"] = this.defaultCleanUpPercentage;
        data["defaultWasteDisposalPercentage"] = this.defaultWasteDisposalPercentage;
        data["summaryInCategories"] = this.summaryInCategories;
        return data;
    }
}

export interface ISettingsUpdateCommand {
    defaultMargin?: number;
    defaultHourRate?: number;
    defaultTermsOfPayment?: number;
    rentalMailingTemplate?: string | undefined;
    warrantySetupTemplate?: string | undefined;
    checkinAtWorkTemplate?: string | undefined;
    safetyHealthEnvironmentPlanTemplate?: string | undefined;
    riskAnalysisTemplate?: string | undefined;
    quotationSmsTemplate?: string | undefined;
    invoiceSmsTemplate?: string | undefined;
    paymentReminderTemplate?: string | undefined;
    phaseArticleId?: string | undefined;
    cleanUpArticleId?: string | undefined;
    cleanUpPerUnitArticleId?: string | undefined;
    wasteDisposalArticleId?: string | undefined;
    wasteDisposalPerUnitArticleId?: string | undefined;
    invoicing?: InvoicingSettings | undefined;
    planning?: PlanningSettings | undefined;
    defaultCleanUpPercentage?: number | undefined;
    defaultWasteDisposalPercentage?: number | undefined;
    summaryInCategories?: boolean;
}

export class MailActionPointCommand implements IMailActionPointCommand {
    id?: string | undefined;
    sendToSubcontractor?: boolean;
    sendToReporter?: boolean;
    sendToExecutor?: boolean;
    accompanyingTextSubcontractor?: string | undefined;
    accompanyingTextReporter?: string | undefined;
    accompanyingTextExecutor?: string | undefined;

    constructor(data?: IMailActionPointCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sendToSubcontractor = _data["sendToSubcontractor"];
            this.sendToReporter = _data["sendToReporter"];
            this.sendToExecutor = _data["sendToExecutor"];
            this.accompanyingTextSubcontractor = _data["accompanyingTextSubcontractor"];
            this.accompanyingTextReporter = _data["accompanyingTextReporter"];
            this.accompanyingTextExecutor = _data["accompanyingTextExecutor"];
        }
    }

    static fromJS(data: any): MailActionPointCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailActionPointCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sendToSubcontractor"] = this.sendToSubcontractor;
        data["sendToReporter"] = this.sendToReporter;
        data["sendToExecutor"] = this.sendToExecutor;
        data["accompanyingTextSubcontractor"] = this.accompanyingTextSubcontractor;
        data["accompanyingTextReporter"] = this.accompanyingTextReporter;
        data["accompanyingTextExecutor"] = this.accompanyingTextExecutor;
        return data;
    }
}

export interface IMailActionPointCommand {
    id?: string | undefined;
    sendToSubcontractor?: boolean;
    sendToReporter?: boolean;
    sendToExecutor?: boolean;
    accompanyingTextSubcontractor?: string | undefined;
    accompanyingTextReporter?: string | undefined;
    accompanyingTextExecutor?: string | undefined;
}

export class UpdateActionPointStatusCommand implements IUpdateActionPointStatusCommand {
    id?: string | undefined;
    status?: ActionPointStatus;

    constructor(data?: IUpdateActionPointStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateActionPointStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActionPointStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateActionPointStatusCommand {
    id?: string | undefined;
    status?: ActionPointStatus;
}

export enum ActionPointStatus {
    Open = 0,
    Send = 1,
    Processed = 2,
    Ignore = 3,
    OnHold = 4,
}

export class MailTemplateDto implements IMailTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;

    constructor(data?: IMailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["type"] = this.type;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;
}

export enum MailTemplateType {
    Quotation = 0,
    Invoicing = 1,
    ProgressStatement = 2,
    Contract = 3,
    CreditNote = 4,
    Order = 5,
    ActionPoint = 6,
    ProjectFiches = 7,
    Project = 8,
}

export class CreateMailTemplateCommand implements ICreateMailTemplateCommand {
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;

    constructor(data?: ICreateMailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CreateMailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["type"] = this.type;
        data["language"] = this.language;
        return data;
    }
}

export interface ICreateMailTemplateCommand {
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;
}

export class UpdateMailTemplateCommand implements IUpdateMailTemplateCommand {
    id?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;

    constructor(data?: IUpdateMailTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UpdateMailTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["type"] = this.type;
        data["language"] = this.language;
        return data;
    }
}

export interface IUpdateMailTemplateCommand {
    id?: string | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    type?: MailTemplateType;
    language?: string | undefined;
}

export class NoteType implements INoteType {
    id?: string | undefined;
    value?: string | undefined;
    order?: number;
    icon?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: INoteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.order = _data["order"];
            this.icon = _data["icon"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): NoteType {
        data = typeof data === 'object' ? data : {};
        let result = new NoteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["order"] = this.order;
        data["icon"] = this.icon;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface INoteType {
    id?: string | undefined;
    value?: string | undefined;
    order?: number;
    icon?: string | undefined;
    isDeleted?: boolean;
}

export class CreateNoteTypesCommand implements ICreateNoteTypesCommand {
    value?: string | undefined;
    icon?: string | undefined;

    constructor(data?: ICreateNoteTypesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): CreateNoteTypesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteTypesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["icon"] = this.icon;
        return data;
    }
}

export interface ICreateNoteTypesCommand {
    value?: string | undefined;
    icon?: string | undefined;
}

export class UpdateNoteTypesCommand implements IUpdateNoteTypesCommand {
    noteTypeId?: string | undefined;
    value?: string | undefined;
    icon?: string | undefined;
    order?: number;

    constructor(data?: IUpdateNoteTypesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteTypeId = _data["noteTypeId"];
            this.value = _data["value"];
            this.icon = _data["icon"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateNoteTypesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNoteTypesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteTypeId"] = this.noteTypeId;
        data["value"] = this.value;
        data["icon"] = this.icon;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateNoteTypesCommand {
    noteTypeId?: string | undefined;
    value?: string | undefined;
    icon?: string | undefined;
    order?: number;
}

export class DeleteNoteTypesCommand implements IDeleteNoteTypesCommand {
    noteTypeId?: string | undefined;

    constructor(data?: IDeleteNoteTypesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteTypeId = _data["noteTypeId"];
        }
    }

    static fromJS(data: any): DeleteNoteTypesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteNoteTypesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteTypeId"] = this.noteTypeId;
        return data;
    }
}

export interface IDeleteNoteTypesCommand {
    noteTypeId?: string | undefined;
}

export abstract class AuditableEntity implements IAuditableEntity {
    createdOn?: Date;
    createdBy?: string | undefined;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: string | undefined;

    constructor(data?: IAuditableEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
        }
    }

    static fromJS(data: any): AuditableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AuditableEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        return data;
    }
}

export interface IAuditableEntity {
    createdOn?: Date;
    createdBy?: string | undefined;
    lastUpdatedOn?: Date | undefined;
    lastUpdatedBy?: string | undefined;
}

export class CustomTaskDto extends AuditableEntity implements ICustomTaskDto {
    id?: string | undefined;
    title?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    category?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    dueDateISO?: Date | undefined;
    taskList?: string[] | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    documentNumber?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    notes?: TaskNote[] | undefined;
    score?: number | undefined;
    report?: ProjectReport | undefined;

    constructor(data?: ICustomTaskDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.team = _data["team"];
            this.parentId = _data["parentId"];
            this.category = _data["category"];
            this.templateId = _data["templateId"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.dueDateISO = _data["dueDateISO"] ? new Date(_data["dueDateISO"].toString()) : <any>undefined;
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(item);
            }
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.documentNumber = _data["documentNumber"];
            this.customer = _data["customer"] ? AssignedCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(TaskNote.fromJS(item));
            }
            this.score = _data["score"];
            this.report = _data["report"] ? ProjectReport.fromJS(_data["report"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["team"] = this.team;
        data["parentId"] = this.parentId;
        data["category"] = this.category;
        data["templateId"] = this.templateId;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueDateISO"] = this.dueDateISO ? this.dueDateISO.toISOString() : <any>undefined;
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item);
        }
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["documentNumber"] = this.documentNumber;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["score"] = this.score;
        data["report"] = this.report ? this.report.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomTaskDto extends IAuditableEntity {
    id?: string | undefined;
    title?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    category?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    dueDateISO?: Date | undefined;
    taskList?: string[] | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    documentNumber?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    notes?: TaskNote[] | undefined;
    score?: number | undefined;
    report?: ProjectReport | undefined;
}

export class AssignedCustomer implements IAssignedCustomer {
    id?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IAssignedCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AssignedCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAssignedCustomer {
    id?: string | undefined;
    type?: string | undefined;
    displayName?: string | undefined;
}

export enum TaskType {
    Varia = 0,
    Call = 1,
    CreateAppointment = 2,
    Appointment = 3,
    CreateQuotation = 4,
}

export enum TaskStatus {
    New = 0,
    Open = 1,
    Pending = 2,
    Postphoned = 3,
    NeedMoreInfo = 4,
    Closed = 5,
}

export class TaskNote implements ITaskNote {
    moment?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    message?: string | undefined;

    constructor(data?: ITaskNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moment = _data["moment"] ? new Date(_data["moment"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TaskNote {
        data = typeof data === 'object' ? data : {};
        let result = new TaskNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moment"] = this.moment ? this.moment.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["message"] = this.message;
        return data;
    }
}

export interface ITaskNote {
    moment?: Date;
    userId?: string | undefined;
    userName?: string | undefined;
    message?: string | undefined;
}

export class ProjectReport implements IProjectReport {
    id?: string | undefined;
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;
    pageId?: string | undefined;
    webUrl?: string | undefined;
    clientUrl?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;
    template?: string | undefined;
    version?: DocumentVersion;

    constructor(data?: IProjectReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.completed = _data["completed"];
            this.pageId = _data["pageId"];
            this.webUrl = _data["webUrl"];
            this.clientUrl = _data["clientUrl"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.template = _data["template"];
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["completed"] = this.completed;
        data["pageId"] = this.pageId;
        data["webUrl"] = this.webUrl;
        data["clientUrl"] = this.clientUrl;
        data["type"] = this.type;
        data["title"] = this.title;
        data["template"] = this.template;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectReport {
    id?: string | undefined;
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;
    pageId?: string | undefined;
    webUrl?: string | undefined;
    clientUrl?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;
    template?: string | undefined;
    version?: DocumentVersion;
}

export enum ProjectReportType {
    Report = 0,
    Visit = 1,
}

export class CreateTaskCommand implements ICreateTaskCommand {
    title?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    reportId?: string | undefined;

    constructor(data?: ICreateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.category = _data["category"];
            this.team = _data["team"];
            this.parentId = _data["parentId"];
            this.templateId = _data["templateId"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.customer = _data["customer"] ? AssignedCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): CreateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["category"] = this.category;
        data["team"] = this.team;
        data["parentId"] = this.parentId;
        data["templateId"] = this.templateId;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface ICreateTaskCommand {
    title?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    reportId?: string | undefined;
}

export class UpdateTaskCommand implements IUpdateTaskCommand {
    id?: string | undefined;
    title?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;

    constructor(data?: IUpdateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.team = _data["team"];
            this.parentId = _data["parentId"];
            this.templateId = _data["templateId"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.customer = _data["customer"] ? AssignedCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["category"] = this.category;
        data["team"] = this.team;
        data["parentId"] = this.parentId;
        data["templateId"] = this.templateId;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateTaskCommand {
    id?: string | undefined;
    title?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
}

export class CreateTaskNoteCommand implements ICreateTaskNoteCommand {
    id?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICreateTaskNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateTaskNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateTaskNoteCommand {
    id?: string | undefined;
    message?: string | undefined;
}

export class CustomTask extends AuditableEntity implements ICustomTask {
    version?: DocumentVersion;
    id?: string | undefined;
    title?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    category?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    dueDateISO?: Date | undefined;
    taskList?: string[] | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    documentNumber?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    notes?: TaskNote[] | undefined;
    score?: number | undefined;
    reportId?: string | undefined;

    constructor(data?: ICustomTask) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
            this.id = _data["id"];
            this.title = _data["title"];
            this.team = _data["team"];
            this.parentId = _data["parentId"];
            this.category = _data["category"];
            this.templateId = _data["templateId"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.dueDateISO = _data["dueDateISO"] ? new Date(_data["dueDateISO"].toString()) : <any>undefined;
            if (Array.isArray(_data["taskList"])) {
                this.taskList = [] as any;
                for (let item of _data["taskList"])
                    this.taskList!.push(item);
            }
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.documentNumber = _data["documentNumber"];
            this.customer = _data["customer"] ? AssignedCustomer.fromJS(_data["customer"]) : <any>undefined;
            this.type = _data["type"];
            this.status = _data["status"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(TaskNote.fromJS(item));
            }
            this.score = _data["score"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): CustomTask {
        data = typeof data === 'object' ? data : {};
        let result = new CustomTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["title"] = this.title;
        data["team"] = this.team;
        data["parentId"] = this.parentId;
        data["category"] = this.category;
        data["templateId"] = this.templateId;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueDateISO"] = this.dueDateISO ? this.dueDateISO.toISOString() : <any>undefined;
        if (Array.isArray(this.taskList)) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item);
        }
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["documentNumber"] = this.documentNumber;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["status"] = this.status;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item.toJSON());
        }
        data["score"] = this.score;
        data["reportId"] = this.reportId;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomTask extends IAuditableEntity {
    version?: DocumentVersion;
    id?: string | undefined;
    title?: string | undefined;
    team?: string | undefined;
    parentId?: string | undefined;
    category?: string | undefined;
    templateId?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    dueDateISO?: Date | undefined;
    taskList?: string[] | undefined;
    userId?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    documentNumber?: string | undefined;
    customer?: AssignedCustomer | undefined;
    type?: TaskType;
    status?: TaskStatus;
    notes?: TaskNote[] | undefined;
    score?: number | undefined;
    reportId?: string | undefined;
}

export class UpdateTaskStatusCommand implements IUpdateTaskStatusCommand {
    id?: string | undefined;
    status?: TaskStatus;

    constructor(data?: IUpdateTaskStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateTaskStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateTaskStatusCommand {
    id?: string | undefined;
    status?: TaskStatus;
}

export class TaskTemplateDto implements ITaskTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    type?: TaskType;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;

    constructor(data?: ITaskTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.team = _data["team"];
            this.type = _data["type"];
            this.assignedUserId = _data["assignedUserId"];
            this.instructionId = _data["instructionId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.nextTaskTemplateId = _data["nextTaskTemplateId"];
        }
    }

    static fromJS(data: any): TaskTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["category"] = this.category;
        data["team"] = this.team;
        data["type"] = this.type;
        data["assignedUserId"] = this.assignedUserId;
        data["instructionId"] = this.instructionId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["nextTaskTemplateId"] = this.nextTaskTemplateId;
        return data;
    }
}

export interface ITaskTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    type?: TaskType;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;
}

export class CreateTaskTemplateCommand implements ICreateTaskTemplateCommand {
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;

    constructor(data?: ICreateTaskTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.team = _data["team"];
            this.assignedUserId = _data["assignedUserId"];
            this.instructionId = _data["instructionId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.nextTaskTemplateId = _data["nextTaskTemplateId"];
        }
    }

    static fromJS(data: any): CreateTaskTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["team"] = this.team;
        data["assignedUserId"] = this.assignedUserId;
        data["instructionId"] = this.instructionId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["nextTaskTemplateId"] = this.nextTaskTemplateId;
        return data;
    }
}

export interface ICreateTaskTemplateCommand {
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;
}

export class UpdateTaskTemplateCommand implements IUpdateTaskTemplateCommand {
    id?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;

    constructor(data?: IUpdateTaskTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.team = _data["team"];
            this.assignedUserId = _data["assignedUserId"];
            this.instructionId = _data["instructionId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.nextTaskTemplateId = _data["nextTaskTemplateId"];
        }
    }

    static fromJS(data: any): UpdateTaskTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["category"] = this.category;
        data["team"] = this.team;
        data["assignedUserId"] = this.assignedUserId;
        data["instructionId"] = this.instructionId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["nextTaskTemplateId"] = this.nextTaskTemplateId;
        return data;
    }
}

export interface IUpdateTaskTemplateCommand {
    id?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    team?: string | undefined;
    assignedUserId?: string | undefined;
    instructionId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    nextTaskTemplateId?: string | undefined;
}

export class ContractListItemDto implements IContractListItemDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    status?: ContractStatus;
    fixedPrice?: number | undefined;
    total?: number;

    constructor(data?: IContractListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
            this.measuringStateRef = _data["measuringStateRef"];
            this.status = _data["status"];
            this.fixedPrice = _data["fixedPrice"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ContractListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        data["measuringStateRef"] = this.measuringStateRef;
        data["status"] = this.status;
        data["fixedPrice"] = this.fixedPrice;
        data["total"] = this.total;
        return data;
    }
}

export interface IContractListItemDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    status?: ContractStatus;
    fixedPrice?: number | undefined;
    total?: number;
}

export enum ContractStatus {
    Open = 0,
    Approved = 1,
    Rejected = 2,
    Send = 3,
}

export class ContractDto implements IContractDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    reference?: string | undefined;
    status?: ContractStatus;
    lines?: ContractLineDto[] | undefined;
    fixedPrice?: number | undefined;
    total?: number;
    fileUrl?: string | undefined;
    tunnelGroupsId?: string | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
            this.measuringStateRef = _data["measuringStateRef"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ContractLineDto.fromJS(item));
            }
            this.fixedPrice = _data["fixedPrice"];
            this.total = _data["total"];
            this.fileUrl = _data["fileUrl"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        data["measuringStateRef"] = this.measuringStateRef;
        data["reference"] = this.reference;
        data["status"] = this.status;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["fixedPrice"] = this.fixedPrice;
        data["total"] = this.total;
        data["fileUrl"] = this.fileUrl;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        return data;
    }
}

export interface IContractDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    reference?: string | undefined;
    status?: ContractStatus;
    lines?: ContractLineDto[] | undefined;
    fixedPrice?: number | undefined;
    total?: number;
    fileUrl?: string | undefined;
    tunnelGroupsId?: string | undefined;
}

export class ContractLineDto implements IContractLineDto {
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    description?: string | undefined;
    measuringStateLineId?: string | undefined;
    amount?: number;
    price?: number;
    total?: number;

    constructor(data?: IContractLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.description = _data["description"];
            this.measuringStateLineId = _data["measuringStateLineId"];
            this.amount = _data["amount"];
            this.price = _data["price"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ContractLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["description"] = this.description;
        data["measuringStateLineId"] = this.measuringStateLineId;
        data["amount"] = this.amount;
        data["price"] = this.price;
        data["total"] = this.total;
        return data;
    }
}

export interface IContractLineDto {
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    description?: string | undefined;
    measuringStateLineId?: string | undefined;
    amount?: number;
    price?: number;
    total?: number;
}

export class UpdateContractCommand implements IUpdateContractCommand {
    documentNumber?: string | undefined;
    status?: ContractStatus;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    fixedPrice?: number | undefined;
    reference?: string | undefined;
    lines?: ContractLine[] | undefined;

    constructor(data?: IUpdateContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.subcontractorId = _data["subcontractorId"];
            this.fixedPrice = _data["fixedPrice"];
            this.reference = _data["reference"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ContractLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["subcontractorId"] = this.subcontractorId;
        data["fixedPrice"] = this.fixedPrice;
        data["reference"] = this.reference;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateContractCommand {
    documentNumber?: string | undefined;
    status?: ContractStatus;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    fixedPrice?: number | undefined;
    reference?: string | undefined;
    lines?: ContractLine[] | undefined;
}

export class ContractLine implements IContractLine {
    lineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    description?: string | undefined;
    measuringStateLineId?: string | undefined;
    amount?: number;
    originalPrice?: number;
    price?: number;
    total?: number;

    constructor(data?: IContractLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.parentLineId = _data["parentLineId"];
            this.measuringUnit = _data["measuringUnit"];
            this.description = _data["description"];
            this.measuringStateLineId = _data["measuringStateLineId"];
            this.amount = _data["amount"];
            this.originalPrice = _data["originalPrice"];
            this.price = _data["price"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ContractLine {
        data = typeof data === 'object' ? data : {};
        let result = new ContractLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["parentLineId"] = this.parentLineId;
        data["measuringUnit"] = this.measuringUnit;
        data["description"] = this.description;
        data["measuringStateLineId"] = this.measuringStateLineId;
        data["amount"] = this.amount;
        data["originalPrice"] = this.originalPrice;
        data["price"] = this.price;
        data["total"] = this.total;
        return data;
    }
}

export interface IContractLine {
    lineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    description?: string | undefined;
    measuringStateLineId?: string | undefined;
    amount?: number;
    originalPrice?: number;
    price?: number;
    total?: number;
}

export class CreateContractFromMeasuringStateCommand implements ICreateContractFromMeasuringStateCommand {
    projectId?: string | undefined;
    measuringStateRef?: string | undefined;
    subcontractorId?: string | undefined;
    reference?: string | undefined;
    contractType?: string | undefined;
    tunnelGroupsId?: string | undefined;

    constructor(data?: ICreateContractFromMeasuringStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.measuringStateRef = _data["measuringStateRef"];
            this.subcontractorId = _data["subcontractorId"];
            this.reference = _data["reference"];
            this.contractType = _data["contractType"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
        }
    }

    static fromJS(data: any): CreateContractFromMeasuringStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractFromMeasuringStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["measuringStateRef"] = this.measuringStateRef;
        data["subcontractorId"] = this.subcontractorId;
        data["reference"] = this.reference;
        data["contractType"] = this.contractType;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        return data;
    }
}

export interface ICreateContractFromMeasuringStateCommand {
    projectId?: string | undefined;
    measuringStateRef?: string | undefined;
    subcontractorId?: string | undefined;
    reference?: string | undefined;
    contractType?: string | undefined;
    tunnelGroupsId?: string | undefined;
}

export class FinanceDocumentSettings implements IFinanceDocumentSettings {
    hideUnitPrices?: boolean;
    hideLineTotals?: boolean;
    hideLineAmounts?: boolean;
    hideSubtotals?: boolean;
    hideTotals?: boolean;
    hideSubtotalDetails?: boolean;
    language?: string | undefined;
    groupArticlesByCategory?: boolean;

    constructor(data?: IFinanceDocumentSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hideUnitPrices = _data["hideUnitPrices"];
            this.hideLineTotals = _data["hideLineTotals"];
            this.hideLineAmounts = _data["hideLineAmounts"];
            this.hideSubtotals = _data["hideSubtotals"];
            this.hideTotals = _data["hideTotals"];
            this.hideSubtotalDetails = _data["hideSubtotalDetails"];
            this.language = _data["language"];
            this.groupArticlesByCategory = _data["groupArticlesByCategory"];
        }
    }

    static fromJS(data: any): FinanceDocumentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceDocumentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hideUnitPrices"] = this.hideUnitPrices;
        data["hideLineTotals"] = this.hideLineTotals;
        data["hideLineAmounts"] = this.hideLineAmounts;
        data["hideSubtotals"] = this.hideSubtotals;
        data["hideTotals"] = this.hideTotals;
        data["hideSubtotalDetails"] = this.hideSubtotalDetails;
        data["language"] = this.language;
        data["groupArticlesByCategory"] = this.groupArticlesByCategory;
        return data;
    }
}

export interface IFinanceDocumentSettings {
    hideUnitPrices?: boolean;
    hideLineTotals?: boolean;
    hideLineAmounts?: boolean;
    hideSubtotals?: boolean;
    hideTotals?: boolean;
    hideSubtotalDetails?: boolean;
    language?: string | undefined;
    groupArticlesByCategory?: boolean;
}

export class MailContractCommand implements IMailContractCommand {
    documentNumber?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    from?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IMailContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.from = _data["from"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["from"] = this.from;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailContractCommand {
    documentNumber?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    from?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class MeasurementListItemDto implements IMeasurementListItemDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    status?: MeasurementStatus;
    header?: string | undefined;
    reference?: string | undefined;

    constructor(data?: IMeasurementListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.recorder = _data["recorder"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.projectType = _data["projectType"];
            this.workType = _data["workType"];
            this.measurementType = _data["measurementType"];
            this.status = _data["status"];
            this.header = _data["header"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): MeasurementListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["recorder"] = this.recorder;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectType"] = this.projectType;
        data["workType"] = this.workType;
        data["measurementType"] = this.measurementType;
        data["status"] = this.status;
        data["header"] = this.header;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IMeasurementListItemDto {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    status?: MeasurementStatus;
    header?: string | undefined;
    reference?: string | undefined;
}

export enum MeasurementStatus {
    Open = 0,
    InProgress = 1,
    Closed = 2,
    Processed = 3,
}

export class MeasurementDto implements IMeasurementDto {
    name?: string | undefined;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    projectName?: string | undefined;
    recorder?: string | undefined;
    status?: MeasurementStatus;
    documentNumber?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    reference?: string | undefined;
    isFirstMeasurement?: boolean;

    constructor(data?: IMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.projectName = _data["projectName"];
            this.recorder = _data["recorder"];
            this.status = _data["status"];
            this.documentNumber = _data["documentNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.projectType = _data["projectType"];
            this.workType = _data["workType"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(MeasurementRoom.fromJS(item));
            }
            this.notes = _data["notes"];
            this.externalNotes = _data["externalNotes"];
            this.reference = _data["reference"];
            this.isFirstMeasurement = _data["isFirstMeasurement"];
        }
    }

    static fromJS(data: any): MeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["projectName"] = this.projectName;
        data["recorder"] = this.recorder;
        data["status"] = this.status;
        data["documentNumber"] = this.documentNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectType"] = this.projectType;
        data["workType"] = this.workType;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["externalNotes"] = this.externalNotes;
        data["reference"] = this.reference;
        data["isFirstMeasurement"] = this.isFirstMeasurement;
        return data;
    }
}

export interface IMeasurementDto {
    name?: string | undefined;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    projectName?: string | undefined;
    recorder?: string | undefined;
    status?: MeasurementStatus;
    documentNumber?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    reference?: string | undefined;
    isFirstMeasurement?: boolean;
}

export class MeasurementRoom implements IMeasurementRoom {
    name?: string | undefined;
    usedArticles?: UsedArticle[] | undefined;

    constructor(data?: IMeasurementRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["usedArticles"])) {
                this.usedArticles = [] as any;
                for (let item of _data["usedArticles"])
                    this.usedArticles!.push(UsedArticle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeasurementRoom {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.usedArticles)) {
            data["usedArticles"] = [];
            for (let item of this.usedArticles)
                data["usedArticles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMeasurementRoom {
    name?: string | undefined;
    usedArticles?: UsedArticle[] | undefined;
}

export class UsedArticle implements IUsedArticle {
    lineId?: string | undefined;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    variant?: string | undefined;
    notes?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    deduction?: boolean;
    measuringUnit?: string | undefined;

    constructor(data?: IUsedArticle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.parentLineId = _data["parentLineId"];
            this.articleId = _data["articleId"];
            this.variant = _data["variant"];
            this.notes = _data["notes"];
            this.length = _data["length"];
            this.height = _data["height"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.deduction = _data["deduction"];
            this.measuringUnit = _data["measuringUnit"];
        }
    }

    static fromJS(data: any): UsedArticle {
        data = typeof data === 'object' ? data : {};
        let result = new UsedArticle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["parentLineId"] = this.parentLineId;
        data["articleId"] = this.articleId;
        data["variant"] = this.variant;
        data["notes"] = this.notes;
        data["length"] = this.length;
        data["height"] = this.height;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["deduction"] = this.deduction;
        data["measuringUnit"] = this.measuringUnit;
        return data;
    }
}

export interface IUsedArticle {
    lineId?: string | undefined;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    variant?: string | undefined;
    notes?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    deduction?: boolean;
    measuringUnit?: string | undefined;
}

export class CreateMeasurementCommand implements ICreateMeasurementCommand {
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date | undefined;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    reference?: string | undefined;

    constructor(data?: ICreateMeasurementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.recorder = _data["recorder"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.projectType = _data["projectType"];
            this.workType = _data["workType"];
            this.measurementType = _data["measurementType"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): CreateMeasurementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasurementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["recorder"] = this.recorder;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectType"] = this.projectType;
        data["workType"] = this.workType;
        data["measurementType"] = this.measurementType;
        data["reference"] = this.reference;
        return data;
    }
}

export interface ICreateMeasurementCommand {
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date | undefined;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    reference?: string | undefined;
}

export class DuplicateMeasurementCommand implements IDuplicateMeasurementCommand {
    projectId?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: IDuplicateMeasurementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.documentNumber = _data["documentNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DuplicateMeasurementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateMeasurementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["documentNumber"] = this.documentNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IDuplicateMeasurementCommand {
    projectId?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;
}

export class MeasurementMergeCommand implements IMeasurementMergeCommand {
    projectId?: string | undefined;
    name?: string | undefined;
    list?: string[] | undefined;
    removeAfterMerge?: boolean;

    constructor(data?: IMeasurementMergeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(item);
            }
            this.removeAfterMerge = _data["removeAfterMerge"];
        }
    }

    static fromJS(data: any): MeasurementMergeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementMergeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item);
        }
        data["removeAfterMerge"] = this.removeAfterMerge;
        return data;
    }
}

export interface IMeasurementMergeCommand {
    projectId?: string | undefined;
    name?: string | undefined;
    list?: string[] | undefined;
    removeAfterMerge?: boolean;
}

export class UpdateMeasurementBasicsCommand implements IUpdateMeasurementBasicsCommand {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    status?: MeasurementStatus;
    reference?: string | undefined;

    constructor(data?: IUpdateMeasurementBasicsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.recorder = _data["recorder"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.projectType = _data["projectType"];
            this.workType = _data["workType"];
            this.measurementType = _data["measurementType"];
            this.status = _data["status"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): UpdateMeasurementBasicsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasurementBasicsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["recorder"] = this.recorder;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectType"] = this.projectType;
        data["workType"] = this.workType;
        data["measurementType"] = this.measurementType;
        data["status"] = this.status;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IUpdateMeasurementBasicsCommand {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    name?: string | undefined;
    recorder?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    measurementType?: string | undefined;
    status?: MeasurementStatus;
    reference?: string | undefined;
}

export class UpdateMeasurementCommand implements IUpdateMeasurementCommand {
    projectId?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasurementStatus;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    expectedDurationInHours?: number | undefined;
    reference?: string | undefined;

    constructor(data?: IUpdateMeasurementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.notes = _data["notes"];
            this.externalNotes = _data["externalNotes"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(MeasurementRoom.fromJS(item));
            }
            this.expectedDurationInHours = _data["expectedDurationInHours"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): UpdateMeasurementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasurementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["notes"] = this.notes;
        data["externalNotes"] = this.externalNotes;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["expectedDurationInHours"] = this.expectedDurationInHours;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IUpdateMeasurementCommand {
    projectId?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasurementStatus;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    expectedDurationInHours?: number | undefined;
    reference?: string | undefined;
}

export class LoadResultMapOfMeasuringStateForAgenda implements ILoadResultMapOfMeasuringStateForAgenda {
    data?: MeasuringStateForAgenda[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfMeasuringStateForAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeasuringStateForAgenda.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfMeasuringStateForAgenda {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfMeasuringStateForAgenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfMeasuringStateForAgenda {
    data?: MeasuringStateForAgenda[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class MeasuringStateForAgenda implements IMeasuringStateForAgenda {
    documentNumber?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectId?: string | undefined;
    subcontractorId?: string | undefined;
    workType?: string | undefined;
    title?: string | undefined;
    startDateProject?: Date | undefined;
    measuringstateProgress?: number;

    constructor(data?: IMeasuringStateForAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.subcontractorId = _data["subcontractorId"];
            this.workType = _data["workType"];
            this.title = _data["title"];
            this.startDateProject = _data["startDateProject"] ? new Date(_data["startDateProject"].toString()) : <any>undefined;
            this.measuringstateProgress = _data["measuringstateProgress"];
        }
    }

    static fromJS(data: any): MeasuringStateForAgenda {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateForAgenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["subcontractorId"] = this.subcontractorId;
        data["workType"] = this.workType;
        data["title"] = this.title;
        data["startDateProject"] = this.startDateProject ? this.startDateProject.toISOString() : <any>undefined;
        data["measuringstateProgress"] = this.measuringstateProgress;
        return data;
    }
}

export interface IMeasuringStateForAgenda {
    documentNumber?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectId?: string | undefined;
    subcontractorId?: string | undefined;
    workType?: string | undefined;
    title?: string | undefined;
    startDateProject?: Date | undefined;
    measuringstateProgress?: number;
}

export class GetMeasuringStateForAgendaPopupQuery implements IGetMeasuringStateForAgendaPopupQuery {
    start?: Date;
    end?: Date;
    searchValue?: string | undefined;
    includeAll?: boolean;

    constructor(data?: IGetMeasuringStateForAgendaPopupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.searchValue = _data["searchValue"];
            this.includeAll = _data["includeAll"];
        }
    }

    static fromJS(data: any): GetMeasuringStateForAgendaPopupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasuringStateForAgendaPopupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["searchValue"] = this.searchValue;
        data["includeAll"] = this.includeAll;
        return data;
    }
}

export interface IGetMeasuringStateForAgendaPopupQuery {
    start?: Date;
    end?: Date;
    searchValue?: string | undefined;
    includeAll?: boolean;
}

export class GenerateMeasuringStatePlanningEndDateCommand implements IGenerateMeasuringStatePlanningEndDateCommand {
    start?: Date;
    measuringStateDocumentNumber?: string | undefined;
    inclusiveWeekend?: boolean;
    teamId?: string | undefined;

    constructor(data?: IGenerateMeasuringStatePlanningEndDateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.measuringStateDocumentNumber = _data["measuringStateDocumentNumber"];
            this.inclusiveWeekend = _data["inclusiveWeekend"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): GenerateMeasuringStatePlanningEndDateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateMeasuringStatePlanningEndDateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["measuringStateDocumentNumber"] = this.measuringStateDocumentNumber;
        data["inclusiveWeekend"] = this.inclusiveWeekend;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface IGenerateMeasuringStatePlanningEndDateCommand {
    start?: Date;
    measuringStateDocumentNumber?: string | undefined;
    inclusiveWeekend?: boolean;
    teamId?: string | undefined;
}

export class MeasuringStateListItemDto implements IMeasuringStateListItemDto {
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    executedPercentage?: number;
    measurementType?: string | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;

    constructor(data?: IMeasuringStateListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectType = _data["projectType"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            this.status = _data["status"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.executedPercentage = _data["executedPercentage"];
            this.measurementType = _data["measurementType"];
            this.allLinesInvoiced = _data["allLinesInvoiced"];
            this.allLinesInvoicedSubcontractor = _data["allLinesInvoicedSubcontractor"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.measuringStateType = _data["measuringStateType"];
        }
    }

    static fromJS(data: any): MeasuringStateListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectType"] = this.projectType;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        data["status"] = this.status;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["executedPercentage"] = this.executedPercentage;
        data["measurementType"] = this.measurementType;
        data["allLinesInvoiced"] = this.allLinesInvoiced;
        data["allLinesInvoicedSubcontractor"] = this.allLinesInvoicedSubcontractor;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["measuringStateType"] = this.measuringStateType;
        return data;
    }
}

export interface IMeasuringStateListItemDto {
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    executedPercentage?: number;
    measurementType?: string | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;
}

export enum MeasuringStateStatus {
    Draft = 0,
    Open = 1,
    Planned = 2,
    InProgress = 3,
    Processed = 5,
}

export class MeasuringStateDto extends AuditableEntity implements IMeasuringStateDto {
    quotationIds?: string[] | undefined;
    projectType?: string | undefined;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    lastModified?: Date;
    measuringStateRatingId?: string | undefined;
    plannedInAgenda?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;
    measurementType?: string | undefined;
    blocks?: MeasuringStateBlock[] | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    allLines?: MeasuringStateLine[] | undefined;
    rawMaterials?: MeasuringStateRawMaterial[] | undefined;
    qualityCheckMonth?: Date | undefined;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedPercentage?: number;

    constructor(data?: IMeasuringStateDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["quotationIds"])) {
                this.quotationIds = [] as any;
                for (let item of _data["quotationIds"])
                    this.quotationIds!.push(item);
            }
            this.projectType = _data["projectType"];
            this.projectId = _data["projectId"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            this.notes = _data["notes"];
            this.team = _data["team"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.measuringStateRatingId = _data["measuringStateRatingId"];
            this.plannedInAgenda = _data["plannedInAgenda"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.measuringStateType = _data["measuringStateType"];
            this.measurementType = _data["measurementType"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(MeasuringStateBlock.fromJS(item));
            }
            this.allLinesInvoiced = _data["allLinesInvoiced"];
            this.allLinesInvoicedSubcontractor = _data["allLinesInvoicedSubcontractor"];
            if (Array.isArray(_data["allLines"])) {
                this.allLines = [] as any;
                for (let item of _data["allLines"])
                    this.allLines!.push(MeasuringStateLine.fromJS(item));
            }
            if (Array.isArray(_data["rawMaterials"])) {
                this.rawMaterials = [] as any;
                for (let item of _data["rawMaterials"])
                    this.rawMaterials!.push(MeasuringStateRawMaterial.fromJS(item));
            }
            this.qualityCheckMonth = _data["qualityCheckMonth"] ? new Date(_data["qualityCheckMonth"].toString()) : <any>undefined;
            this.totalLabourCost = _data["totalLabourCost"];
            this.totalExecutedLabourCost = _data["totalExecutedLabourCost"];
            this.executedPercentage = _data["executedPercentage"];
        }
    }

    static fromJS(data: any): MeasuringStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotationIds)) {
            data["quotationIds"] = [];
            for (let item of this.quotationIds)
                data["quotationIds"].push(item);
        }
        data["projectType"] = this.projectType;
        data["projectId"] = this.projectId;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        data["notes"] = this.notes;
        data["team"] = this.team;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["measuringStateRatingId"] = this.measuringStateRatingId;
        data["plannedInAgenda"] = this.plannedInAgenda;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["measuringStateType"] = this.measuringStateType;
        data["measurementType"] = this.measurementType;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["allLinesInvoiced"] = this.allLinesInvoiced;
        data["allLinesInvoicedSubcontractor"] = this.allLinesInvoicedSubcontractor;
        if (Array.isArray(this.allLines)) {
            data["allLines"] = [];
            for (let item of this.allLines)
                data["allLines"].push(item.toJSON());
        }
        if (Array.isArray(this.rawMaterials)) {
            data["rawMaterials"] = [];
            for (let item of this.rawMaterials)
                data["rawMaterials"].push(item.toJSON());
        }
        data["qualityCheckMonth"] = this.qualityCheckMonth ? this.qualityCheckMonth.toISOString() : <any>undefined;
        data["totalLabourCost"] = this.totalLabourCost;
        data["totalExecutedLabourCost"] = this.totalExecutedLabourCost;
        data["executedPercentage"] = this.executedPercentage;
        super.toJSON(data);
        return data;
    }
}

export interface IMeasuringStateDto extends IAuditableEntity {
    quotationIds?: string[] | undefined;
    projectType?: string | undefined;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    lastModified?: Date;
    measuringStateRatingId?: string | undefined;
    plannedInAgenda?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;
    measurementType?: string | undefined;
    blocks?: MeasuringStateBlock[] | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    allLines?: MeasuringStateLine[] | undefined;
    rawMaterials?: MeasuringStateRawMaterial[] | undefined;
    qualityCheckMonth?: Date | undefined;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedPercentage?: number;
}

export class MeasuringStateBlock implements IMeasuringStateBlock {
    id?: string | undefined;
    title?: string | undefined;
    lines?: MeasuringStateLine[] | undefined;
    selected?: boolean;
    measurementType?: string | undefined;

    constructor(data?: IMeasuringStateBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MeasuringStateLine.fromJS(item));
            }
            this.selected = _data["selected"];
            this.measurementType = _data["measurementType"];
        }
    }

    static fromJS(data: any): MeasuringStateBlock {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        data["measurementType"] = this.measurementType;
        return data;
    }
}

export interface IMeasuringStateBlock {
    id?: string | undefined;
    title?: string | undefined;
    lines?: MeasuringStateLine[] | undefined;
    selected?: boolean;
    measurementType?: string | undefined;
}

export class MeasuringStateLine implements IMeasuringStateLine {
    id?: string | undefined;
    lineId?: string | undefined;
    code?: string | undefined;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    description?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    measuringUnit?: string | undefined;
    labourCost?: number | undefined;
    materialCost?: number | undefined;
    completed?: boolean;
    partialCompleted?: boolean;
    remarks?: string | undefined;
    price?: number;
    total?: number;
    selected?: boolean;
    invoiced?: boolean;
    invoicedSubcontractor?: boolean;
    includedInProgressState?: boolean;
    dateExecuted?: Date | undefined;
    monthExecuted?: Date | undefined;
    executedById?: string | undefined;
    qualityCheckMonth?: Date | undefined;
    qualityChecked?: boolean;
    qualityCheckedById?: string | undefined;
    executionCanBeCanceled?: boolean;
    visibleInList?: boolean;
    orderDocumentNumber?: string | undefined;
    quotationId?: string | undefined;
    quotationLineId?: string | undefined;

    constructor(data?: IMeasuringStateLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lineId = _data["lineId"];
            this.code = _data["code"];
            this.parentLineId = _data["parentLineId"];
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.variant = _data["variant"];
            this.description = _data["description"];
            this.length = _data["length"];
            this.height = _data["height"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.measuringUnit = _data["measuringUnit"];
            this.labourCost = _data["labourCost"];
            this.materialCost = _data["materialCost"];
            this.completed = _data["completed"];
            this.partialCompleted = _data["partialCompleted"];
            this.remarks = _data["remarks"];
            this.price = _data["price"];
            this.total = _data["total"];
            this.selected = _data["selected"];
            this.invoiced = _data["invoiced"];
            this.invoicedSubcontractor = _data["invoicedSubcontractor"];
            this.includedInProgressState = _data["includedInProgressState"];
            this.dateExecuted = _data["dateExecuted"] ? new Date(_data["dateExecuted"].toString()) : <any>undefined;
            this.monthExecuted = _data["monthExecuted"] ? new Date(_data["monthExecuted"].toString()) : <any>undefined;
            this.executedById = _data["executedById"];
            this.qualityCheckMonth = _data["qualityCheckMonth"] ? new Date(_data["qualityCheckMonth"].toString()) : <any>undefined;
            this.qualityChecked = _data["qualityChecked"];
            this.qualityCheckedById = _data["qualityCheckedById"];
            this.executionCanBeCanceled = _data["executionCanBeCanceled"];
            this.visibleInList = _data["visibleInList"];
            this.orderDocumentNumber = _data["orderDocumentNumber"];
            this.quotationId = _data["quotationId"];
            this.quotationLineId = _data["quotationLineId"];
        }
    }

    static fromJS(data: any): MeasuringStateLine {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lineId"] = this.lineId;
        data["code"] = this.code;
        data["parentLineId"] = this.parentLineId;
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["variant"] = this.variant;
        data["description"] = this.description;
        data["length"] = this.length;
        data["height"] = this.height;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["measuringUnit"] = this.measuringUnit;
        data["labourCost"] = this.labourCost;
        data["materialCost"] = this.materialCost;
        data["completed"] = this.completed;
        data["partialCompleted"] = this.partialCompleted;
        data["remarks"] = this.remarks;
        data["price"] = this.price;
        data["total"] = this.total;
        data["selected"] = this.selected;
        data["invoiced"] = this.invoiced;
        data["invoicedSubcontractor"] = this.invoicedSubcontractor;
        data["includedInProgressState"] = this.includedInProgressState;
        data["dateExecuted"] = this.dateExecuted ? this.dateExecuted.toISOString() : <any>undefined;
        data["monthExecuted"] = this.monthExecuted ? this.monthExecuted.toISOString() : <any>undefined;
        data["executedById"] = this.executedById;
        data["qualityCheckMonth"] = this.qualityCheckMonth ? this.qualityCheckMonth.toISOString() : <any>undefined;
        data["qualityChecked"] = this.qualityChecked;
        data["qualityCheckedById"] = this.qualityCheckedById;
        data["executionCanBeCanceled"] = this.executionCanBeCanceled;
        data["visibleInList"] = this.visibleInList;
        data["orderDocumentNumber"] = this.orderDocumentNumber;
        data["quotationId"] = this.quotationId;
        data["quotationLineId"] = this.quotationLineId;
        return data;
    }
}

export interface IMeasuringStateLine {
    id?: string | undefined;
    lineId?: string | undefined;
    code?: string | undefined;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    description?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    measuringUnit?: string | undefined;
    labourCost?: number | undefined;
    materialCost?: number | undefined;
    completed?: boolean;
    partialCompleted?: boolean;
    remarks?: string | undefined;
    price?: number;
    total?: number;
    selected?: boolean;
    invoiced?: boolean;
    invoicedSubcontractor?: boolean;
    includedInProgressState?: boolean;
    dateExecuted?: Date | undefined;
    monthExecuted?: Date | undefined;
    executedById?: string | undefined;
    qualityCheckMonth?: Date | undefined;
    qualityChecked?: boolean;
    qualityCheckedById?: string | undefined;
    executionCanBeCanceled?: boolean;
    visibleInList?: boolean;
    orderDocumentNumber?: string | undefined;
    quotationId?: string | undefined;
    quotationLineId?: string | undefined;
}

export class RawMaterialBase implements IRawMaterialBase {
    id?: string | undefined;
    name?: string | undefined;
    measuringUnit?: string | undefined;
    unitPrice?: number | undefined;
    amount?: number;
    totalPrice?: number | undefined;

    constructor(data?: IRawMaterialBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.measuringUnit = _data["measuringUnit"];
            this.unitPrice = _data["unitPrice"];
            this.amount = _data["amount"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RawMaterialBase {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["measuringUnit"] = this.measuringUnit;
        data["unitPrice"] = this.unitPrice;
        data["amount"] = this.amount;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRawMaterialBase {
    id?: string | undefined;
    name?: string | undefined;
    measuringUnit?: string | undefined;
    unitPrice?: number | undefined;
    amount?: number;
    totalPrice?: number | undefined;
}

export class MeasuringStateRawMaterial extends RawMaterialBase implements IMeasuringStateRawMaterial {

    constructor(data?: IMeasuringStateRawMaterial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MeasuringStateRawMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateRawMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMeasuringStateRawMaterial extends IRawMaterialBase {
}

export class MeasuringStateRawMaterialUsageDto implements IMeasuringStateRawMaterialUsageDto {
    id?: string | undefined;
    name?: string | undefined;
    measuringUnit?: string | undefined;
    unitPrice?: number | undefined;
    totalPrice?: number | undefined;
    amount?: number;

    constructor(data?: IMeasuringStateRawMaterialUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.measuringUnit = _data["measuringUnit"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MeasuringStateRawMaterialUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateRawMaterialUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["measuringUnit"] = this.measuringUnit;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMeasuringStateRawMaterialUsageDto {
    id?: string | undefined;
    name?: string | undefined;
    measuringUnit?: string | undefined;
    unitPrice?: number | undefined;
    totalPrice?: number | undefined;
    amount?: number;
}

export class UpdateMeasuringStateCommand implements IUpdateMeasuringStateCommand {
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    measuringStateRatingId?: string | undefined;
    status?: MeasuringStateStatus;
    blocks?: MeasuringStateBlock[] | undefined;
    monthExecuted?: Date | undefined;
    allLines?: MeasuringStateLine[] | undefined;
    executedLines?: MeasuringStateLine[] | undefined;
    orderDocumentNumber?: string | undefined;

    constructor(data?: IUpdateMeasuringStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectType = _data["projectType"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            this.notes = _data["notes"];
            this.team = _data["team"];
            this.measuringStateRatingId = _data["measuringStateRatingId"];
            this.status = _data["status"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(MeasuringStateBlock.fromJS(item));
            }
            this.monthExecuted = _data["monthExecuted"] ? new Date(_data["monthExecuted"].toString()) : <any>undefined;
            if (Array.isArray(_data["allLines"])) {
                this.allLines = [] as any;
                for (let item of _data["allLines"])
                    this.allLines!.push(MeasuringStateLine.fromJS(item));
            }
            if (Array.isArray(_data["executedLines"])) {
                this.executedLines = [] as any;
                for (let item of _data["executedLines"])
                    this.executedLines!.push(MeasuringStateLine.fromJS(item));
            }
            this.orderDocumentNumber = _data["orderDocumentNumber"];
        }
    }

    static fromJS(data: any): UpdateMeasuringStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasuringStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectType"] = this.projectType;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        data["notes"] = this.notes;
        data["team"] = this.team;
        data["measuringStateRatingId"] = this.measuringStateRatingId;
        data["status"] = this.status;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["monthExecuted"] = this.monthExecuted ? this.monthExecuted.toISOString() : <any>undefined;
        if (Array.isArray(this.allLines)) {
            data["allLines"] = [];
            for (let item of this.allLines)
                data["allLines"].push(item.toJSON());
        }
        if (Array.isArray(this.executedLines)) {
            data["executedLines"] = [];
            for (let item of this.executedLines)
                data["executedLines"].push(item.toJSON());
        }
        data["orderDocumentNumber"] = this.orderDocumentNumber;
        return data;
    }
}

export interface IUpdateMeasuringStateCommand {
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    measuringStateRatingId?: string | undefined;
    status?: MeasuringStateStatus;
    blocks?: MeasuringStateBlock[] | undefined;
    monthExecuted?: Date | undefined;
    allLines?: MeasuringStateLine[] | undefined;
    executedLines?: MeasuringStateLine[] | undefined;
    orderDocumentNumber?: string | undefined;
}

export class UpdateMeasuringStateTypeCommand implements IUpdateMeasuringStateTypeCommand {
    documentNumber?: string | undefined;
    measuringStateType?: string | undefined;

    constructor(data?: IUpdateMeasuringStateTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.measuringStateType = _data["measuringStateType"];
        }
    }

    static fromJS(data: any): UpdateMeasuringStateTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasuringStateTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["measuringStateType"] = this.measuringStateType;
        return data;
    }
}

export interface IUpdateMeasuringStateTypeCommand {
    documentNumber?: string | undefined;
    measuringStateType?: string | undefined;
}

export class GenerateMeasuringStateCommand implements IGenerateMeasuringStateCommand {
    quotationIds?: string[] | undefined;

    constructor(data?: IGenerateMeasuringStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quotationIds"])) {
                this.quotationIds = [] as any;
                for (let item of _data["quotationIds"])
                    this.quotationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateMeasuringStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateMeasuringStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotationIds)) {
            data["quotationIds"] = [];
            for (let item of this.quotationIds)
                data["quotationIds"].push(item);
        }
        return data;
    }
}

export interface IGenerateMeasuringStateCommand {
    quotationIds?: string[] | undefined;
}

export class GenerateMeasuringStateFromMeasurementCommand implements IGenerateMeasuringStateFromMeasurementCommand {
    projectId?: string | undefined;
    measurementNames?: string[] | undefined;

    constructor(data?: IGenerateMeasuringStateFromMeasurementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["measurementNames"])) {
                this.measurementNames = [] as any;
                for (let item of _data["measurementNames"])
                    this.measurementNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateMeasuringStateFromMeasurementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateMeasuringStateFromMeasurementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.measurementNames)) {
            data["measurementNames"] = [];
            for (let item of this.measurementNames)
                data["measurementNames"].push(item);
        }
        return data;
    }
}

export interface IGenerateMeasuringStateFromMeasurementCommand {
    projectId?: string | undefined;
    measurementNames?: string[] | undefined;
}

export class SplitMeasuringStateCommand implements ISplitMeasuringStateCommand {
    documentNumber?: string | undefined;
    blocks?: MeasuringStateBlock[] | undefined;

    constructor(data?: ISplitMeasuringStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(MeasuringStateBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplitMeasuringStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SplitMeasuringStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISplitMeasuringStateCommand {
    documentNumber?: string | undefined;
    blocks?: MeasuringStateBlock[] | undefined;
}

export class MergeMeasuringStateCommand implements IMergeMeasuringStateCommand {
    documentNumbers?: string[] | undefined;
    projectId?: string | undefined;

    constructor(data?: IMergeMeasuringStateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentNumbers"])) {
                this.documentNumbers = [] as any;
                for (let item of _data["documentNumbers"])
                    this.documentNumbers!.push(item);
            }
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): MergeMeasuringStateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MergeMeasuringStateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentNumbers)) {
            data["documentNumbers"] = [];
            for (let item of this.documentNumbers)
                data["documentNumbers"].push(item);
        }
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IMergeMeasuringStateCommand {
    documentNumbers?: string[] | undefined;
    projectId?: string | undefined;
}

export class ListForFollowUpLoadResultDto implements IListForFollowUpLoadResultDto {
    data?: MeasuringStateForFollowUpDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: IListForFollowUpLoadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MeasuringStateForFollowUpDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): ListForFollowUpLoadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListForFollowUpLoadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface IListForFollowUpLoadResultDto {
    data?: MeasuringStateForFollowUpDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class MeasuringStateForFollowUpDto implements IMeasuringStateForFollowUpDto {
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;
    percentageExecuted?: number;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    subcontractor?: string | undefined;

    constructor(data?: IMeasuringStateForFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.customer = _data["customer"];
            this.documentNumber = _data["documentNumber"];
            this.name = _data["name"];
            this.percentageExecuted = _data["percentageExecuted"];
            this.projectLeader = _data["projectLeader"];
            this.qualityGuard = _data["qualityGuard"];
            this.subcontractor = _data["subcontractor"];
        }
    }

    static fromJS(data: any): MeasuringStateForFollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateForFollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["customer"] = this.customer;
        data["documentNumber"] = this.documentNumber;
        data["name"] = this.name;
        data["percentageExecuted"] = this.percentageExecuted;
        data["projectLeader"] = this.projectLeader;
        data["qualityGuard"] = this.qualityGuard;
        data["subcontractor"] = this.subcontractor;
        return data;
    }
}

export interface IMeasuringStateForFollowUpDto {
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;
    percentageExecuted?: number;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    subcontractor?: string | undefined;
}

export class ListForFollowUpQuery implements IListForFollowUpQuery {
    billingType?: BillingType | undefined;
    periodType?: PeriodType;
    options?: DataSourceLoadOptionsBase | undefined;

    constructor(data?: IListForFollowUpQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingType = _data["billingType"];
            this.periodType = _data["periodType"];
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListForFollowUpQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ListForFollowUpQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingType"] = this.billingType;
        data["periodType"] = this.periodType;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListForFollowUpQuery {
    billingType?: BillingType | undefined;
    periodType?: PeriodType;
    options?: DataSourceLoadOptionsBase | undefined;
}

export enum BillingType {
    AdvanceInvoice = 0,
    ProgressStatement = 1,
}

export enum PeriodType {
    IncludingCurrentMonth = 0,
    ExcludingCurrentMonth = 1,
    OnlyCurrentMonth = 2,
}

/** A class with properties that specify data processing settings. */
export class DataSourceLoadOptionsBase implements IDataSourceLoadOptionsBase {
    /** A flag indicating whether the total number of data objects is required. */
    requireTotalCount?: boolean;
    /** A flag indicating whether the number of top-level groups is required. */
    requireGroupCount?: boolean;
    /** A flag indicating whether the current query is made to get the total number of data objects. */
    isCountQuery?: boolean;
    /** The number of data objects to be skipped from the start of the resulting set. */
    skip?: number;
    /** The number of data objects to be loaded. */
    take?: number;
    /** A sort expression. */
    sort?: SortingInfo[] | undefined;
    /** A group expression. */
    group?: GroupingInfo[] | undefined;
    /** A filter expression. */
    filter?: any[] | undefined;
    /** A total summary expression. */
    totalSummary?: SummaryInfo[] | undefined;
    /** A group summary expression. */
    groupSummary?: SummaryInfo[] | undefined;
    /** A select expression. */
    select?: string[] | undefined;
    /** An array of data fields that limits the Select expression.
The applied select expression is the intersection of PreSelect and Select. */
    preSelect?: string[] | undefined;
    /** A flag that indicates whether the LINQ provider should execute the select expression.
If set to false, the select operation is performed in memory. */
    remoteSelect?: boolean | undefined;
    /** A flag that indicates whether the LINQ provider should execute grouping.
If set to false, the entire dataset is loaded and grouped in memory. */
    remoteGrouping?: boolean | undefined;
    expandLinqSumType?: boolean | undefined;
    /** An array of primary keys. */
    primaryKey?: string[] | undefined;
    /** The data field to be used for sorting by default. */
    defaultSort?: string | undefined;
    /** A flag that indicates whether filter expressions should include a ToLower() call that makes string comparison case-insensitive.
Defaults to true for LINQ to Objects, false for any other provider. */
    stringToLower?: boolean | undefined;
    /** If this flag is enabled, keys and data are loaded via separate queries. This may result in a more efficient SQL execution plan. */
    paginateViaPrimaryKey?: boolean | undefined;
    sortByPrimaryKey?: boolean | undefined;
    allowAsyncOverSync?: boolean;

    constructor(data?: IDataSourceLoadOptionsBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireTotalCount = _data["requireTotalCount"];
            this.requireGroupCount = _data["requireGroupCount"];
            this.isCountQuery = _data["isCountQuery"];
            this.skip = _data["skip"];
            this.take = _data["take"];
            if (Array.isArray(_data["sort"])) {
                this.sort = [] as any;
                for (let item of _data["sort"])
                    this.sort!.push(SortingInfo.fromJS(item));
            }
            if (Array.isArray(_data["group"])) {
                this.group = [] as any;
                for (let item of _data["group"])
                    this.group!.push(GroupingInfo.fromJS(item));
            }
            if (Array.isArray(_data["filter"])) {
                this.filter = [] as any;
                for (let item of _data["filter"])
                    this.filter!.push(item);
            }
            if (Array.isArray(_data["totalSummary"])) {
                this.totalSummary = [] as any;
                for (let item of _data["totalSummary"])
                    this.totalSummary!.push(SummaryInfo.fromJS(item));
            }
            if (Array.isArray(_data["groupSummary"])) {
                this.groupSummary = [] as any;
                for (let item of _data["groupSummary"])
                    this.groupSummary!.push(SummaryInfo.fromJS(item));
            }
            if (Array.isArray(_data["select"])) {
                this.select = [] as any;
                for (let item of _data["select"])
                    this.select!.push(item);
            }
            if (Array.isArray(_data["preSelect"])) {
                this.preSelect = [] as any;
                for (let item of _data["preSelect"])
                    this.preSelect!.push(item);
            }
            this.remoteSelect = _data["remoteSelect"];
            this.remoteGrouping = _data["remoteGrouping"];
            this.expandLinqSumType = _data["expandLinqSumType"];
            if (Array.isArray(_data["primaryKey"])) {
                this.primaryKey = [] as any;
                for (let item of _data["primaryKey"])
                    this.primaryKey!.push(item);
            }
            this.defaultSort = _data["defaultSort"];
            this.stringToLower = _data["stringToLower"];
            this.paginateViaPrimaryKey = _data["paginateViaPrimaryKey"];
            this.sortByPrimaryKey = _data["sortByPrimaryKey"];
            this.allowAsyncOverSync = _data["allowAsyncOverSync"];
        }
    }

    static fromJS(data: any): DataSourceLoadOptionsBase {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceLoadOptionsBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireTotalCount"] = this.requireTotalCount;
        data["requireGroupCount"] = this.requireGroupCount;
        data["isCountQuery"] = this.isCountQuery;
        data["skip"] = this.skip;
        data["take"] = this.take;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item.toJSON());
        }
        if (Array.isArray(this.group)) {
            data["group"] = [];
            for (let item of this.group)
                data["group"].push(item.toJSON());
        }
        if (Array.isArray(this.filter)) {
            data["filter"] = [];
            for (let item of this.filter)
                data["filter"].push(item);
        }
        if (Array.isArray(this.totalSummary)) {
            data["totalSummary"] = [];
            for (let item of this.totalSummary)
                data["totalSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.groupSummary)) {
            data["groupSummary"] = [];
            for (let item of this.groupSummary)
                data["groupSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.select)) {
            data["select"] = [];
            for (let item of this.select)
                data["select"].push(item);
        }
        if (Array.isArray(this.preSelect)) {
            data["preSelect"] = [];
            for (let item of this.preSelect)
                data["preSelect"].push(item);
        }
        data["remoteSelect"] = this.remoteSelect;
        data["remoteGrouping"] = this.remoteGrouping;
        data["expandLinqSumType"] = this.expandLinqSumType;
        if (Array.isArray(this.primaryKey)) {
            data["primaryKey"] = [];
            for (let item of this.primaryKey)
                data["primaryKey"].push(item);
        }
        data["defaultSort"] = this.defaultSort;
        data["stringToLower"] = this.stringToLower;
        data["paginateViaPrimaryKey"] = this.paginateViaPrimaryKey;
        data["sortByPrimaryKey"] = this.sortByPrimaryKey;
        data["allowAsyncOverSync"] = this.allowAsyncOverSync;
        return data;
    }
}

/** A class with properties that specify data processing settings. */
export interface IDataSourceLoadOptionsBase {
    /** A flag indicating whether the total number of data objects is required. */
    requireTotalCount?: boolean;
    /** A flag indicating whether the number of top-level groups is required. */
    requireGroupCount?: boolean;
    /** A flag indicating whether the current query is made to get the total number of data objects. */
    isCountQuery?: boolean;
    /** The number of data objects to be skipped from the start of the resulting set. */
    skip?: number;
    /** The number of data objects to be loaded. */
    take?: number;
    /** A sort expression. */
    sort?: SortingInfo[] | undefined;
    /** A group expression. */
    group?: GroupingInfo[] | undefined;
    /** A filter expression. */
    filter?: any[] | undefined;
    /** A total summary expression. */
    totalSummary?: SummaryInfo[] | undefined;
    /** A group summary expression. */
    groupSummary?: SummaryInfo[] | undefined;
    /** A select expression. */
    select?: string[] | undefined;
    /** An array of data fields that limits the Select expression.
The applied select expression is the intersection of PreSelect and Select. */
    preSelect?: string[] | undefined;
    /** A flag that indicates whether the LINQ provider should execute the select expression.
If set to false, the select operation is performed in memory. */
    remoteSelect?: boolean | undefined;
    /** A flag that indicates whether the LINQ provider should execute grouping.
If set to false, the entire dataset is loaded and grouped in memory. */
    remoteGrouping?: boolean | undefined;
    expandLinqSumType?: boolean | undefined;
    /** An array of primary keys. */
    primaryKey?: string[] | undefined;
    /** The data field to be used for sorting by default. */
    defaultSort?: string | undefined;
    /** A flag that indicates whether filter expressions should include a ToLower() call that makes string comparison case-insensitive.
Defaults to true for LINQ to Objects, false for any other provider. */
    stringToLower?: boolean | undefined;
    /** If this flag is enabled, keys and data are loaded via separate queries. This may result in a more efficient SQL execution plan. */
    paginateViaPrimaryKey?: boolean | undefined;
    sortByPrimaryKey?: boolean | undefined;
    allowAsyncOverSync?: boolean;
}

export class SetMultipleQualityCheckedCommand implements ISetMultipleQualityCheckedCommand {
    documentNumbers?: string[] | undefined;
    periodType?: PeriodType;

    constructor(data?: ISetMultipleQualityCheckedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentNumbers"])) {
                this.documentNumbers = [] as any;
                for (let item of _data["documentNumbers"])
                    this.documentNumbers!.push(item);
            }
            this.periodType = _data["periodType"];
        }
    }

    static fromJS(data: any): SetMultipleQualityCheckedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetMultipleQualityCheckedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentNumbers)) {
            data["documentNumbers"] = [];
            for (let item of this.documentNumbers)
                data["documentNumbers"].push(item);
        }
        data["periodType"] = this.periodType;
        return data;
    }
}

export interface ISetMultipleQualityCheckedCommand {
    documentNumbers?: string[] | undefined;
    periodType?: PeriodType;
}

export class ListProjectsToProgressLoadResultDto implements IListProjectsToProgressLoadResultDto {
    data?: ProjectToProgressDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
    totalProjectCount?: number;
    progressStatementProjectCount?: number;

    constructor(data?: IListProjectsToProgressLoadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectToProgressDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
            this.totalProjectCount = _data["totalProjectCount"];
            this.progressStatementProjectCount = _data["progressStatementProjectCount"];
        }
    }

    static fromJS(data: any): ListProjectsToProgressLoadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListProjectsToProgressLoadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        data["totalProjectCount"] = this.totalProjectCount;
        data["progressStatementProjectCount"] = this.progressStatementProjectCount;
        return data;
    }
}

export interface IListProjectsToProgressLoadResultDto {
    data?: ProjectToProgressDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
    totalProjectCount?: number;
    progressStatementProjectCount?: number;
}

export class ProjectToProgressDto implements IProjectToProgressDto {
    projectId?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    billingType?: BillingType | undefined;
    projectReference?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;
    percentageExecuted?: number;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    subcontractor?: string | undefined;
    customerProgressStatus?: MeasuringStateProgressStatus;
    currentPeriodProgressStatementDocumentNumbers?: string[] | undefined;
    subcontractorProgressStatus?: MeasuringStateProgressStatus;
    currentPeriodSettlementDocumentNumbers?: string[] | undefined;

    constructor(data?: IProjectToProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.billingType = _data["billingType"];
            this.projectReference = _data["projectReference"];
            this.customer = _data["customer"];
            this.documentNumber = _data["documentNumber"];
            this.name = _data["name"];
            this.percentageExecuted = _data["percentageExecuted"];
            this.projectLeader = _data["projectLeader"];
            this.qualityGuard = _data["qualityGuard"];
            this.subcontractor = _data["subcontractor"];
            this.customerProgressStatus = _data["customerProgressStatus"];
            if (Array.isArray(_data["currentPeriodProgressStatementDocumentNumbers"])) {
                this.currentPeriodProgressStatementDocumentNumbers = [] as any;
                for (let item of _data["currentPeriodProgressStatementDocumentNumbers"])
                    this.currentPeriodProgressStatementDocumentNumbers!.push(item);
            }
            this.subcontractorProgressStatus = _data["subcontractorProgressStatus"];
            if (Array.isArray(_data["currentPeriodSettlementDocumentNumbers"])) {
                this.currentPeriodSettlementDocumentNumbers = [] as any;
                for (let item of _data["currentPeriodSettlementDocumentNumbers"])
                    this.currentPeriodSettlementDocumentNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectToProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectToProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["billingType"] = this.billingType;
        data["projectReference"] = this.projectReference;
        data["customer"] = this.customer;
        data["documentNumber"] = this.documentNumber;
        data["name"] = this.name;
        data["percentageExecuted"] = this.percentageExecuted;
        data["projectLeader"] = this.projectLeader;
        data["qualityGuard"] = this.qualityGuard;
        data["subcontractor"] = this.subcontractor;
        data["customerProgressStatus"] = this.customerProgressStatus;
        if (Array.isArray(this.currentPeriodProgressStatementDocumentNumbers)) {
            data["currentPeriodProgressStatementDocumentNumbers"] = [];
            for (let item of this.currentPeriodProgressStatementDocumentNumbers)
                data["currentPeriodProgressStatementDocumentNumbers"].push(item);
        }
        data["subcontractorProgressStatus"] = this.subcontractorProgressStatus;
        if (Array.isArray(this.currentPeriodSettlementDocumentNumbers)) {
            data["currentPeriodSettlementDocumentNumbers"] = [];
            for (let item of this.currentPeriodSettlementDocumentNumbers)
                data["currentPeriodSettlementDocumentNumbers"].push(item);
        }
        return data;
    }
}

export interface IProjectToProgressDto {
    projectId?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    billingType?: BillingType | undefined;
    projectReference?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    name?: string | undefined;
    percentageExecuted?: number;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    subcontractor?: string | undefined;
    customerProgressStatus?: MeasuringStateProgressStatus;
    currentPeriodProgressStatementDocumentNumbers?: string[] | undefined;
    subcontractorProgressStatus?: MeasuringStateProgressStatus;
    currentPeriodSettlementDocumentNumbers?: string[] | undefined;
}

export enum MeasuringStateProgressStatus {
    NoProgress = 0,
    PartialProgress = 1,
    FullyProgressed = 2,
}

export class ListProjectsToProgressQuery implements IListProjectsToProgressQuery {
    billingType?: BillingType | undefined;
    periodType?: PeriodType;
    options?: DataSourceLoadOptionsBase | undefined;

    constructor(data?: IListProjectsToProgressQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingType = _data["billingType"];
            this.periodType = _data["periodType"];
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListProjectsToProgressQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ListProjectsToProgressQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingType"] = this.billingType;
        data["periodType"] = this.periodType;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListProjectsToProgressQuery {
    billingType?: BillingType | undefined;
    periodType?: PeriodType;
    options?: DataSourceLoadOptionsBase | undefined;
}

export class MeasuringStateRatingItemInfoDto implements IMeasuringStateRatingItemInfoDto {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;

    constructor(data?: IMeasuringStateRatingItemInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cleanliness = _data["cleanliness"];
            this.quality = _data["quality"];
            this.fulfillingAgreements = _data["fulfillingAgreements"];
            this.punctuality = _data["punctuality"];
            this.measuringStateId = _data["measuringStateId"];
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
        }
    }

    static fromJS(data: any): MeasuringStateRatingItemInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateRatingItemInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cleanliness"] = this.cleanliness;
        data["quality"] = this.quality;
        data["fulfillingAgreements"] = this.fulfillingAgreements;
        data["punctuality"] = this.punctuality;
        data["measuringStateId"] = this.measuringStateId;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        return data;
    }
}

export interface IMeasuringStateRatingItemInfoDto {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
}

export class MeasuringStateRatingAverageInfoDto implements IMeasuringStateRatingAverageInfoDto {
    averageCleanliness?: number;
    averageQuality?: number;
    averageFulfillingAgreements?: number;
    averagePunctuality?: number;
    count?: number;

    constructor(data?: IMeasuringStateRatingAverageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageCleanliness = _data["averageCleanliness"];
            this.averageQuality = _data["averageQuality"];
            this.averageFulfillingAgreements = _data["averageFulfillingAgreements"];
            this.averagePunctuality = _data["averagePunctuality"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): MeasuringStateRatingAverageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateRatingAverageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageCleanliness"] = this.averageCleanliness;
        data["averageQuality"] = this.averageQuality;
        data["averageFulfillingAgreements"] = this.averageFulfillingAgreements;
        data["averagePunctuality"] = this.averagePunctuality;
        data["count"] = this.count;
        return data;
    }
}

export interface IMeasuringStateRatingAverageInfoDto {
    averageCleanliness?: number;
    averageQuality?: number;
    averageFulfillingAgreements?: number;
    averagePunctuality?: number;
    count?: number;
}

export class MeasuringStateRating implements IMeasuringStateRating {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;

    constructor(data?: IMeasuringStateRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cleanliness = _data["cleanliness"];
            this.quality = _data["quality"];
            this.fulfillingAgreements = _data["fulfillingAgreements"];
            this.punctuality = _data["punctuality"];
            this.measuringStateId = _data["measuringStateId"];
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
        }
    }

    static fromJS(data: any): MeasuringStateRating {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringStateRating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cleanliness"] = this.cleanliness;
        data["quality"] = this.quality;
        data["fulfillingAgreements"] = this.fulfillingAgreements;
        data["punctuality"] = this.punctuality;
        data["measuringStateId"] = this.measuringStateId;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        return data;
    }
}

export interface IMeasuringStateRating {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
}

export class CreateMeasuringStateRatingCommand implements ICreateMeasuringStateRatingCommand {
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;

    constructor(data?: ICreateMeasuringStateRatingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cleanliness = _data["cleanliness"];
            this.quality = _data["quality"];
            this.fulfillingAgreements = _data["fulfillingAgreements"];
            this.punctuality = _data["punctuality"];
            this.measuringStateId = _data["measuringStateId"];
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
        }
    }

    static fromJS(data: any): CreateMeasuringStateRatingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasuringStateRatingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cleanliness"] = this.cleanliness;
        data["quality"] = this.quality;
        data["fulfillingAgreements"] = this.fulfillingAgreements;
        data["punctuality"] = this.punctuality;
        data["measuringStateId"] = this.measuringStateId;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        return data;
    }
}

export interface ICreateMeasuringStateRatingCommand {
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
}

export class UpdateMeasuringStateRatingCommand implements IUpdateMeasuringStateRatingCommand {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;

    constructor(data?: IUpdateMeasuringStateRatingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cleanliness = _data["cleanliness"];
            this.quality = _data["quality"];
            this.fulfillingAgreements = _data["fulfillingAgreements"];
            this.punctuality = _data["punctuality"];
            this.measuringStateId = _data["measuringStateId"];
        }
    }

    static fromJS(data: any): UpdateMeasuringStateRatingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasuringStateRatingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cleanliness"] = this.cleanliness;
        data["quality"] = this.quality;
        data["fulfillingAgreements"] = this.fulfillingAgreements;
        data["punctuality"] = this.punctuality;
        data["measuringStateId"] = this.measuringStateId;
        return data;
    }
}

export interface IUpdateMeasuringStateRatingCommand {
    id?: string | undefined;
    cleanliness?: number;
    quality?: number;
    fulfillingAgreements?: number;
    punctuality?: number;
    measuringStateId?: string | undefined;
}

export class DeleteMeasuringStateRatingCommand implements IDeleteMeasuringStateRatingCommand {
    id?: string | undefined;

    constructor(data?: IDeleteMeasuringStateRatingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteMeasuringStateRatingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMeasuringStateRatingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteMeasuringStateRatingCommand {
    id?: string | undefined;
}

export class ProgressStatementListItemDto implements IProgressStatementListItemDto {
    documentNumber?: string | undefined;
    versionNumber?: number;
    status?: ProgressStatementStatus;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    contact?: ContactBasicInformationDto | undefined;
    customer?: ContactBasicInformationDto | undefined;

    constructor(data?: IProgressStatementListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.versionNumber = _data["versionNumber"];
            this.status = _data["status"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.totalCost = _data["totalCost"];
            this.total = _data["total"];
            this.totalMargin = _data["totalMargin"];
            this.contact = _data["contact"] ? ContactBasicInformationDto.fromJS(_data["contact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformationDto.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgressStatementListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["versionNumber"] = this.versionNumber;
        data["status"] = this.status;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["totalMargin"] = this.totalMargin;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProgressStatementListItemDto {
    documentNumber?: string | undefined;
    versionNumber?: number;
    status?: ProgressStatementStatus;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    contact?: ContactBasicInformationDto | undefined;
    customer?: ContactBasicInformationDto | undefined;
}

export enum ProgressStatementStatus {
    Draft = 0,
    Open = 1,
    Send = 2,
    Approved = 3,
    Declined = 4,
    Replaced = 5,
    Invoiced = 6,
}

export class ContactBasicInformationDto implements IContactBasicInformationDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContactBasicInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactBasicInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBasicInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactBasicInformationDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class BillingDetails implements IBillingDetails {
    discountPercentage?: number | undefined;

    constructor(data?: IBillingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): BillingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IBillingDetails {
    discountPercentage?: number | undefined;
}

export class ProgressStatementDto extends AuditableEntity implements IProgressStatementDto {
    documentNumber?: string | undefined;
    versionNumber?: number;
    internalVersionNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    lastModified?: Date;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectType?: string | undefined;
    projectIsOnHold?: boolean;
    contact?: ContactBasicInformation | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    totalCost?: number;
    totalWithoutDiscount?: number;
    total?: number;
    totalMargin?: number;
    articleSummary?: ProgressStatementArticleUsage[] | undefined;

    constructor(data?: IProgressStatementDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.versionNumber = _data["versionNumber"];
            this.internalVersionNumber = _data["internalVersionNumber"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodUntil = _data["periodUntil"] ? new Date(_data["periodUntil"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.quotationReference = _data["quotationReference"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectNumber = _data["projectNumber"];
            this.projectType = _data["projectType"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.contact = _data["contact"] ? ContactBasicInformation.fromJS(_data["contact"]) : <any>undefined;
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(ProgressStatementBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.totalCost = _data["totalCost"];
            this.totalWithoutDiscount = _data["totalWithoutDiscount"];
            this.total = _data["total"];
            this.totalMargin = _data["totalMargin"];
            if (Array.isArray(_data["articleSummary"])) {
                this.articleSummary = [] as any;
                for (let item of _data["articleSummary"])
                    this.articleSummary!.push(ProgressStatementArticleUsage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgressStatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["versionNumber"] = this.versionNumber;
        data["internalVersionNumber"] = this.internalVersionNumber;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodUntil"] = this.periodUntil ? this.periodUntil.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["quotationReference"] = this.quotationReference;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectNumber"] = this.projectNumber;
        data["projectType"] = this.projectType;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["totalCost"] = this.totalCost;
        data["totalWithoutDiscount"] = this.totalWithoutDiscount;
        data["total"] = this.total;
        data["totalMargin"] = this.totalMargin;
        if (Array.isArray(this.articleSummary)) {
            data["articleSummary"] = [];
            for (let item of this.articleSummary)
                data["articleSummary"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProgressStatementDto extends IAuditableEntity {
    documentNumber?: string | undefined;
    versionNumber?: number;
    internalVersionNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    lastModified?: Date;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectType?: string | undefined;
    projectIsOnHold?: boolean;
    contact?: ContactBasicInformation | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    totalCost?: number;
    totalWithoutDiscount?: number;
    total?: number;
    totalMargin?: number;
    articleSummary?: ProgressStatementArticleUsage[] | undefined;
}

export class ContactBasicInformation implements IContactBasicInformation {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContactBasicInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactBasicInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBasicInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactBasicInformation {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class ProgressStatementBlock implements IProgressStatementBlock {
    id?: string | undefined;
    title?: string | undefined;
    lines?: ProgressStatementLine[] | undefined;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    measuringStateBlockId?: string | undefined;

    constructor(data?: IProgressStatementBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ProgressStatementLine.fromJS(item));
            }
            this.totalCost = _data["totalCost"];
            this.total = _data["total"];
            this.totalMargin = _data["totalMargin"];
            this.measuringStateBlockId = _data["measuringStateBlockId"];
        }
    }

    static fromJS(data: any): ProgressStatementBlock {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["totalMargin"] = this.totalMargin;
        data["measuringStateBlockId"] = this.measuringStateBlockId;
        return data;
    }
}

export interface IProgressStatementBlock {
    id?: string | undefined;
    title?: string | undefined;
    lines?: ProgressStatementLine[] | undefined;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    measuringStateBlockId?: string | undefined;
}

export class ProgressStatementLine implements IProgressStatementLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    price?: number;
    labourCost?: number | undefined;
    originalPrice?: number;
    cost?: number;
    margin?: number;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    measuringStateLineId?: string | undefined;
    measuringStateDocumentNumber?: string | undefined;
    quotationId?: string | undefined;
    quotationLineId?: string | undefined;

    constructor(data?: IProgressStatementLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.hidden = _data["hidden"];
            this.parentLineId = _data["parentLineId"];
            this.measuringUnit = _data["measuringUnit"];
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.remarks = _data["remarks"];
            this.price = _data["price"];
            this.labourCost = _data["labourCost"];
            this.originalPrice = _data["originalPrice"];
            this.cost = _data["cost"];
            this.margin = _data["margin"];
            this.totalCost = _data["totalCost"];
            this.total = _data["total"];
            this.totalMargin = _data["totalMargin"];
            this.measuringStateLineId = _data["measuringStateLineId"];
            this.measuringStateDocumentNumber = _data["measuringStateDocumentNumber"];
            this.quotationId = _data["quotationId"];
            this.quotationLineId = _data["quotationLineId"];
        }
    }

    static fromJS(data: any): ProgressStatementLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["hidden"] = this.hidden;
        data["parentLineId"] = this.parentLineId;
        data["measuringUnit"] = this.measuringUnit;
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["remarks"] = this.remarks;
        data["price"] = this.price;
        data["labourCost"] = this.labourCost;
        data["originalPrice"] = this.originalPrice;
        data["cost"] = this.cost;
        data["margin"] = this.margin;
        data["totalCost"] = this.totalCost;
        data["total"] = this.total;
        data["totalMargin"] = this.totalMargin;
        data["measuringStateLineId"] = this.measuringStateLineId;
        data["measuringStateDocumentNumber"] = this.measuringStateDocumentNumber;
        data["quotationId"] = this.quotationId;
        data["quotationLineId"] = this.quotationLineId;
        return data;
    }
}

export interface IProgressStatementLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    price?: number;
    labourCost?: number | undefined;
    originalPrice?: number;
    cost?: number;
    margin?: number;
    totalCost?: number;
    total?: number;
    totalMargin?: number;
    measuringStateLineId?: string | undefined;
    measuringStateDocumentNumber?: string | undefined;
    quotationId?: string | undefined;
    quotationLineId?: string | undefined;
}

export class ProgressStatementArticleUsage implements IProgressStatementArticleUsage {
    articleId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    articleCategoryId?: string | undefined;

    constructor(data?: IProgressStatementArticleUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.articleCategoryId = _data["articleCategoryId"];
        }
    }

    static fromJS(data: any): ProgressStatementArticleUsage {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementArticleUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["articleCategoryId"] = this.articleCategoryId;
        return data;
    }
}

export interface IProgressStatementArticleUsage {
    articleId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    articleCategoryId?: string | undefined;
}

export class GenerateProgressStatementDocumentCommand implements IGenerateProgressStatementDocumentCommand {
    documentNumber?: string | undefined;
    versionNumber?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    language?: string | undefined;

    constructor(data?: IGenerateProgressStatementDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.versionNumber = _data["versionNumber"];
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GenerateProgressStatementDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateProgressStatementDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["versionNumber"] = this.versionNumber;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["language"] = this.language;
        return data;
    }
}

export interface IGenerateProgressStatementDocumentCommand {
    documentNumber?: string | undefined;
    versionNumber?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    language?: string | undefined;
}

export class ExportProgressStatementCommand implements IExportProgressStatementCommand {
    projectId?: string | undefined;
    currentProgressStatement?: string | undefined;
    language?: string | undefined;

    constructor(data?: IExportProgressStatementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.currentProgressStatement = _data["currentProgressStatement"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): ExportProgressStatementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProgressStatementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["currentProgressStatement"] = this.currentProgressStatement;
        data["language"] = this.language;
        return data;
    }
}

export interface IExportProgressStatementCommand {
    projectId?: string | undefined;
    currentProgressStatement?: string | undefined;
    language?: string | undefined;
}

export class ExportPdfProgressStatementCommand implements IExportPdfProgressStatementCommand {
    projectId?: string | undefined;
    currentProgressStatement?: string | undefined;
    language?: string | undefined;

    constructor(data?: IExportPdfProgressStatementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.currentProgressStatement = _data["currentProgressStatement"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): ExportPdfProgressStatementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPdfProgressStatementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["currentProgressStatement"] = this.currentProgressStatement;
        data["language"] = this.language;
        return data;
    }
}

export interface IExportPdfProgressStatementCommand {
    projectId?: string | undefined;
    currentProgressStatement?: string | undefined;
    language?: string | undefined;
}

export class ProgressStatementSelectionDataDto implements IProgressStatementSelectionDataDto {
    id?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    quantity?: string | undefined;
    completed?: boolean;

    constructor(data?: IProgressStatementSelectionDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): ProgressStatementSelectionDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementSelectionDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IProgressStatementSelectionDataDto {
    id?: string | undefined;
    parentId?: string | undefined;
    name?: string | undefined;
    quantity?: string | undefined;
    completed?: boolean;
}

export class AddProgressStatementDataCommand implements IAddProgressStatementDataCommand {
    documentNumber?: string | undefined;
    data?: ProgressStatementSelectionDataDto[] | undefined;

    constructor(data?: IAddProgressStatementDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProgressStatementSelectionDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddProgressStatementDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddProgressStatementDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddProgressStatementDataCommand {
    documentNumber?: string | undefined;
    data?: ProgressStatementSelectionDataDto[] | undefined;
}

export class UpdateProgressStatementCommand implements IUpdateProgressStatementCommand {
    documentNumber?: string | undefined;
    internalVersionNumber?: number;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    contact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;

    constructor(data?: IUpdateProgressStatementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.internalVersionNumber = _data["internalVersionNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodUntil = _data["periodUntil"] ? new Date(_data["periodUntil"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.quotationReference = _data["quotationReference"];
            this.contact = _data["contact"] ? ContactBasicInformation.fromJS(_data["contact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(ProgressStatementBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
        }
    }

    static fromJS(data: any): UpdateProgressStatementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgressStatementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["internalVersionNumber"] = this.internalVersionNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodUntil"] = this.periodUntil ? this.periodUntil.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["quotationReference"] = this.quotationReference;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        return data;
    }
}

export interface IUpdateProgressStatementCommand {
    documentNumber?: string | undefined;
    internalVersionNumber?: number;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    contact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
}

export class MailProgressStatementCommand implements IMailProgressStatementCommand {
    from?: string | undefined;
    documentNumber?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    exportType?: ProgressStatementExportType;
    language?: string | undefined;

    constructor(data?: IMailProgressStatementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.documentNumber = _data["documentNumber"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.exportType = _data["exportType"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailProgressStatementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailProgressStatementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["documentNumber"] = this.documentNumber;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["exportType"] = this.exportType;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailProgressStatementCommand {
    from?: string | undefined;
    documentNumber?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    exportType?: ProgressStatementExportType;
    language?: string | undefined;
}

export enum ProgressStatementExportType {
    Standard = 1,
    Excel = 2,
    None = 3,
    Pdf = 4,
}

export class GetProgressStatementsForInvoiceQuery implements IGetProgressStatementsForInvoiceQuery {
    projectId?: string | undefined;

    constructor(data?: IGetProgressStatementsForInvoiceQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetProgressStatementsForInvoiceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgressStatementsForInvoiceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetProgressStatementsForInvoiceQuery {
    projectId?: string | undefined;
}

export class ListProgressStatementForFollowUpLoadResultDto implements IListProgressStatementForFollowUpLoadResultDto {
    data?: ProgressStatementForFollowUpDto[] | undefined;
    totalCount?: number;
    totalAmount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
    toApproveCount?: number;
    toApproveAmount?: number;
    toInvoiceCount?: number;
    toInvoiceAmount?: number;

    constructor(data?: IListProgressStatementForFollowUpLoadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProgressStatementForFollowUpDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalAmount = _data["totalAmount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
            this.toApproveCount = _data["toApproveCount"];
            this.toApproveAmount = _data["toApproveAmount"];
            this.toInvoiceCount = _data["toInvoiceCount"];
            this.toInvoiceAmount = _data["toInvoiceAmount"];
        }
    }

    static fromJS(data: any): ListProgressStatementForFollowUpLoadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListProgressStatementForFollowUpLoadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["totalAmount"] = this.totalAmount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        data["toApproveCount"] = this.toApproveCount;
        data["toApproveAmount"] = this.toApproveAmount;
        data["toInvoiceCount"] = this.toInvoiceCount;
        data["toInvoiceAmount"] = this.toInvoiceAmount;
        return data;
    }
}

export interface IListProgressStatementForFollowUpLoadResultDto {
    data?: ProgressStatementForFollowUpDto[] | undefined;
    totalCount?: number;
    totalAmount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
    toApproveCount?: number;
    toApproveAmount?: number;
    toInvoiceCount?: number;
    toInvoiceAmount?: number;
}

export class ProgressStatementForFollowUpDto implements IProgressStatementForFollowUpDto {
    projectId?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    status?: ProgressStatementStatus;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    amount?: number;
    dateSent?: Date | undefined;

    constructor(data?: IProgressStatementForFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.customer = _data["customer"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.projectLeader = _data["projectLeader"];
            this.qualityGuard = _data["qualityGuard"];
            this.amount = _data["amount"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgressStatementForFollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatementForFollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["customer"] = this.customer;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["projectLeader"] = this.projectLeader;
        data["qualityGuard"] = this.qualityGuard;
        data["amount"] = this.amount;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProgressStatementForFollowUpDto {
    projectId?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    customer?: string | undefined;
    documentNumber?: string | undefined;
    status?: ProgressStatementStatus;
    projectLeader?: string | undefined;
    qualityGuard?: string | undefined;
    amount?: number;
    dateSent?: Date | undefined;
}

export class ListProgressStatementsForFollowUpQuery implements IListProgressStatementsForFollowUpQuery {
    options?: DataSourceLoadOptionsBase | undefined;
    statusFilter?: ProgressStatementStatusFilter;

    constructor(data?: IListProgressStatementsForFollowUpQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
            this.statusFilter = _data["statusFilter"];
        }
    }

    static fromJS(data: any): ListProgressStatementsForFollowUpQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ListProgressStatementsForFollowUpQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        return data;
    }
}

export interface IListProgressStatementsForFollowUpQuery {
    options?: DataSourceLoadOptionsBase | undefined;
    statusFilter?: ProgressStatementStatusFilter;
}

export enum ProgressStatementStatusFilter {
    ToApprove = 0,
    ToInvoice = 1,
}

export class SetProgressStatementStatusCommand implements ISetProgressStatementStatusCommand {
    documentNumbers?: string[] | undefined;
    status?: ProgressStatementStatus;

    constructor(data?: ISetProgressStatementStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentNumbers"])) {
                this.documentNumbers = [] as any;
                for (let item of _data["documentNumbers"])
                    this.documentNumbers!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetProgressStatementStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetProgressStatementStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentNumbers)) {
            data["documentNumbers"] = [];
            for (let item of this.documentNumbers)
                data["documentNumbers"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface ISetProgressStatementStatusCommand {
    documentNumbers?: string[] | undefined;
    status?: ProgressStatementStatus;
}

export class ProjectContactDto implements IProjectContactDto {
    tags?: string[] | undefined;
    contact?: ContactBasicInformationDto | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;

    constructor(data?: IProjectContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.contact = _data["contact"] ? ContactBasicInformationDto.fromJS(_data["contact"]) : <any>undefined;
            this.sendInvoice = _data["sendInvoice"];
            this.sendQuotation = _data["sendQuotation"];
            this.sendProgressStatement = _data["sendProgressStatement"];
            this.sendProjectFiches = _data["sendProjectFiches"];
        }
    }

    static fromJS(data: any): ProjectContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["sendInvoice"] = this.sendInvoice;
        data["sendQuotation"] = this.sendQuotation;
        data["sendProgressStatement"] = this.sendProgressStatement;
        data["sendProjectFiches"] = this.sendProjectFiches;
        return data;
    }
}

export interface IProjectContactDto {
    tags?: string[] | undefined;
    contact?: ContactBasicInformationDto | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;
}

export class ProjectAddOrUpdateContactCommand implements IProjectAddOrUpdateContactCommand {
    id?: string | undefined;
    projectId?: string | undefined;
    tags?: string[] | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;

    constructor(data?: IProjectAddOrUpdateContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.sendInvoice = _data["sendInvoice"];
            this.sendQuotation = _data["sendQuotation"];
            this.sendProgressStatement = _data["sendProgressStatement"];
            this.sendProjectFiches = _data["sendProjectFiches"];
        }
    }

    static fromJS(data: any): ProjectAddOrUpdateContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAddOrUpdateContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sendInvoice"] = this.sendInvoice;
        data["sendQuotation"] = this.sendQuotation;
        data["sendProgressStatement"] = this.sendProgressStatement;
        data["sendProjectFiches"] = this.sendProjectFiches;
        return data;
    }
}

export interface IProjectAddOrUpdateContactCommand {
    id?: string | undefined;
    projectId?: string | undefined;
    tags?: string[] | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;
}

export class ProjectForOutlookPlugin implements IProjectForOutlookPlugin {
    id?: string | undefined;
    value?: string | undefined;

    constructor(data?: IProjectForOutlookPlugin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectForOutlookPlugin {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectForOutlookPlugin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IProjectForOutlookPlugin {
    id?: string | undefined;
    value?: string | undefined;
}

export class Communication implements ICommunication {
    id?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    strippedBody?: string | undefined;
    communicationType?: CommunicationType;
    noteTypeIcon?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeId?: string | undefined;
    fromName?: string | undefined;
    fromValue?: string | undefined;
    dateSent?: Date;
    isDeleted?: boolean;
    ownerId?: string | undefined;
    ownerTableName?: string | undefined;
    createDate?: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    receivers?: CommunictionReceiver[] | undefined;
    attachments?: CommunicationAttachment[] | undefined;
    externalId?: string | undefined;

    constructor(data?: ICommunication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.strippedBody = _data["strippedBody"];
            this.communicationType = _data["communicationType"];
            this.noteTypeIcon = _data["noteTypeIcon"];
            this.noteTypeName = _data["noteTypeName"];
            this.noteTypeId = _data["noteTypeId"];
            this.fromName = _data["fromName"];
            this.fromValue = _data["fromValue"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.ownerId = _data["ownerId"];
            this.ownerTableName = _data["ownerTableName"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            if (Array.isArray(_data["receivers"])) {
                this.receivers = [] as any;
                for (let item of _data["receivers"])
                    this.receivers!.push(CommunictionReceiver.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommunicationAttachment.fromJS(item));
            }
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): Communication {
        data = typeof data === 'object' ? data : {};
        let result = new Communication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["strippedBody"] = this.strippedBody;
        data["communicationType"] = this.communicationType;
        data["noteTypeIcon"] = this.noteTypeIcon;
        data["noteTypeName"] = this.noteTypeName;
        data["noteTypeId"] = this.noteTypeId;
        data["fromName"] = this.fromName;
        data["fromValue"] = this.fromValue;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["ownerId"] = this.ownerId;
        data["ownerTableName"] = this.ownerTableName;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        if (Array.isArray(this.receivers)) {
            data["receivers"] = [];
            for (let item of this.receivers)
                data["receivers"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface ICommunication {
    id?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    strippedBody?: string | undefined;
    communicationType?: CommunicationType;
    noteTypeIcon?: string | undefined;
    noteTypeName?: string | undefined;
    noteTypeId?: string | undefined;
    fromName?: string | undefined;
    fromValue?: string | undefined;
    dateSent?: Date;
    isDeleted?: boolean;
    ownerId?: string | undefined;
    ownerTableName?: string | undefined;
    createDate?: Date;
    createdById?: string | undefined;
    createdByName?: string | undefined;
    receivers?: CommunictionReceiver[] | undefined;
    attachments?: CommunicationAttachment[] | undefined;
    externalId?: string | undefined;
}

export class ProjectReportsVm implements IProjectReportsVm {
    items?: ProjectReport[] | undefined;
    templates?: OneNotePageListItem[] | undefined;
    oldNoteBookId?: string | undefined;
    newNoteBookId?: string | undefined;
    resyncedPages?: number;

    constructor(data?: IProjectReportsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectReport.fromJS(item));
            }
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(OneNotePageListItem.fromJS(item));
            }
            this.oldNoteBookId = _data["oldNoteBookId"];
            this.newNoteBookId = _data["newNoteBookId"];
            this.resyncedPages = _data["resyncedPages"];
        }
    }

    static fromJS(data: any): ProjectReportsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        data["oldNoteBookId"] = this.oldNoteBookId;
        data["newNoteBookId"] = this.newNoteBookId;
        data["resyncedPages"] = this.resyncedPages;
        return data;
    }
}

export interface IProjectReportsVm {
    items?: ProjectReport[] | undefined;
    templates?: OneNotePageListItem[] | undefined;
    oldNoteBookId?: string | undefined;
    newNoteBookId?: string | undefined;
    resyncedPages?: number;
}

export class OneNotePageListItem implements IOneNotePageListItem {
    id?: string | undefined;
    title?: string | undefined;
    clientUrl?: string | undefined;
    webUrl?: string | undefined;
    type?: ProjectReportType;
    date?: Date | undefined;

    constructor(data?: IOneNotePageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.clientUrl = _data["clientUrl"];
            this.webUrl = _data["webUrl"];
            this.type = _data["type"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OneNotePageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OneNotePageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["clientUrl"] = this.clientUrl;
        data["webUrl"] = this.webUrl;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOneNotePageListItem {
    id?: string | undefined;
    title?: string | undefined;
    clientUrl?: string | undefined;
    webUrl?: string | undefined;
    type?: ProjectReportType;
    date?: Date | undefined;
}

export class ManualSyncOnenoteCommand implements IManualSyncOnenoteCommand {
    projectId?: string | undefined;

    constructor(data?: IManualSyncOnenoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ManualSyncOnenoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ManualSyncOnenoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IManualSyncOnenoteCommand {
    projectId?: string | undefined;
}

export class CreateProjectReportCommand implements ICreateProjectReportCommand {
    projectId?: string | undefined;
    templateId?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;

    constructor(data?: ICreateProjectReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
            this.type = _data["type"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateProjectReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        data["type"] = this.type;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateProjectReportCommand {
    projectId?: string | undefined;
    templateId?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;
}

export class UpdateProjectReportCommand implements IUpdateProjectReportCommand {
    projectId?: string | undefined;
    pageId?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;

    constructor(data?: IUpdateProjectReportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.pageId = _data["pageId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): UpdateProjectReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["pageId"] = this.pageId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IUpdateProjectReportCommand {
    projectId?: string | undefined;
    pageId?: string | undefined;
    type?: ProjectReportType;
    title?: string | undefined;
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;
}

export class ProjectBasicInfoDto implements IProjectBasicInfoDto {
    id?: string | undefined;
    name?: string | undefined;
    address?: Address | undefined;
    tunnelGroupsId?: string | undefined;

    constructor(data?: IProjectBasicInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.tunnelGroupsId = _data["tunnelGroupsId"];
        }
    }

    static fromJS(data: any): ProjectBasicInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBasicInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        return data;
    }
}

export interface IProjectBasicInfoDto {
    id?: string | undefined;
    name?: string | undefined;
    address?: Address | undefined;
    tunnelGroupsId?: string | undefined;
}

export class Address implements IAddress {
    name?: string | undefined;
    type?: AddressType;
    addressline1?: string | undefined;
    addressline2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.addressline1 = _data["addressline1"];
            this.addressline2 = _data["addressline2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["addressline1"] = this.addressline1;
        data["addressline2"] = this.addressline2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddress {
    name?: string | undefined;
    type?: AddressType;
    addressline1?: string | undefined;
    addressline2?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export enum AddressType {
    Default = 0,
    DeliveryAddress = 1,
    InvoicingAddress = 2,
    VisitAddress = 3,
}

export class LoadResultMapOfProjectListItemDto implements ILoadResultMapOfProjectListItemDto {
    data?: ProjectListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfProjectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfProjectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfProjectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfProjectListItemDto {
    data?: ProjectListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class ProjectListItemDto implements IProjectListItemDto {
    id?: string | undefined;
    name?: string | undefined;
    source?: string | undefined;
    projectNumber?: string | undefined;
    isOnHond?: boolean;
    status?: number;
    type?: string | undefined;
    declineReason?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    termsOfPayment?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    stats?: Statistics | undefined;
    openQuotations?: number;
    executedPercentage?: number;
    lastGeneratedFichesZip?: Date | undefined;
    fichesZipSent?: boolean;
    siteLabel?: string | undefined;

    constructor(data?: IProjectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.source = _data["source"];
            this.projectNumber = _data["projectNumber"];
            this.isOnHond = _data["isOnHond"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.declineReason = _data["declineReason"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
            this.customerReference = _data["customerReference"];
            this.caseNumberRsz = _data["caseNumberRsz"];
            this.termsOfPayment = _data["termsOfPayment"];
            this.requestedExecutionDate = _data["requestedExecutionDate"] ? new Date(_data["requestedExecutionDate"].toString()) : <any>undefined;
            this.stats = _data["stats"] ? Statistics.fromJS(_data["stats"]) : <any>undefined;
            this.openQuotations = _data["openQuotations"];
            this.executedPercentage = _data["executedPercentage"];
            this.lastGeneratedFichesZip = _data["lastGeneratedFichesZip"] ? new Date(_data["lastGeneratedFichesZip"].toString()) : <any>undefined;
            this.fichesZipSent = _data["fichesZipSent"];
            this.siteLabel = _data["siteLabel"];
        }
    }

    static fromJS(data: any): ProjectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["source"] = this.source;
        data["projectNumber"] = this.projectNumber;
        data["isOnHond"] = this.isOnHond;
        data["status"] = this.status;
        data["type"] = this.type;
        data["declineReason"] = this.declineReason;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["customerReference"] = this.customerReference;
        data["caseNumberRsz"] = this.caseNumberRsz;
        data["termsOfPayment"] = this.termsOfPayment;
        data["requestedExecutionDate"] = this.requestedExecutionDate ? this.requestedExecutionDate.toISOString() : <any>undefined;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["openQuotations"] = this.openQuotations;
        data["executedPercentage"] = this.executedPercentage;
        data["lastGeneratedFichesZip"] = this.lastGeneratedFichesZip ? this.lastGeneratedFichesZip.toISOString() : <any>undefined;
        data["fichesZipSent"] = this.fichesZipSent;
        data["siteLabel"] = this.siteLabel;
        return data;
    }
}

export interface IProjectListItemDto {
    id?: string | undefined;
    name?: string | undefined;
    source?: string | undefined;
    projectNumber?: string | undefined;
    isOnHond?: boolean;
    status?: number;
    type?: string | undefined;
    declineReason?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    termsOfPayment?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    stats?: Statistics | undefined;
    openQuotations?: number;
    executedPercentage?: number;
    lastGeneratedFichesZip?: Date | undefined;
    fichesZipSent?: boolean;
    siteLabel?: string | undefined;
}

export class Statistics implements IStatistics {
    completed?: boolean;
    measurementsOpen?: number;
    measurementsProcessed?: number;
    measurementsClosed?: number;
    measurementsInProgress?: number;
    estimatedTurnover?: number;
    effectiveTurnover?: number;
    estimatedMaterialCost?: number;
    effectiveMaterialCost?: number;
    estimatedLabourCost?: number;
    effectiveLabourCost?: number;
    effectiveVariaCost?: number;
    estimatedTotalCosts?: number;
    effectiveTotalCosts?: number;
    estimatedProfit?: number;
    effectiveProfit?: number;

    constructor(data?: IStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.measurementsOpen = _data["measurementsOpen"];
            this.measurementsProcessed = _data["measurementsProcessed"];
            this.measurementsClosed = _data["measurementsClosed"];
            this.measurementsInProgress = _data["measurementsInProgress"];
            this.estimatedTurnover = _data["estimatedTurnover"];
            this.effectiveTurnover = _data["effectiveTurnover"];
            this.estimatedMaterialCost = _data["estimatedMaterialCost"];
            this.effectiveMaterialCost = _data["effectiveMaterialCost"];
            this.estimatedLabourCost = _data["estimatedLabourCost"];
            this.effectiveLabourCost = _data["effectiveLabourCost"];
            this.effectiveVariaCost = _data["effectiveVariaCost"];
            this.estimatedTotalCosts = _data["estimatedTotalCosts"];
            this.effectiveTotalCosts = _data["effectiveTotalCosts"];
            this.estimatedProfit = _data["estimatedProfit"];
            this.effectiveProfit = _data["effectiveProfit"];
        }
    }

    static fromJS(data: any): Statistics {
        data = typeof data === 'object' ? data : {};
        let result = new Statistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["measurementsOpen"] = this.measurementsOpen;
        data["measurementsProcessed"] = this.measurementsProcessed;
        data["measurementsClosed"] = this.measurementsClosed;
        data["measurementsInProgress"] = this.measurementsInProgress;
        data["estimatedTurnover"] = this.estimatedTurnover;
        data["effectiveTurnover"] = this.effectiveTurnover;
        data["estimatedMaterialCost"] = this.estimatedMaterialCost;
        data["effectiveMaterialCost"] = this.effectiveMaterialCost;
        data["estimatedLabourCost"] = this.estimatedLabourCost;
        data["effectiveLabourCost"] = this.effectiveLabourCost;
        data["effectiveVariaCost"] = this.effectiveVariaCost;
        data["estimatedTotalCosts"] = this.estimatedTotalCosts;
        data["effectiveTotalCosts"] = this.effectiveTotalCosts;
        data["estimatedProfit"] = this.estimatedProfit;
        data["effectiveProfit"] = this.effectiveProfit;
        return data;
    }
}

export interface IStatistics {
    completed?: boolean;
    measurementsOpen?: number;
    measurementsProcessed?: number;
    measurementsClosed?: number;
    measurementsInProgress?: number;
    estimatedTurnover?: number;
    effectiveTurnover?: number;
    estimatedMaterialCost?: number;
    effectiveMaterialCost?: number;
    estimatedLabourCost?: number;
    effectiveLabourCost?: number;
    effectiveVariaCost?: number;
    estimatedTotalCosts?: number;
    effectiveTotalCosts?: number;
    estimatedProfit?: number;
    effectiveProfit?: number;
}

export class ProjectsLookupQuery implements IProjectsLookupQuery {
    options?: DataSourceLoadOptionsBase | undefined;
    contactId?: string | undefined;
    contactType?: ProjectLookupContactType;

    constructor(data?: IProjectsLookupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contactType = _data["contactType"];
        }
    }

    static fromJS(data: any): ProjectsLookupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectsLookupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contactType"] = this.contactType;
        return data;
    }
}

export interface IProjectsLookupQuery {
    options?: DataSourceLoadOptionsBase | undefined;
    contactId?: string | undefined;
    contactType?: ProjectLookupContactType;
}

export enum ProjectLookupContactType {
    All = 0,
    Contact = 1,
    Company = 2,
}

export class MaterialOrderDesignInfoDto implements IMaterialOrderDesignInfoDto {
    id?: string | undefined;
    name?: string | undefined;
    articleCategoryId?: string | undefined;
    details?: MaterialOrderDesignInfoDetails[] | undefined;

    constructor(data?: IMaterialOrderDesignInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.articleCategoryId = _data["articleCategoryId"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(MaterialOrderDesignInfoDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialOrderDesignInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialOrderDesignInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["articleCategoryId"] = this.articleCategoryId;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialOrderDesignInfoDto {
    id?: string | undefined;
    name?: string | undefined;
    articleCategoryId?: string | undefined;
    details?: MaterialOrderDesignInfoDetails[] | undefined;
}

export class MaterialOrderDesignInfoDetails implements IMaterialOrderDesignInfoDetails {
    brand?: string | undefined;
    kind?: string | undefined;
    measuringUnit?: string | undefined;
    defaultAmount?: number;
    supplierDetails?: MaterialOrderDesignSupplierDetails[] | undefined;

    constructor(data?: IMaterialOrderDesignInfoDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"];
            this.kind = _data["kind"];
            this.measuringUnit = _data["measuringUnit"];
            this.defaultAmount = _data["defaultAmount"];
            if (Array.isArray(_data["supplierDetails"])) {
                this.supplierDetails = [] as any;
                for (let item of _data["supplierDetails"])
                    this.supplierDetails!.push(MaterialOrderDesignSupplierDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialOrderDesignInfoDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialOrderDesignInfoDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand;
        data["kind"] = this.kind;
        data["measuringUnit"] = this.measuringUnit;
        data["defaultAmount"] = this.defaultAmount;
        if (Array.isArray(this.supplierDetails)) {
            data["supplierDetails"] = [];
            for (let item of this.supplierDetails)
                data["supplierDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialOrderDesignInfoDetails {
    brand?: string | undefined;
    kind?: string | undefined;
    measuringUnit?: string | undefined;
    defaultAmount?: number;
    supplierDetails?: MaterialOrderDesignSupplierDetails[] | undefined;
}

export class MaterialOrderDesignSupplierDetails implements IMaterialOrderDesignSupplierDetails {
    supplierId?: string | undefined;
    supplierReference?: string | undefined;
    quantity?: number;
    measuringUnit?: string | undefined;
    unitPrice?: number;
    total?: number;
    selected?: boolean;
    isDefault?: boolean;
    isCheapest?: boolean;

    constructor(data?: IMaterialOrderDesignSupplierDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.supplierReference = _data["supplierReference"];
            this.quantity = _data["quantity"];
            this.measuringUnit = _data["measuringUnit"];
            this.unitPrice = _data["unitPrice"];
            this.total = _data["total"];
            this.selected = _data["selected"];
            this.isDefault = _data["isDefault"];
            this.isCheapest = _data["isCheapest"];
        }
    }

    static fromJS(data: any): MaterialOrderDesignSupplierDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialOrderDesignSupplierDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["supplierReference"] = this.supplierReference;
        data["quantity"] = this.quantity;
        data["measuringUnit"] = this.measuringUnit;
        data["unitPrice"] = this.unitPrice;
        data["total"] = this.total;
        data["selected"] = this.selected;
        data["isDefault"] = this.isDefault;
        data["isCheapest"] = this.isCheapest;
        return data;
    }
}

export interface IMaterialOrderDesignSupplierDetails {
    supplierId?: string | undefined;
    supplierReference?: string | undefined;
    quantity?: number;
    measuringUnit?: string | undefined;
    unitPrice?: number;
    total?: number;
    selected?: boolean;
    isDefault?: boolean;
    isCheapest?: boolean;
}

export class GetMaterialOrderDesignInfoQuery implements IGetMaterialOrderDesignInfoQuery {
    projectId?: string | undefined;
    documentNumbers?: string[] | undefined;

    constructor(data?: IGetMaterialOrderDesignInfoQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["documentNumbers"])) {
                this.documentNumbers = [] as any;
                for (let item of _data["documentNumbers"])
                    this.documentNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMaterialOrderDesignInfoQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMaterialOrderDesignInfoQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.documentNumbers)) {
            data["documentNumbers"] = [];
            for (let item of this.documentNumbers)
                data["documentNumbers"].push(item);
        }
        return data;
    }
}

export interface IGetMaterialOrderDesignInfoQuery {
    projectId?: string | undefined;
    documentNumbers?: string[] | undefined;
}

export class Project extends EntityBase implements IProject {
    version?: DocumentVersion;
    name?: string | undefined;
    source?: string | undefined;
    sharepointFolder?: string | undefined;
    projectNumber?: string | undefined;
    status?: number;
    executedPercentage?: number;
    declineReason?: string | undefined;
    location?: Location | undefined;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    notebookId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    measurements?: Measurement[] | undefined;
    measuringStates?: MeasuringState[] | undefined;
    progressStatements?: ProgressStatement[] | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    contacts?: AssignedContact[] | undefined;
    contracts?: Contract[] | undefined;
    reports?: ProjectReport[] | undefined;
    visits?: ProjectVisit[] | undefined;
    metaData?: ProjectMetaData[] | undefined;
    financeDocumentSettings?: FinanceDocumentSettings | undefined;
    lastGeneratedFichesZip?: Date | undefined;
    lastFichesZipSent?: Date | undefined;
    lastSyncWithOnenote?: Date | undefined;
    automaticProjectFichesSent?: boolean;
    projectCosts?: ProjectCost[] | undefined;
    openQuotations?: number;
    stats?: Statistics | undefined;
    tunnelGroupsId?: string | undefined;
    templateCompanyPrefix?: string | undefined;
    templateCompanyPrefixNormalized?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;
    webUrl?: string | undefined;
    isOnHold?: boolean;
    lastOnHoldReason?: string | undefined;
    lastOnHoldCreateDate?: Date | undefined;
    onHoldStatuses?: OnHoldStatus[] | undefined;

    constructor(data?: IProject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
            this.name = _data["name"];
            this.source = _data["source"];
            this.sharepointFolder = _data["sharepointFolder"];
            this.projectNumber = _data["projectNumber"];
            this.status = _data["status"];
            this.executedPercentage = _data["executedPercentage"];
            this.declineReason = _data["declineReason"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.type = _data["type"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
            this.notebookId = _data["notebookId"];
            this.customerReference = _data["customerReference"];
            this.caseNumberRsz = _data["caseNumberRsz"];
            this.specificProcedures = _data["specificProcedures"];
            this.checkinAtWorkTodo = _data["checkinAtWorkTodo"];
            this.checkinAtWork = _data["checkinAtWork"];
            this.termsOfPayment = _data["termsOfPayment"];
            this.cleanUpPercentage = _data["cleanUpPercentage"];
            this.wasteDisposalPercentage = _data["wasteDisposalPercentage"];
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(Measurement.fromJS(item));
            }
            if (Array.isArray(_data["measuringStates"])) {
                this.measuringStates = [] as any;
                for (let item of _data["measuringStates"])
                    this.measuringStates!.push(MeasuringState.fromJS(item));
            }
            if (Array.isArray(_data["progressStatements"])) {
                this.progressStatements = [] as any;
                for (let item of _data["progressStatements"])
                    this.progressStatements!.push(ProgressStatement.fromJS(item));
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.numberOfPhases = _data["numberOfPhases"];
            this.requestedExecutionDate = _data["requestedExecutionDate"] ? new Date(_data["requestedExecutionDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.warranty = _data["warranty"] ? ProjectWarrantySettings.fromJS(_data["warranty"]) : <any>undefined;
            this.provideSafetyHealthEnvironmentPlanTodo = _data["provideSafetyHealthEnvironmentPlanTodo"];
            this.provideSafetyHealthEnvironmentPlan = _data["provideSafetyHealthEnvironmentPlan"];
            this.provideRiskAnalysisTodo = _data["provideRiskAnalysisTodo"];
            this.provideRiskAnalysis = _data["provideRiskAnalysis"];
            this.provideInsuranceAttestTodo = _data["provideInsuranceAttestTodo"];
            this.provideInsuranceAttest = _data["provideInsuranceAttest"];
            this.provideTechnicalFilesTodo = _data["provideTechnicalFilesTodo"];
            this.provideTechnicalFiles = _data["provideTechnicalFiles"];
            this.progressStatementAcceptTerms = _data["progressStatementAcceptTerms"];
            this.penaltyClause = _data["penaltyClause"];
            this.penaltyClauseValue = _data["penaltyClauseValue"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(AssignedContact.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(ProjectReport.fromJS(item));
            }
            if (Array.isArray(_data["visits"])) {
                this.visits = [] as any;
                for (let item of _data["visits"])
                    this.visits!.push(ProjectVisit.fromJS(item));
            }
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(ProjectMetaData.fromJS(item));
            }
            this.financeDocumentSettings = _data["financeDocumentSettings"] ? FinanceDocumentSettings.fromJS(_data["financeDocumentSettings"]) : <any>undefined;
            this.lastGeneratedFichesZip = _data["lastGeneratedFichesZip"] ? new Date(_data["lastGeneratedFichesZip"].toString()) : <any>undefined;
            this.lastFichesZipSent = _data["lastFichesZipSent"] ? new Date(_data["lastFichesZipSent"].toString()) : <any>undefined;
            this.lastSyncWithOnenote = _data["lastSyncWithOnenote"] ? new Date(_data["lastSyncWithOnenote"].toString()) : <any>undefined;
            this.automaticProjectFichesSent = _data["automaticProjectFichesSent"];
            if (Array.isArray(_data["projectCosts"])) {
                this.projectCosts = [] as any;
                for (let item of _data["projectCosts"])
                    this.projectCosts!.push(ProjectCost.fromJS(item));
            }
            this.openQuotations = _data["openQuotations"];
            this.stats = _data["stats"] ? Statistics.fromJS(_data["stats"]) : <any>undefined;
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.templateCompanyPrefix = _data["templateCompanyPrefix"];
            this.templateCompanyPrefixNormalized = _data["templateCompanyPrefixNormalized"];
            this.siteLabel = _data["siteLabel"];
            this.billingType = _data["billingType"];
            this.qualityGuardId = _data["qualityGuardId"];
            this.webUrl = _data["webUrl"];
            this.isOnHold = _data["isOnHold"];
            this.lastOnHoldReason = _data["lastOnHoldReason"];
            this.lastOnHoldCreateDate = _data["lastOnHoldCreateDate"] ? new Date(_data["lastOnHoldCreateDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["onHoldStatuses"])) {
                this.onHoldStatuses = [] as any;
                for (let item of _data["onHoldStatuses"])
                    this.onHoldStatuses!.push(OnHoldStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["source"] = this.source;
        data["sharepointFolder"] = this.sharepointFolder;
        data["projectNumber"] = this.projectNumber;
        data["status"] = this.status;
        data["executedPercentage"] = this.executedPercentage;
        data["declineReason"] = this.declineReason;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["notebookId"] = this.notebookId;
        data["customerReference"] = this.customerReference;
        data["caseNumberRsz"] = this.caseNumberRsz;
        data["specificProcedures"] = this.specificProcedures;
        data["checkinAtWorkTodo"] = this.checkinAtWorkTodo;
        data["checkinAtWork"] = this.checkinAtWork;
        data["termsOfPayment"] = this.termsOfPayment;
        data["cleanUpPercentage"] = this.cleanUpPercentage;
        data["wasteDisposalPercentage"] = this.wasteDisposalPercentage;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item.toJSON());
        }
        if (Array.isArray(this.measuringStates)) {
            data["measuringStates"] = [];
            for (let item of this.measuringStates)
                data["measuringStates"].push(item.toJSON());
        }
        if (Array.isArray(this.progressStatements)) {
            data["progressStatements"] = [];
            for (let item of this.progressStatements)
                data["progressStatements"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["numberOfPhases"] = this.numberOfPhases;
        data["requestedExecutionDate"] = this.requestedExecutionDate ? this.requestedExecutionDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["warranty"] = this.warranty ? this.warranty.toJSON() : <any>undefined;
        data["provideSafetyHealthEnvironmentPlanTodo"] = this.provideSafetyHealthEnvironmentPlanTodo;
        data["provideSafetyHealthEnvironmentPlan"] = this.provideSafetyHealthEnvironmentPlan;
        data["provideRiskAnalysisTodo"] = this.provideRiskAnalysisTodo;
        data["provideRiskAnalysis"] = this.provideRiskAnalysis;
        data["provideInsuranceAttestTodo"] = this.provideInsuranceAttestTodo;
        data["provideInsuranceAttest"] = this.provideInsuranceAttest;
        data["provideTechnicalFilesTodo"] = this.provideTechnicalFilesTodo;
        data["provideTechnicalFiles"] = this.provideTechnicalFiles;
        data["progressStatementAcceptTerms"] = this.progressStatementAcceptTerms;
        data["penaltyClause"] = this.penaltyClause;
        data["penaltyClauseValue"] = this.penaltyClauseValue;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item.toJSON());
        }
        if (Array.isArray(this.visits)) {
            data["visits"] = [];
            for (let item of this.visits)
                data["visits"].push(item.toJSON());
        }
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        data["financeDocumentSettings"] = this.financeDocumentSettings ? this.financeDocumentSettings.toJSON() : <any>undefined;
        data["lastGeneratedFichesZip"] = this.lastGeneratedFichesZip ? this.lastGeneratedFichesZip.toISOString() : <any>undefined;
        data["lastFichesZipSent"] = this.lastFichesZipSent ? this.lastFichesZipSent.toISOString() : <any>undefined;
        data["lastSyncWithOnenote"] = this.lastSyncWithOnenote ? this.lastSyncWithOnenote.toISOString() : <any>undefined;
        data["automaticProjectFichesSent"] = this.automaticProjectFichesSent;
        if (Array.isArray(this.projectCosts)) {
            data["projectCosts"] = [];
            for (let item of this.projectCosts)
                data["projectCosts"].push(item.toJSON());
        }
        data["openQuotations"] = this.openQuotations;
        data["stats"] = this.stats ? this.stats.toJSON() : <any>undefined;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["templateCompanyPrefix"] = this.templateCompanyPrefix;
        data["templateCompanyPrefixNormalized"] = this.templateCompanyPrefixNormalized;
        data["siteLabel"] = this.siteLabel;
        data["billingType"] = this.billingType;
        data["qualityGuardId"] = this.qualityGuardId;
        data["webUrl"] = this.webUrl;
        data["isOnHold"] = this.isOnHold;
        data["lastOnHoldReason"] = this.lastOnHoldReason;
        data["lastOnHoldCreateDate"] = this.lastOnHoldCreateDate ? this.lastOnHoldCreateDate.toISOString() : <any>undefined;
        if (Array.isArray(this.onHoldStatuses)) {
            data["onHoldStatuses"] = [];
            for (let item of this.onHoldStatuses)
                data["onHoldStatuses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProject extends IEntityBase {
    version?: DocumentVersion;
    name?: string | undefined;
    source?: string | undefined;
    sharepointFolder?: string | undefined;
    projectNumber?: string | undefined;
    status?: number;
    executedPercentage?: number;
    declineReason?: string | undefined;
    location?: Location | undefined;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    notebookId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    measurements?: Measurement[] | undefined;
    measuringStates?: MeasuringState[] | undefined;
    progressStatements?: ProgressStatement[] | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    contacts?: AssignedContact[] | undefined;
    contracts?: Contract[] | undefined;
    reports?: ProjectReport[] | undefined;
    visits?: ProjectVisit[] | undefined;
    metaData?: ProjectMetaData[] | undefined;
    financeDocumentSettings?: FinanceDocumentSettings | undefined;
    lastGeneratedFichesZip?: Date | undefined;
    lastFichesZipSent?: Date | undefined;
    lastSyncWithOnenote?: Date | undefined;
    automaticProjectFichesSent?: boolean;
    projectCosts?: ProjectCost[] | undefined;
    openQuotations?: number;
    stats?: Statistics | undefined;
    tunnelGroupsId?: string | undefined;
    templateCompanyPrefix?: string | undefined;
    templateCompanyPrefixNormalized?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;
    webUrl?: string | undefined;
    isOnHold?: boolean;
    lastOnHoldReason?: string | undefined;
    lastOnHoldCreateDate?: Date | undefined;
    onHoldStatuses?: OnHoldStatus[] | undefined;
}

export class Location implements ILocation {
    latitude?: number;
    longitude?: number;
    accuracy?: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.accuracy = _data["accuracy"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["accuracy"] = this.accuracy;
        return data;
    }
}

export interface ILocation {
    latitude?: number;
    longitude?: number;
    accuracy?: number;
}

export class Measurement implements IMeasurement {
    name?: string | undefined;
    projectId?: string | undefined;
    recorder?: string | undefined;
    status?: MeasurementStatus;
    measurementType?: string | undefined;
    documentNumber?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    expectedDurationInHours?: number | undefined;
    header?: string | undefined;
    reference?: string | undefined;
    usedArticles?: { [key: string]: number; } | undefined;

    constructor(data?: IMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.recorder = _data["recorder"];
            this.status = _data["status"];
            this.measurementType = _data["measurementType"];
            this.documentNumber = _data["documentNumber"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.projectType = _data["projectType"];
            this.workType = _data["workType"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(MeasurementRoom.fromJS(item));
            }
            this.notes = _data["notes"];
            this.externalNotes = _data["externalNotes"];
            this.expectedDurationInHours = _data["expectedDurationInHours"];
            this.header = _data["header"];
            this.reference = _data["reference"];
            if (_data["usedArticles"]) {
                this.usedArticles = {} as any;
                for (let key in _data["usedArticles"]) {
                    if (_data["usedArticles"].hasOwnProperty(key))
                        (<any>this.usedArticles)![key] = _data["usedArticles"][key];
                }
            }
        }
    }

    static fromJS(data: any): Measurement {
        data = typeof data === 'object' ? data : {};
        let result = new Measurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["recorder"] = this.recorder;
        data["status"] = this.status;
        data["measurementType"] = this.measurementType;
        data["documentNumber"] = this.documentNumber;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectType"] = this.projectType;
        data["workType"] = this.workType;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["externalNotes"] = this.externalNotes;
        data["expectedDurationInHours"] = this.expectedDurationInHours;
        data["header"] = this.header;
        data["reference"] = this.reference;
        if (this.usedArticles) {
            data["usedArticles"] = {};
            for (let key in this.usedArticles) {
                if (this.usedArticles.hasOwnProperty(key))
                    (<any>data["usedArticles"])[key] = (<any>this.usedArticles)[key];
            }
        }
        return data;
    }
}

export interface IMeasurement {
    name?: string | undefined;
    projectId?: string | undefined;
    recorder?: string | undefined;
    status?: MeasurementStatus;
    measurementType?: string | undefined;
    documentNumber?: string | undefined;
    date?: Date;
    projectType?: string | undefined;
    workType?: string | undefined;
    rooms?: MeasurementRoom[] | undefined;
    notes?: string | undefined;
    externalNotes?: string | undefined;
    expectedDurationInHours?: number | undefined;
    header?: string | undefined;
    reference?: string | undefined;
    usedArticles?: { [key: string]: number; } | undefined;
}

export class MeasuringState implements IMeasuringState {
    version?: DocumentVersion;
    quotationIds?: string[] | undefined;
    projectType?: string | undefined;
    projectId?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    lastModified?: Date;
    qualityCheckMonth?: Date | undefined;
    measuringStateRatingId?: string | undefined;
    plannedInAgenda?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;
    measurementType?: string | undefined;
    totalCost?: number;
    totalExecutedCost?: number;
    totalMaterialCost?: number;
    totalExecutedMaterialCost?: number;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedPercentage?: number;
    totalExecutedPercentage?: number;
    qualityCheckedPercentage?: number;
    blocks?: MeasuringStateBlock[] | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    allLinesIncludedInProgressState?: boolean;
    rawMaterials?: MeasuringStateRawMaterial[] | undefined;
    codes?: Article[] | undefined;
    codeSummary?: MeasurementStateCodeUsage[] | undefined;
    allLines?: MeasuringStateLine[] | undefined;
    executedLines?: MeasuringStateLine[] | undefined;
    qualityCheckedLines?: MeasuringStateLine[] | undefined;
    customerProgressStatus?: MeasuringStateProgressStatus;
    subcontractorProgressStatus?: MeasuringStateProgressStatus;

    constructor(data?: IMeasuringState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
            if (Array.isArray(_data["quotationIds"])) {
                this.quotationIds = [] as any;
                for (let item of _data["quotationIds"])
                    this.quotationIds!.push(item);
            }
            this.projectType = _data["projectType"];
            this.projectId = _data["projectId"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            this.notes = _data["notes"];
            this.team = _data["team"];
            this.documentNumber = _data["documentNumber"];
            this.status = _data["status"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.qualityCheckMonth = _data["qualityCheckMonth"] ? new Date(_data["qualityCheckMonth"].toString()) : <any>undefined;
            this.measuringStateRatingId = _data["measuringStateRatingId"];
            this.plannedInAgenda = _data["plannedInAgenda"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.measuringStateType = _data["measuringStateType"];
            this.measurementType = _data["measurementType"];
            this.totalCost = _data["totalCost"];
            this.totalExecutedCost = _data["totalExecutedCost"];
            this.totalMaterialCost = _data["totalMaterialCost"];
            this.totalExecutedMaterialCost = _data["totalExecutedMaterialCost"];
            this.totalLabourCost = _data["totalLabourCost"];
            this.totalExecutedLabourCost = _data["totalExecutedLabourCost"];
            this.executedPercentage = _data["executedPercentage"];
            this.totalExecutedPercentage = _data["totalExecutedPercentage"];
            this.qualityCheckedPercentage = _data["qualityCheckedPercentage"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(MeasuringStateBlock.fromJS(item));
            }
            this.allLinesInvoiced = _data["allLinesInvoiced"];
            this.allLinesInvoicedSubcontractor = _data["allLinesInvoicedSubcontractor"];
            this.allLinesIncludedInProgressState = _data["allLinesIncludedInProgressState"];
            if (Array.isArray(_data["rawMaterials"])) {
                this.rawMaterials = [] as any;
                for (let item of _data["rawMaterials"])
                    this.rawMaterials!.push(MeasuringStateRawMaterial.fromJS(item));
            }
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(Article.fromJS(item));
            }
            if (Array.isArray(_data["codeSummary"])) {
                this.codeSummary = [] as any;
                for (let item of _data["codeSummary"])
                    this.codeSummary!.push(MeasurementStateCodeUsage.fromJS(item));
            }
            if (Array.isArray(_data["allLines"])) {
                this.allLines = [] as any;
                for (let item of _data["allLines"])
                    this.allLines!.push(MeasuringStateLine.fromJS(item));
            }
            if (Array.isArray(_data["executedLines"])) {
                this.executedLines = [] as any;
                for (let item of _data["executedLines"])
                    this.executedLines!.push(MeasuringStateLine.fromJS(item));
            }
            if (Array.isArray(_data["qualityCheckedLines"])) {
                this.qualityCheckedLines = [] as any;
                for (let item of _data["qualityCheckedLines"])
                    this.qualityCheckedLines!.push(MeasuringStateLine.fromJS(item));
            }
            this.customerProgressStatus = _data["customerProgressStatus"];
            this.subcontractorProgressStatus = _data["subcontractorProgressStatus"];
        }
    }

    static fromJS(data: any): MeasuringState {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        if (Array.isArray(this.quotationIds)) {
            data["quotationIds"] = [];
            for (let item of this.quotationIds)
                data["quotationIds"].push(item);
        }
        data["projectType"] = this.projectType;
        data["projectId"] = this.projectId;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        data["notes"] = this.notes;
        data["team"] = this.team;
        data["documentNumber"] = this.documentNumber;
        data["status"] = this.status;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["qualityCheckMonth"] = this.qualityCheckMonth ? this.qualityCheckMonth.toISOString() : <any>undefined;
        data["measuringStateRatingId"] = this.measuringStateRatingId;
        data["plannedInAgenda"] = this.plannedInAgenda;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["measuringStateType"] = this.measuringStateType;
        data["measurementType"] = this.measurementType;
        data["totalCost"] = this.totalCost;
        data["totalExecutedCost"] = this.totalExecutedCost;
        data["totalMaterialCost"] = this.totalMaterialCost;
        data["totalExecutedMaterialCost"] = this.totalExecutedMaterialCost;
        data["totalLabourCost"] = this.totalLabourCost;
        data["totalExecutedLabourCost"] = this.totalExecutedLabourCost;
        data["executedPercentage"] = this.executedPercentage;
        data["totalExecutedPercentage"] = this.totalExecutedPercentage;
        data["qualityCheckedPercentage"] = this.qualityCheckedPercentage;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["allLinesInvoiced"] = this.allLinesInvoiced;
        data["allLinesInvoicedSubcontractor"] = this.allLinesInvoicedSubcontractor;
        data["allLinesIncludedInProgressState"] = this.allLinesIncludedInProgressState;
        if (Array.isArray(this.rawMaterials)) {
            data["rawMaterials"] = [];
            for (let item of this.rawMaterials)
                data["rawMaterials"].push(item.toJSON());
        }
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item.toJSON());
        }
        if (Array.isArray(this.codeSummary)) {
            data["codeSummary"] = [];
            for (let item of this.codeSummary)
                data["codeSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.allLines)) {
            data["allLines"] = [];
            for (let item of this.allLines)
                data["allLines"].push(item.toJSON());
        }
        if (Array.isArray(this.executedLines)) {
            data["executedLines"] = [];
            for (let item of this.executedLines)
                data["executedLines"].push(item.toJSON());
        }
        if (Array.isArray(this.qualityCheckedLines)) {
            data["qualityCheckedLines"] = [];
            for (let item of this.qualityCheckedLines)
                data["qualityCheckedLines"].push(item.toJSON());
        }
        data["customerProgressStatus"] = this.customerProgressStatus;
        data["subcontractorProgressStatus"] = this.subcontractorProgressStatus;
        return data;
    }
}

export interface IMeasuringState {
    version?: DocumentVersion;
    quotationIds?: string[] | undefined;
    projectType?: string | undefined;
    projectId?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    notes?: string | undefined;
    team?: string | undefined;
    documentNumber?: string | undefined;
    status?: MeasuringStateStatus;
    createDate?: Date;
    lastModified?: Date;
    qualityCheckMonth?: Date | undefined;
    measuringStateRatingId?: string | undefined;
    plannedInAgenda?: boolean;
    tunnelGroupsId?: string | undefined;
    measuringStateType?: string | undefined;
    measurementType?: string | undefined;
    totalCost?: number;
    totalExecutedCost?: number;
    totalMaterialCost?: number;
    totalExecutedMaterialCost?: number;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedPercentage?: number;
    totalExecutedPercentage?: number;
    qualityCheckedPercentage?: number;
    blocks?: MeasuringStateBlock[] | undefined;
    allLinesInvoiced?: boolean;
    allLinesInvoicedSubcontractor?: boolean;
    allLinesIncludedInProgressState?: boolean;
    rawMaterials?: MeasuringStateRawMaterial[] | undefined;
    codes?: Article[] | undefined;
    codeSummary?: MeasurementStateCodeUsage[] | undefined;
    allLines?: MeasuringStateLine[] | undefined;
    executedLines?: MeasuringStateLine[] | undefined;
    qualityCheckedLines?: MeasuringStateLine[] | undefined;
    customerProgressStatus?: MeasuringStateProgressStatus;
    subcontractorProgressStatus?: MeasuringStateProgressStatus;
}

export class Article extends EntityBase implements IArticle {
    name?: string | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    labourCosts?: LabourCost[] | undefined;
    variants?: Variant[] | undefined;
    billOfMaterials?: BillOfMaterialLine[] | undefined;
    categoryId?: string | undefined;

    constructor(data?: IArticle) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["allowedWorktypes"])) {
                this.allowedWorktypes = [] as any;
                for (let item of _data["allowedWorktypes"])
                    this.allowedWorktypes!.push(item);
            }
            this.description = _data["description"];
            this.measuringUnit = _data["measuringUnit"];
            if (Array.isArray(_data["labourCosts"])) {
                this.labourCosts = [] as any;
                for (let item of _data["labourCosts"])
                    this.labourCosts!.push(LabourCost.fromJS(item));
            }
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(Variant.fromJS(item));
            }
            if (Array.isArray(_data["billOfMaterials"])) {
                this.billOfMaterials = [] as any;
                for (let item of _data["billOfMaterials"])
                    this.billOfMaterials!.push(BillOfMaterialLine.fromJS(item));
            }
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): Article {
        data = typeof data === 'object' ? data : {};
        let result = new Article();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.allowedWorktypes)) {
            data["allowedWorktypes"] = [];
            for (let item of this.allowedWorktypes)
                data["allowedWorktypes"].push(item);
        }
        data["description"] = this.description;
        data["measuringUnit"] = this.measuringUnit;
        if (Array.isArray(this.labourCosts)) {
            data["labourCosts"] = [];
            for (let item of this.labourCosts)
                data["labourCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        if (Array.isArray(this.billOfMaterials)) {
            data["billOfMaterials"] = [];
            for (let item of this.billOfMaterials)
                data["billOfMaterials"].push(item.toJSON());
        }
        data["categoryId"] = this.categoryId;
        super.toJSON(data);
        return data;
    }
}

export interface IArticle extends IEntityBase {
    name?: string | undefined;
    status?: ArticleStatus;
    type?: ArticleType;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    labourCosts?: LabourCost[] | undefined;
    variants?: Variant[] | undefined;
    billOfMaterials?: BillOfMaterialLine[] | undefined;
    categoryId?: string | undefined;
}

export enum ArticleStatus {
    Active = 0,
    Disabled = 1,
}

export enum ArticleType {
    Default = 0,
    Combination = 1,
}

export class LabourCost implements ILabourCost {
    type?: string | undefined;
    cost?: number;
    averageCost?: number;
    costTarget?: number;
    targetDuration?: number;
    minimumLabourDuration?: number;

    constructor(data?: ILabourCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.cost = _data["cost"];
            this.averageCost = _data["averageCost"];
            this.costTarget = _data["costTarget"];
            this.targetDuration = _data["targetDuration"];
            this.minimumLabourDuration = _data["minimumLabourDuration"];
        }
    }

    static fromJS(data: any): LabourCost {
        data = typeof data === 'object' ? data : {};
        let result = new LabourCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["cost"] = this.cost;
        data["averageCost"] = this.averageCost;
        data["costTarget"] = this.costTarget;
        data["targetDuration"] = this.targetDuration;
        data["minimumLabourDuration"] = this.minimumLabourDuration;
        return data;
    }
}

export interface ILabourCost {
    type?: string | undefined;
    cost?: number;
    averageCost?: number;
    costTarget?: number;
    targetDuration?: number;
    minimumLabourDuration?: number;
}

export class Variant implements IVariant {
    name?: string | undefined;
    salesPrices?: SalesPrice[] | undefined;
    materials?: UsedMaterial[] | undefined;

    constructor(data?: IVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["salesPrices"])) {
                this.salesPrices = [] as any;
                for (let item of _data["salesPrices"])
                    this.salesPrices!.push(SalesPrice.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(UsedMaterial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Variant {
        data = typeof data === 'object' ? data : {};
        let result = new Variant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.salesPrices)) {
            data["salesPrices"] = [];
            for (let item of this.salesPrices)
                data["salesPrices"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVariant {
    name?: string | undefined;
    salesPrices?: SalesPrice[] | undefined;
    materials?: UsedMaterial[] | undefined;
}

export class SalesPrice implements ISalesPrice {
    margin?: number;
    cost?: number;
    type?: string | undefined;
    price?: number;
    autoUpdate?: boolean;
    profit?: number;

    constructor(data?: ISalesPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.margin = _data["margin"];
            this.cost = _data["cost"];
            this.type = _data["type"];
            this.price = _data["price"];
            this.autoUpdate = _data["autoUpdate"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesPrice {
        data = typeof data === 'object' ? data : {};
        let result = new SalesPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["margin"] = this.margin;
        data["cost"] = this.cost;
        data["type"] = this.type;
        data["price"] = this.price;
        data["autoUpdate"] = this.autoUpdate;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesPrice {
    margin?: number;
    cost?: number;
    type?: string | undefined;
    price?: number;
    autoUpdate?: boolean;
    profit?: number;
}

export class UsedMaterial implements IUsedMaterial {
    rawMaterialRef?: string | undefined;
    quantityWithoutLosses?: number;
    lossPercentage?: number;
    amount?: number;

    constructor(data?: IUsedMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawMaterialRef = _data["rawMaterialRef"];
            this.quantityWithoutLosses = _data["quantityWithoutLosses"];
            this.lossPercentage = _data["lossPercentage"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): UsedMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new UsedMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialRef"] = this.rawMaterialRef;
        data["quantityWithoutLosses"] = this.quantityWithoutLosses;
        data["lossPercentage"] = this.lossPercentage;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IUsedMaterial {
    rawMaterialRef?: string | undefined;
    quantityWithoutLosses?: number;
    lossPercentage?: number;
    amount?: number;
}

export class BillOfMaterialLine implements IBillOfMaterialLine {
    objectId?: string | undefined;
    amount?: number;

    constructor(data?: IBillOfMaterialLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BillOfMaterialLine {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfMaterialLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBillOfMaterialLine {
    objectId?: string | undefined;
    amount?: number;
}

export class MeasurementStateCodeUsage implements IMeasurementStateCodeUsage {
    articleId?: string | undefined;
    code?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    articleCategoryId?: string | undefined;

    constructor(data?: IMeasurementStateCodeUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.code = _data["code"];
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.articleCategoryId = _data["articleCategoryId"];
        }
    }

    static fromJS(data: any): MeasurementStateCodeUsage {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementStateCodeUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["code"] = this.code;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["articleCategoryId"] = this.articleCategoryId;
        return data;
    }
}

export interface IMeasurementStateCodeUsage {
    articleId?: string | undefined;
    code?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    articleCategoryId?: string | undefined;
}

export class ProgressStatement implements IProgressStatement {
    documentNumber?: string | undefined;
    versionNumber?: number;
    mergedDocumentNumber?: string | undefined;
    internalVersionNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    lastModified?: Date;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    contact?: ContactBasicInformation | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    totalCost?: number;
    totalWithoutDiscount?: number;
    total?: number;
    totalMargin?: number;
    allLines?: ProgressStatementLine[] | undefined;
    articleSummary?: ProgressStatementArticleUsage[] | undefined;
    version?: DocumentVersion;

    constructor(data?: IProgressStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.versionNumber = _data["versionNumber"];
            this.mergedDocumentNumber = _data["mergedDocumentNumber"];
            this.internalVersionNumber = _data["internalVersionNumber"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodUntil = _data["periodUntil"] ? new Date(_data["periodUntil"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.quotationReference = _data["quotationReference"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.contact = _data["contact"] ? ContactBasicInformation.fromJS(_data["contact"]) : <any>undefined;
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(ProgressStatementBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.totalCost = _data["totalCost"];
            this.totalWithoutDiscount = _data["totalWithoutDiscount"];
            this.total = _data["total"];
            this.totalMargin = _data["totalMargin"];
            if (Array.isArray(_data["allLines"])) {
                this.allLines = [] as any;
                for (let item of _data["allLines"])
                    this.allLines!.push(ProgressStatementLine.fromJS(item));
            }
            if (Array.isArray(_data["articleSummary"])) {
                this.articleSummary = [] as any;
                for (let item of _data["articleSummary"])
                    this.articleSummary!.push(ProgressStatementArticleUsage.fromJS(item));
            }
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProgressStatement {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["versionNumber"] = this.versionNumber;
        data["mergedDocumentNumber"] = this.mergedDocumentNumber;
        data["internalVersionNumber"] = this.internalVersionNumber;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodUntil"] = this.periodUntil ? this.periodUntil.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["quotationReference"] = this.quotationReference;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["totalCost"] = this.totalCost;
        data["totalWithoutDiscount"] = this.totalWithoutDiscount;
        data["total"] = this.total;
        data["totalMargin"] = this.totalMargin;
        if (Array.isArray(this.allLines)) {
            data["allLines"] = [];
            for (let item of this.allLines)
                data["allLines"].push(item.toJSON());
        }
        if (Array.isArray(this.articleSummary)) {
            data["articleSummary"] = [];
            for (let item of this.articleSummary)
                data["articleSummary"].push(item.toJSON());
        }
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProgressStatement {
    documentNumber?: string | undefined;
    versionNumber?: number;
    mergedDocumentNumber?: string | undefined;
    internalVersionNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
    lastModified?: Date;
    status?: ProgressStatementStatus;
    quotationReference?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    contact?: ContactBasicInformation | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: ProgressStatementBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    totalCost?: number;
    totalWithoutDiscount?: number;
    total?: number;
    totalMargin?: number;
    allLines?: ProgressStatementLine[] | undefined;
    articleSummary?: ProgressStatementArticleUsage[] | undefined;
    version?: DocumentVersion;
}

export class ProjectWarrantySettings implements IProjectWarrantySettings {
    enabled?: boolean;
    amount?: number | undefined;
    released?: string | undefined;

    constructor(data?: IProjectWarrantySettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.amount = _data["amount"];
            this.released = _data["released"];
        }
    }

    static fromJS(data: any): ProjectWarrantySettings {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWarrantySettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["amount"] = this.amount;
        data["released"] = this.released;
        return data;
    }
}

export interface IProjectWarrantySettings {
    enabled?: boolean;
    amount?: number | undefined;
    released?: string | undefined;
}

export class AssignedContact implements IAssignedContact {
    tags?: string[] | undefined;
    contact?: ContactBasicInformation | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;

    constructor(data?: IAssignedContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.contact = _data["contact"] ? ContactBasicInformation.fromJS(_data["contact"]) : <any>undefined;
            this.sendInvoice = _data["sendInvoice"];
            this.sendQuotation = _data["sendQuotation"];
            this.sendProgressStatement = _data["sendProgressStatement"];
            this.sendProjectFiches = _data["sendProjectFiches"];
        }
    }

    static fromJS(data: any): AssignedContact {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["sendInvoice"] = this.sendInvoice;
        data["sendQuotation"] = this.sendQuotation;
        data["sendProgressStatement"] = this.sendProgressStatement;
        data["sendProjectFiches"] = this.sendProjectFiches;
        return data;
    }
}

export interface IAssignedContact {
    tags?: string[] | undefined;
    contact?: ContactBasicInformation | undefined;
    sendInvoice?: boolean;
    sendQuotation?: boolean;
    sendProgressStatement?: boolean;
    sendProjectFiches?: boolean;
}

export class Contract implements IContract {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    reference?: string | undefined;
    status?: ContractStatus;
    fileId?: string | undefined;
    fileSignedId?: string | undefined;
    lines?: ContractLine[] | undefined;
    fixedPrice?: number | undefined;
    contractType?: string | undefined;
    tunnelGroupsId?: string | undefined;
    total?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    version?: DocumentVersion;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
            this.measuringStateRef = _data["measuringStateRef"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            this.fileId = _data["fileId"];
            this.fileSignedId = _data["fileSignedId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ContractLine.fromJS(item));
            }
            this.fixedPrice = _data["fixedPrice"];
            this.contractType = _data["contractType"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.total = _data["total"];
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        data["measuringStateRef"] = this.measuringStateRef;
        data["reference"] = this.reference;
        data["status"] = this.status;
        data["fileId"] = this.fileId;
        data["fileSignedId"] = this.fileSignedId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["fixedPrice"] = this.fixedPrice;
        data["contractType"] = this.contractType;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["total"] = this.total;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContract {
    documentNumber?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    date?: Date;
    subcontractorId?: string | undefined;
    subcontractorName?: string | undefined;
    measuringStateRef?: string | undefined;
    reference?: string | undefined;
    status?: ContractStatus;
    fileId?: string | undefined;
    fileSignedId?: string | undefined;
    lines?: ContractLine[] | undefined;
    fixedPrice?: number | undefined;
    contractType?: string | undefined;
    tunnelGroupsId?: string | undefined;
    total?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    version?: DocumentVersion;
}

export class ProjectVisit implements IProjectVisit {
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;
    pageId?: string | undefined;
    webUrl?: string | undefined;
    clientUrl?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;

    constructor(data?: IProjectVisit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.completed = _data["completed"];
            this.pageId = _data["pageId"];
            this.webUrl = _data["webUrl"];
            this.clientUrl = _data["clientUrl"];
            this.type = _data["type"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ProjectVisit {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVisit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["completed"] = this.completed;
        data["pageId"] = this.pageId;
        data["webUrl"] = this.webUrl;
        data["clientUrl"] = this.clientUrl;
        data["type"] = this.type;
        data["title"] = this.title;
        return data;
    }
}

export interface IProjectVisit {
    date?: Date;
    employeeId?: string | undefined;
    completed?: boolean;
    pageId?: string | undefined;
    webUrl?: string | undefined;
    clientUrl?: string | undefined;
    type?: string | undefined;
    title?: string | undefined;
}

export class MetaDataItem implements IMetaDataItem {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IMetaDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetaDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new MetaDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IMetaDataItem {
    key?: string | undefined;
    value?: string | undefined;
}

export class ProjectMetaData extends MetaDataItem implements IProjectMetaData {
    showOnDocuments?: boolean;

    constructor(data?: IProjectMetaData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showOnDocuments = _data["showOnDocuments"];
        }
    }

    static fromJS(data: any): ProjectMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showOnDocuments"] = this.showOnDocuments;
        super.toJSON(data);
        return data;
    }
}

export interface IProjectMetaData extends IMetaDataItem {
    showOnDocuments?: boolean;
}

export class ProjectCost implements IProjectCost {
    description?: string | undefined;
    amount?: number;
    type?: ProjectCostType;

    constructor(data?: IProjectCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProjectCost {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["type"] = this.type;
        return data;
    }
}

export interface IProjectCost {
    description?: string | undefined;
    amount?: number;
    type?: ProjectCostType;
}

export enum ProjectCostType {
    Material = 0,
    Labour = 1,
    Varia = 2,
}

export class OnHoldStatus implements IOnHoldStatus {
    isOnHold?: boolean;
    reason?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;

    constructor(data?: IOnHoldStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOnHold = _data["isOnHold"];
            this.reason = _data["reason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): OnHoldStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OnHoldStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOnHold"] = this.isOnHold;
        data["reason"] = this.reason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IOnHoldStatus {
    isOnHold?: boolean;
    reason?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
}

export class ProjectForPlanningViewModel implements IProjectForPlanningViewModel {
    id?: string | undefined;
    name?: string | undefined;
    projectNumber?: string | undefined;
    checkinAtWork?: boolean;
    checkinAtWorkTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;

    constructor(data?: IProjectForPlanningViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectNumber = _data["projectNumber"];
            this.checkinAtWork = _data["checkinAtWork"];
            this.checkinAtWorkTodo = _data["checkinAtWorkTodo"];
            this.provideSafetyHealthEnvironmentPlan = _data["provideSafetyHealthEnvironmentPlan"];
            this.provideSafetyHealthEnvironmentPlanTodo = _data["provideSafetyHealthEnvironmentPlanTodo"];
            this.provideRiskAnalysisTodo = _data["provideRiskAnalysisTodo"];
            this.provideRiskAnalysis = _data["provideRiskAnalysis"];
            this.provideInsuranceAttestTodo = _data["provideInsuranceAttestTodo"];
            this.provideInsuranceAttest = _data["provideInsuranceAttest"];
            this.provideTechnicalFilesTodo = _data["provideTechnicalFilesTodo"];
            this.provideTechnicalFiles = _data["provideTechnicalFiles"];
        }
    }

    static fromJS(data: any): ProjectForPlanningViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectForPlanningViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectNumber"] = this.projectNumber;
        data["checkinAtWork"] = this.checkinAtWork;
        data["checkinAtWorkTodo"] = this.checkinAtWorkTodo;
        data["provideSafetyHealthEnvironmentPlan"] = this.provideSafetyHealthEnvironmentPlan;
        data["provideSafetyHealthEnvironmentPlanTodo"] = this.provideSafetyHealthEnvironmentPlanTodo;
        data["provideRiskAnalysisTodo"] = this.provideRiskAnalysisTodo;
        data["provideRiskAnalysis"] = this.provideRiskAnalysis;
        data["provideInsuranceAttestTodo"] = this.provideInsuranceAttestTodo;
        data["provideInsuranceAttest"] = this.provideInsuranceAttest;
        data["provideTechnicalFilesTodo"] = this.provideTechnicalFilesTodo;
        data["provideTechnicalFiles"] = this.provideTechnicalFiles;
        return data;
    }
}

export interface IProjectForPlanningViewModel {
    id?: string | undefined;
    name?: string | undefined;
    projectNumber?: string | undefined;
    checkinAtWork?: boolean;
    checkinAtWorkTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
}

export class LoadResultMapOfContactBasicInformation implements ILoadResultMapOfContactBasicInformation {
    data?: ContactBasicInformation[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfContactBasicInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContactBasicInformation.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfContactBasicInformation {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfContactBasicInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfContactBasicInformation {
    data?: ContactBasicInformation[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class GetAllProjectContactsQuery implements IGetAllProjectContactsQuery {
    projectId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;
    onlySubcontractors?: boolean;

    constructor(data?: IGetAllProjectContactsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
            this.onlySubcontractors = _data["onlySubcontractors"];
        }
    }

    static fromJS(data: any): GetAllProjectContactsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProjectContactsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["onlySubcontractors"] = this.onlySubcontractors;
        return data;
    }
}

export interface IGetAllProjectContactsQuery {
    projectId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;
    onlySubcontractors?: boolean;
}

export class ProjectPurchaseOverviewDto implements IProjectPurchaseOverviewDto {
    approvedQuotationsPercentage?: number;
    approvedQuotations?: number;
    quotations?: number;
    sentInvoicesPercentage?: number;
    sentInvoices?: number;
    payedInvoicesPercentage?: number;
    payedInvoices?: number;
    openInvoicesPercentage?: number;
    openInvoices?: number;
    creditNoteToInvoicePercentage?: number;
    creditNotes?: number;
    invoiceToCreditNotePercentage?: number;
    invoices?: number;

    constructor(data?: IProjectPurchaseOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvedQuotationsPercentage = _data["approvedQuotationsPercentage"];
            this.approvedQuotations = _data["approvedQuotations"];
            this.quotations = _data["quotations"];
            this.sentInvoicesPercentage = _data["sentInvoicesPercentage"];
            this.sentInvoices = _data["sentInvoices"];
            this.payedInvoicesPercentage = _data["payedInvoicesPercentage"];
            this.payedInvoices = _data["payedInvoices"];
            this.openInvoicesPercentage = _data["openInvoicesPercentage"];
            this.openInvoices = _data["openInvoices"];
            this.creditNoteToInvoicePercentage = _data["creditNoteToInvoicePercentage"];
            this.creditNotes = _data["creditNotes"];
            this.invoiceToCreditNotePercentage = _data["invoiceToCreditNotePercentage"];
            this.invoices = _data["invoices"];
        }
    }

    static fromJS(data: any): ProjectPurchaseOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPurchaseOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvedQuotationsPercentage"] = this.approvedQuotationsPercentage;
        data["approvedQuotations"] = this.approvedQuotations;
        data["quotations"] = this.quotations;
        data["sentInvoicesPercentage"] = this.sentInvoicesPercentage;
        data["sentInvoices"] = this.sentInvoices;
        data["payedInvoicesPercentage"] = this.payedInvoicesPercentage;
        data["payedInvoices"] = this.payedInvoices;
        data["openInvoicesPercentage"] = this.openInvoicesPercentage;
        data["openInvoices"] = this.openInvoices;
        data["creditNoteToInvoicePercentage"] = this.creditNoteToInvoicePercentage;
        data["creditNotes"] = this.creditNotes;
        data["invoiceToCreditNotePercentage"] = this.invoiceToCreditNotePercentage;
        data["invoices"] = this.invoices;
        return data;
    }
}

export interface IProjectPurchaseOverviewDto {
    approvedQuotationsPercentage?: number;
    approvedQuotations?: number;
    quotations?: number;
    sentInvoicesPercentage?: number;
    sentInvoices?: number;
    payedInvoicesPercentage?: number;
    payedInvoices?: number;
    openInvoicesPercentage?: number;
    openInvoices?: number;
    creditNoteToInvoicePercentage?: number;
    creditNotes?: number;
    invoiceToCreditNotePercentage?: number;
    invoices?: number;
}

export class GetProjectPurchaseOverviewQuery implements IGetProjectPurchaseOverviewQuery {
    projectId?: string | undefined;

    constructor(data?: IGetProjectPurchaseOverviewQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetProjectPurchaseOverviewQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectPurchaseOverviewQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetProjectPurchaseOverviewQuery {
    projectId?: string | undefined;
}

export class ProjectCreateCommand implements IProjectCreateCommand {
    name?: string | undefined;
    source?: string | undefined;
    status?: number;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    tunnelGroupsId?: string | undefined;
    overrideAndCreateNew?: boolean;
    templateCompanyPrefix?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;

    constructor(data?: IProjectCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.source = _data["source"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
            this.customerReference = _data["customerReference"];
            this.caseNumberRsz = _data["caseNumberRsz"];
            this.specificProcedures = _data["specificProcedures"];
            this.checkinAtWorkTodo = _data["checkinAtWorkTodo"];
            this.checkinAtWork = _data["checkinAtWork"];
            this.termsOfPayment = _data["termsOfPayment"];
            this.cleanUpPercentage = _data["cleanUpPercentage"];
            this.wasteDisposalPercentage = _data["wasteDisposalPercentage"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.numberOfPhases = _data["numberOfPhases"];
            this.requestedExecutionDate = _data["requestedExecutionDate"] ? new Date(_data["requestedExecutionDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.warranty = _data["warranty"] ? ProjectWarrantySettings.fromJS(_data["warranty"]) : <any>undefined;
            this.provideSafetyHealthEnvironmentPlanTodo = _data["provideSafetyHealthEnvironmentPlanTodo"];
            this.provideSafetyHealthEnvironmentPlan = _data["provideSafetyHealthEnvironmentPlan"];
            this.provideRiskAnalysisTodo = _data["provideRiskAnalysisTodo"];
            this.provideRiskAnalysis = _data["provideRiskAnalysis"];
            this.provideInsuranceAttestTodo = _data["provideInsuranceAttestTodo"];
            this.provideInsuranceAttest = _data["provideInsuranceAttest"];
            this.provideTechnicalFilesTodo = _data["provideTechnicalFilesTodo"];
            this.provideTechnicalFiles = _data["provideTechnicalFiles"];
            this.progressStatementAcceptTerms = _data["progressStatementAcceptTerms"];
            this.penaltyClause = _data["penaltyClause"];
            this.penaltyClauseValue = _data["penaltyClauseValue"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.overrideAndCreateNew = _data["overrideAndCreateNew"];
            this.templateCompanyPrefix = _data["templateCompanyPrefix"];
            this.siteLabel = _data["siteLabel"];
            this.billingType = _data["billingType"];
            this.qualityGuardId = _data["qualityGuardId"];
        }
    }

    static fromJS(data: any): ProjectCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["source"] = this.source;
        data["status"] = this.status;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["customerReference"] = this.customerReference;
        data["caseNumberRsz"] = this.caseNumberRsz;
        data["specificProcedures"] = this.specificProcedures;
        data["checkinAtWorkTodo"] = this.checkinAtWorkTodo;
        data["checkinAtWork"] = this.checkinAtWork;
        data["termsOfPayment"] = this.termsOfPayment;
        data["cleanUpPercentage"] = this.cleanUpPercentage;
        data["wasteDisposalPercentage"] = this.wasteDisposalPercentage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["numberOfPhases"] = this.numberOfPhases;
        data["requestedExecutionDate"] = this.requestedExecutionDate ? this.requestedExecutionDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["warranty"] = this.warranty ? this.warranty.toJSON() : <any>undefined;
        data["provideSafetyHealthEnvironmentPlanTodo"] = this.provideSafetyHealthEnvironmentPlanTodo;
        data["provideSafetyHealthEnvironmentPlan"] = this.provideSafetyHealthEnvironmentPlan;
        data["provideRiskAnalysisTodo"] = this.provideRiskAnalysisTodo;
        data["provideRiskAnalysis"] = this.provideRiskAnalysis;
        data["provideInsuranceAttestTodo"] = this.provideInsuranceAttestTodo;
        data["provideInsuranceAttest"] = this.provideInsuranceAttest;
        data["provideTechnicalFilesTodo"] = this.provideTechnicalFilesTodo;
        data["provideTechnicalFiles"] = this.provideTechnicalFiles;
        data["progressStatementAcceptTerms"] = this.progressStatementAcceptTerms;
        data["penaltyClause"] = this.penaltyClause;
        data["penaltyClauseValue"] = this.penaltyClauseValue;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["overrideAndCreateNew"] = this.overrideAndCreateNew;
        data["templateCompanyPrefix"] = this.templateCompanyPrefix;
        data["siteLabel"] = this.siteLabel;
        data["billingType"] = this.billingType;
        data["qualityGuardId"] = this.qualityGuardId;
        return data;
    }
}

export interface IProjectCreateCommand {
    name?: string | undefined;
    source?: string | undefined;
    status?: number;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    tunnelGroupsId?: string | undefined;
    overrideAndCreateNew?: boolean;
    templateCompanyPrefix?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;
}

export class ProjectUpdateCommand implements IProjectUpdateCommand {
    id?: string | undefined;
    name?: string | undefined;
    source?: string | undefined;
    status?: number;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    declineReason?: string | undefined;
    statsCompleted?: boolean;
    tunnelGroupsId?: string | undefined;
    templateCompanyPrefix?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;

    constructor(data?: IProjectUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.source = _data["source"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
            this.customerReference = _data["customerReference"];
            this.caseNumberRsz = _data["caseNumberRsz"];
            this.specificProcedures = _data["specificProcedures"];
            this.checkinAtWorkTodo = _data["checkinAtWorkTodo"];
            this.checkinAtWork = _data["checkinAtWork"];
            this.termsOfPayment = _data["termsOfPayment"];
            this.cleanUpPercentage = _data["cleanUpPercentage"];
            this.wasteDisposalPercentage = _data["wasteDisposalPercentage"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.numberOfPhases = _data["numberOfPhases"];
            this.requestedExecutionDate = _data["requestedExecutionDate"] ? new Date(_data["requestedExecutionDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.warranty = _data["warranty"] ? ProjectWarrantySettings.fromJS(_data["warranty"]) : <any>undefined;
            this.provideSafetyHealthEnvironmentPlanTodo = _data["provideSafetyHealthEnvironmentPlanTodo"];
            this.provideSafetyHealthEnvironmentPlan = _data["provideSafetyHealthEnvironmentPlan"];
            this.provideRiskAnalysisTodo = _data["provideRiskAnalysisTodo"];
            this.provideRiskAnalysis = _data["provideRiskAnalysis"];
            this.provideInsuranceAttestTodo = _data["provideInsuranceAttestTodo"];
            this.provideInsuranceAttest = _data["provideInsuranceAttest"];
            this.provideTechnicalFilesTodo = _data["provideTechnicalFilesTodo"];
            this.provideTechnicalFiles = _data["provideTechnicalFiles"];
            this.progressStatementAcceptTerms = _data["progressStatementAcceptTerms"];
            this.penaltyClause = _data["penaltyClause"];
            this.penaltyClauseValue = _data["penaltyClauseValue"];
            this.declineReason = _data["declineReason"];
            this.statsCompleted = _data["statsCompleted"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.templateCompanyPrefix = _data["templateCompanyPrefix"];
            this.siteLabel = _data["siteLabel"];
            this.billingType = _data["billingType"];
            this.qualityGuardId = _data["qualityGuardId"];
        }
    }

    static fromJS(data: any): ProjectUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["source"] = this.source;
        data["status"] = this.status;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["customerReference"] = this.customerReference;
        data["caseNumberRsz"] = this.caseNumberRsz;
        data["specificProcedures"] = this.specificProcedures;
        data["checkinAtWorkTodo"] = this.checkinAtWorkTodo;
        data["checkinAtWork"] = this.checkinAtWork;
        data["termsOfPayment"] = this.termsOfPayment;
        data["cleanUpPercentage"] = this.cleanUpPercentage;
        data["wasteDisposalPercentage"] = this.wasteDisposalPercentage;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["numberOfPhases"] = this.numberOfPhases;
        data["requestedExecutionDate"] = this.requestedExecutionDate ? this.requestedExecutionDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["warranty"] = this.warranty ? this.warranty.toJSON() : <any>undefined;
        data["provideSafetyHealthEnvironmentPlanTodo"] = this.provideSafetyHealthEnvironmentPlanTodo;
        data["provideSafetyHealthEnvironmentPlan"] = this.provideSafetyHealthEnvironmentPlan;
        data["provideRiskAnalysisTodo"] = this.provideRiskAnalysisTodo;
        data["provideRiskAnalysis"] = this.provideRiskAnalysis;
        data["provideInsuranceAttestTodo"] = this.provideInsuranceAttestTodo;
        data["provideInsuranceAttest"] = this.provideInsuranceAttest;
        data["provideTechnicalFilesTodo"] = this.provideTechnicalFilesTodo;
        data["provideTechnicalFiles"] = this.provideTechnicalFiles;
        data["progressStatementAcceptTerms"] = this.progressStatementAcceptTerms;
        data["penaltyClause"] = this.penaltyClause;
        data["penaltyClauseValue"] = this.penaltyClauseValue;
        data["declineReason"] = this.declineReason;
        data["statsCompleted"] = this.statsCompleted;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["templateCompanyPrefix"] = this.templateCompanyPrefix;
        data["siteLabel"] = this.siteLabel;
        data["billingType"] = this.billingType;
        data["qualityGuardId"] = this.qualityGuardId;
        return data;
    }
}

export interface IProjectUpdateCommand {
    id?: string | undefined;
    name?: string | undefined;
    source?: string | undefined;
    status?: number;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    customerReference?: string | undefined;
    caseNumberRsz?: string | undefined;
    specificProcedures?: string | undefined;
    checkinAtWorkTodo?: boolean;
    checkinAtWork?: boolean;
    termsOfPayment?: number | undefined;
    cleanUpPercentage?: number | undefined;
    wasteDisposalPercentage?: number | undefined;
    startDate?: Date | undefined;
    numberOfPhases?: number | undefined;
    requestedExecutionDate?: Date | undefined;
    endDate?: Date | undefined;
    warranty?: ProjectWarrantySettings | undefined;
    provideSafetyHealthEnvironmentPlanTodo?: boolean;
    provideSafetyHealthEnvironmentPlan?: boolean;
    provideRiskAnalysisTodo?: boolean;
    provideRiskAnalysis?: boolean;
    provideInsuranceAttestTodo?: boolean;
    provideInsuranceAttest?: boolean;
    provideTechnicalFilesTodo?: boolean;
    provideTechnicalFiles?: boolean;
    progressStatementAcceptTerms?: number | undefined;
    penaltyClause?: boolean;
    penaltyClauseValue?: string | undefined;
    declineReason?: string | undefined;
    statsCompleted?: boolean;
    tunnelGroupsId?: string | undefined;
    templateCompanyPrefix?: string | undefined;
    siteLabel?: string | undefined;
    billingType?: BillingType | undefined;
    qualityGuardId?: string | undefined;
}

export class ProjectLocationUpdateCommand implements IProjectLocationUpdateCommand {
    id?: string | undefined;
    location?: Location | undefined;

    constructor(data?: IProjectLocationUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectLocationUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLocationUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectLocationUpdateCommand {
    id?: string | undefined;
    location?: Location | undefined;
}

export class ProcessZipCommand implements IProcessZipCommand {
    projectId?: string | undefined;

    constructor(data?: IProcessZipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProcessZipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessZipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProcessZipCommand {
    projectId?: string | undefined;
}

export class MailFichesZipCommand implements IMailFichesZipCommand {
    projectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    from?: string | undefined;

    constructor(data?: IMailFichesZipCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): MailFichesZipCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailFichesZipCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["from"] = this.from;
        return data;
    }
}

export interface IMailFichesZipCommand {
    projectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    from?: string | undefined;
}

export class TemplateCompanyPrefixDto implements ITemplateCompanyPrefixDto {
    displayName?: string | undefined;
    prefix?: string | undefined;

    constructor(data?: ITemplateCompanyPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): TemplateCompanyPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCompanyPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface ITemplateCompanyPrefixDto {
    displayName?: string | undefined;
    prefix?: string | undefined;
}

export class ProjectProgressionDto implements IProjectProgressionDto {
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectId?: string | undefined;
    status?: string | undefined;
    totalCost?: number;
    totalExecutedCost?: number;
    executedCostRate?: number;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedLabourCostRate?: number;
    projectTotal?: number;
    paidInvoiceTotal?: number;
    paidInvoiceRate?: number;
    contractsTotal?: number;
    lastInvoiceDate?: string | undefined;
    invoiceTotalExcl?: number;
    invoiceTotalIncl?: number;
    subcontractorRate?: number;
    subcontractorTotal?: number;
    lastOrderDate?: string | undefined;
    invoicedToCustomerRateExcl?: number;
    invoicedToCustomerRateIncl?: number;

    constructor(data?: IProjectProgressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.projectNumber = _data["projectNumber"];
            this.projectId = _data["projectId"];
            this.status = _data["status"];
            this.totalCost = _data["totalCost"];
            this.totalExecutedCost = _data["totalExecutedCost"];
            this.executedCostRate = _data["executedCostRate"];
            this.totalLabourCost = _data["totalLabourCost"];
            this.totalExecutedLabourCost = _data["totalExecutedLabourCost"];
            this.executedLabourCostRate = _data["executedLabourCostRate"];
            this.projectTotal = _data["projectTotal"];
            this.paidInvoiceTotal = _data["paidInvoiceTotal"];
            this.paidInvoiceRate = _data["paidInvoiceRate"];
            this.contractsTotal = _data["contractsTotal"];
            this.lastInvoiceDate = _data["lastInvoiceDate"];
            this.invoiceTotalExcl = _data["invoiceTotalExcl"];
            this.invoiceTotalIncl = _data["invoiceTotalIncl"];
            this.subcontractorRate = _data["subcontractorRate"];
            this.subcontractorTotal = _data["subcontractorTotal"];
            this.lastOrderDate = _data["lastOrderDate"];
            this.invoicedToCustomerRateExcl = _data["invoicedToCustomerRateExcl"];
            this.invoicedToCustomerRateIncl = _data["invoicedToCustomerRateIncl"];
        }
    }

    static fromJS(data: any): ProjectProgressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectProgressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["projectNumber"] = this.projectNumber;
        data["projectId"] = this.projectId;
        data["status"] = this.status;
        data["totalCost"] = this.totalCost;
        data["totalExecutedCost"] = this.totalExecutedCost;
        data["executedCostRate"] = this.executedCostRate;
        data["totalLabourCost"] = this.totalLabourCost;
        data["totalExecutedLabourCost"] = this.totalExecutedLabourCost;
        data["executedLabourCostRate"] = this.executedLabourCostRate;
        data["projectTotal"] = this.projectTotal;
        data["paidInvoiceTotal"] = this.paidInvoiceTotal;
        data["paidInvoiceRate"] = this.paidInvoiceRate;
        data["contractsTotal"] = this.contractsTotal;
        data["lastInvoiceDate"] = this.lastInvoiceDate;
        data["invoiceTotalExcl"] = this.invoiceTotalExcl;
        data["invoiceTotalIncl"] = this.invoiceTotalIncl;
        data["subcontractorRate"] = this.subcontractorRate;
        data["subcontractorTotal"] = this.subcontractorTotal;
        data["lastOrderDate"] = this.lastOrderDate;
        data["invoicedToCustomerRateExcl"] = this.invoicedToCustomerRateExcl;
        data["invoicedToCustomerRateIncl"] = this.invoicedToCustomerRateIncl;
        return data;
    }
}

export interface IProjectProgressionDto {
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectId?: string | undefined;
    status?: string | undefined;
    totalCost?: number;
    totalExecutedCost?: number;
    executedCostRate?: number;
    totalLabourCost?: number;
    totalExecutedLabourCost?: number;
    executedLabourCostRate?: number;
    projectTotal?: number;
    paidInvoiceTotal?: number;
    paidInvoiceRate?: number;
    contractsTotal?: number;
    lastInvoiceDate?: string | undefined;
    invoiceTotalExcl?: number;
    invoiceTotalIncl?: number;
    subcontractorRate?: number;
    subcontractorTotal?: number;
    lastOrderDate?: string | undefined;
    invoicedToCustomerRateExcl?: number;
    invoicedToCustomerRateIncl?: number;
}

export class PlanningAgendaItem implements IPlanningAgendaItem {
    id?: string | undefined;
    title?: string | undefined;
    projectId?: string | undefined;
    teamId?: string | undefined;
    subcontractorId?: string | undefined;
    start?: Date;
    end?: Date;
    measuringStateDocumentNumber?: string | undefined;
    inclusiveWeekend?: boolean;
    members?: string[] | undefined;
    workTypes?: string[] | undefined;
    tasks?: StringValueViewModel[] | undefined;
    dates?: StartEndDateTimeOffset[] | undefined;

    constructor(data?: IPlanningAgendaItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.teamId = _data["teamId"];
            this.subcontractorId = _data["subcontractorId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.measuringStateDocumentNumber = _data["measuringStateDocumentNumber"];
            this.inclusiveWeekend = _data["inclusiveWeekend"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
            if (Array.isArray(_data["workTypes"])) {
                this.workTypes = [] as any;
                for (let item of _data["workTypes"])
                    this.workTypes!.push(item);
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(StringValueViewModel.fromJS(item));
            }
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(StartEndDateTimeOffset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlanningAgendaItem {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningAgendaItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["teamId"] = this.teamId;
        data["subcontractorId"] = this.subcontractorId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["measuringStateDocumentNumber"] = this.measuringStateDocumentNumber;
        data["inclusiveWeekend"] = this.inclusiveWeekend;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        if (Array.isArray(this.workTypes)) {
            data["workTypes"] = [];
            for (let item of this.workTypes)
                data["workTypes"].push(item);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlanningAgendaItem {
    id?: string | undefined;
    title?: string | undefined;
    projectId?: string | undefined;
    teamId?: string | undefined;
    subcontractorId?: string | undefined;
    start?: Date;
    end?: Date;
    measuringStateDocumentNumber?: string | undefined;
    inclusiveWeekend?: boolean;
    members?: string[] | undefined;
    workTypes?: string[] | undefined;
    tasks?: StringValueViewModel[] | undefined;
    dates?: StartEndDateTimeOffset[] | undefined;
}

export class StringValueViewModel implements IStringValueViewModel {
    name?: string | undefined;
    checked?: boolean;
    disabled?: boolean;

    constructor(data?: IStringValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.checked = _data["checked"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): StringValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StringValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["checked"] = this.checked;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IStringValueViewModel {
    name?: string | undefined;
    checked?: boolean;
    disabled?: boolean;
}

export class StartEndDateTimeOffset implements IStartEndDateTimeOffset {
    start?: Date;
    end?: Date;
    weekOfYear?: number;

    constructor(data?: IStartEndDateTimeOffset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.weekOfYear = _data["weekOfYear"];
        }
    }

    static fromJS(data: any): StartEndDateTimeOffset {
        data = typeof data === 'object' ? data : {};
        let result = new StartEndDateTimeOffset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["weekOfYear"] = this.weekOfYear;
        return data;
    }
}

export interface IStartEndDateTimeOffset {
    start?: Date;
    end?: Date;
    weekOfYear?: number;
}

export class GetSinglePlanningAgendaItemForEditQuery implements IGetSinglePlanningAgendaItemForEditQuery {
    id?: string | undefined;

    constructor(data?: IGetSinglePlanningAgendaItemForEditQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSinglePlanningAgendaItemForEditQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSinglePlanningAgendaItemForEditQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSinglePlanningAgendaItemForEditQuery {
    id?: string | undefined;
}

export class PlanningAgendaItemForAgenda implements IPlanningAgendaItemForAgenda {
    id?: string | undefined;
    resourceId?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    start?: Date;
    end?: Date;
    eventBackgroundColor?: string | undefined;
    weekOfYear?: number;

    constructor(data?: IPlanningAgendaItemForAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.eventBackgroundColor = _data["eventBackgroundColor"];
            this.weekOfYear = _data["weekOfYear"];
        }
    }

    static fromJS(data: any): PlanningAgendaItemForAgenda {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningAgendaItemForAgenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["eventBackgroundColor"] = this.eventBackgroundColor;
        data["weekOfYear"] = this.weekOfYear;
        return data;
    }
}

export interface IPlanningAgendaItemForAgenda {
    id?: string | undefined;
    resourceId?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    start?: Date;
    end?: Date;
    eventBackgroundColor?: string | undefined;
    weekOfYear?: number;
}

export class GetPlanningAgendaItemsQuery implements IGetPlanningAgendaItemsQuery {
    start?: Date;
    end?: Date;

    constructor(data?: IGetPlanningAgendaItemsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlanningAgendaItemsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanningAgendaItemsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPlanningAgendaItemsQuery {
    start?: Date;
    end?: Date;
}

export class PlanningItemForProgressMode implements IPlanningItemForProgressMode {
    id?: string | undefined;
    resourceId?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    eventBackgroundColor?: string | undefined;
    measuringStateProgress?: number;
    timeProgress?: number;
    lastVisit?: Date;
    newVisitNeeded?: boolean;

    constructor(data?: IPlanningItemForProgressMode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.title = _data["title"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.eventBackgroundColor = _data["eventBackgroundColor"];
            this.measuringStateProgress = _data["measuringStateProgress"];
            this.timeProgress = _data["timeProgress"];
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : <any>undefined;
            this.newVisitNeeded = _data["newVisitNeeded"];
        }
    }

    static fromJS(data: any): PlanningItemForProgressMode {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningItemForProgressMode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["title"] = this.title;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["eventBackgroundColor"] = this.eventBackgroundColor;
        data["measuringStateProgress"] = this.measuringStateProgress;
        data["timeProgress"] = this.timeProgress;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : <any>undefined;
        data["newVisitNeeded"] = this.newVisitNeeded;
        return data;
    }
}

export interface IPlanningItemForProgressMode {
    id?: string | undefined;
    resourceId?: string | undefined;
    title?: string | undefined;
    start?: Date;
    end?: Date;
    eventBackgroundColor?: string | undefined;
    measuringStateProgress?: number;
    timeProgress?: number;
    lastVisit?: Date;
    newVisitNeeded?: boolean;
}

export class GetPlanningItemsForProgressModeQuery implements IGetPlanningItemsForProgressModeQuery {
    start?: Date;
    end?: Date;

    constructor(data?: IGetPlanningItemsForProgressModeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlanningItemsForProgressModeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanningItemsForProgressModeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPlanningItemsForProgressModeQuery {
    start?: Date;
    end?: Date;
}

export class CreatePlanningAgendaItemCommand implements ICreatePlanningAgendaItemCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;
    start?: Date;
    end?: Date;

    constructor(data?: ICreatePlanningAgendaItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningAgendaItem = _data["planningAgendaItem"] ? PlanningAgendaItem.fromJS(_data["planningAgendaItem"]) : <any>undefined;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePlanningAgendaItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanningAgendaItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningAgendaItem"] = this.planningAgendaItem ? this.planningAgendaItem.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreatePlanningAgendaItemCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;
    start?: Date;
    end?: Date;
}

export class UpdatePlanningAgendaItemCommand implements IUpdatePlanningAgendaItemCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;

    constructor(data?: IUpdatePlanningAgendaItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningAgendaItem = _data["planningAgendaItem"] ? PlanningAgendaItem.fromJS(_data["planningAgendaItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePlanningAgendaItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanningAgendaItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningAgendaItem"] = this.planningAgendaItem ? this.planningAgendaItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePlanningAgendaItemCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;
}

export class UpdatePlanningAgendaItemByDropCommand implements IUpdatePlanningAgendaItemByDropCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;
    weekOfYear?: number;

    constructor(data?: IUpdatePlanningAgendaItemByDropCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningAgendaItem = _data["planningAgendaItem"] ? PlanningAgendaItem.fromJS(_data["planningAgendaItem"]) : <any>undefined;
            this.weekOfYear = _data["weekOfYear"];
        }
    }

    static fromJS(data: any): UpdatePlanningAgendaItemByDropCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanningAgendaItemByDropCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningAgendaItem"] = this.planningAgendaItem ? this.planningAgendaItem.toJSON() : <any>undefined;
        data["weekOfYear"] = this.weekOfYear;
        return data;
    }
}

export interface IUpdatePlanningAgendaItemByDropCommand {
    planningAgendaItem?: PlanningAgendaItem | undefined;
    weekOfYear?: number;
}

export class DeletePlanningAgendaItemCommand implements IDeletePlanningAgendaItemCommand {
    planningItemId?: string | undefined;

    constructor(data?: IDeletePlanningAgendaItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planningItemId = _data["planningItemId"];
        }
    }

    static fromJS(data: any): DeletePlanningAgendaItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlanningAgendaItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planningItemId"] = this.planningItemId;
        return data;
    }
}

export interface IDeletePlanningAgendaItemCommand {
    planningItemId?: string | undefined;
}

export class SendMailCommand implements ISendMailCommand {
    from?: string | undefined;
    sendSms?: boolean;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    replyTo?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    objectId?: string | undefined;

    constructor(data?: ISendMailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.sendSms = _data["sendSms"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["replyTo"])) {
                this.replyTo = [] as any;
                for (let item of _data["replyTo"])
                    this.replyTo!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): SendMailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["sendSms"] = this.sendSms;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface ISendMailCommand {
    from?: string | undefined;
    sendSms?: boolean;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    replyTo?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    objectId?: string | undefined;
}

export class LoadResultMapOfCreditNoteListItemDto implements ILoadResultMapOfCreditNoteListItemDto {
    data?: CreditNoteListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfCreditNoteListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CreditNoteListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfCreditNoteListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfCreditNoteListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfCreditNoteListItemDto {
    data?: CreditNoteListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class CreditNoteListItemDto implements ICreditNoteListItemDto {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectName?: string | undefined;
    projectId?: string | undefined;
    projectNameNormalized?: string | undefined;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    total?: number;
    tax?: number;
    toPay?: number;
    sentToAccountantDate?: Date | undefined;

    constructor(data?: ICreditNoteListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.paidAmount = _data["paidAmount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            this.projectNameNormalized = _data["projectNameNormalized"];
            this.invoiceDocumentNumber = _data["invoiceDocumentNumber"];
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.toPay = _data["toPay"];
            this.sentToAccountantDate = _data["sentToAccountantDate"] ? new Date(_data["sentToAccountantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditNoteListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["paidAmount"] = this.paidAmount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        data["projectNameNormalized"] = this.projectNameNormalized;
        data["invoiceDocumentNumber"] = this.invoiceDocumentNumber;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["toPay"] = this.toPay;
        data["sentToAccountantDate"] = this.sentToAccountantDate ? this.sentToAccountantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreditNoteListItemDto {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectName?: string | undefined;
    projectId?: string | undefined;
    projectNameNormalized?: string | undefined;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    total?: number;
    tax?: number;
    toPay?: number;
    sentToAccountantDate?: Date | undefined;
}

export enum CreditNoteStatus {
    Open = 1,
    Send = 2,
    Paid = 4,
}

export class CreditNotesLookupQuery implements ICreditNotesLookupQuery {
    contactId?: string | undefined;
    projectId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;

    constructor(data?: ICreditNotesLookupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.projectId = _data["projectId"];
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditNotesLookupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNotesLookupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["projectId"] = this.projectId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreditNotesLookupQuery {
    contactId?: string | undefined;
    projectId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;
}

export class CreditNoteDto extends AuditableEntity implements ICreditNoteDto {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectNameNormalized?: string | undefined;
    projectIsOnHold?: boolean;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: CreditNoteBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    tax?: number;
    toPay?: number;
    sentToAccountantDate?: Date | undefined;

    constructor(data?: ICreditNoteDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.paidAmount = _data["paidAmount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectNumber = _data["projectNumber"];
            this.projectNameNormalized = _data["projectNameNormalized"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.invoiceDocumentNumber = _data["invoiceDocumentNumber"];
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(MetaDataItem.fromJS(item));
            }
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(CreditNoteBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.toPay = _data["toPay"];
            this.sentToAccountantDate = _data["sentToAccountantDate"] ? new Date(_data["sentToAccountantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["paidAmount"] = this.paidAmount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectNumber"] = this.projectNumber;
        data["projectNameNormalized"] = this.projectNameNormalized;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["invoiceDocumentNumber"] = this.invoiceDocumentNumber;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["toPay"] = this.toPay;
        data["sentToAccountantDate"] = this.sentToAccountantDate ? this.sentToAccountantDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditNoteDto extends IAuditableEntity {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    projectNameNormalized?: string | undefined;
    projectIsOnHold?: boolean;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: CreditNoteBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    tax?: number;
    toPay?: number;
    sentToAccountantDate?: Date | undefined;
}

export class CreditNoteBlock implements ICreditNoteBlock {
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    lines?: CreditNoteLine[] | undefined;
    total?: number;

    constructor(data?: ICreditNoteBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showTitle = _data["showTitle"];
            this.showTotals = _data["showTotals"];
            this.title = _data["title"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(CreditNoteLine.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CreditNoteBlock {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showTitle"] = this.showTitle;
        data["showTotals"] = this.showTotals;
        data["title"] = this.title;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface ICreditNoteBlock {
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    lines?: CreditNoteLine[] | undefined;
    total?: number;
}

export class CreditNoteLine implements ICreditNoteLine {
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    price?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    total?: number;

    constructor(data?: ICreditNoteLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.description = _data["description"];
            this.remarks = _data["remarks"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): CreditNoteLine {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["description"] = this.description;
        data["remarks"] = this.remarks;
        data["total"] = this.total;
        return data;
    }
}

export interface ICreditNoteLine {
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    price?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    total?: number;
}

export class CreateCreditNoteCommand implements ICreateCreditNoteCommand {
    invoiceId?: string | undefined;
    projectId?: string | undefined;

    constructor(data?: ICreateCreditNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateCreditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCreditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateCreditNoteCommand {
    invoiceId?: string | undefined;
    projectId?: string | undefined;
}

export class UpdateCreditNoteCommand implements IUpdateCreditNoteCommand {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectId?: string | undefined;
    projectName?: string | undefined;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: CreditNoteBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;

    constructor(data?: IUpdateCreditNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.paidAmount = _data["paidAmount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.invoiceDocumentNumber = _data["invoiceDocumentNumber"];
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(MetaDataItem.fromJS(item));
            }
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(CreditNoteBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
        }
    }

    static fromJS(data: any): UpdateCreditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCreditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["paidAmount"] = this.paidAmount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["invoiceDocumentNumber"] = this.invoiceDocumentNumber;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        return data;
    }
}

export interface IUpdateCreditNoteCommand {
    id?: string | undefined;
    documentNumber?: string | undefined;
    paidAmount?: number;
    date?: Date;
    taxRate?: number;
    projectId?: string | undefined;
    projectName?: string | undefined;
    invoiceDocumentNumber?: string | undefined;
    status?: CreditNoteStatus;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: CreditNoteBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
}

export class MailCreditNoteCommand implements IMailCreditNoteCommand {
    from?: string | undefined;
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IMailCreditNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailCreditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailCreditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailCreditNoteCommand {
    from?: string | undefined;
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class SendCreditNotesToAccountantCommand implements ISendCreditNotesToAccountantCommand {
    creditNoteIds?: string[] | undefined;

    constructor(data?: ISendCreditNotesToAccountantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["creditNoteIds"])) {
                this.creditNoteIds = [] as any;
                for (let item of _data["creditNoteIds"])
                    this.creditNoteIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendCreditNotesToAccountantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendCreditNotesToAccountantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.creditNoteIds)) {
            data["creditNoteIds"] = [];
            for (let item of this.creditNoteIds)
                data["creditNoteIds"].push(item);
        }
        return data;
    }
}

export interface ISendCreditNotesToAccountantCommand {
    creditNoteIds?: string[] | undefined;
}

export class GenerateCreditNoteDocumentCommand implements IGenerateCreditNoteDocumentCommand {
    id?: string | undefined;
    language?: string | undefined;
    groupArticlesByCategory?: boolean;

    constructor(data?: IGenerateCreditNoteDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.groupArticlesByCategory = _data["groupArticlesByCategory"];
        }
    }

    static fromJS(data: any): GenerateCreditNoteDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCreditNoteDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["groupArticlesByCategory"] = this.groupArticlesByCategory;
        return data;
    }
}

export interface IGenerateCreditNoteDocumentCommand {
    id?: string | undefined;
    language?: string | undefined;
    groupArticlesByCategory?: boolean;
}

export class InvoiceListItemDto implements IInvoiceListItemDto {
    id?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    paymentDate?: Date | undefined;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformationDto | undefined;
    customer?: ContactBasicInformationDto | undefined;
    advancedInvoice?: boolean;
    advancedInvoiceProcessed?: boolean;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    tax?: number;
    totalWithTax?: number;
    originalTotal?: number;
    totalDifference?: number;
    toPay?: number;
    margin?: number;
    paymentNote?: string | undefined;
    firstReminderDate?: Date | undefined;
    secondReminderDate?: Date | undefined;
    internalNotes?: string | undefined;
    isSentToAccountant?: boolean;
    sentToAccountantDate?: Date | undefined;

    constructor(data?: IInvoiceListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.documentNumber = _data["documentNumber"];
            this.projectType = _data["projectType"];
            this.paidAmount = _data["paidAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformationDto.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformationDto.fromJS(_data["customer"]) : <any>undefined;
            this.advancedInvoice = _data["advancedInvoice"];
            this.advancedInvoiceProcessed = _data["advancedInvoiceProcessed"];
            this.total = _data["total"];
            this.totalWithoutDiscount = _data["totalWithoutDiscount"];
            this.totalDiscount = _data["totalDiscount"];
            this.tax = _data["tax"];
            this.totalWithTax = _data["totalWithTax"];
            this.originalTotal = _data["originalTotal"];
            this.totalDifference = _data["totalDifference"];
            this.toPay = _data["toPay"];
            this.margin = _data["margin"];
            this.paymentNote = _data["paymentNote"];
            this.firstReminderDate = _data["firstReminderDate"] ? new Date(_data["firstReminderDate"].toString()) : <any>undefined;
            this.secondReminderDate = _data["secondReminderDate"] ? new Date(_data["secondReminderDate"].toString()) : <any>undefined;
            this.internalNotes = _data["internalNotes"];
            this.isSentToAccountant = _data["isSentToAccountant"];
            this.sentToAccountantDate = _data["sentToAccountantDate"] ? new Date(_data["sentToAccountantDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["documentNumber"] = this.documentNumber;
        data["projectType"] = this.projectType;
        data["paidAmount"] = this.paidAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["advancedInvoice"] = this.advancedInvoice;
        data["advancedInvoiceProcessed"] = this.advancedInvoiceProcessed;
        data["total"] = this.total;
        data["totalWithoutDiscount"] = this.totalWithoutDiscount;
        data["totalDiscount"] = this.totalDiscount;
        data["tax"] = this.tax;
        data["totalWithTax"] = this.totalWithTax;
        data["originalTotal"] = this.originalTotal;
        data["totalDifference"] = this.totalDifference;
        data["toPay"] = this.toPay;
        data["margin"] = this.margin;
        data["paymentNote"] = this.paymentNote;
        data["firstReminderDate"] = this.firstReminderDate ? this.firstReminderDate.toISOString() : <any>undefined;
        data["secondReminderDate"] = this.secondReminderDate ? this.secondReminderDate.toISOString() : <any>undefined;
        data["internalNotes"] = this.internalNotes;
        data["isSentToAccountant"] = this.isSentToAccountant;
        data["sentToAccountantDate"] = this.sentToAccountantDate ? this.sentToAccountantDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInvoiceListItemDto {
    id?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    documentNumber?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    paymentDate?: Date | undefined;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformationDto | undefined;
    customer?: ContactBasicInformationDto | undefined;
    advancedInvoice?: boolean;
    advancedInvoiceProcessed?: boolean;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    tax?: number;
    totalWithTax?: number;
    originalTotal?: number;
    totalDifference?: number;
    toPay?: number;
    margin?: number;
    paymentNote?: string | undefined;
    firstReminderDate?: Date | undefined;
    secondReminderDate?: Date | undefined;
    internalNotes?: string | undefined;
    isSentToAccountant?: boolean;
    sentToAccountantDate?: Date | undefined;
}

export enum InvoiceStatus {
    Draft = 0,
    Open = 1,
    Send = 2,
    Overdue = 3,
    Paid = 4,
    FirstReminder = 5,
    SecondReminder = 6,
}

export class GetInvoicesForRappelsQuery implements IGetInvoicesForRappelsQuery {
    projectId?: string | undefined;

    constructor(data?: IGetInvoicesForRappelsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetInvoicesForRappelsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoicesForRappelsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetInvoicesForRappelsQuery {
    projectId?: string | undefined;
}

export class InvoiceStatsDto implements IInvoiceStatsDto {
    open?: number;
    send?: number;
    overdue?: number;
    draft?: number;

    constructor(data?: IInvoiceStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.open = _data["open"];
            this.send = _data["send"];
            this.overdue = _data["overdue"];
            this.draft = _data["draft"];
        }
    }

    static fromJS(data: any): InvoiceStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["open"] = this.open;
        data["send"] = this.send;
        data["overdue"] = this.overdue;
        data["draft"] = this.draft;
        return data;
    }
}

export interface IInvoiceStatsDto {
    open?: number;
    send?: number;
    overdue?: number;
    draft?: number;
}

export class InvoiceDto implements IInvoiceDto {
    id?: string | undefined;
    projectId?: string | undefined;
    documentSettings?: InvoiceDocumentSettings | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    projectNumber?: string | undefined;
    documentNumber?: string | undefined;
    paymentNote?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    paymentDate?: Date | undefined;
    invoiceNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    lastModified?: Date;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformation | undefined;
    advancedInvoice?: boolean;
    advancedInvoiceProcessed?: boolean;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: InvoiceBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    tax?: number;
    originalTotal?: number;
    totalDifference?: number;
    toPay?: number;
    margin?: number;
    isSentToAccountant?: boolean;
    sentToAccountantDate?: Date | undefined;
    canBeRemoved?: boolean;
    quotationIdsInLines?: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.documentSettings = _data["documentSettings"] ? InvoiceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.projectName = _data["projectName"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.projectNumber = _data["projectNumber"];
            this.documentNumber = _data["documentNumber"];
            this.paymentNote = _data["paymentNote"];
            this.projectType = _data["projectType"];
            this.paidAmount = _data["paidAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.invoiceNumber = _data["invoiceNumber"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.advancedInvoice = _data["advancedInvoice"];
            this.advancedInvoiceProcessed = _data["advancedInvoiceProcessed"];
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["metaData"])) {
                this.metaData = [] as any;
                for (let item of _data["metaData"])
                    this.metaData!.push(MetaDataItem.fromJS(item));
            }
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(InvoiceBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.total = _data["total"];
            this.totalWithoutDiscount = _data["totalWithoutDiscount"];
            this.totalDiscount = _data["totalDiscount"];
            this.tax = _data["tax"];
            this.originalTotal = _data["originalTotal"];
            this.totalDifference = _data["totalDifference"];
            this.toPay = _data["toPay"];
            this.margin = _data["margin"];
            this.isSentToAccountant = _data["isSentToAccountant"];
            this.sentToAccountantDate = _data["sentToAccountantDate"] ? new Date(_data["sentToAccountantDate"].toString()) : <any>undefined;
            this.canBeRemoved = _data["canBeRemoved"];
            if (Array.isArray(_data["quotationIdsInLines"])) {
                this.quotationIdsInLines = [] as any;
                for (let item of _data["quotationIdsInLines"])
                    this.quotationIdsInLines!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["projectName"] = this.projectName;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["projectNumber"] = this.projectNumber;
        data["documentNumber"] = this.documentNumber;
        data["paymentNote"] = this.paymentNote;
        data["projectType"] = this.projectType;
        data["paidAmount"] = this.paidAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["advancedInvoice"] = this.advancedInvoice;
        data["advancedInvoiceProcessed"] = this.advancedInvoiceProcessed;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.metaData)) {
            data["metaData"] = [];
            for (let item of this.metaData)
                data["metaData"].push(item.toJSON());
        }
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["total"] = this.total;
        data["totalWithoutDiscount"] = this.totalWithoutDiscount;
        data["totalDiscount"] = this.totalDiscount;
        data["tax"] = this.tax;
        data["originalTotal"] = this.originalTotal;
        data["totalDifference"] = this.totalDifference;
        data["toPay"] = this.toPay;
        data["margin"] = this.margin;
        data["isSentToAccountant"] = this.isSentToAccountant;
        data["sentToAccountantDate"] = this.sentToAccountantDate ? this.sentToAccountantDate.toISOString() : <any>undefined;
        data["canBeRemoved"] = this.canBeRemoved;
        if (Array.isArray(this.quotationIdsInLines)) {
            data["quotationIdsInLines"] = [];
            for (let item of this.quotationIdsInLines)
                data["quotationIdsInLines"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    id?: string | undefined;
    projectId?: string | undefined;
    documentSettings?: InvoiceDocumentSettings | undefined;
    projectName?: string | undefined;
    projectIsOnHold?: boolean;
    projectNumber?: string | undefined;
    documentNumber?: string | undefined;
    paymentNote?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    paymentDate?: Date | undefined;
    invoiceNumber?: number;
    createDate?: Date;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    lastModified?: Date;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformation | undefined;
    advancedInvoice?: boolean;
    advancedInvoiceProcessed?: boolean;
    customer?: ContactBasicInformation | undefined;
    metaData?: MetaDataItem[] | undefined;
    blocks?: InvoiceBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    tax?: number;
    originalTotal?: number;
    totalDifference?: number;
    toPay?: number;
    margin?: number;
    isSentToAccountant?: boolean;
    sentToAccountantDate?: Date | undefined;
    canBeRemoved?: boolean;
    quotationIdsInLines?: string[] | undefined;
}

export class InvoiceDocumentSettings extends FinanceDocumentSettings implements IInvoiceDocumentSettings {
    summarizeByProgressStatement?: boolean;
    progressStatementMergedDocumentNumber?: string | undefined;

    constructor(data?: IInvoiceDocumentSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.summarizeByProgressStatement = _data["summarizeByProgressStatement"];
            this.progressStatementMergedDocumentNumber = _data["progressStatementMergedDocumentNumber"];
        }
    }

    static fromJS(data: any): InvoiceDocumentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDocumentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summarizeByProgressStatement"] = this.summarizeByProgressStatement;
        data["progressStatementMergedDocumentNumber"] = this.progressStatementMergedDocumentNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceDocumentSettings extends IFinanceDocumentSettings {
    summarizeByProgressStatement?: boolean;
    progressStatementMergedDocumentNumber?: string | undefined;
}

export class InvoiceBlock implements IInvoiceBlock {
    id?: string | undefined;
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    lines?: InvoiceLine[] | undefined;
    progressStatementBlockId?: string | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;

    constructor(data?: IInvoiceBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showTitle = _data["showTitle"];
            this.showTotals = _data["showTotals"];
            this.title = _data["title"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InvoiceLine.fromJS(item));
            }
            this.progressStatementBlockId = _data["progressStatementBlockId"];
            this.total = _data["total"];
            this.originalTotal = _data["originalTotal"];
            this.totalDifference = _data["totalDifference"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): InvoiceBlock {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showTitle"] = this.showTitle;
        data["showTotals"] = this.showTotals;
        data["title"] = this.title;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["progressStatementBlockId"] = this.progressStatementBlockId;
        data["total"] = this.total;
        data["originalTotal"] = this.originalTotal;
        data["totalDifference"] = this.totalDifference;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IInvoiceBlock {
    id?: string | undefined;
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    lines?: InvoiceLine[] | undefined;
    progressStatementBlockId?: string | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;
}

export class InvoiceLine implements IInvoiceLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    price?: number;
    originalPrice?: number;
    cost?: number;
    discount?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    source?: string | undefined;
    total?: number;
    originalTotal?: number;
    margin?: number;
    quotationId?: string | undefined;
    measuringStateLineId?: string | undefined;
    progressStatementLineId?: string | undefined;

    constructor(data?: IInvoiceLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.hidden = _data["hidden"];
            this.parentLineId = _data["parentLineId"];
            this.measuringUnit = _data["measuringUnit"];
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.originalPrice = _data["originalPrice"];
            this.cost = _data["cost"];
            this.discount = _data["discount"];
            this.description = _data["description"];
            this.remarks = _data["remarks"];
            this.source = _data["source"];
            this.total = _data["total"];
            this.originalTotal = _data["originalTotal"];
            this.margin = _data["margin"];
            this.quotationId = _data["quotationId"];
            this.measuringStateLineId = _data["measuringStateLineId"];
            this.progressStatementLineId = _data["progressStatementLineId"];
        }
    }

    static fromJS(data: any): InvoiceLine {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["hidden"] = this.hidden;
        data["parentLineId"] = this.parentLineId;
        data["measuringUnit"] = this.measuringUnit;
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["originalPrice"] = this.originalPrice;
        data["cost"] = this.cost;
        data["discount"] = this.discount;
        data["description"] = this.description;
        data["remarks"] = this.remarks;
        data["source"] = this.source;
        data["total"] = this.total;
        data["originalTotal"] = this.originalTotal;
        data["margin"] = this.margin;
        data["quotationId"] = this.quotationId;
        data["measuringStateLineId"] = this.measuringStateLineId;
        data["progressStatementLineId"] = this.progressStatementLineId;
        return data;
    }
}

export interface IInvoiceLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    measuringUnit?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    quantity?: number;
    price?: number;
    originalPrice?: number;
    cost?: number;
    discount?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    source?: string | undefined;
    total?: number;
    originalTotal?: number;
    margin?: number;
    quotationId?: string | undefined;
    measuringStateLineId?: string | undefined;
    progressStatementLineId?: string | undefined;
}

export class GenerateInvoiceDocumentCommand implements IGenerateInvoiceDocumentCommand {
    id?: string | undefined;
    documentSettings?: InvoiceDocumentSettings | undefined;
    language?: string | undefined;

    constructor(data?: IGenerateInvoiceDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSettings = _data["documentSettings"] ? InvoiceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GenerateInvoiceDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInvoiceDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        data["language"] = this.language;
        return data;
    }
}

export interface IGenerateInvoiceDocumentCommand {
    id?: string | undefined;
    documentSettings?: InvoiceDocumentSettings | undefined;
    language?: string | undefined;
}

export class InvoiceUpdateCommand implements IInvoiceUpdateCommand {
    id?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    paymentDate?: Date | undefined;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformation | undefined;
    advancedInvoice?: boolean;
    customer?: ContactBasicInformation | undefined;
    blocks?: InvoiceBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;

    constructor(data?: IInvoiceUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.paidAmount = _data["paidAmount"];
            this.total = _data["total"];
            this.totalWithoutDiscount = _data["totalWithoutDiscount"];
            this.totalDiscount = _data["totalDiscount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.taxRate = _data["taxRate"];
            this.status = _data["status"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.advancedInvoice = _data["advancedInvoice"];
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(InvoiceBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
        }
    }

    static fromJS(data: any): InvoiceUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["paidAmount"] = this.paidAmount;
        data["total"] = this.total;
        data["totalWithoutDiscount"] = this.totalWithoutDiscount;
        data["totalDiscount"] = this.totalDiscount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["taxRate"] = this.taxRate;
        data["status"] = this.status;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["advancedInvoice"] = this.advancedInvoice;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        return data;
    }
}

export interface IInvoiceUpdateCommand {
    id?: string | undefined;
    projectId?: string | undefined;
    projectType?: string | undefined;
    paidAmount?: number;
    total?: number;
    totalWithoutDiscount?: number;
    totalDiscount?: number;
    paymentDate?: Date | undefined;
    date?: Date | undefined;
    dueDate?: Date | undefined;
    taxRate?: number;
    status?: InvoiceStatus;
    customerContact?: ContactBasicInformation | undefined;
    advancedInvoice?: boolean;
    customer?: ContactBasicInformation | undefined;
    blocks?: InvoiceBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
}

export class GenerateInvoiceFromQuotationsCommand implements IGenerateInvoiceFromQuotationsCommand {
    sourceList?: string[] | undefined;

    constructor(data?: IGenerateInvoiceFromQuotationsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceList"])) {
                this.sourceList = [] as any;
                for (let item of _data["sourceList"])
                    this.sourceList!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateInvoiceFromQuotationsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInvoiceFromQuotationsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceList)) {
            data["sourceList"] = [];
            for (let item of this.sourceList)
                data["sourceList"].push(item);
        }
        return data;
    }
}

export interface IGenerateInvoiceFromQuotationsCommand {
    sourceList?: string[] | undefined;
}

export class GenerateAdvancedInvoiceCommand implements IGenerateAdvancedInvoiceCommand {
    sourceList?: string[] | undefined;
    percentage?: number;

    constructor(data?: IGenerateAdvancedInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceList"])) {
                this.sourceList = [] as any;
                for (let item of _data["sourceList"])
                    this.sourceList!.push(item);
            }
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): GenerateAdvancedInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateAdvancedInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceList)) {
            data["sourceList"] = [];
            for (let item of this.sourceList)
                data["sourceList"].push(item);
        }
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IGenerateAdvancedInvoiceCommand {
    sourceList?: string[] | undefined;
    percentage?: number;
}

export class GenerateInvoiceFromProgressStatementsCommand implements IGenerateInvoiceFromProgressStatementsCommand {
    projectId?: string | undefined;
    sourceList?: string[] | undefined;
    advancedInvoicesList?: string[] | undefined;
    projectEndDate?: Date | undefined;

    constructor(data?: IGenerateInvoiceFromProgressStatementsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["sourceList"])) {
                this.sourceList = [] as any;
                for (let item of _data["sourceList"])
                    this.sourceList!.push(item);
            }
            if (Array.isArray(_data["advancedInvoicesList"])) {
                this.advancedInvoicesList = [] as any;
                for (let item of _data["advancedInvoicesList"])
                    this.advancedInvoicesList!.push(item);
            }
            this.projectEndDate = _data["projectEndDate"] ? new Date(_data["projectEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateInvoiceFromProgressStatementsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInvoiceFromProgressStatementsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.sourceList)) {
            data["sourceList"] = [];
            for (let item of this.sourceList)
                data["sourceList"].push(item);
        }
        if (Array.isArray(this.advancedInvoicesList)) {
            data["advancedInvoicesList"] = [];
            for (let item of this.advancedInvoicesList)
                data["advancedInvoicesList"].push(item);
        }
        data["projectEndDate"] = this.projectEndDate ? this.projectEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGenerateInvoiceFromProgressStatementsCommand {
    projectId?: string | undefined;
    sourceList?: string[] | undefined;
    advancedInvoicesList?: string[] | undefined;
    projectEndDate?: Date | undefined;
}

export class GenerateInvoiceFromMeasuringStatesCommand implements IGenerateInvoiceFromMeasuringStatesCommand {
    projectId?: string | undefined;
    measuringStateNumbers?: string[] | undefined;

    constructor(data?: IGenerateInvoiceFromMeasuringStatesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["measuringStateNumbers"])) {
                this.measuringStateNumbers = [] as any;
                for (let item of _data["measuringStateNumbers"])
                    this.measuringStateNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateInvoiceFromMeasuringStatesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateInvoiceFromMeasuringStatesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.measuringStateNumbers)) {
            data["measuringStateNumbers"] = [];
            for (let item of this.measuringStateNumbers)
                data["measuringStateNumbers"].push(item);
        }
        return data;
    }
}

export interface IGenerateInvoiceFromMeasuringStatesCommand {
    projectId?: string | undefined;
    measuringStateNumbers?: string[] | undefined;
}

export class PaymentDto implements IPaymentDto {
    id?: string | undefined;
    invoiceId?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date | undefined;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.amount = _data["amount"];
            this.ogm = _data["ogm"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["amount"] = this.amount;
        data["ogm"] = this.ogm;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPaymentDto {
    id?: string | undefined;
    invoiceId?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date | undefined;
}

export class InvoicePaidCommand implements IInvoicePaidCommand {
    id?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date;
    setInvoiceAsPaid?: boolean;

    constructor(data?: IInvoicePaidCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.ogm = _data["ogm"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.setInvoiceAsPaid = _data["setInvoiceAsPaid"];
        }
    }

    static fromJS(data: any): InvoicePaidCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaidCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["ogm"] = this.ogm;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["setInvoiceAsPaid"] = this.setInvoiceAsPaid;
        return data;
    }
}

export interface IInvoicePaidCommand {
    id?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date;
    setInvoiceAsPaid?: boolean;
}

export class MailInvoiceCommand implements IMailInvoiceCommand {
    from?: string | undefined;
    sendSms?: boolean;
    objectIds?: string[] | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    progressStatementDocumentNumber?: string | undefined;
    exportType?: ProgressStatementExportType;
    language?: string | undefined;

    constructor(data?: IMailInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.sendSms = _data["sendSms"];
            if (Array.isArray(_data["objectIds"])) {
                this.objectIds = [] as any;
                for (let item of _data["objectIds"])
                    this.objectIds!.push(item);
            }
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.progressStatementDocumentNumber = _data["progressStatementDocumentNumber"];
            this.exportType = _data["exportType"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["sendSms"] = this.sendSms;
        if (Array.isArray(this.objectIds)) {
            data["objectIds"] = [];
            for (let item of this.objectIds)
                data["objectIds"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["progressStatementDocumentNumber"] = this.progressStatementDocumentNumber;
        data["exportType"] = this.exportType;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailInvoiceCommand {
    from?: string | undefined;
    sendSms?: boolean;
    objectIds?: string[] | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    progressStatementDocumentNumber?: string | undefined;
    exportType?: ProgressStatementExportType;
    language?: string | undefined;
}

export class EditInvoicePaidCommand implements IEditInvoicePaidCommand {
    id?: string | undefined;
    invoiceId?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date;
    setInvoiceAsPaid?: boolean;

    constructor(data?: IEditInvoicePaidCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceId = _data["invoiceId"];
            this.amount = _data["amount"];
            this.ogm = _data["ogm"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.setInvoiceAsPaid = _data["setInvoiceAsPaid"];
        }
    }

    static fromJS(data: any): EditInvoicePaidCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditInvoicePaidCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceId"] = this.invoiceId;
        data["amount"] = this.amount;
        data["ogm"] = this.ogm;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["setInvoiceAsPaid"] = this.setInvoiceAsPaid;
        return data;
    }
}

export interface IEditInvoicePaidCommand {
    id?: string | undefined;
    invoiceId?: string | undefined;
    amount?: number;
    ogm?: string | undefined;
    paymentDate?: Date;
    setInvoiceAsPaid?: boolean;
}

export class SendInvoicesToAccountantCommand implements ISendInvoicesToAccountantCommand {
    invoiceIds?: string[] | undefined;

    constructor(data?: ISendInvoicesToAccountantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendInvoicesToAccountantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvoicesToAccountantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        return data;
    }
}

export interface ISendInvoicesToAccountantCommand {
    invoiceIds?: string[] | undefined;
}

export class InvoicingClosedLog implements IInvoicingClosedLog {
    id?: string | undefined;
    closedDate?: Date;
    closedBy?: string | undefined;
    closedByName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IInvoicingClosedLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>undefined;
            this.closedBy = _data["closedBy"];
            this.closedByName = _data["closedByName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InvoicingClosedLog {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingClosedLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["closedBy"] = this.closedBy;
        data["closedByName"] = this.closedByName;
        data["description"] = this.description;
        return data;
    }
}

export interface IInvoicingClosedLog {
    id?: string | undefined;
    closedDate?: Date;
    closedBy?: string | undefined;
    closedByName?: string | undefined;
    description?: string | undefined;
}

export class CreateInvoicingClosedLogCommand implements ICreateInvoicingClosedLogCommand {
    description?: string | undefined;

    constructor(data?: ICreateInvoicingClosedLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateInvoicingClosedLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoicingClosedLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateInvoicingClosedLogCommand {
    description?: string | undefined;
}

export class OrdersLookupLoadResultDto implements IOrdersLookupLoadResultDto {
    data?: OrderListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    subcontractorAmount?: number;
    materialAmount?: number;

    constructor(data?: IOrdersLookupLoadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrderListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            this.subcontractorAmount = _data["subcontractorAmount"];
            this.materialAmount = _data["materialAmount"];
        }
    }

    static fromJS(data: any): OrdersLookupLoadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersLookupLoadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        data["subcontractorAmount"] = this.subcontractorAmount;
        data["materialAmount"] = this.materialAmount;
        return data;
    }
}

export interface IOrdersLookupLoadResultDto {
    data?: OrderListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    subcontractorAmount?: number;
    materialAmount?: number;
}

export class OrderListItemDto implements IOrderListItemDto {
    id?: string | undefined;
    documentNumber?: string | undefined;
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    date?: Date;
    status?: OrderStatus;
    type?: OrderType;
    invoiceReceived?: boolean;
    goodsReceived?: boolean;
    totalExcl?: number;

    constructor(data?: IOrderListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.invoiceReceived = _data["invoiceReceived"];
            this.goodsReceived = _data["goodsReceived"];
            this.totalExcl = _data["totalExcl"];
        }
    }

    static fromJS(data: any): OrderListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["invoiceReceived"] = this.invoiceReceived;
        data["goodsReceived"] = this.goodsReceived;
        data["totalExcl"] = this.totalExcl;
        return data;
    }
}

export interface IOrderListItemDto {
    id?: string | undefined;
    documentNumber?: string | undefined;
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    date?: Date;
    status?: OrderStatus;
    type?: OrderType;
    invoiceReceived?: boolean;
    goodsReceived?: boolean;
    totalExcl?: number;
}

export enum OrderStatus {
    Draft = 0,
    Open = 1,
    Send = 2,
    Completed = 3,
}

export enum OrderType {
    MaterialsOrder = 0,
    SubcontractorSettlement = 1,
    Other = 10,
}

export class OrdersLookupQuery implements IOrdersLookupQuery {
    projectId?: string | undefined;
    supplierId?: string | undefined;
    options?: DataSourceLoadOptions | undefined;

    constructor(data?: IOrdersLookupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.supplierId = _data["supplierId"];
            this.options = _data["options"] ? DataSourceLoadOptions.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrdersLookupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersLookupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["supplierId"] = this.supplierId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrdersLookupQuery {
    projectId?: string | undefined;
    supplierId?: string | undefined;
    options?: DataSourceLoadOptions | undefined;
}

export class DataSourceLoadOptions extends DataSourceLoadOptionsBase implements IDataSourceLoadOptions {

    constructor(data?: IDataSourceLoadOptions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DataSourceLoadOptions {
        data = typeof data === 'object' ? data : {};
        let result = new DataSourceLoadOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDataSourceLoadOptions extends IDataSourceLoadOptionsBase {
}

export class OrderVm implements IOrderVm {
    order?: Order | undefined;
    supplier?: ContactBase | undefined;
    projectIsOnHold?: boolean;
    projectNumber?: string | undefined;

    constructor(data?: IOrderVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.supplier = _data["supplier"] ? ContactBase.fromJS(_data["supplier"]) : <any>undefined;
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.projectNumber = _data["projectNumber"];
        }
    }

    static fromJS(data: any): OrderVm {
        data = typeof data === 'object' ? data : {};
        let result = new OrderVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["projectNumber"] = this.projectNumber;
        return data;
    }
}

export interface IOrderVm {
    order?: Order | undefined;
    supplier?: ContactBase | undefined;
    projectIsOnHold?: boolean;
    projectNumber?: string | undefined;
}

export class Order extends AuditableEntity implements IOrder {
    id?: string | undefined;
    documentNumber?: string | undefined;
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    driveKey?: string | undefined;
    date?: Date;
    remarks?: string | undefined;
    remarksInternal?: string | undefined;
    status?: OrderStatus;
    type?: OrderType;
    invoiceReceived?: boolean;
    goodsReceived?: boolean;
    lines?: OrderLine[] | undefined;
    cashDiscount?: boolean;
    cashDiscountPercentage?: number | undefined;
    cashDiscountPeriod?: number | undefined;
    totalExcl?: number;
    version?: DocumentVersion;
    contractDocumentNumber?: string | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;

    constructor(data?: IOrder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.driveKey = _data["driveKey"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.remarksInternal = _data["remarksInternal"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.invoiceReceived = _data["invoiceReceived"];
            this.goodsReceived = _data["goodsReceived"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLine.fromJS(item));
            }
            this.cashDiscount = _data["cashDiscount"];
            this.cashDiscountPercentage = _data["cashDiscountPercentage"];
            this.cashDiscountPeriod = _data["cashDiscountPeriod"];
            this.totalExcl = _data["totalExcl"];
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
            this.contractDocumentNumber = _data["contractDocumentNumber"];
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodUntil = _data["periodUntil"] ? new Date(_data["periodUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["driveKey"] = this.driveKey;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["remarksInternal"] = this.remarksInternal;
        data["status"] = this.status;
        data["type"] = this.type;
        data["invoiceReceived"] = this.invoiceReceived;
        data["goodsReceived"] = this.goodsReceived;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["cashDiscount"] = this.cashDiscount;
        data["cashDiscountPercentage"] = this.cashDiscountPercentage;
        data["cashDiscountPeriod"] = this.cashDiscountPeriod;
        data["totalExcl"] = this.totalExcl;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["contractDocumentNumber"] = this.contractDocumentNumber;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodUntil"] = this.periodUntil ? this.periodUntil.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrder extends IAuditableEntity {
    id?: string | undefined;
    documentNumber?: string | undefined;
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    projectId?: string | undefined;
    projectName?: string | undefined;
    driveKey?: string | undefined;
    date?: Date;
    remarks?: string | undefined;
    remarksInternal?: string | undefined;
    status?: OrderStatus;
    type?: OrderType;
    invoiceReceived?: boolean;
    goodsReceived?: boolean;
    lines?: OrderLine[] | undefined;
    cashDiscount?: boolean;
    cashDiscountPercentage?: number | undefined;
    cashDiscountPeriod?: number | undefined;
    totalExcl?: number;
    version?: DocumentVersion;
    contractDocumentNumber?: string | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
}

export class OrderLine implements IOrderLine {
    quantity?: number;
    measuringUnit?: string | undefined;
    unitPrice?: number;
    totalPrice?: number;
    description?: string | undefined;
    articleCategoryId?: string | undefined;
    remarks?: string | undefined;
    delivered?: boolean;
    supplierReference?: string | undefined;
    metaData?: { [key: string]: string; } | undefined;

    constructor(data?: IOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.measuringUnit = _data["measuringUnit"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
            this.description = _data["description"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.remarks = _data["remarks"];
            this.delivered = _data["delivered"];
            this.supplierReference = _data["supplierReference"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
        }
    }

    static fromJS(data: any): OrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["measuringUnit"] = this.measuringUnit;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["description"] = this.description;
        data["articleCategoryId"] = this.articleCategoryId;
        data["remarks"] = this.remarks;
        data["delivered"] = this.delivered;
        data["supplierReference"] = this.supplierReference;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        return data;
    }
}

export interface IOrderLine {
    quantity?: number;
    measuringUnit?: string | undefined;
    unitPrice?: number;
    totalPrice?: number;
    description?: string | undefined;
    articleCategoryId?: string | undefined;
    remarks?: string | undefined;
    delivered?: boolean;
    supplierReference?: string | undefined;
    metaData?: { [key: string]: string; } | undefined;
}

export class ContactBase implements IContactBase {
    id?: string | undefined;
    disabled?: boolean;
    displayName?: string | undefined;
    displayNameNormalized?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContactBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.displayName = _data["displayName"];
            this.displayNameNormalized = _data["displayNameNormalized"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            if (Array.isArray(_data["pricingAgreements"])) {
                this.pricingAgreements = [] as any;
                for (let item of _data["pricingAgreements"])
                    this.pricingAgreements!.push(PricingAgreement.fromJS(item));
            }
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactBase {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["displayName"] = this.displayName;
        data["displayNameNormalized"] = this.displayNameNormalized;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        if (Array.isArray(this.pricingAgreements)) {
            data["pricingAgreements"] = [];
            for (let item of this.pricingAgreements)
                data["pricingAgreements"].push(item.toJSON());
        }
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactBase {
    id?: string | undefined;
    disabled?: boolean;
    displayName?: string | undefined;
    displayNameNormalized?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class PricingAgreement implements IPricingAgreement {
    articleId?: string | undefined;
    variant?: string | undefined;
    projectType?: string | undefined;
    price?: number | undefined;

    constructor(data?: IPricingAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.variant = _data["variant"];
            this.projectType = _data["projectType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): PricingAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new PricingAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["variant"] = this.variant;
        data["projectType"] = this.projectType;
        data["price"] = this.price;
        return data;
    }
}

export interface IPricingAgreement {
    articleId?: string | undefined;
    variant?: string | undefined;
    projectType?: string | undefined;
    price?: number | undefined;
}

export class ExportOrderCommand implements IExportOrderCommand {
    currentOrder?: string | undefined;

    constructor(data?: IExportOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentOrder = _data["currentOrder"];
        }
    }

    static fromJS(data: any): ExportOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentOrder"] = this.currentOrder;
        return data;
    }
}

export interface IExportOrderCommand {
    currentOrder?: string | undefined;
}

export class UpdateOrderCommand implements IUpdateOrderCommand {
    id?: string | undefined;
    supplierId?: string | undefined;
    projectId?: string | undefined;
    date?: Date;
    remarks?: string | undefined;
    remarksInternal?: string | undefined;
    status?: OrderStatus;
    cashDiscount?: boolean;
    cashDiscountPercentage?: number | undefined;
    cashDiscountPeriod?: number | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;

    constructor(data?: IUpdateOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.projectId = _data["projectId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.remarksInternal = _data["remarksInternal"];
            this.status = _data["status"];
            this.cashDiscount = _data["cashDiscount"];
            this.cashDiscountPercentage = _data["cashDiscountPercentage"];
            this.cashDiscountPeriod = _data["cashDiscountPeriod"];
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodUntil = _data["periodUntil"] ? new Date(_data["periodUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["projectId"] = this.projectId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["remarksInternal"] = this.remarksInternal;
        data["status"] = this.status;
        data["cashDiscount"] = this.cashDiscount;
        data["cashDiscountPercentage"] = this.cashDiscountPercentage;
        data["cashDiscountPeriod"] = this.cashDiscountPeriod;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodUntil"] = this.periodUntil ? this.periodUntil.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateOrderCommand {
    id?: string | undefined;
    supplierId?: string | undefined;
    projectId?: string | undefined;
    date?: Date;
    remarks?: string | undefined;
    remarksInternal?: string | undefined;
    status?: OrderStatus;
    cashDiscount?: boolean;
    cashDiscountPercentage?: number | undefined;
    cashDiscountPeriod?: number | undefined;
    periodFrom?: Date | undefined;
    periodUntil?: Date | undefined;
}

export class UpdateOrderLinesCommand implements IUpdateOrderLinesCommand {
    id?: string | undefined;
    lines?: OrderLine[] | undefined;

    constructor(data?: IUpdateOrderLinesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderLinesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderLinesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateOrderLinesCommand {
    id?: string | undefined;
    lines?: OrderLine[] | undefined;
}

export class MailOrderCommand implements IMailOrderCommand {
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    from?: string | undefined;

    constructor(data?: IMailOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): MailOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["from"] = this.from;
        return data;
    }
}

export interface IMailOrderCommand {
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    from?: string | undefined;
}

export class CreateMaterialOrderFromMeasuringStatesCommand implements ICreateMaterialOrderFromMeasuringStatesCommand {
    projectId?: string | undefined;
    lines?: MaterialOrderDesignInfoDto[] | undefined;

    constructor(data?: ICreateMaterialOrderFromMeasuringStatesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MaterialOrderDesignInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMaterialOrderFromMeasuringStatesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialOrderFromMeasuringStatesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMaterialOrderFromMeasuringStatesCommand {
    projectId?: string | undefined;
    lines?: MaterialOrderDesignInfoDto[] | undefined;
}

export class QuotationDetailedDto implements IQuotationDetailedDto {
    id?: string | undefined;
    type?: QuotationType;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    documentNumber?: string | undefined;
    title?: string | undefined;
    date?: Date | undefined;
    lastModified?: Date | undefined;
    internalContact?: string | undefined;
    internalContactMail?: string | undefined;
    status?: QuotationStatus;
    projectType?: string | undefined;
    projectName?: string | undefined;
    projectDocumentNumber?: string | undefined;
    workType?: string | undefined;
    measurementName?: string | undefined;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: QuotationBlock[] | undefined;
    conditions?: { [key: string]: string; } | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    articleSummary?: QuotationCodeUsage[] | undefined;
    measuringDurations?: MeasuringDuration[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountLines?: QuotationDiscountLine[] | undefined;
    calculatedValues?: QuotationCalculatedValuesDto | undefined;
    tunnelLabourCost?: number | undefined;
    tunnelMaterialCost?: number | undefined;
    tunnelTotalSubcontractorCost?: number | undefined;
    tunnelMargin?: number | undefined;

    constructor(data?: IQuotationDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.projectId = _data["projectId"];
            this.projectIsOnHold = _data["projectIsOnHold"];
            this.documentNumber = _data["documentNumber"];
            this.title = _data["title"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.internalContact = _data["internalContact"];
            this.internalContactMail = _data["internalContactMail"];
            this.status = _data["status"];
            this.projectType = _data["projectType"];
            this.projectName = _data["projectName"];
            this.projectDocumentNumber = _data["projectDocumentNumber"];
            this.workType = _data["workType"];
            this.measurementName = _data["measurementName"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(QuotationBlock.fromJS(item));
            }
            if (_data["conditions"]) {
                this.conditions = {} as any;
                for (let key in _data["conditions"]) {
                    if (_data["conditions"].hasOwnProperty(key))
                        (<any>this.conditions)![key] = _data["conditions"][key];
                }
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.total = _data["total"];
            this.originalTotal = _data["originalTotal"];
            this.totalDifference = _data["totalDifference"];
            this.margin = _data["margin"];
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
            if (Array.isArray(_data["articleSummary"])) {
                this.articleSummary = [] as any;
                for (let item of _data["articleSummary"])
                    this.articleSummary!.push(QuotationCodeUsage.fromJS(item));
            }
            if (Array.isArray(_data["measuringDurations"])) {
                this.measuringDurations = [] as any;
                for (let item of _data["measuringDurations"])
                    this.measuringDurations!.push(MeasuringDuration.fromJS(item));
            }
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            if (Array.isArray(_data["discountLines"])) {
                this.discountLines = [] as any;
                for (let item of _data["discountLines"])
                    this.discountLines!.push(QuotationDiscountLine.fromJS(item));
            }
            this.calculatedValues = _data["calculatedValues"] ? QuotationCalculatedValuesDto.fromJS(_data["calculatedValues"]) : <any>undefined;
            this.tunnelLabourCost = _data["tunnelLabourCost"];
            this.tunnelMaterialCost = _data["tunnelMaterialCost"];
            this.tunnelTotalSubcontractorCost = _data["tunnelTotalSubcontractorCost"];
            this.tunnelMargin = _data["tunnelMargin"];
        }
    }

    static fromJS(data: any): QuotationDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["projectId"] = this.projectId;
        data["projectIsOnHold"] = this.projectIsOnHold;
        data["documentNumber"] = this.documentNumber;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["internalContact"] = this.internalContact;
        data["internalContactMail"] = this.internalContactMail;
        data["status"] = this.status;
        data["projectType"] = this.projectType;
        data["projectName"] = this.projectName;
        data["projectDocumentNumber"] = this.projectDocumentNumber;
        data["workType"] = this.workType;
        data["measurementName"] = this.measurementName;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        if (this.conditions) {
            data["conditions"] = {};
            for (let key in this.conditions) {
                if (this.conditions.hasOwnProperty(key))
                    (<any>data["conditions"])[key] = (<any>this.conditions)[key];
            }
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["total"] = this.total;
        data["originalTotal"] = this.originalTotal;
        data["totalDifference"] = this.totalDifference;
        data["margin"] = this.margin;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.articleSummary)) {
            data["articleSummary"] = [];
            for (let item of this.articleSummary)
                data["articleSummary"].push(item.toJSON());
        }
        if (Array.isArray(this.measuringDurations)) {
            data["measuringDurations"] = [];
            for (let item of this.measuringDurations)
                data["measuringDurations"].push(item.toJSON());
        }
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        if (Array.isArray(this.discountLines)) {
            data["discountLines"] = [];
            for (let item of this.discountLines)
                data["discountLines"].push(item.toJSON());
        }
        data["calculatedValues"] = this.calculatedValues ? this.calculatedValues.toJSON() : <any>undefined;
        data["tunnelLabourCost"] = this.tunnelLabourCost;
        data["tunnelMaterialCost"] = this.tunnelMaterialCost;
        data["tunnelTotalSubcontractorCost"] = this.tunnelTotalSubcontractorCost;
        data["tunnelMargin"] = this.tunnelMargin;
        return data;
    }
}

export interface IQuotationDetailedDto {
    id?: string | undefined;
    type?: QuotationType;
    projectId?: string | undefined;
    projectIsOnHold?: boolean;
    documentNumber?: string | undefined;
    title?: string | undefined;
    date?: Date | undefined;
    lastModified?: Date | undefined;
    internalContact?: string | undefined;
    internalContactMail?: string | undefined;
    status?: QuotationStatus;
    projectType?: string | undefined;
    projectName?: string | undefined;
    projectDocumentNumber?: string | undefined;
    workType?: string | undefined;
    measurementName?: string | undefined;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: QuotationBlock[] | undefined;
    conditions?: { [key: string]: string; } | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;
    documentSettings?: FinanceDocumentSettings | undefined;
    articleSummary?: QuotationCodeUsage[] | undefined;
    measuringDurations?: MeasuringDuration[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountLines?: QuotationDiscountLine[] | undefined;
    calculatedValues?: QuotationCalculatedValuesDto | undefined;
    tunnelLabourCost?: number | undefined;
    tunnelMaterialCost?: number | undefined;
    tunnelTotalSubcontractorCost?: number | undefined;
    tunnelMargin?: number | undefined;
}

export enum QuotationType {
    Standard = 0,
    AdditionalWork = 1,
    FlatRate = 2,
    Raming = 3,
    Execution = 4,
    AfterCare = 5,
}

export enum QuotationStatus {
    Draft = 0,
    Open = 1,
    Send = 2,
    Approved = 3,
    Declined = 4,
    Replaced = 5,
}

export class QuotationBlock implements IQuotationBlock {
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    measurementType?: string | undefined;
    lines?: QuotationLine[] | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;

    constructor(data?: IQuotationBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showTitle = _data["showTitle"];
            this.showTotals = _data["showTotals"];
            this.title = _data["title"];
            this.measurementType = _data["measurementType"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(QuotationLine.fromJS(item));
            }
            this.total = _data["total"];
            this.originalTotal = _data["originalTotal"];
            this.totalDifference = _data["totalDifference"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): QuotationBlock {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showTitle"] = this.showTitle;
        data["showTotals"] = this.showTotals;
        data["title"] = this.title;
        data["measurementType"] = this.measurementType;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["originalTotal"] = this.originalTotal;
        data["totalDifference"] = this.totalDifference;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IQuotationBlock {
    showTitle?: boolean;
    showTotals?: boolean;
    title?: string | undefined;
    measurementType?: string | undefined;
    lines?: QuotationLine[] | undefined;
    total?: number;
    originalTotal?: number;
    totalDifference?: number;
    margin?: number;
}

export class QuotationLine implements IQuotationLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    measuringUnit?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    price?: number;
    originalPrice?: number;
    originalCost?: number;
    cost?: number;
    discount?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    minimumDuration?: number;
    total?: number;
    originalTotal?: number;
    subcontractorCost?: number | undefined;
    margin?: number;
    labourCost?: number | undefined;
    originalLabourCost?: number | undefined;
    materialCost?: number | undefined;
    originalMaterialCost?: number | undefined;
    estimatedWorkMinutes?: number | undefined;
    originalEstimatedWorkMinutes?: number | undefined;
    targetDurationOfArticle?: number;
    salesPriceMargin?: number;

    constructor(data?: IQuotationLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.hidden = _data["hidden"];
            this.parentLineId = _data["parentLineId"];
            this.articleId = _data["articleId"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.variant = _data["variant"];
            this.measuringUnit = _data["measuringUnit"];
            this.length = _data["length"];
            this.height = _data["height"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.originalPrice = _data["originalPrice"];
            this.originalCost = _data["originalCost"];
            this.cost = _data["cost"];
            this.discount = _data["discount"];
            this.description = _data["description"];
            this.remarks = _data["remarks"];
            this.minimumDuration = _data["minimumDuration"];
            this.total = _data["total"];
            this.originalTotal = _data["originalTotal"];
            this.subcontractorCost = _data["subcontractorCost"];
            this.margin = _data["margin"];
            this.labourCost = _data["labourCost"];
            this.originalLabourCost = _data["originalLabourCost"];
            this.materialCost = _data["materialCost"];
            this.originalMaterialCost = _data["originalMaterialCost"];
            this.estimatedWorkMinutes = _data["estimatedWorkMinutes"];
            this.originalEstimatedWorkMinutes = _data["originalEstimatedWorkMinutes"];
            this.targetDurationOfArticle = _data["targetDurationOfArticle"];
            this.salesPriceMargin = _data["salesPriceMargin"];
        }
    }

    static fromJS(data: any): QuotationLine {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["hidden"] = this.hidden;
        data["parentLineId"] = this.parentLineId;
        data["articleId"] = this.articleId;
        data["articleCategoryId"] = this.articleCategoryId;
        data["variant"] = this.variant;
        data["measuringUnit"] = this.measuringUnit;
        data["length"] = this.length;
        data["height"] = this.height;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["originalPrice"] = this.originalPrice;
        data["originalCost"] = this.originalCost;
        data["cost"] = this.cost;
        data["discount"] = this.discount;
        data["description"] = this.description;
        data["remarks"] = this.remarks;
        data["minimumDuration"] = this.minimumDuration;
        data["total"] = this.total;
        data["originalTotal"] = this.originalTotal;
        data["subcontractorCost"] = this.subcontractorCost;
        data["margin"] = this.margin;
        data["labourCost"] = this.labourCost;
        data["originalLabourCost"] = this.originalLabourCost;
        data["materialCost"] = this.materialCost;
        data["originalMaterialCost"] = this.originalMaterialCost;
        data["estimatedWorkMinutes"] = this.estimatedWorkMinutes;
        data["originalEstimatedWorkMinutes"] = this.originalEstimatedWorkMinutes;
        data["targetDurationOfArticle"] = this.targetDurationOfArticle;
        data["salesPriceMargin"] = this.salesPriceMargin;
        return data;
    }
}

export interface IQuotationLine {
    lineId?: string | undefined;
    hidden?: boolean;
    parentLineId?: string | undefined;
    articleId?: string | undefined;
    articleCategoryId?: string | undefined;
    variant?: string | undefined;
    measuringUnit?: string | undefined;
    length?: number | undefined;
    height?: number | undefined;
    amount?: number | undefined;
    quantity?: number;
    price?: number;
    originalPrice?: number;
    originalCost?: number;
    cost?: number;
    discount?: number;
    description?: string | undefined;
    remarks?: string | undefined;
    minimumDuration?: number;
    total?: number;
    originalTotal?: number;
    subcontractorCost?: number | undefined;
    margin?: number;
    labourCost?: number | undefined;
    originalLabourCost?: number | undefined;
    materialCost?: number | undefined;
    originalMaterialCost?: number | undefined;
    estimatedWorkMinutes?: number | undefined;
    originalEstimatedWorkMinutes?: number | undefined;
    targetDurationOfArticle?: number;
    salesPriceMargin?: number;
}

export class QuotationCodeUsage implements IQuotationCodeUsage {
    articleId?: string | undefined;
    article?: Article | undefined;
    variant?: string | undefined;
    quantity?: number;
    unitPrice?: number;

    constructor(data?: IQuotationCodeUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.article = _data["article"] ? Article.fromJS(_data["article"]) : <any>undefined;
            this.variant = _data["variant"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): QuotationCodeUsage {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationCodeUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["variant"] = this.variant;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface IQuotationCodeUsage {
    articleId?: string | undefined;
    article?: Article | undefined;
    variant?: string | undefined;
    quantity?: number;
    unitPrice?: number;
}

export class MeasuringDuration implements IMeasuringDuration {
    measuringName?: string | undefined;
    durationInHours?: number;

    constructor(data?: IMeasuringDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measuringName = _data["measuringName"];
            this.durationInHours = _data["durationInHours"];
        }
    }

    static fromJS(data: any): MeasuringDuration {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measuringName"] = this.measuringName;
        data["durationInHours"] = this.durationInHours;
        return data;
    }
}

export interface IMeasuringDuration {
    measuringName?: string | undefined;
    durationInHours?: number;
}

export class QuotationDiscountLine implements IQuotationDiscountLine {
    key?: number;
    name?: string | undefined;
    isSelected?: boolean;
    total?: number;
    totalWithDiscount?: number;
    discountPercentage?: number;
    margin?: number;

    constructor(data?: IQuotationDiscountLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.isSelected = _data["isSelected"];
            this.total = _data["total"];
            this.totalWithDiscount = _data["totalWithDiscount"];
            this.discountPercentage = _data["discountPercentage"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): QuotationDiscountLine {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDiscountLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["isSelected"] = this.isSelected;
        data["total"] = this.total;
        data["totalWithDiscount"] = this.totalWithDiscount;
        data["discountPercentage"] = this.discountPercentage;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IQuotationDiscountLine {
    key?: number;
    name?: string | undefined;
    isSelected?: boolean;
    total?: number;
    totalWithDiscount?: number;
    discountPercentage?: number;
    margin?: number;
}

export class QuotationCalculatedValuesDto implements IQuotationCalculatedValuesDto {
    total?: number;
    margin?: number;

    constructor(data?: IQuotationCalculatedValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): QuotationCalculatedValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationCalculatedValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IQuotationCalculatedValuesDto {
    total?: number;
    margin?: number;
}

export class QuotationBasicListItemDto implements IQuotationBasicListItemDto {
    id?: string | undefined;
    type?: QuotationType;
    title?: string | undefined;
    documentNumber?: string | undefined;

    constructor(data?: IQuotationBasicListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): QuotationBasicListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationBasicListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["documentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IQuotationBasicListItemDto {
    id?: string | undefined;
    type?: QuotationType;
    title?: string | undefined;
    documentNumber?: string | undefined;
}

export class QuotationsStatsDto implements IQuotationsStatsDto {
    open?: number;
    draft?: number;
    send?: number;

    constructor(data?: IQuotationsStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.open = _data["open"];
            this.draft = _data["draft"];
            this.send = _data["send"];
        }
    }

    static fromJS(data: any): QuotationsStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationsStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["open"] = this.open;
        data["draft"] = this.draft;
        data["send"] = this.send;
        return data;
    }
}

export interface IQuotationsStatsDto {
    open?: number;
    draft?: number;
    send?: number;
}

export class QuotationForAgenda implements IQuotationForAgenda {
    id?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectId?: string | undefined;
    quotationIds?: QuotationObject[] | undefined;

    constructor(data?: IQuotationForAgenda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["quotationIds"])) {
                this.quotationIds = [] as any;
                for (let item of _data["quotationIds"])
                    this.quotationIds!.push(QuotationObject.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuotationForAgenda {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationForAgenda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.quotationIds)) {
            data["quotationIds"] = [];
            for (let item of this.quotationIds)
                data["quotationIds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuotationForAgenda {
    id?: string | undefined;
    projectNumber?: string | undefined;
    projectName?: string | undefined;
    projectId?: string | undefined;
    quotationIds?: QuotationObject[] | undefined;
}

export class QuotationObject implements IQuotationObject {
    id?: string | undefined;
    documentNumber?: string | undefined;

    constructor(data?: IQuotationObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): QuotationObject {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IQuotationObject {
    id?: string | undefined;
    documentNumber?: string | undefined;
}

export class QuotationListForAgendaQuery implements IQuotationListForAgendaQuery {
    start?: Date;
    end?: Date;

    constructor(data?: IQuotationListForAgendaQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotationListForAgendaQuery {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationListForAgendaQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IQuotationListForAgendaQuery {
    start?: Date;
    end?: Date;
}

export class QuotationDiscountLinesDto implements IQuotationDiscountLinesDto {

    [key: string]: QuotationDiscountLineDto[] | any;

    constructor(data?: IQuotationDiscountLinesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): QuotationDiscountLinesDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDiscountLinesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IQuotationDiscountLinesDto {

    [key: string]: QuotationDiscountLineDto[] | any;
}

export class QuotationDiscountLineDto implements IQuotationDiscountLineDto {
    key?: number;
    name?: string | undefined;
    discountPercentage?: number;

    constructor(data?: IQuotationDiscountLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): QuotationDiscountLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDiscountLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IQuotationDiscountLineDto {
    key?: number;
    name?: string | undefined;
    discountPercentage?: number;
}

export class EnumDto implements IEnumDto {
    name?: string | undefined;
    value?: number;

    constructor(data?: IEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IEnumDto {
    name?: string | undefined;
    value?: number;
}

export class QuotationTypeDto extends EnumDto implements IQuotationTypeDto {

    constructor(data?: IQuotationTypeDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): QuotationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IQuotationTypeDto extends IEnumDto {
}

export class UpdateQuotationDetailsCommand implements IUpdateQuotationDetailsCommand {
    id?: string | undefined;
    type?: QuotationType;
    title?: string | undefined;
    date?: Date | undefined;
    internalContact?: string | undefined;
    internalContactMail?: string | undefined;
    status?: QuotationStatus;
    projectType?: string | undefined;
    projectId?: string | undefined;
    workType?: string | undefined;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: QuotationBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    tunnelGroupsId?: string | undefined;
    discountLines?: QuotationDiscountLine[] | undefined;
    calculatedValues?: QuotationCalculatedValues | undefined;
    tunnelLabourCost?: number | undefined;
    tunnelMaterialCost?: number | undefined;
    tunnelTotalSubcontractorCost?: number | undefined;
    tunnelMargin?: number | undefined;

    constructor(data?: IUpdateQuotationDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.internalContact = _data["internalContact"];
            this.internalContactMail = _data["internalContactMail"];
            this.status = _data["status"];
            this.projectType = _data["projectType"];
            this.projectId = _data["projectId"];
            this.workType = _data["workType"];
            this.customerContact = _data["customerContact"] ? ContactBasicInformation.fromJS(_data["customerContact"]) : <any>undefined;
            this.customer = _data["customer"] ? ContactBasicInformation.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(QuotationBlock.fromJS(item));
            }
            this.notes = _data["notes"];
            this.internalNotes = _data["internalNotes"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            if (Array.isArray(_data["discountLines"])) {
                this.discountLines = [] as any;
                for (let item of _data["discountLines"])
                    this.discountLines!.push(QuotationDiscountLine.fromJS(item));
            }
            this.calculatedValues = _data["calculatedValues"] ? QuotationCalculatedValues.fromJS(_data["calculatedValues"]) : <any>undefined;
            this.tunnelLabourCost = _data["tunnelLabourCost"];
            this.tunnelMaterialCost = _data["tunnelMaterialCost"];
            this.tunnelTotalSubcontractorCost = _data["tunnelTotalSubcontractorCost"];
            this.tunnelMargin = _data["tunnelMargin"];
        }
    }

    static fromJS(data: any): UpdateQuotationDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuotationDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["internalContact"] = this.internalContact;
        data["internalContactMail"] = this.internalContactMail;
        data["status"] = this.status;
        data["projectType"] = this.projectType;
        data["projectId"] = this.projectId;
        data["workType"] = this.workType;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["internalNotes"] = this.internalNotes;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        if (Array.isArray(this.discountLines)) {
            data["discountLines"] = [];
            for (let item of this.discountLines)
                data["discountLines"].push(item.toJSON());
        }
        data["calculatedValues"] = this.calculatedValues ? this.calculatedValues.toJSON() : <any>undefined;
        data["tunnelLabourCost"] = this.tunnelLabourCost;
        data["tunnelMaterialCost"] = this.tunnelMaterialCost;
        data["tunnelTotalSubcontractorCost"] = this.tunnelTotalSubcontractorCost;
        data["tunnelMargin"] = this.tunnelMargin;
        return data;
    }
}

export interface IUpdateQuotationDetailsCommand {
    id?: string | undefined;
    type?: QuotationType;
    title?: string | undefined;
    date?: Date | undefined;
    internalContact?: string | undefined;
    internalContactMail?: string | undefined;
    status?: QuotationStatus;
    projectType?: string | undefined;
    projectId?: string | undefined;
    workType?: string | undefined;
    customerContact?: ContactBasicInformation | undefined;
    customer?: ContactBasicInformation | undefined;
    blocks?: QuotationBlock[] | undefined;
    notes?: string | undefined;
    internalNotes?: string | undefined;
    tunnelGroupsId?: string | undefined;
    discountLines?: QuotationDiscountLine[] | undefined;
    calculatedValues?: QuotationCalculatedValues | undefined;
    tunnelLabourCost?: number | undefined;
    tunnelMaterialCost?: number | undefined;
    tunnelTotalSubcontractorCost?: number | undefined;
    tunnelMargin?: number | undefined;
}

export class QuotationCalculatedValues implements IQuotationCalculatedValues {
    margin?: number;
    total?: number;

    constructor(data?: IQuotationCalculatedValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.margin = _data["margin"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): QuotationCalculatedValues {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationCalculatedValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["margin"] = this.margin;
        data["total"] = this.total;
        return data;
    }
}

export interface IQuotationCalculatedValues {
    margin?: number;
    total?: number;
}

export class IncreaseQuotationByPercentageCommand implements IIncreaseQuotationByPercentageCommand {
    id?: string | undefined;
    percentage?: number;

    constructor(data?: IIncreaseQuotationByPercentageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): IncreaseQuotationByPercentageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IncreaseQuotationByPercentageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IIncreaseQuotationByPercentageCommand {
    id?: string | undefined;
    percentage?: number;
}

export class GenerateQuotationDocumentCommand implements IGenerateQuotationDocumentCommand {
    id?: string | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;

    constructor(data?: IGenerateQuotationDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSettings = _data["documentSettings"] ? FinanceDocumentSettings.fromJS(_data["documentSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateQuotationDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQuotationDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSettings"] = this.documentSettings ? this.documentSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGenerateQuotationDocumentCommand {
    id?: string | undefined;
    documentSettings?: FinanceDocumentSettings | undefined;
}

export class GenerateQuotationCommand implements IGenerateQuotationCommand {
    projectId?: string | undefined;
    measurementNames?: string[] | undefined;
    quotationId?: string | undefined;
    contactId?: string | undefined;

    constructor(data?: IGenerateQuotationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["measurementNames"])) {
                this.measurementNames = [] as any;
                for (let item of _data["measurementNames"])
                    this.measurementNames!.push(item);
            }
            this.quotationId = _data["quotationId"];
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any): GenerateQuotationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateQuotationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.measurementNames)) {
            data["measurementNames"] = [];
            for (let item of this.measurementNames)
                data["measurementNames"].push(item);
        }
        data["quotationId"] = this.quotationId;
        data["contactId"] = this.contactId;
        return data;
    }
}

export interface IGenerateQuotationCommand {
    projectId?: string | undefined;
    measurementNames?: string[] | undefined;
    quotationId?: string | undefined;
    contactId?: string | undefined;
}

export class MailQuotationCommand implements IMailQuotationCommand {
    from?: string | undefined;
    sendSms?: boolean;
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    replyTo?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;

    constructor(data?: IMailQuotationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.sendSms = _data["sendSms"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["replyTo"])) {
                this.replyTo = [] as any;
                for (let item of _data["replyTo"])
                    this.replyTo!.push(item);
            }
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MailQuotationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MailQuotationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["sendSms"] = this.sendSms;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.replyTo)) {
            data["replyTo"] = [];
            for (let item of this.replyTo)
                data["replyTo"].push(item);
        }
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["language"] = this.language;
        return data;
    }
}

export interface IMailQuotationCommand {
    from?: string | undefined;
    sendSms?: boolean;
    objectId?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    replyTo?: string[] | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    language?: string | undefined;
}

export class VolumeDiscount extends EntityBase implements IVolumeDiscount {
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;
    isDeleted?: boolean;

    constructor(data?: IVolumeDiscount) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.upperLimit = _data["upperLimit"];
            this.lowerLimit = _data["lowerLimit"];
            this.discountPercentage = _data["discountPercentage"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): VolumeDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new VolumeDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upperLimit"] = this.upperLimit;
        data["lowerLimit"] = this.lowerLimit;
        data["discountPercentage"] = this.discountPercentage;
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }
}

export interface IVolumeDiscount extends IEntityBase {
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;
    isDeleted?: boolean;
}

export class CreateVolumeDiscountsCommand implements ICreateVolumeDiscountsCommand {
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;

    constructor(data?: ICreateVolumeDiscountsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upperLimit = _data["upperLimit"];
            this.lowerLimit = _data["lowerLimit"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): CreateVolumeDiscountsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVolumeDiscountsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upperLimit"] = this.upperLimit;
        data["lowerLimit"] = this.lowerLimit;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface ICreateVolumeDiscountsCommand {
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;
}

export class UpdateVolumeDiscountsCommand implements IUpdateVolumeDiscountsCommand {
    id?: string | undefined;
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;

    constructor(data?: IUpdateVolumeDiscountsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.upperLimit = _data["upperLimit"];
            this.lowerLimit = _data["lowerLimit"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): UpdateVolumeDiscountsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVolumeDiscountsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["upperLimit"] = this.upperLimit;
        data["lowerLimit"] = this.lowerLimit;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IUpdateVolumeDiscountsCommand {
    id?: string | undefined;
    upperLimit?: number | undefined;
    lowerLimit?: number | undefined;
    discountPercentage?: number;
}

export class DeleteVolumeDiscountsCommand implements IDeleteVolumeDiscountsCommand {
    id?: string | undefined;

    constructor(data?: IDeleteVolumeDiscountsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteVolumeDiscountsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVolumeDiscountsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteVolumeDiscountsCommand {
    id?: string | undefined;
}

export class Company implements ICompany {
    id?: string | undefined;
    companyName?: string | undefined;
    disabled?: boolean;
    isSupplier?: boolean;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    contactIds?: string[] | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    files?: FileMeta[] | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    addresses?: Address[] | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
            this.disabled = _data["disabled"];
            this.isSupplier = _data["isSupplier"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["contactIds"])) {
                this.contactIds = [] as any;
                for (let item of _data["contactIds"])
                    this.contactIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileMeta.fromJS(item));
            }
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            if (Array.isArray(_data["pricingAgreements"])) {
                this.pricingAgreements = [] as any;
                for (let item of _data["pricingAgreements"])
                    this.pricingAgreements!.push(PricingAgreement.fromJS(item));
            }
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        data["disabled"] = this.disabled;
        data["isSupplier"] = this.isSupplier;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.contactIds)) {
            data["contactIds"] = [];
            for (let item of this.contactIds)
                data["contactIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingAgreements)) {
            data["pricingAgreements"] = [];
            for (let item of this.pricingAgreements)
                data["pricingAgreements"].push(item.toJSON());
        }
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompany {
    id?: string | undefined;
    companyName?: string | undefined;
    disabled?: boolean;
    isSupplier?: boolean;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    contactIds?: string[] | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    files?: FileMeta[] | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    addresses?: Address[] | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class FileMeta implements IFileMeta {
    name?: string | undefined;
    uploadTime?: Date;
    blobName?: string | undefined;
    contentType?: string | undefined;
    objectId?: string | undefined;
    tags?: string[] | undefined;

    constructor(data?: IFileMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uploadTime = _data["uploadTime"] ? new Date(_data["uploadTime"].toString()) : <any>undefined;
            this.blobName = _data["blobName"];
            this.contentType = _data["contentType"];
            this.objectId = _data["objectId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): FileMeta {
        data = typeof data === 'object' ? data : {};
        let result = new FileMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uploadTime"] = this.uploadTime ? this.uploadTime.toISOString() : <any>undefined;
        data["blobName"] = this.blobName;
        data["contentType"] = this.contentType;
        data["objectId"] = this.objectId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IFileMeta {
    name?: string | undefined;
    uploadTime?: Date;
    blobName?: string | undefined;
    contentType?: string | undefined;
    objectId?: string | undefined;
    tags?: string[] | undefined;
}

export class LoadResultMapOfContactListItemDto implements ILoadResultMapOfContactListItemDto {
    data?: ContactListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfContactListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContactListItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfContactListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfContactListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfContactListItemDto {
    data?: ContactListItemDto[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class ContactListItemDto implements IContactListItemDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    discountPercentage?: number | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContactListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.discountPercentage = _data["discountPercentage"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["discountPercentage"] = this.discountPercentage;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactListItemDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    discountPercentage?: number | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class ContactsLookupQuery implements IContactsLookupQuery {
    projectId?: string | undefined;
    type?: string | undefined;
    relationId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;
    tunnelGroupsId?: string | undefined;

    constructor(data?: IContactsLookupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.type = _data["type"];
            this.relationId = _data["relationId"];
            this.options = _data["options"] ? DataSourceLoadOptionsBase.fromJS(_data["options"]) : <any>undefined;
            this.tunnelGroupsId = _data["tunnelGroupsId"];
        }
    }

    static fromJS(data: any): ContactsLookupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsLookupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["type"] = this.type;
        data["relationId"] = this.relationId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        return data;
    }
}

export interface IContactsLookupQuery {
    projectId?: string | undefined;
    type?: string | undefined;
    relationId?: string | undefined;
    options?: DataSourceLoadOptionsBase | undefined;
    tunnelGroupsId?: string | undefined;
}

export class ContactBasicsDto implements IContactBasicsDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactBasicsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactBasicsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactBasicsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IContactBasicsDto {
    id?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class SubcontractorDto implements ISubcontractorDto {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    displayName?: string | undefined;
    vatNumber?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    specialty?: string | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: ISubcontractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.companyName = _data["companyName"];
            this.displayName = _data["displayName"];
            this.vatNumber = _data["vatNumber"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.specialty = _data["specialty"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubcontractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["companyName"] = this.companyName;
        data["displayName"] = this.displayName;
        data["vatNumber"] = this.vatNumber;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["specialty"] = this.specialty;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubcontractorDto {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    displayName?: string | undefined;
    vatNumber?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    specialty?: string | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class CompanyDto implements ICompanyDto {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    displayName?: string | undefined;
    vatNumber?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.companyName = _data["companyName"];
            this.displayName = _data["displayName"];
            this.vatNumber = _data["vatNumber"];
            this.type = _data["type"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["companyName"] = this.companyName;
        data["displayName"] = this.displayName;
        data["vatNumber"] = this.vatNumber;
        data["type"] = this.type;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompanyDto {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    displayName?: string | undefined;
    vatNumber?: string | undefined;
    type?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class ContactDto implements IContactDto {
    id?: string | undefined;
    disabled?: boolean;
    firstname?: string | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    jobTitle?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    mobile?: string | undefined;
    address?: Address | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.firstname = _data["firstname"];
            this.middlename = _data["middlename"];
            this.lastname = _data["lastname"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.jobTitle = _data["jobTitle"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.mobile = _data["mobile"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.language = _data["language"];
            this.nationality = _data["nationality"];
            this.nationalInsuranceNumber = _data["nationalInsuranceNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.birthLocation = _data["birthLocation"];
            this.team = _data["team"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["firstname"] = this.firstname;
        data["middlename"] = this.middlename;
        data["lastname"] = this.lastname;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["jobTitle"] = this.jobTitle;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["mobile"] = this.mobile;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["language"] = this.language;
        data["nationality"] = this.nationality;
        data["nationalInsuranceNumber"] = this.nationalInsuranceNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["birthLocation"] = this.birthLocation;
        data["team"] = this.team;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContactDto {
    id?: string | undefined;
    disabled?: boolean;
    firstname?: string | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    jobTitle?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    contantPaymentTerms?: number | undefined;
    mobile?: string | undefined;
    address?: Address | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class CreateContactCommand implements ICreateContactCommand {
    relationId?: string | undefined;
    projectId?: string | undefined;
    firstname?: string | undefined;
    contantPaymentTerms?: number | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    address?: Address | undefined;
    discountPercentage?: number | undefined;

    constructor(data?: ICreateContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relationId = _data["relationId"];
            this.projectId = _data["projectId"];
            this.firstname = _data["firstname"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.middlename = _data["middlename"];
            this.lastname = _data["lastname"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.language = _data["language"];
            this.nationality = _data["nationality"];
            this.nationalInsuranceNumber = _data["nationalInsuranceNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.birthLocation = _data["birthLocation"];
            this.team = _data["team"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): CreateContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relationId"] = this.relationId;
        data["projectId"] = this.projectId;
        data["firstname"] = this.firstname;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["middlename"] = this.middlename;
        data["lastname"] = this.lastname;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["language"] = this.language;
        data["nationality"] = this.nationality;
        data["nationalInsuranceNumber"] = this.nationalInsuranceNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["birthLocation"] = this.birthLocation;
        data["team"] = this.team;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface ICreateContactCommand {
    relationId?: string | undefined;
    projectId?: string | undefined;
    firstname?: string | undefined;
    contantPaymentTerms?: number | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    address?: Address | undefined;
    discountPercentage?: number | undefined;
}

export class UpdateContactCommand implements IUpdateContactCommand {
    id?: string | undefined;
    disabled?: boolean;
    firstname?: string | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    address?: Address | undefined;
    contantPaymentTerms?: number | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IUpdateContactCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.firstname = _data["firstname"];
            this.middlename = _data["middlename"];
            this.lastname = _data["lastname"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.language = _data["language"];
            this.nationality = _data["nationality"];
            this.nationalInsuranceNumber = _data["nationalInsuranceNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.birthLocation = _data["birthLocation"];
            this.team = _data["team"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["firstname"] = this.firstname;
        data["middlename"] = this.middlename;
        data["lastname"] = this.lastname;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["language"] = this.language;
        data["nationality"] = this.nationality;
        data["nationalInsuranceNumber"] = this.nationalInsuranceNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["birthLocation"] = this.birthLocation;
        data["team"] = this.team;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateContactCommand {
    id?: string | undefined;
    disabled?: boolean;
    firstname?: string | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    address?: Address | undefined;
    contantPaymentTerms?: number | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class CreateCompanyCommand implements ICreateCompanyCommand {
    projectId?: string | undefined;
    isSupplier?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    addresses?: Address[] | undefined;
    discountPercentage?: number | undefined;

    constructor(data?: ICreateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isSupplier = _data["isSupplier"];
            this.companyName = _data["companyName"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): CreateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isSupplier"] = this.isSupplier;
        data["companyName"] = this.companyName;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface ICreateCompanyCommand {
    projectId?: string | undefined;
    isSupplier?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    addresses?: Address[] | undefined;
    discountPercentage?: number | undefined;
}

export class UpdateCompanyCommand implements IUpdateCompanyCommand {
    id?: string | undefined;
    isSupplier?: boolean;
    disabled?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IUpdateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSupplier = _data["isSupplier"];
            this.disabled = _data["disabled"];
            this.companyName = _data["companyName"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSupplier"] = this.isSupplier;
        data["disabled"] = this.disabled;
        data["companyName"] = this.companyName;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCompanyCommand {
    id?: string | undefined;
    isSupplier?: boolean;
    disabled?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    addresses?: Address[] | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class CreateSubcontractorCommand implements ICreateSubcontractorCommand {
    projectId?: string | undefined;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    specialty?: string | undefined;
    addresses?: Address[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountPercentage?: number | undefined;

    constructor(data?: ICreateSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.companyName = _data["companyName"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.specialty = _data["specialty"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): CreateSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["companyName"] = this.companyName;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["specialty"] = this.specialty;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface ICreateSubcontractorCommand {
    projectId?: string | undefined;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    specialty?: string | undefined;
    addresses?: Address[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountPercentage?: number | undefined;
}

export class UpdateSubcontractorCommand implements IUpdateSubcontractorCommand {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    specialty?: string | undefined;
    addresses?: Address[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountPercentage?: number | undefined;

    constructor(data?: IUpdateSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.companyName = _data["companyName"];
            this.vatNumber = _data["vatNumber"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.language = _data["language"];
            this.termsOfPayment = _data["termsOfPayment"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.specialty = _data["specialty"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): UpdateSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["companyName"] = this.companyName;
        data["vatNumber"] = this.vatNumber;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["language"] = this.language;
        data["termsOfPayment"] = this.termsOfPayment;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["specialty"] = this.specialty;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IUpdateSubcontractorCommand {
    id?: string | undefined;
    disabled?: boolean;
    companyName?: string | undefined;
    vatNumber?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    language?: string | undefined;
    termsOfPayment?: number | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    specialty?: string | undefined;
    addresses?: Address[] | undefined;
    tunnelGroupsId?: string | undefined;
    discountPercentage?: number | undefined;
}

export class Contact implements IContact {
    id?: string | undefined;
    firstname?: string | undefined;
    disabled?: boolean;
    contantPaymentTerms?: number | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.disabled = _data["disabled"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            this.middlename = _data["middlename"];
            this.lastname = _data["lastname"];
            this.jobTitle = _data["jobTitle"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.language = _data["language"];
            this.nationality = _data["nationality"];
            this.nationalInsuranceNumber = _data["nationalInsuranceNumber"];
            this.socialSecurityNumber = _data["socialSecurityNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.birthLocation = _data["birthLocation"];
            this.team = _data["team"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.notes = _data["notes"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.userId = _data["userId"];
            if (Array.isArray(_data["pricingAgreements"])) {
                this.pricingAgreements = [] as any;
                for (let item of _data["pricingAgreements"])
                    this.pricingAgreements!.push(PricingAgreement.fromJS(item));
            }
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["disabled"] = this.disabled;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        data["middlename"] = this.middlename;
        data["lastname"] = this.lastname;
        data["jobTitle"] = this.jobTitle;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["language"] = this.language;
        data["nationality"] = this.nationality;
        data["nationalInsuranceNumber"] = this.nationalInsuranceNumber;
        data["socialSecurityNumber"] = this.socialSecurityNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["birthLocation"] = this.birthLocation;
        data["team"] = this.team;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notes"] = this.notes;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        if (Array.isArray(this.pricingAgreements)) {
            data["pricingAgreements"] = [];
            for (let item of this.pricingAgreements)
                data["pricingAgreements"].push(item.toJSON());
        }
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContact {
    id?: string | undefined;
    firstname?: string | undefined;
    disabled?: boolean;
    contantPaymentTerms?: number | undefined;
    middlename?: string | undefined;
    lastname?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    language?: string | undefined;
    nationality?: string | undefined;
    nationalInsuranceNumber?: string | undefined;
    socialSecurityNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    birthLocation?: string | undefined;
    team?: string | undefined;
    tags?: string[] | undefined;
    notes?: string | undefined;
    displayName?: string | undefined;
    type?: string | undefined;
    address?: Address | undefined;
    userId?: string | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    billingDetails?: BillingDetails | undefined;
}

export class UpdateEmployeeCommand implements IUpdateEmployeeCommand {
    id?: string | undefined;
    canToggleProjectsOnHold?: boolean;

    constructor(data?: IUpdateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.canToggleProjectsOnHold = _data["canToggleProjectsOnHold"];
        }
    }

    static fromJS(data: any): UpdateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["canToggleProjectsOnHold"] = this.canToggleProjectsOnHold;
        return data;
    }
}

export interface IUpdateEmployeeCommand {
    id?: string | undefined;
    canToggleProjectsOnHold?: boolean;
}

export class Employee implements IEmployee {
    id?: string | undefined;
    disabled?: boolean;
    displayName?: string | undefined;
    type?: string | undefined;
    jobTitle?: string | undefined;
    accountEnabled?: boolean | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    adUserId?: string | undefined;
    billingDetails?: BillingDetails | undefined;
    canToggleProjectsOnHold?: boolean;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabled = _data["disabled"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.jobTitle = _data["jobTitle"];
            this.accountEnabled = _data["accountEnabled"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contantPaymentTerms = _data["contantPaymentTerms"];
            if (Array.isArray(_data["pricingAgreements"])) {
                this.pricingAgreements = [] as any;
                for (let item of _data["pricingAgreements"])
                    this.pricingAgreements!.push(PricingAgreement.fromJS(item));
            }
            this.adUserId = _data["adUserId"];
            this.billingDetails = _data["billingDetails"] ? BillingDetails.fromJS(_data["billingDetails"]) : <any>undefined;
            this.canToggleProjectsOnHold = _data["canToggleProjectsOnHold"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabled"] = this.disabled;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["jobTitle"] = this.jobTitle;
        data["accountEnabled"] = this.accountEnabled;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contantPaymentTerms"] = this.contantPaymentTerms;
        if (Array.isArray(this.pricingAgreements)) {
            data["pricingAgreements"] = [];
            for (let item of this.pricingAgreements)
                data["pricingAgreements"].push(item.toJSON());
        }
        data["adUserId"] = this.adUserId;
        data["billingDetails"] = this.billingDetails ? this.billingDetails.toJSON() : <any>undefined;
        data["canToggleProjectsOnHold"] = this.canToggleProjectsOnHold;
        return data;
    }
}

export interface IEmployee {
    id?: string | undefined;
    disabled?: boolean;
    displayName?: string | undefined;
    type?: string | undefined;
    jobTitle?: string | undefined;
    accountEnabled?: boolean | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    contantPaymentTerms?: number | undefined;
    pricingAgreements?: PricingAgreement[] | undefined;
    adUserId?: string | undefined;
    billingDetails?: BillingDetails | undefined;
    canToggleProjectsOnHold?: boolean;
}

/** The type Entity. */
export class Entity implements IEntity {
    /** Gets or sets id.
Read-only. */
    id?: string | undefined;
    /** Gets or sets @odata.type. */
    odataType?: string | undefined;

    [key: string]: any;

    constructor(data?: IEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.odataType = _data["@odata.type"];
        }
    }

    static fromJS(data: any): Entity {
        data = typeof data === 'object' ? data : {};
        let result = new Entity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["@odata.type"] = this.odataType;
        return data;
    }
}

/** The type Entity. */
export interface IEntity {
    /** Gets or sets id.
Read-only. */
    id?: string | undefined;
    /** Gets or sets @odata.type. */
    odataType?: string | undefined;

    [key: string]: any;
}

/** The type Directory Object. */
export class DirectoryObject extends Entity implements IDirectoryObject {
    /** Gets or sets deleted date time. */
    deletedDateTime?: Date | undefined;

    [key: string]: any;

    constructor(data?: IDirectoryObject) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.deletedDateTime = _data["deletedDateTime"] ? new Date(_data["deletedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DirectoryObject {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["deletedDateTime"] = this.deletedDateTime ? this.deletedDateTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** The type Directory Object. */
export interface IDirectoryObject extends IEntity {
    /** Gets or sets deleted date time. */
    deletedDateTime?: Date | undefined;

    [key: string]: any;
}

export class Subcontractor extends Company implements ISubcontractor {
    teamIds?: string[] | undefined;
    labourAgreements?: LabourAgreement[] | undefined;
    specialty?: string | undefined;
    tunnelGroupsId?: string | undefined;
    tunnelGroups?: string | undefined;

    constructor(data?: ISubcontractor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["teamIds"])) {
                this.teamIds = [] as any;
                for (let item of _data["teamIds"])
                    this.teamIds!.push(item);
            }
            if (Array.isArray(_data["labourAgreements"])) {
                this.labourAgreements = [] as any;
                for (let item of _data["labourAgreements"])
                    this.labourAgreements!.push(LabourAgreement.fromJS(item));
            }
            this.specialty = _data["specialty"];
            this.tunnelGroupsId = _data["tunnelGroupsId"];
            this.tunnelGroups = _data["tunnelGroups"];
        }
    }

    static fromJS(data: any): Subcontractor {
        data = typeof data === 'object' ? data : {};
        let result = new Subcontractor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.teamIds)) {
            data["teamIds"] = [];
            for (let item of this.teamIds)
                data["teamIds"].push(item);
        }
        if (Array.isArray(this.labourAgreements)) {
            data["labourAgreements"] = [];
            for (let item of this.labourAgreements)
                data["labourAgreements"].push(item.toJSON());
        }
        data["specialty"] = this.specialty;
        data["tunnelGroupsId"] = this.tunnelGroupsId;
        data["tunnelGroups"] = this.tunnelGroups;
        super.toJSON(data);
        return data;
    }
}

export interface ISubcontractor extends ICompany {
    teamIds?: string[] | undefined;
    labourAgreements?: LabourAgreement[] | undefined;
    specialty?: string | undefined;
    tunnelGroupsId?: string | undefined;
    tunnelGroups?: string | undefined;
}

export class LabourAgreement implements ILabourAgreement {
    articleId?: string | undefined;
    type?: string | undefined;
    price?: number;

    constructor(data?: ILabourAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.type = _data["type"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): LabourAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new LabourAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["type"] = this.type;
        data["price"] = this.price;
        return data;
    }
}

export interface ILabourAgreement {
    articleId?: string | undefined;
    type?: string | undefined;
    price?: number;
}

export class TeamAgendaDto implements ITeamAgendaDto {
    id?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    members?: string[] | undefined;

    constructor(data?: ITeamAgendaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subcontractorId = _data["subcontractorId"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): TeamAgendaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamAgendaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subcontractorId"] = this.subcontractorId;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface ITeamAgendaDto {
    id?: string | undefined;
    title?: string | undefined;
    subcontractorId?: string | undefined;
    members?: string[] | undefined;
}

export class TeamForPlanningDto implements ITeamForPlanningDto {
    id?: string | undefined;
    title?: string | undefined;

    constructor(data?: ITeamForPlanningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): TeamForPlanningDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamForPlanningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ITeamForPlanningDto {
    id?: string | undefined;
    title?: string | undefined;
}

export class GetTeamsForPlanningQuery implements IGetTeamsForPlanningQuery {
    workTypes?: string[] | undefined;

    constructor(data?: IGetTeamsForPlanningQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workTypes"])) {
                this.workTypes = [] as any;
                for (let item of _data["workTypes"])
                    this.workTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTeamsForPlanningQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamsForPlanningQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workTypes)) {
            data["workTypes"] = [];
            for (let item of this.workTypes)
                data["workTypes"].push(item);
        }
        return data;
    }
}

export interface IGetTeamsForPlanningQuery {
    workTypes?: string[] | undefined;
}

export class Team implements ITeam {
    id?: string | undefined;
    name?: string | undefined;
    hourlyRate?: number;
    activeOnAgenda?: boolean;
    correctionFactor?: number;
    subcontractorId?: string | undefined;
    members?: string[] | undefined;
    workTypes?: string[] | undefined;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.hourlyRate = _data["hourlyRate"];
            this.activeOnAgenda = _data["activeOnAgenda"];
            this.correctionFactor = _data["correctionFactor"];
            this.subcontractorId = _data["subcontractorId"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
            if (Array.isArray(_data["workTypes"])) {
                this.workTypes = [] as any;
                for (let item of _data["workTypes"])
                    this.workTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["hourlyRate"] = this.hourlyRate;
        data["activeOnAgenda"] = this.activeOnAgenda;
        data["correctionFactor"] = this.correctionFactor;
        data["subcontractorId"] = this.subcontractorId;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        if (Array.isArray(this.workTypes)) {
            data["workTypes"] = [];
            for (let item of this.workTypes)
                data["workTypes"].push(item);
        }
        return data;
    }
}

export interface ITeam {
    id?: string | undefined;
    name?: string | undefined;
    hourlyRate?: number;
    activeOnAgenda?: boolean;
    correctionFactor?: number;
    subcontractorId?: string | undefined;
    members?: string[] | undefined;
    workTypes?: string[] | undefined;
}

export class CreateTeamCommand implements ICreateTeamCommand {
    team?: Team | undefined;

    constructor(data?: ICreateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateTeamCommand {
    team?: Team | undefined;
}

export class UpdateTeamCommand implements IUpdateTeamCommand {
    team?: Team | undefined;

    constructor(data?: IUpdateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateTeamCommand {
    team?: Team | undefined;
}

export class ZipCodeDto implements IZipCodeDto {
    postcode?: string | undefined;
    plaatsnaam?: string | undefined;
    deelgemeente?: string | undefined;
    hoofdgemeente?: string | undefined;
    provincie?: string | undefined;

    constructor(data?: IZipCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postcode = _data["postcode"];
            this.plaatsnaam = _data["plaatsnaam"];
            this.deelgemeente = _data["deelgemeente"];
            this.hoofdgemeente = _data["hoofdgemeente"];
            this.provincie = _data["provincie"];
        }
    }

    static fromJS(data: any): ZipCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZipCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["plaatsnaam"] = this.plaatsnaam;
        data["deelgemeente"] = this.deelgemeente;
        data["hoofdgemeente"] = this.hoofdgemeente;
        data["provincie"] = this.provincie;
        return data;
    }
}

export interface IZipCodeDto {
    postcode?: string | undefined;
    plaatsnaam?: string | undefined;
    deelgemeente?: string | undefined;
    hoofdgemeente?: string | undefined;
    provincie?: string | undefined;
}

export class ArticleCategory extends EntityBase implements IArticleCategory {
    majorNumber?: number;
    minorNumber?: number;
    patchNumber?: number;
    name?: string | undefined;
    isDeleted?: boolean;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;
    version?: DocumentVersion;

    constructor(data?: IArticleCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.majorNumber = _data["majorNumber"];
            this.minorNumber = _data["minorNumber"];
            this.patchNumber = _data["patchNumber"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
            this.optimizationFrom = _data["optimizationFrom"];
            this.optimizationUntil = _data["optimizationUntil"];
            this.optimizationPercentage = _data["optimizationPercentage"];
            this.articleCategoryNumber = _data["articleCategoryNumber"];
            this.version = _data["version"] ? DocumentVersion.fromJS(_data["version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticleCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["majorNumber"] = this.majorNumber;
        data["minorNumber"] = this.minorNumber;
        data["patchNumber"] = this.patchNumber;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        data["optimizationFrom"] = this.optimizationFrom;
        data["optimizationUntil"] = this.optimizationUntil;
        data["optimizationPercentage"] = this.optimizationPercentage;
        data["articleCategoryNumber"] = this.articleCategoryNumber;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IArticleCategory extends IEntityBase {
    majorNumber?: number;
    minorNumber?: number;
    patchNumber?: number;
    name?: string | undefined;
    isDeleted?: boolean;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;
    version?: DocumentVersion;
}

export class LoadResultMapOfArticleCategory implements ILoadResultMapOfArticleCategory {
    data?: ArticleCategory[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfArticleCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArticleCategory.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfArticleCategory {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfArticleCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfArticleCategory {
    data?: ArticleCategory[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class CreateArticleCategoryCommand implements ICreateArticleCategoryCommand {
    name?: string | undefined;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;

    constructor(data?: ICreateArticleCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.optimizationFrom = _data["optimizationFrom"];
            this.optimizationUntil = _data["optimizationUntil"];
            this.optimizationPercentage = _data["optimizationPercentage"];
            this.articleCategoryNumber = _data["articleCategoryNumber"];
        }
    }

    static fromJS(data: any): CreateArticleCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["optimizationFrom"] = this.optimizationFrom;
        data["optimizationUntil"] = this.optimizationUntil;
        data["optimizationPercentage"] = this.optimizationPercentage;
        data["articleCategoryNumber"] = this.articleCategoryNumber;
        return data;
    }
}

export interface ICreateArticleCategoryCommand {
    name?: string | undefined;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;
}

export class UpdateArticleCategoryCommand implements IUpdateArticleCategoryCommand {
    id?: string | undefined;
    name?: string | undefined;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;

    constructor(data?: IUpdateArticleCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.optimizationFrom = _data["optimizationFrom"];
            this.optimizationUntil = _data["optimizationUntil"];
            this.optimizationPercentage = _data["optimizationPercentage"];
            this.articleCategoryNumber = _data["articleCategoryNumber"];
        }
    }

    static fromJS(data: any): UpdateArticleCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["optimizationFrom"] = this.optimizationFrom;
        data["optimizationUntil"] = this.optimizationUntil;
        data["optimizationPercentage"] = this.optimizationPercentage;
        data["articleCategoryNumber"] = this.articleCategoryNumber;
        return data;
    }
}

export interface IUpdateArticleCategoryCommand {
    id?: string | undefined;
    name?: string | undefined;
    optimizationFrom?: number | undefined;
    optimizationUntil?: number | undefined;
    optimizationPercentage?: number | undefined;
    articleCategoryNumber?: string | undefined;
}

export class CreateArticleCommand implements ICreateArticleCommand {
    name?: string | undefined;
    type?: ArticleType;
    measuringUnit?: string | undefined;
    categoryId?: string | undefined;

    constructor(data?: ICreateArticleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.measuringUnit = _data["measuringUnit"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): CreateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["measuringUnit"] = this.measuringUnit;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ICreateArticleCommand {
    name?: string | undefined;
    type?: ArticleType;
    measuringUnit?: string | undefined;
    categoryId?: string | undefined;
}

export class CopyArticleCommand implements ICopyArticleCommand {
    name?: string | undefined;
    id?: string | undefined;

    constructor(data?: ICopyArticleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CopyArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICopyArticleCommand {
    name?: string | undefined;
    id?: string | undefined;
}

export class UpdateArticleCommand implements IUpdateArticleCommand {
    id?: string | undefined;
    name?: string | undefined;
    status?: ArticleStatus;
    measuringUnit?: string | undefined;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    labourCosts?: LabourCost[] | undefined;
    variants?: Variant[] | undefined;
    categoryId?: string | undefined;

    constructor(data?: IUpdateArticleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.measuringUnit = _data["measuringUnit"];
            if (Array.isArray(_data["allowedWorktypes"])) {
                this.allowedWorktypes = [] as any;
                for (let item of _data["allowedWorktypes"])
                    this.allowedWorktypes!.push(item);
            }
            this.description = _data["description"];
            if (Array.isArray(_data["labourCosts"])) {
                this.labourCosts = [] as any;
                for (let item of _data["labourCosts"])
                    this.labourCosts!.push(LabourCost.fromJS(item));
            }
            if (Array.isArray(_data["variants"])) {
                this.variants = [] as any;
                for (let item of _data["variants"])
                    this.variants!.push(Variant.fromJS(item));
            }
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): UpdateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["measuringUnit"] = this.measuringUnit;
        if (Array.isArray(this.allowedWorktypes)) {
            data["allowedWorktypes"] = [];
            for (let item of this.allowedWorktypes)
                data["allowedWorktypes"].push(item);
        }
        data["description"] = this.description;
        if (Array.isArray(this.labourCosts)) {
            data["labourCosts"] = [];
            for (let item of this.labourCosts)
                data["labourCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.variants)) {
            data["variants"] = [];
            for (let item of this.variants)
                data["variants"].push(item.toJSON());
        }
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IUpdateArticleCommand {
    id?: string | undefined;
    name?: string | undefined;
    status?: ArticleStatus;
    measuringUnit?: string | undefined;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    labourCosts?: LabourCost[] | undefined;
    variants?: Variant[] | undefined;
    categoryId?: string | undefined;
}

export class UpdateArticleBasicsCommand implements IUpdateArticleBasicsCommand {
    id?: string | undefined;
    name?: string | undefined;
    status?: ArticleStatus;
    measuringUnit?: string | undefined;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    categoryId?: string | undefined;

    constructor(data?: IUpdateArticleBasicsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.measuringUnit = _data["measuringUnit"];
            if (Array.isArray(_data["allowedWorktypes"])) {
                this.allowedWorktypes = [] as any;
                for (let item of _data["allowedWorktypes"])
                    this.allowedWorktypes!.push(item);
            }
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): UpdateArticleBasicsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleBasicsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["measuringUnit"] = this.measuringUnit;
        if (Array.isArray(this.allowedWorktypes)) {
            data["allowedWorktypes"] = [];
            for (let item of this.allowedWorktypes)
                data["allowedWorktypes"].push(item);
        }
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IUpdateArticleBasicsCommand {
    id?: string | undefined;
    name?: string | undefined;
    status?: ArticleStatus;
    measuringUnit?: string | undefined;
    allowedWorktypes?: string[] | undefined;
    description?: string | undefined;
    categoryId?: string | undefined;
}

export class UpdateArticleLabourCostCommand implements IUpdateArticleLabourCostCommand {
    id?: string | undefined;
    labourCosts?: LabourCost[] | undefined;

    constructor(data?: IUpdateArticleLabourCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["labourCosts"])) {
                this.labourCosts = [] as any;
                for (let item of _data["labourCosts"])
                    this.labourCosts!.push(LabourCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateArticleLabourCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleLabourCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.labourCosts)) {
            data["labourCosts"] = [];
            for (let item of this.labourCosts)
                data["labourCosts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateArticleLabourCostCommand {
    id?: string | undefined;
    labourCosts?: LabourCost[] | undefined;
}

export class UpdateArticleBillOfMaterialsCommand implements IUpdateArticleBillOfMaterialsCommand {
    id?: string | undefined;
    billOfMaterials?: BillOfMaterialLine[] | undefined;

    constructor(data?: IUpdateArticleBillOfMaterialsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["billOfMaterials"])) {
                this.billOfMaterials = [] as any;
                for (let item of _data["billOfMaterials"])
                    this.billOfMaterials!.push(BillOfMaterialLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateArticleBillOfMaterialsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleBillOfMaterialsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.billOfMaterials)) {
            data["billOfMaterials"] = [];
            for (let item of this.billOfMaterials)
                data["billOfMaterials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateArticleBillOfMaterialsCommand {
    id?: string | undefined;
    billOfMaterials?: BillOfMaterialLine[] | undefined;
}

export class ArticleTranslationDto implements IArticleTranslationDto {
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IArticleTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ArticleTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IArticleTranslationDto {
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class MeasuringUnit extends EntityBase implements IMeasuringUnit {
    name?: string | undefined;

    constructor(data?: IMeasuringUnit) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MeasuringUnit {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IMeasuringUnit extends IEntityBase {
    name?: string | undefined;
}

export class CreateMeasuringUnitCommand implements ICreateMeasuringUnitCommand {
    name?: string | undefined;

    constructor(data?: ICreateMeasuringUnitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMeasuringUnitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasuringUnitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMeasuringUnitCommand {
    name?: string | undefined;
}

export class UpdateMeasuringUnitCommand implements IUpdateMeasuringUnitCommand {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUpdateMeasuringUnitCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateMeasuringUnitCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasuringUnitCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateMeasuringUnitCommand {
    id?: string | undefined;
    name?: string | undefined;
}

export class MeasuringUnitTranslationDto implements IMeasuringUnitTranslationDto {
    language?: string | undefined;
    value?: string | undefined;

    constructor(data?: IMeasuringUnitTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MeasuringUnitTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringUnitTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }
}

export interface IMeasuringUnitTranslationDto {
    language?: string | undefined;
    value?: string | undefined;
}

export class RawMaterialGroup implements IRawMaterialGroup {
    id?: string | undefined;
    name?: string | undefined;
    margin?: number;
    order?: number;
    isDeleted?: boolean;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;

    constructor(data?: IRawMaterialGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.margin = _data["margin"];
            this.order = _data["order"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["tunnelGroups"])) {
                this.tunnelGroups = [] as any;
                for (let item of _data["tunnelGroups"])
                    this.tunnelGroups!.push(RawMaterialGroupTunnelGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["margin"] = this.margin;
        data["order"] = this.order;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.tunnelGroups)) {
            data["tunnelGroups"] = [];
            for (let item of this.tunnelGroups)
                data["tunnelGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRawMaterialGroup {
    id?: string | undefined;
    name?: string | undefined;
    margin?: number;
    order?: number;
    isDeleted?: boolean;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;
}

export class RawMaterialGroupTunnelGroup implements IRawMaterialGroupTunnelGroup {
    id?: string | undefined;
    discountValue?: number | undefined;

    constructor(data?: IRawMaterialGroupTunnelGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discountValue = _data["discountValue"];
        }
    }

    static fromJS(data: any): RawMaterialGroupTunnelGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialGroupTunnelGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discountValue"] = this.discountValue;
        return data;
    }
}

export interface IRawMaterialGroupTunnelGroup {
    id?: string | undefined;
    discountValue?: number | undefined;
}

export class CreateRawMaterialGroupCommand implements ICreateRawMaterialGroupCommand {
    name?: string | undefined;
    margin?: number;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;

    constructor(data?: ICreateRawMaterialGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.margin = _data["margin"];
            if (Array.isArray(_data["tunnelGroups"])) {
                this.tunnelGroups = [] as any;
                for (let item of _data["tunnelGroups"])
                    this.tunnelGroups!.push(RawMaterialGroupTunnelGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRawMaterialGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRawMaterialGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["margin"] = this.margin;
        if (Array.isArray(this.tunnelGroups)) {
            data["tunnelGroups"] = [];
            for (let item of this.tunnelGroups)
                data["tunnelGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateRawMaterialGroupCommand {
    name?: string | undefined;
    margin?: number;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;
}

export class UpdateRawMaterialGroupCommand implements IUpdateRawMaterialGroupCommand {
    id?: string | undefined;
    name?: string | undefined;
    margin?: number;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;

    constructor(data?: IUpdateRawMaterialGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.margin = _data["margin"];
            if (Array.isArray(_data["tunnelGroups"])) {
                this.tunnelGroups = [] as any;
                for (let item of _data["tunnelGroups"])
                    this.tunnelGroups!.push(RawMaterialGroupTunnelGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRawMaterialGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRawMaterialGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["margin"] = this.margin;
        if (Array.isArray(this.tunnelGroups)) {
            data["tunnelGroups"] = [];
            for (let item of this.tunnelGroups)
                data["tunnelGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateRawMaterialGroupCommand {
    id?: string | undefined;
    name?: string | undefined;
    margin?: number;
    tunnelGroups?: RawMaterialGroupTunnelGroup[] | undefined;
}

export class DeleteRawMaterialGroupCommand implements IDeleteRawMaterialGroupCommand {
    rawMaterialGroupId?: string | undefined;

    constructor(data?: IDeleteRawMaterialGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rawMaterialGroupId = _data["rawMaterialGroupId"];
        }
    }

    static fromJS(data: any): DeleteRawMaterialGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRawMaterialGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rawMaterialGroupId"] = this.rawMaterialGroupId;
        return data;
    }
}

export interface IDeleteRawMaterialGroupCommand {
    rawMaterialGroupId?: string | undefined;
}

export class RawMaterialDto implements IRawMaterialDto {
    id?: string | undefined;
    name?: string | undefined;
    status?: RawMaterialStatus;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    margin?: number;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;
    tags?: string[] | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    defaultPrice?: WholesalePricing | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;

    constructor(data?: IRawMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.measuringUnit = _data["measuringUnit"];
            this.margin = _data["margin"];
            if (Array.isArray(_data["conversions"])) {
                this.conversions = [] as any;
                for (let item of _data["conversions"])
                    this.conversions!.push(RawMaterialConversion.fromJS(item));
            }
            if (Array.isArray(_data["pricing"])) {
                this.pricing = [] as any;
                for (let item of _data["pricing"])
                    this.pricing!.push(WholesalePricing.fromJS(item));
            }
            if (Array.isArray(_data["pricingHistory"])) {
                this.pricingHistory = [] as any;
                for (let item of _data["pricingHistory"])
                    this.pricingHistory!.push(WholesalePricing.fromJS(item));
            }
            this.unused = _data["unused"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.materialGroup = _data["materialGroup"] ? RawMaterialGroup.fromJS(_data["materialGroup"]) : <any>undefined;
            this.defaultPrice = _data["defaultPrice"] ? WholesalePricing.fromJS(_data["defaultPrice"]) : <any>undefined;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(RawMaterialTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RawMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["description"] = this.description;
        data["measuringUnit"] = this.measuringUnit;
        data["margin"] = this.margin;
        if (Array.isArray(this.conversions)) {
            data["conversions"] = [];
            for (let item of this.conversions)
                data["conversions"].push(item.toJSON());
        }
        if (Array.isArray(this.pricing)) {
            data["pricing"] = [];
            for (let item of this.pricing)
                data["pricing"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingHistory)) {
            data["pricingHistory"] = [];
            for (let item of this.pricingHistory)
                data["pricingHistory"].push(item.toJSON());
        }
        data["unused"] = this.unused;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["defaultPrice"] = this.defaultPrice ? this.defaultPrice.toJSON() : <any>undefined;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRawMaterialDto {
    id?: string | undefined;
    name?: string | undefined;
    status?: RawMaterialStatus;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    margin?: number;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;
    tags?: string[] | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    defaultPrice?: WholesalePricing | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;
}

export enum RawMaterialStatus {
    Active = 0,
    Disabled = 1,
}

export class RawMaterialConversion implements IRawMaterialConversion {
    amountA?: number;
    amountB?: number;
    measuringUnitA?: string | undefined;
    measuringUnitB?: string | undefined;

    constructor(data?: IRawMaterialConversion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountA = _data["amountA"];
            this.amountB = _data["amountB"];
            this.measuringUnitA = _data["measuringUnitA"];
            this.measuringUnitB = _data["measuringUnitB"];
        }
    }

    static fromJS(data: any): RawMaterialConversion {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialConversion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountA"] = this.amountA;
        data["amountB"] = this.amountB;
        data["measuringUnitA"] = this.measuringUnitA;
        data["measuringUnitB"] = this.measuringUnitB;
        return data;
    }
}

export interface IRawMaterialConversion {
    amountA?: number;
    amountB?: number;
    measuringUnitA?: string | undefined;
    measuringUnitB?: string | undefined;
}

export class WholesalePricing implements IWholesalePricing {
    wholesaleId?: string | undefined;
    wholesaleRef?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    amount?: number;
    measuringUnit?: string | undefined;
    convertAmountA?: number | undefined;
    convertAmountB?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePrice?: number;
    purchasePriceDefaultMeasuringUnit?: number;
    purchasePricePrivate?: number | undefined;
    salesPricePrivate?: number | undefined;
    salesPriceOrganisation?: number | undefined;
    minimumQuantity?: number | undefined;
    start?: Date;
    end?: Date | undefined;
    default?: boolean;

    constructor(data?: IWholesalePricing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wholesaleId = _data["wholesaleId"];
            this.wholesaleRef = _data["wholesaleRef"];
            this.brand = _data["brand"];
            this.kind = _data["kind"];
            this.amount = _data["amount"];
            this.measuringUnit = _data["measuringUnit"];
            this.convertAmountA = _data["convertAmountA"];
            this.convertAmountB = _data["convertAmountB"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.purchasePrice = _data["purchasePrice"];
            this.purchasePriceDefaultMeasuringUnit = _data["purchasePriceDefaultMeasuringUnit"];
            this.purchasePricePrivate = _data["purchasePricePrivate"];
            this.salesPricePrivate = _data["salesPricePrivate"];
            this.salesPriceOrganisation = _data["salesPriceOrganisation"];
            this.minimumQuantity = _data["minimumQuantity"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): WholesalePricing {
        data = typeof data === 'object' ? data : {};
        let result = new WholesalePricing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wholesaleId"] = this.wholesaleId;
        data["wholesaleRef"] = this.wholesaleRef;
        data["brand"] = this.brand;
        data["kind"] = this.kind;
        data["amount"] = this.amount;
        data["measuringUnit"] = this.measuringUnit;
        data["convertAmountA"] = this.convertAmountA;
        data["convertAmountB"] = this.convertAmountB;
        data["purchaseAmount"] = this.purchaseAmount;
        data["purchasePrice"] = this.purchasePrice;
        data["purchasePriceDefaultMeasuringUnit"] = this.purchasePriceDefaultMeasuringUnit;
        data["purchasePricePrivate"] = this.purchasePricePrivate;
        data["salesPricePrivate"] = this.salesPricePrivate;
        data["salesPriceOrganisation"] = this.salesPriceOrganisation;
        data["minimumQuantity"] = this.minimumQuantity;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["default"] = this.default;
        return data;
    }
}

export interface IWholesalePricing {
    wholesaleId?: string | undefined;
    wholesaleRef?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    amount?: number;
    measuringUnit?: string | undefined;
    convertAmountA?: number | undefined;
    convertAmountB?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePrice?: number;
    purchasePriceDefaultMeasuringUnit?: number;
    purchasePricePrivate?: number | undefined;
    salesPricePrivate?: number | undefined;
    salesPriceOrganisation?: number | undefined;
    minimumQuantity?: number | undefined;
    start?: Date;
    end?: Date | undefined;
    default?: boolean;
}

export class RawMaterialTranslationDto implements IRawMaterialTranslationDto {
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRawMaterialTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RawMaterialTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterialTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IRawMaterialTranslationDto {
    language?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class RawMaterial extends EntityBase implements IRawMaterial {
    name?: string | undefined;
    status?: RawMaterialStatus;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    margin?: number;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;
    tags?: string[] | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    defaultPrice?: WholesalePricing | undefined;

    constructor(data?: IRawMaterial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.measuringUnit = _data["measuringUnit"];
            this.margin = _data["margin"];
            if (Array.isArray(_data["conversions"])) {
                this.conversions = [] as any;
                for (let item of _data["conversions"])
                    this.conversions!.push(RawMaterialConversion.fromJS(item));
            }
            if (Array.isArray(_data["pricing"])) {
                this.pricing = [] as any;
                for (let item of _data["pricing"])
                    this.pricing!.push(WholesalePricing.fromJS(item));
            }
            if (Array.isArray(_data["pricingHistory"])) {
                this.pricingHistory = [] as any;
                for (let item of _data["pricingHistory"])
                    this.pricingHistory!.push(WholesalePricing.fromJS(item));
            }
            this.unused = _data["unused"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.materialGroup = _data["materialGroup"] ? RawMaterialGroup.fromJS(_data["materialGroup"]) : <any>undefined;
            this.defaultPrice = _data["defaultPrice"] ? WholesalePricing.fromJS(_data["defaultPrice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RawMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new RawMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["description"] = this.description;
        data["measuringUnit"] = this.measuringUnit;
        data["margin"] = this.margin;
        if (Array.isArray(this.conversions)) {
            data["conversions"] = [];
            for (let item of this.conversions)
                data["conversions"].push(item.toJSON());
        }
        if (Array.isArray(this.pricing)) {
            data["pricing"] = [];
            for (let item of this.pricing)
                data["pricing"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingHistory)) {
            data["pricingHistory"] = [];
            for (let item of this.pricingHistory)
                data["pricingHistory"].push(item.toJSON());
        }
        data["unused"] = this.unused;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["defaultPrice"] = this.defaultPrice ? this.defaultPrice.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRawMaterial extends IEntityBase {
    name?: string | undefined;
    status?: RawMaterialStatus;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    margin?: number;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;
    tags?: string[] | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    defaultPrice?: WholesalePricing | undefined;
}

export class CreateRawMaterialCommand implements ICreateRawMaterialCommand {
    name?: string | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    margin?: number;
    tags?: string[] | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;

    constructor(data?: ICreateRawMaterialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.measuringUnit = _data["measuringUnit"];
            this.materialGroup = _data["materialGroup"] ? RawMaterialGroup.fromJS(_data["materialGroup"]) : <any>undefined;
            this.margin = _data["margin"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(RawMaterialTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRawMaterialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRawMaterialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["measuringUnit"] = this.measuringUnit;
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["margin"] = this.margin;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateRawMaterialCommand {
    name?: string | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    margin?: number;
    tags?: string[] | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;
}

export class UpdateRawMaterialCommand implements IUpdateRawMaterialCommand {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    margin?: number;
    tags?: string[] | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;

    constructor(data?: IUpdateRawMaterialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.measuringUnit = _data["measuringUnit"];
            this.materialGroup = _data["materialGroup"] ? RawMaterialGroup.fromJS(_data["materialGroup"]) : <any>undefined;
            this.margin = _data["margin"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(RawMaterialTranslationDto.fromJS(item));
            }
            if (Array.isArray(_data["conversions"])) {
                this.conversions = [] as any;
                for (let item of _data["conversions"])
                    this.conversions!.push(RawMaterialConversion.fromJS(item));
            }
            if (Array.isArray(_data["pricing"])) {
                this.pricing = [] as any;
                for (let item of _data["pricing"])
                    this.pricing!.push(WholesalePricing.fromJS(item));
            }
            if (Array.isArray(_data["pricingHistory"])) {
                this.pricingHistory = [] as any;
                for (let item of _data["pricingHistory"])
                    this.pricingHistory!.push(WholesalePricing.fromJS(item));
            }
            this.unused = _data["unused"];
        }
    }

    static fromJS(data: any): UpdateRawMaterialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRawMaterialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["measuringUnit"] = this.measuringUnit;
        data["materialGroup"] = this.materialGroup ? this.materialGroup.toJSON() : <any>undefined;
        data["margin"] = this.margin;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        if (Array.isArray(this.conversions)) {
            data["conversions"] = [];
            for (let item of this.conversions)
                data["conversions"].push(item.toJSON());
        }
        if (Array.isArray(this.pricing)) {
            data["pricing"] = [];
            for (let item of this.pricing)
                data["pricing"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingHistory)) {
            data["pricingHistory"] = [];
            for (let item of this.pricingHistory)
                data["pricingHistory"].push(item.toJSON());
        }
        data["unused"] = this.unused;
        return data;
    }
}

export interface IUpdateRawMaterialCommand {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    measuringUnit?: string | undefined;
    materialGroup?: RawMaterialGroup | undefined;
    margin?: number;
    tags?: string[] | undefined;
    translations?: RawMaterialTranslationDto[] | undefined;
    conversions?: RawMaterialConversion[] | undefined;
    pricing?: WholesalePricing[] | undefined;
    pricingHistory?: WholesalePricing[] | undefined;
    unused?: boolean;
}

export class ImportRawMaterialsDataCommand implements IImportRawMaterialsDataCommand {
    supplierId?: string | undefined;
    data?: ImportRawMaterialDataDto[] | undefined;

    constructor(data?: IImportRawMaterialsDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImportRawMaterialDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportRawMaterialsDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRawMaterialsDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportRawMaterialsDataCommand {
    supplierId?: string | undefined;
    data?: ImportRawMaterialDataDto[] | undefined;
}

export class ImportRawMaterialDataDto implements IImportRawMaterialDataDto {
    id?: string | undefined;
    name?: string | undefined;
    pricingEntries?: ImportRawMaterialPricingDataDto[] | undefined;

    constructor(data?: IImportRawMaterialDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["pricingEntries"])) {
                this.pricingEntries = [] as any;
                for (let item of _data["pricingEntries"])
                    this.pricingEntries!.push(ImportRawMaterialPricingDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportRawMaterialDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRawMaterialDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.pricingEntries)) {
            data["pricingEntries"] = [];
            for (let item of this.pricingEntries)
                data["pricingEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportRawMaterialDataDto {
    id?: string | undefined;
    name?: string | undefined;
    pricingEntries?: ImportRawMaterialPricingDataDto[] | undefined;
}

export class ImportRawMaterialPricingDataDto implements IImportRawMaterialPricingDataDto {
    newData?: ImportRawMaterialDataCsvEntry | undefined;
    oldData?: ExportRawMaterialDataDto | undefined;

    constructor(data?: IImportRawMaterialPricingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newData = _data["newData"] ? ImportRawMaterialDataCsvEntry.fromJS(_data["newData"]) : <any>undefined;
            this.oldData = _data["oldData"] ? ExportRawMaterialDataDto.fromJS(_data["oldData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportRawMaterialPricingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRawMaterialPricingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newData"] = this.newData ? this.newData.toJSON() : <any>undefined;
        data["oldData"] = this.oldData ? this.oldData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportRawMaterialPricingDataDto {
    newData?: ImportRawMaterialDataCsvEntry | undefined;
    oldData?: ExportRawMaterialDataDto | undefined;
}

export class ImportRawMaterialDataCsvEntry implements IImportRawMaterialDataCsvEntry {
    id?: string | undefined;
    name?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    supplierReference?: string | undefined;
    pieceAmount?: number | undefined;
    pieceMeasuringUnit?: string | undefined;
    minPiecesPerOrder?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePriceB2B?: number | undefined;
    purchasePriceB2C?: number | undefined;

    constructor(data?: IImportRawMaterialDataCsvEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.brand = _data["brand"];
            this.kind = _data["kind"];
            this.supplierReference = _data["supplierReference"];
            this.pieceAmount = _data["pieceAmount"];
            this.pieceMeasuringUnit = _data["pieceMeasuringUnit"];
            this.minPiecesPerOrder = _data["minPiecesPerOrder"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.purchasePriceB2B = _data["purchasePriceB2B"];
            this.purchasePriceB2C = _data["purchasePriceB2C"];
        }
    }

    static fromJS(data: any): ImportRawMaterialDataCsvEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRawMaterialDataCsvEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["brand"] = this.brand;
        data["kind"] = this.kind;
        data["supplierReference"] = this.supplierReference;
        data["pieceAmount"] = this.pieceAmount;
        data["pieceMeasuringUnit"] = this.pieceMeasuringUnit;
        data["minPiecesPerOrder"] = this.minPiecesPerOrder;
        data["purchaseAmount"] = this.purchaseAmount;
        data["purchasePriceB2B"] = this.purchasePriceB2B;
        data["purchasePriceB2C"] = this.purchasePriceB2C;
        return data;
    }
}

export interface IImportRawMaterialDataCsvEntry {
    id?: string | undefined;
    name?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    supplierReference?: string | undefined;
    pieceAmount?: number | undefined;
    pieceMeasuringUnit?: string | undefined;
    minPiecesPerOrder?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePriceB2B?: number | undefined;
    purchasePriceB2C?: number | undefined;
}

export class ExportRawMaterialDataDto implements IExportRawMaterialDataDto {
    id?: string | undefined;
    name?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    supplierReference?: string | undefined;
    pieceAmount?: number | undefined;
    pieceMeasuringUnit?: string | undefined;
    minPiecesPerOrder?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePriceB2B?: number | undefined;
    purchasePriceB2C?: number | undefined;

    constructor(data?: IExportRawMaterialDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.brand = _data["brand"];
            this.kind = _data["kind"];
            this.supplierReference = _data["supplierReference"];
            this.pieceAmount = _data["pieceAmount"];
            this.pieceMeasuringUnit = _data["pieceMeasuringUnit"];
            this.minPiecesPerOrder = _data["minPiecesPerOrder"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.purchasePriceB2B = _data["purchasePriceB2B"];
            this.purchasePriceB2C = _data["purchasePriceB2C"];
        }
    }

    static fromJS(data: any): ExportRawMaterialDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRawMaterialDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["brand"] = this.brand;
        data["kind"] = this.kind;
        data["supplierReference"] = this.supplierReference;
        data["pieceAmount"] = this.pieceAmount;
        data["pieceMeasuringUnit"] = this.pieceMeasuringUnit;
        data["minPiecesPerOrder"] = this.minPiecesPerOrder;
        data["purchaseAmount"] = this.purchaseAmount;
        data["purchasePriceB2B"] = this.purchasePriceB2B;
        data["purchasePriceB2C"] = this.purchasePriceB2C;
        return data;
    }
}

export interface IExportRawMaterialDataDto {
    id?: string | undefined;
    name?: string | undefined;
    brand?: string | undefined;
    kind?: string | undefined;
    supplierReference?: string | undefined;
    pieceAmount?: number | undefined;
    pieceMeasuringUnit?: string | undefined;
    minPiecesPerOrder?: number | undefined;
    purchaseAmount?: number | undefined;
    purchasePriceB2B?: number | undefined;
    purchasePriceB2C?: number | undefined;
}

export class TunnelGroup extends EntityBase implements ITunnelGroup {
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;
    isDeleted?: boolean;

    constructor(data?: ITunnelGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.materialMargin = _data["materialMargin"];
            this.labourMargin = _data["labourMargin"];
            this.priority = _data["priority"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TunnelGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TunnelGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["materialMargin"] = this.materialMargin;
        data["labourMargin"] = this.labourMargin;
        data["priority"] = this.priority;
        data["isDeleted"] = this.isDeleted;
        super.toJSON(data);
        return data;
    }
}

export interface ITunnelGroup extends IEntityBase {
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;
    isDeleted?: boolean;
}

export class LoadResultMapOfTunnelGroup implements ILoadResultMapOfTunnelGroup {
    data?: TunnelGroup[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;

    constructor(data?: ILoadResultMapOfTunnelGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TunnelGroup.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["summary"])) {
                this.summary = [] as any;
                for (let item of _data["summary"])
                    this.summary!.push(item);
            }
        }
    }

    static fromJS(data: any): LoadResultMapOfTunnelGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LoadResultMapOfTunnelGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.summary)) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item);
        }
        return data;
    }
}

export interface ILoadResultMapOfTunnelGroup {
    data?: TunnelGroup[] | undefined;
    totalCount?: number;
    groupCount?: number;
    summary?: any[] | undefined;
}

export class CreateTunnelGroupCommand implements ICreateTunnelGroupCommand {
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;

    constructor(data?: ICreateTunnelGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.materialMargin = _data["materialMargin"];
            this.labourMargin = _data["labourMargin"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): CreateTunnelGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTunnelGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["materialMargin"] = this.materialMargin;
        data["labourMargin"] = this.labourMargin;
        data["priority"] = this.priority;
        return data;
    }
}

export interface ICreateTunnelGroupCommand {
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;
}

export class UpdateTunnelGroupCommand implements IUpdateTunnelGroupCommand {
    id?: string | undefined;
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;

    constructor(data?: IUpdateTunnelGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.materialMargin = _data["materialMargin"];
            this.labourMargin = _data["labourMargin"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): UpdateTunnelGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTunnelGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["materialMargin"] = this.materialMargin;
        data["labourMargin"] = this.labourMargin;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IUpdateTunnelGroupCommand {
    id?: string | undefined;
    name?: string | undefined;
    materialMargin?: number;
    labourMargin?: number;
    priority?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}